import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, Directive, ViewContainerRef, ElementRef, Renderer2, HostListener, Optional, ViewChild, HostBinding, NgModule, forwardRef, TemplateRef, ContentChildren, InjectionToken, Injectable, Injector, Inject, PLATFORM_ID, EventEmitter, Output, Pipe, ComponentFactoryResolver, SkipSelf, LOCALE_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser, formatDate, DOCUMENT } from '@angular/common';
import * as i1 from '@angular/cdk/overlay';
import { Overlay, OverlayModule, OverlayConfig } from '@angular/cdk/overlay';
import { TemplatePortal, ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { Subject, BehaviorSubject, of, forkJoin, ReplaySubject } from 'rxjs';
import { NG_VALUE_ACCESSOR, FormGroupDirective, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { map } from 'rxjs/operators';
import { LayoutModule } from '@angular/cdk/layout';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import emailMask from 'text-mask-addons/dist/emailMask';
import { DomSanitizer, ɵgetDOM } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject as Subject$1 } from 'rxjs/internal/Subject';
import { Metrika } from 'ng-yandex-metrika';
import { __awaiter } from 'tslib';
import { createTextMaskInputElement } from 'text-mask-core/dist/textMaskCore';
import { trigger, transition, style, animate } from '@angular/animations';
import { CdkScrollableModule } from '@angular/cdk/scrolling';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/cdk/overlay';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/platform-browser';
import * as ɵngcc5 from '@angular/router';
import * as ɵngcc6 from '@angular/cdk/scrolling';
import * as ɵngcc7 from 'ng-yandex-metrika';

function AudioComponent_mtg_svg_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtg-svg-icon", 12);
} }
function AudioComponent_mtg_svg_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtg-svg-icon", 13);
} }
function AudioComponent_mtg_spinner_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtg-spinner");
} }
const _c0 = function (a0) { return { width: a0 }; };
const _c1 = ["linkElement"];
function ButtonComponent_a_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 4, 5);
    ɵngcc0.ɵɵelementContainer(2, 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("href", ctx_r0.href, ɵngcc0.ɵɵsanitizeUrl)("target", ctx_r0.target)("classList", ctx_r0.class);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ButtonComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵelementContainer(1, 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("type", ctx_r1.type)("classList", ctx_r1.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ButtonComponent_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 8);
    ɵngcc0.ɵɵelementContainer(1, 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("classList", ctx_r2.class);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ButtonComponent_ng_template_3_mtg_svg_icon_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtg-svg-icon", 12);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r6.leadingIcon);
} }
function ButtonComponent_ng_template_3_mtg_svg_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtg-svg-icon", 13);
} }
function ButtonComponent_ng_template_3_mtg_svg_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtg-svg-icon", 14);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("icon", ctx_r8.trailingIcon);
} }
function ButtonComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ButtonComponent_ng_template_3_mtg_svg_icon_0_Template, 1, 1, "mtg-svg-icon", 9);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵtemplate(2, ButtonComponent_ng_template_3_mtg_svg_icon_2_Template, 1, 0, "mtg-svg-icon", 10);
    ɵngcc0.ɵɵtemplate(3, ButtonComponent_ng_template_3_mtg_svg_icon_3_Template, 1, 1, "mtg-svg-icon", 11);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.leadingIcon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.hasDropdown);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.trailingIcon && !ctx_r4.hasDropdown);
} }
const _c2 = ["*"];
function SpinnerComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", +ctx_r0.progress, "%");
} }
const _c3 = function (a0) { return { reverse: a0 }; };
const _c4 = ["content"];
function DropdownMenuComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
function DropdownItemComponent_mtg_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtg-svg-icon", 1);
} }
function DropdownComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r7.viewValue);
} }
function DropdownComponent_div_0_ng_container_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r10.viewValue);
} }
function DropdownComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_div_0_ng_container_5_div_1_Template, 2, 1, "div", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const group_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", group_r8.items);
} }
function DropdownComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18)(1, "input", 19);
    ɵngcc0.ɵɵlistener("input", function DropdownComponent_div_0_div_8_Template_input_input_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r11.searchValue($event.target.value)); });
    ɵngcc0.ɵɵpipe(2, "mtgTranslate");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", ctx_r6.search)("placeholder", ɵngcc0.ɵɵpipeBind2(2, 2, ctx_r6.localization, "search"));
} }
function DropdownComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DropdownComponent_div_0_div_4_Template, 2, 1, "div", 7);
    ɵngcc0.ɵɵtemplate(5, DropdownComponent_div_0_ng_container_5_Template, 2, 1, "ng-container", 8);
    ɵngcc0.ɵɵelementStart(6, "div", 9);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵtemplate(8, DropdownComponent_div_0_div_8_Template, 3, 5, "div", 10);
    ɵngcc0.ɵɵelementStart(9, "div", 11);
    ɵngcc0.ɵɵelement(10, "div", 12);
    ɵngcc0.ɵɵelementStart(11, "div", 13)(12, "div", 14);
    ɵngcc0.ɵɵtext(13);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelement(14, "div", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 16);
    ɵngcc0.ɵɵelement(16, "mtg-svg-icon", 17);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("mtgDropdownTriggerFor", _r3)("mtgDropdownDisabled", ctx_r0.disabled);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.items);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.groups);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.valueText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.withSearch);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
function DropdownComponent_mtg_button_1_mtg_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mtg-svg-icon", 23);
    ɵngcc0.ɵɵlistener("click", function DropdownComponent_mtg_button_1_mtg_svg_icon_1_Template_mtg_svg_icon_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r16.reset()); });
    ɵngcc0.ɵɵelementEnd();
} }
function DropdownComponent_mtg_button_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "mtgTranslate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind2(2, 2, ctx_r18.localization, "selected"), ": ", ctx_r18.value.length, " ");
} }
function DropdownComponent_mtg_button_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r19.label, " ");
} }
function DropdownComponent_mtg_button_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_mtg_button_1_ng_container_2_ng_container_1_Template, 3, 5, "ng-container", 22);
    ɵngcc0.ɵɵtemplate(2, DropdownComponent_mtg_button_1_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 22);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.value.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.value.length <= 0);
} }
function DropdownComponent_mtg_button_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r15.valueText || ctx_r15.label, " ");
} }
function DropdownComponent_mtg_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mtg-button", 20);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_mtg_button_1_mtg_svg_icon_1_Template, 1, 0, "mtg-svg-icon", 21);
    ɵngcc0.ɵɵtemplate(2, DropdownComponent_mtg_button_1_ng_container_2_Template, 3, 2, "ng-container", 22);
    ɵngcc0.ɵɵtemplate(3, DropdownComponent_mtg_button_1_ng_container_3_Template, 2, 1, "ng-container", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("color", !ctx_r1.valueText ? "secondary" : "primary")("variant", ctx_r1.variant)("mtgDropdownTriggerFor", _r3)("fluid", ctx_r1.fluid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.valueText && ctx_r1.resetVisible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.multi);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.multi);
} }
function DropdownComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r20.getErrors().join(", "), " ");
} }
function DropdownComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵtemplate(1, DropdownComponent_div_2_ng_container_1_Template, 2, 1, "ng-container", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.getErrors().length);
} }
const _c5 = ["host"];
const _c6 = ["container"];
function DialogComponent_mtg_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mtg-button", 8);
    ɵngcc0.ɵɵlistener("click", function DialogComponent_mtg_button_3_Template_mtg_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.close()); });
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 9);
    ɵngcc0.ɵɵelementEnd();
} }
const _c7 = function (a0) { return { fullscreen: a0 }; };
function DialogPageComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelement(1, "mtg-spinner");
    ɵngcc0.ɵɵelementEnd();
} }
function AgreementComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1)(1, "p");
    ɵngcc0.ɵɵtext(2, " \u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044F \u0441\u0432\u043E\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0434\u0430\u0451\u0442 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443, \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u0432\u043E\u0438\u0445 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0424\u0417 \u2116 152-\u0424\u0417 \u00AB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\u00BB \u043E\u0442 27.07.2006 \u0433. \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0446\u0435\u043B\u044F\u0445: ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "ul")(4, "li");
    ɵngcc0.ɵɵtext(5, "\u041E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "li");
    ɵngcc0.ɵɵtext(7, "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u044B\u0445 \u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0445");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "li");
    ɵngcc0.ɵɵtext(9, "\u041F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0430\u0443\u0434\u0438\u0442\u0430 \u0438 \u043F\u0440\u043E\u0447\u0438\u0445 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0439 \u0441 \u0446\u0435\u043B\u044C\u044E \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u0438\u044F \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u0443\u0441\u043B\u0443\u0433.");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(10, "p");
    ɵngcc0.ɵɵtext(11, "\u041F\u043E\u0434 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\u0434\u0440\u0430\u0437\u0443\u043C\u0435\u0432\u0430\u0435\u0442\u0441\u044F \u043B\u044E\u0431\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430, \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0449\u0430\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043B\u0438\u0447\u043D\u043E\u0441\u0442\u044C \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F/\u041F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F \u0442\u0430\u043A\u0430\u044F \u043A\u0430\u043A:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "ul")(13, "li");
    ɵngcc0.ɵɵtext(14, "\u0424\u0430\u043C\u0438\u043B\u0438\u044F, \u0418\u043C\u044F, \u041E\u0442\u0447\u0435\u0441\u0442\u0432\u043E;");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "li");
    ɵngcc0.ɵɵtext(16, "\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F;");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "li");
    ɵngcc0.ɵɵtext(18, "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D;");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "li");
    ɵngcc0.ɵɵtext(20, "\u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B;");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "li");
    ɵngcc0.ɵɵtext(22, "\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441;");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "li");
    ɵngcc0.ɵɵtext(24, "\u0411\u0438\u043E\u043C\u0435\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0435.");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(25, "p");
    ɵngcc0.ɵɵtext(26, "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0445 \u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F\u0445 \u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0441\u0438\u0441\u0442\u0435\u043C, \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0441\u043B\u0443\u0447\u0430\u0435\u0432, \u043A\u043E\u0433\u0434\u0430 \u043D\u0435\u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435\u043C \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430.");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(27, "p");
    ɵngcc0.ɵɵtext(28, "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C, \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0441\u043B\u0443\u0447\u0430\u0435\u0432:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "ul")(30, "li");
    ɵngcc0.ɵɵtext(31, "\u041F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0430\u043C \u0443\u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0435\u043D\u043D\u044B\u0445 \u043E\u0440\u0433\u0430\u043D\u043E\u0432 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u0432\u043B\u0430\u0441\u0442\u0438 \u0420\u0424 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F\u043C \u0438 \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u0424;");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(32, "li");
    ɵngcc0.ɵɵtext(33, "\u0421\u0442\u0440\u0430\u0442\u0435\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0442 \u0441 \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0435\u0439 \u0434\u043B\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 \u0438 \u0443\u0441\u043B\u0443\u0433, \u0438\u043B\u0438 \u0442\u0435\u043C \u0438\u0437 \u043D\u0438\u0445, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043F\u043E\u043C\u043E\u0433\u0430\u044E\u0442 \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u044B\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u044B \u0438 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u044F\u043C. \u041C\u044B \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0439 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0442\u0440\u0435\u0431\u0443\u0435\u043C\u043E\u0439 \u0443\u0441\u043B\u0443\u0433\u0438 \u0438\u043B\u0438 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0439 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438.");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(34, "p");
    ɵngcc0.ɵɵtext(35, "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0432\u043D\u043E\u0441\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430, \u043F\u0440\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0438, \u0447\u0442\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043D\u0435 \u043F\u0440\u043E\u0442\u0438\u0432\u043E\u0440\u0435\u0447\u0430\u0442 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0420\u0424. \u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0445 \u043F\u0440\u0430\u0432\u0438\u043B \u0432\u0441\u0442\u0443\u043F\u0430\u044E\u0442 \u0432 \u0441\u0438\u043B\u0443 \u043F\u043E\u0441\u043B\u0435 \u0438\u0445 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043D\u0430 \u0421\u0430\u0439\u0442\u0435 https://mtgame.ru.");
    ɵngcc0.ɵɵelementEnd()();
} }
function AgreementComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtext(1, " TODO\n");
    ɵngcc0.ɵɵelementEnd();
} }
const _c8 = ["scrollContainer"];
const _c9 = ["input"];
const _c10 = ["textarea"];
function TextFieldComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r0.leadingIcon);
} }
function TextFieldComponent_input_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 14, 15);
    ɵngcc0.ɵɵlistener("focus", function TextFieldComponent_input_2_Template_input_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.onFocus($event)); })("blur", function TextFieldComponent_input_2_Template_input_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.onBlur($event)); })("input", function TextFieldComponent_input_2_Template_input_input_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r10.changeValue($event.target.value)); })("keydown", function TextFieldComponent_input_2_Template_input_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r11.onKeyDown($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("type", ctx_r1.type === "password" && ctx_r1.showPassword ? "text" : ctx_r1.type)("min", ctx_r1.min)("pattern", ctx_r1.pattern || "")("placeholder", ctx_r1.placeholder || "")("disabled", ctx_r1.disabled);
} }
function TextFieldComponent_textarea_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "textarea", 16, 17);
    ɵngcc0.ɵɵlistener("focus", function TextFieldComponent_textarea_3_Template_textarea_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r13.onFocus($event)); })("blur", function TextFieldComponent_textarea_3_Template_textarea_blur_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r15.onBlur($event)); })("input", function TextFieldComponent_textarea_3_Template_textarea_input_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r16.changeValue($event.target.value)); })("keydown", function TextFieldComponent_textarea_3_Template_textarea_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r17.onKeyDown($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("placeholder", ctx_r2.placeholder || "")("disabled", ctx_r2.disabled);
} }
function TextFieldComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("icon", ctx_r3.trailingIcon);
} }
function TextFieldComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵlistener("click", function TextFieldComponent_div_11_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r18.clear()); });
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 20);
    ɵngcc0.ɵɵelementEnd();
} }
function TextFieldComponent_div_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r20.getErrors().join(", "), " ");
} }
function TextFieldComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtemplate(1, TextFieldComponent_div_12_ng_container_1_Template, 2, 1, "ng-container", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.getErrors().length && (!ctx_r5.isFocused || ctx_r5.hasErrorsOnFocus));
} }
const _c11 = function (a0) { return { textarea: a0 }; };
function ToastComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " \uD83D\uDC4D");
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c12 = ["slider"];
function DataSliderComponent_div_0_mtg_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mtg-button", 9);
    ɵngcc0.ɵɵlistener("click", function DataSliderComponent_div_0_mtg_button_1_Template_mtg_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r5.slideLeft()); });
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 10);
    ɵngcc0.ɵɵelementEnd();
} }
function DataSliderComponent_div_0_mtg_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mtg-button", 11);
    ɵngcc0.ɵɵlistener("click", function DataSliderComponent_div_0_mtg_button_2_Template_mtg_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r7.slideRight()); });
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 12);
    ɵngcc0.ɵɵelementEnd();
} }
const _c13 = function (a0) { return { inside: a0 }; };
function DataSliderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, DataSliderComponent_div_0_mtg_button_1_Template, 2, 0, "mtg-button", 7);
    ɵngcc0.ɵɵtemplate(2, DataSliderComponent_div_0_mtg_button_2_Template, 2, 0, "mtg-button", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c13, ctx_r0.arrowInside));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canScrollLeft);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canScrollRight);
} }
const _c14 = ["scroll"];
function TableComponent_mtg_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mtg-button", 5);
    ɵngcc0.ɵɵlistener("click", function TableComponent_mtg_button_4_Template_mtg_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.scrollLeft()); });
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("top", ctx_r1.stickyTop);
} }
function TableComponent_mtg_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mtg-button", 7);
    ɵngcc0.ɵɵlistener("click", function TableComponent_mtg_button_5_Template_mtg_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.scrollRight()); });
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("top", ctx_r2.stickyTop);
} }
function TableColGroupComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelementContainer(4, 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function TableColGroupComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function TooltipComponent_ng_container_0_ng_content_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngTemplateOutlet", "content"]);
} }
function TooltipComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TooltipComponent_ng_container_0_ng_content_1_Template, 1, 0, "ng-content", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.content);
} }
function TooltipComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.text);
} }
function ShareComponent_mtg_button_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mtg-button", 6);
    ɵngcc0.ɵɵelement(1, "mtg-svg-icon", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("mtgDropdownTriggerFor", _r2);
} }
function ShareComponent_mtg_svg_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mtg-svg-icon", 8);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("mtgDropdownTriggerFor", _r2);
} }
function TypeaheadComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
class AudioComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.state = 'pause';
        this.audio = new Audio();
    }
    detectChanges() {
        if (this.audio) {
            this.audio.pause();
        }
        if (this.source) {
            this.initializeAudio();
        }
    }
    ngOnChanges(changes) {
        if (changes.source) {
            this.detectChanges();
        }
    }
    initializeAudio() {
        this.audio = new Audio(this.source);
        this.audio.addEventListener('playing', () => {
            this.state = 'playing';
            this.cdr.markForCheck();
        });
        this.audio.addEventListener('pause', () => {
            this.state = 'pause';
            this.cdr.markForCheck();
        });
        this.audio.addEventListener('timeupdate', event => {
            this.progress = 100 * this.audio.currentTime / this.duration;
            this.cdr.markForCheck();
        });
        this.audio.addEventListener('durationchange', event => {
            this.duration = this.audio.duration;
            this.cdr.markForCheck();
        });
    }
    togglePlay() {
        if (this.audio.paused) {
            this.playAudio();
        }
        else {
            this.audio.pause();
        }
    }
    playAudio() {
        this.state = 'loading';
        this.audio.play().catch(error => {
            this.state = 'pause';
        });
    }
    pauseAudio() {
        this.audio.pause();
    }
    setMeta(name, source) {
        this.name = name;
        if (!this.source || this.source !== source) {
            this.source = source;
            this.detectChanges();
        }
    }
    setDuration(event) {
        const rect = event.target.getBoundingClientRect();
        const progress = (event.clientX - rect.x) / rect.width;
        if (progress < 0 || progress > 1) {
            return;
        }
        this.audio.currentTime = progress * this.duration;
    }
    strPadLeft(time, pad, length) {
        return (new Array(length + 1).join(pad) + time).slice(-length);
    }
    getPrettyTime(time) {
        if (!time) {
            return '';
        }
        const minutes = Math.floor(time / 60);
        const seconds = Math.round(time - minutes * 60);
        return `${minutes}:${this.strPadLeft(seconds, '0', 2)}`;
    }
    get durationInfo() {
        return this.audio.currentTime
            ? this.getPrettyTime(this.audio.currentTime)
            : this.getPrettyTime(this.audio.duration);
    }
}
AudioComponent.ɵfac = function AudioComponent_Factory(t) { return new (t || AudioComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AudioComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AudioComponent, selectors: [["mtg-audio"]], inputs: { name: "name", source: "source" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 14, vars: 8, consts: [[1, "audio-player"], ["variant", "circle", 3, "click"], ["icon", "icons-play", 4, "ngIf"], ["icon", "icons-pause", 4, "ngIf"], [4, "ngIf"], [1, "info-block"], [1, "info"], [1, "name"], [1, "duration-time"], [1, "duration", 3, "click"], [1, "line"], [1, "progress", 3, "ngStyle"], ["icon", "icons-play"], ["icon", "icons-pause"]], template: function AudioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "mtg-button", 1);
        ɵngcc0.ɵɵlistener("click", function AudioComponent_Template_mtg_button_click_1_listener() { return ctx.togglePlay(); });
        ɵngcc0.ɵɵtemplate(2, AudioComponent_mtg_svg_icon_2_Template, 1, 0, "mtg-svg-icon", 2);
        ɵngcc0.ɵɵtemplate(3, AudioComponent_mtg_svg_icon_3_Template, 1, 0, "mtg-svg-icon", 3);
        ɵngcc0.ɵɵtemplate(4, AudioComponent_mtg_spinner_4_Template, 1, 0, "mtg-spinner", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5)(6, "div", 6)(7, "div", 7);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵlistener("click", function AudioComponent_Template_div_click_11_listener($event) { return ctx.setDuration($event); });
        ɵngcc0.ɵɵelementStart(12, "div", 10);
        ɵngcc0.ɵɵelement(13, "div", 11);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.state === "pause");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.state === "playing");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.state === "loading");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.name, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.durationInfo, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(6, _c0, ctx.progress + "%"));
    } }, dependencies: function () { return [ɵngcc1.NgIf, ɵngcc1.NgStyle, ButtonComponent, SvgIconComponent, SpinnerComponent]; }, encapsulation: 2, changeDetection: 0 });
AudioComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
AudioComponent.propDecorators = {
    source: [{ type: Input }],
    name: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AudioComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-audio',
                template: "<div class=\"audio-player\">\n  <mtg-button variant=\"circle\" (click)=\"togglePlay()\">\n    <mtg-svg-icon icon=\"icons-play\" *ngIf=\"state === 'pause'\"></mtg-svg-icon>\n    <mtg-svg-icon icon=\"icons-pause\" *ngIf=\"state === 'playing'\"></mtg-svg-icon>\n    <mtg-spinner *ngIf=\"state === 'loading'\"></mtg-spinner>\n  </mtg-button>\n  <div class=\"info-block\">\n    <div class=\"info\">\n      <div class=\"name\">\n        {{name}}\n      </div>\n      <div class=\"duration-time\">\n        {{durationInfo}}\n      </div>\n    </div>\n    <div class=\"duration\" (click)=\"setDuration($event)\">\n      <div class=\"line\">\n        <div class=\"progress\" [ngStyle]=\"{width: progress + '%'}\"></div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { name: [{
            type: Input
        }], source: [{
            type: Input
        }] }); })();

class DropdownTriggerDirective {
    constructor(viewContainerRef, overlay, elementRef, renderer, cdr) {
        this.viewContainerRef = viewContainerRef;
        this.overlay = overlay;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cdr = cdr;
        // tslint:disable-next-line:no-input-rename
        this.position = 'right';
        this.subscriptions = [];
        this.isVisible$ = new Subject();
    }
    ngOnInit() {
        this.subscriptions.push(this.renderer.listen('window', 'click', $event => {
            if (!this.isVisible) {
                return;
            }
            const target = $event.composedPath() && $event.composedPath()[0] || $event.target;
            if (!this.overlayRef.hostElement.contains(target) &&
                !this.elementRef.nativeElement.contains(target)) {
                this.hideMenu();
                this.cdr.markForCheck();
            }
        }), this.renderer.listen('window', 'resize', () => {
            this.syncWidth();
        }));
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
        for (const unsubscribe of this.subscriptions) {
            unsubscribe();
        }
        this.isVisible$.complete();
    }
    onClick($event) {
        if (!this.isVisible) {
            this.showMenu();
        }
        else {
            this.hideMenu();
        }
    }
    showMenu() {
        if (this.overlayRef || this.disabled) {
            return;
        }
        this.isVisible = true;
        this.isVisible$.next(true);
        this.overlayRef = this.overlay.create({
            positionStrategy: this.getPositionStrategy(),
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
        });
        this.dropdownMenu.trigger = this;
        const templatePortal = new TemplatePortal(this.dropdownMenu.templateRef, this.viewContainerRef);
        this.overlayRef.attach(templatePortal);
        if (this.activeClass) {
            this.elementRef.nativeElement.classList.add(this.activeClass);
        }
        this.syncWidth();
    }
    hideMenu() {
        if (!this.overlayRef) {
            return;
        }
        this.isVisible = false;
        this.isVisible$.next(false);
        this.overlayRef.dispose();
        delete this.overlayRef;
        if (this.activeClass) {
            this.elementRef.nativeElement.classList.remove(this.activeClass);
        }
    }
    getPositionStrategy() {
        if (this.position === 'left') {
            return this.overlay.position()
                .flexibleConnectedTo(this.elementRef.nativeElement)
                .withFlexibleDimensions(true)
                .withPush(false)
                .withPositions([
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top'
                },
                {
                    originX: 'end',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'bottom'
                },
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top'
                },
                {
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'start',
                    overlayY: 'bottom'
                }
            ]);
        }
        else {
            return this.overlay.position()
                .flexibleConnectedTo(this.elementRef.nativeElement)
                .withFlexibleDimensions(true)
                .withPush(false)
                .withPositions([
                {
                    originX: 'end',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'top'
                },
                {
                    originX: 'end',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'bottom'
                },
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top'
                },
                {
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'start',
                    overlayY: 'bottom'
                }
            ]);
        }
    }
    syncWidth() {
        if (!this.overlayRef) {
            return;
        }
        const boundBox = this.elementRef.nativeElement.getBoundingClientRect();
        this.overlayRef.updateSize({
            minWidth: boundBox.width
        });
    }
}
DropdownTriggerDirective.ɵfac = function DropdownTriggerDirective_Factory(t) { return new (t || DropdownTriggerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DropdownTriggerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DropdownTriggerDirective, selectors: [["", "mtgDropdownTriggerFor", ""]], hostBindings: function DropdownTriggerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DropdownTriggerDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { position: ["mtgDropdownPosition", "position"], dropdownMenu: ["mtgDropdownTriggerFor", "dropdownMenu"], activeClass: ["mtgDropdownActiveClass", "activeClass"], disabled: ["mtgDropdownDisabled", "disabled"] } });
DropdownTriggerDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: Overlay },
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
DropdownTriggerDirective.propDecorators = {
    dropdownMenu: [{ type: Input, args: ['mtgDropdownTriggerFor',] }],
    position: [{ type: Input, args: ['mtgDropdownPosition',] }],
    activeClass: [{ type: Input, args: ['mtgDropdownActiveClass',] }],
    disabled: [{ type: Input, args: ['mtgDropdownDisabled',] }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownTriggerDirective, [{
        type: Directive,
        args: [{
                selector: '[mtgDropdownTriggerFor]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc2.Overlay }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { position: [{
            type: Input,
            args: ['mtgDropdownPosition']
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], dropdownMenu: [{
            type: Input,
            args: ['mtgDropdownTriggerFor']
        }], activeClass: [{
            type: Input,
            args: ['mtgDropdownActiveClass']
        }], disabled: [{
            type: Input,
            args: ['mtgDropdownDisabled']
        }] }); })();

class ButtonComponent {
    constructor(dropdown, cdr) {
        this.dropdown = dropdown;
        this.cdr = cdr;
        this.type = 'button';
        this.target = 'self';
    }
    get classButtonFluid() {
        return this.fluid;
    }
    get class() {
        const classes = ['button'];
        if (this.color === 'secondary') {
            classes.push('button--color-secondary');
        }
        else {
            classes.push('button--color-primary');
        }
        if (this.size === 'lg') {
            classes.push('button--size-lg');
        }
        else if (this.size === 'sm') {
            classes.push('button--size-sm');
        }
        else {
            classes.push('button--size-md');
        }
        if (this.variant === 'circle') {
            classes.push('button--variant-circle');
        }
        else if (this.variant === 'link') {
            classes.push('button--variant-link');
        }
        else if (this.variant === 'outline') {
            classes.push('button--variant-outline');
        }
        else {
            classes.push('button--variant-button');
        }
        if (this.dropdown) {
            classes.push('button--dropdown');
            if (this.dropdownVisible) {
                classes.push('button--dropdown-opened');
            }
        }
        if (this.fluid) {
            classes.push('button--fluid');
        }
        if (this.disabled) {
            classes.push('button--disabled');
        }
        return classes.join(' ');
    }
    ngOnInit() {
        if (this.dropdown) {
            this.dropdown.isVisible$.subscribe(isVisible => {
                this.dropdownVisible = isVisible;
                this.cdr.markForCheck();
            });
        }
    }
    get hasDropdown() {
        return Boolean(this.dropdown) && this.variant !== 'circle';
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(ɵngcc0.ɵɵdirectiveInject(DropdownTriggerDirective, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonComponent, selectors: [["mtg-button"]], viewQuery: function ButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.linkElement = _t.first);
    } }, hostVars: 2, hostBindings: function ButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("button--fluid", ctx.classButtonFluid);
    } }, inputs: { type: "type", target: "target", color: "color", size: "size", variant: "variant", leadingIcon: "leadingIcon", trailingIcon: "trailingIcon", href: "href", fluid: "fluid", disabled: "disabled" }, ngContentSelectors: _c2, decls: 5, vars: 3, consts: [[3, "href", "target", "classList", 4, "ngIf"], [3, "type", "classList", 4, "ngIf"], [3, "classList", 4, "ngIf"], ["content", ""], [3, "href", "target", "classList"], ["linkElement", ""], [3, "ngTemplateOutlet"], [3, "type", "classList"], [3, "classList"], ["class", "leading-icon", 3, "icon", 4, "ngIf"], ["icon", "icons-selector-down", "class", "trailing-icon dropdown-selector", 4, "ngIf"], ["class", "trailing-icon", 3, "icon", 4, "ngIf"], [1, "leading-icon", 3, "icon"], ["icon", "icons-selector-down", 1, "trailing-icon", "dropdown-selector"], [1, "trailing-icon", 3, "icon"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, ButtonComponent_a_0_Template, 3, 4, "a", 0);
        ɵngcc0.ɵɵtemplate(1, ButtonComponent_button_1_Template, 2, 3, "button", 1);
        ɵngcc0.ɵɵtemplate(2, ButtonComponent_label_2_Template, 2, 2, "label", 2);
        ɵngcc0.ɵɵtemplate(3, ButtonComponent_ng_template_3_Template, 4, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.href && ctx.variant !== "label");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.href && ctx.variant !== "label");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.variant === "label");
    } }, dependencies: function () { return [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, SvgIconComponent]; }, encapsulation: 2, changeDetection: 0 });
ButtonComponent.ctorParameters = () => [
    { type: DropdownTriggerDirective, decorators: [{ type: Optional }] },
    { type: ChangeDetectorRef }
];
ButtonComponent.propDecorators = {
    color: [{ type: Input }],
    size: [{ type: Input }],
    variant: [{ type: Input }],
    leadingIcon: [{ type: Input }],
    trailingIcon: [{ type: Input }],
    type: [{ type: Input }],
    href: [{ type: Input }],
    target: [{ type: Input }],
    fluid: [{ type: Input }],
    disabled: [{ type: Input }],
    linkElement: [{ type: ViewChild, args: ['linkElement', { read: ElementRef },] }],
    classButtonFluid: [{ type: HostBinding, args: ['class.button--fluid',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-button',
                template: "<a [href]=\"href\" [target]=\"target\" *ngIf=\"href && variant !== 'label'\" [classList]=\"class\" #linkElement>\n  <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n</a>\n<button [type]=\"type\" *ngIf=\"!href && variant !== 'label'\" [classList]=\"class\">\n  <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n</button>\n<label *ngIf=\"variant === 'label'\" [classList]=\"class\">\n  <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n</label>\n<ng-template #content>\n  <mtg-svg-icon class=\"leading-icon\" [icon]=\"leadingIcon\" *ngIf=\"leadingIcon\"></mtg-svg-icon>\n  <ng-content></ng-content>\n  <mtg-svg-icon *ngIf=\"hasDropdown\" icon=\"icons-selector-down\" class=\"trailing-icon dropdown-selector\"></mtg-svg-icon>\n  <mtg-svg-icon class=\"trailing-icon\" [icon]=\"trailingIcon\" *ngIf=\"trailingIcon && !hasDropdown\"></mtg-svg-icon>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: DropdownTriggerDirective, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, { type: [{
            type: Input
        }], target: [{
            type: Input
        }], classButtonFluid: [{
            type: HostBinding,
            args: ['class.button--fluid']
        }], color: [{
            type: Input
        }], size: [{
            type: Input
        }], variant: [{
            type: Input
        }], leadingIcon: [{
            type: Input
        }], trailingIcon: [{
            type: Input
        }], href: [{
            type: Input
        }], fluid: [{
            type: Input
        }], disabled: [{
            type: Input
        }], linkElement: [{
            type: ViewChild,
            args: ['linkElement', { read: ElementRef }]
        }] }); })();

class SvgIconComponent {
    constructor() {
        this.defaultClass = true;
    }
    get iconHref() {
        return `#${this.icon}`;
    }
}
SvgIconComponent.ɵfac = function SvgIconComponent_Factory(t) { return new (t || SvgIconComponent)(); };
SvgIconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SvgIconComponent, selectors: [["mtg-svg-icon"]], hostVars: 2, hostBindings: function SvgIconComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("svg-icon", ctx.defaultClass);
    } }, inputs: { icon: "icon" }, decls: 2, vars: 1, consts: [["viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"]], template: function SvgIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "use");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("href", ctx.iconHref, null, "xlink");
    } }, encapsulation: 2, changeDetection: 0 });
SvgIconComponent.propDecorators = {
    icon: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.svg-icon',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgIconComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-svg-icon',
                template: "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <use [attr.xlink:href]=\"iconHref\"></use>\n</svg>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.svg-icon']
        }], icon: [{
            type: Input
        }] }); })();

class SvgIconDefinitionsComponent {
}
SvgIconDefinitionsComponent.ɵfac = function SvgIconDefinitionsComponent_Factory(t) { return new (t || SvgIconDefinitionsComponent)(); };
SvgIconDefinitionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SvgIconDefinitionsComponent, selectors: [["mtg-svg-icon-definitions"]], decls: 247, vars: 0, consts: [["aria-hidden", "true", "version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", 2, "position", "absolute", "width", "0", "height", "0", "overflow", "hidden"], ["id", "icons-switcher", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"], ["id", "icons-date", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M6 3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3L8 4H16V3C16 2.44772 16.4477 2 17 2C17.5523 2 18 2.44772 18 3V4.12602C19.7252 4.57006 21 6.13616 21 8V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V8C3 6.13616 4.27477 4.57006 6 4.12602L6 3ZM5 16V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V16H5Z"], ["id", "icons-done", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M18.9476 7.08676C19.3524 7.46256 19.3758 8.09529 19 8.50001L11.2328 16.6804C11.0479 16.8795 10.7901 16.9948 10.5185 16.9998C10.2469 17.0049 9.98496 16.8992 9.79288 16.7071L5.50006 12.4142C5.10954 12.0237 5.10954 11.3905 5.50006 11C5.89059 10.6094 6.52375 10.6094 6.91427 11L10.4733 14.5591L17.5344 7.1391C17.9102 6.73439 18.5429 6.71096 18.9476 7.08676Z"], ["id", "icons-selector-down", "viewBox", "0 0 16 16", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M3 5H13L8 11L3 5Z"], ["id", "icons-selector-up", "viewBox", "0 0 16 16", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M13 11L3 11L8 5L13 11Z"], ["id", "icons-star-outline", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12.807 2.60164C12.6554 2.29446 12.3426 2.1 12 2.1C11.6574 2.1 11.3446 2.29446 11.193 2.60164L8.62117 7.81182L2.86984 8.65246C2.53093 8.702 2.24952 8.9396 2.14388 9.26541C2.03824 9.59122 2.12669 9.94874 2.37204 10.1877L6.53293 14.2404L5.55095 19.9659C5.49304 20.3035 5.63186 20.6448 5.90904 20.8461C6.18622 21.0475 6.55368 21.074 6.85691 20.9146L12 18.2099L17.1431 20.9146C17.4463 21.074 17.8138 21.0475 18.091 20.8461C18.3681 20.6448 18.507 20.3035 18.449 19.9659L17.4671 14.2404L21.628 10.1877C21.8733 9.94874 21.9618 9.59122 21.8561 9.26541C21.7505 8.9396 21.4691 8.702 21.1302 8.65246L15.3788 7.81182L12.807 2.60164ZM10.026 9.03236L12 5.03333L13.974 9.03236C14.105 9.29772 14.358 9.48174 14.6508 9.52454L19.0664 10.1699L15.872 13.2813C15.6598 13.488 15.5629 13.7861 15.613 14.0781L16.3666 18.4725L12.4189 16.3964C12.1567 16.2585 11.8433 16.2585 11.5811 16.3964L7.63336 18.4725L8.38705 14.0781C8.43714 13.7861 8.34025 13.488 8.12796 13.2813L4.93357 10.1699L9.34917 9.52454C9.64199 9.48174 9.89505 9.29772 10.026 9.03236Z"], ["id", "icons-star-filled", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M12 2.1C12.3426 2.1 12.6554 2.29446 12.807 2.60164L15.3788 7.81182L21.1302 8.65246C21.4691 8.702 21.7505 8.9396 21.8561 9.26541C21.9618 9.59122 21.8733 9.94874 21.628 10.1877L17.4671 14.2404L18.449 19.9659C18.507 20.3035 18.3681 20.6448 18.091 20.8461C17.8138 21.0475 17.4463 21.074 17.1431 20.9146L12 18.2099L6.85691 20.9146C6.55368 21.074 6.18622 21.0475 5.90904 20.8461C5.63186 20.6448 5.49304 20.3035 5.55095 19.9659L6.53293 14.2404L2.37204 10.1877C2.12669 9.94874 2.03824 9.59122 2.14388 9.26541C2.24952 8.9396 2.53093 8.702 2.86984 8.65246L8.62117 7.81182L11.193 2.60164C11.3446 2.29446 11.6574 2.1 12 2.1Z"], ["id", "icons-enter", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M7 6C7 5.44772 7.44772 5 8 5H16C16.5523 5 17 5.44772 17 6V18C17 18.5523 16.5523 19 16 19H8C7.44772 19 7 18.5523 7 18V16C7 15.4477 6.55228 15 6 15C5.44772 15 5 15.4477 5 16V18C5 19.6569 6.34315 21 8 21H16C17.6569 21 19 19.6569 19 18V6C19 4.34315 17.6569 3 16 3H8C6.34315 3 5 4.34315 5 6V7V8V10C5 11.6569 6.34315 13 8 13H10V15L14 12L10 9V11H8C7.44772 11 7 10.5523 7 10V8V7V6Z"], ["id", "icons-close", "viewBox", "0 0 16 16", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L8 6.58579L11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289C13.0976 3.68342 13.0976 4.31658 12.7071 4.70711L9.41421 8L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L8 9.41421L4.70711 12.7071C4.31658 13.0976 3.68342 13.0976 3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L6.58579 8L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z"], ["id", "icons-printer", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M 20.484375 6.046875 L 19.828125 6.046875 L 19.828125 3.515625 C 19.828125 1.578125 18.25 0 16.3125 0 L 7.6875 0 C 5.75 0 4.171875 1.578125 4.171875 3.515625 L 4.171875 6.046875 L 3.515625 6.046875 C 1.578125 6.046875 0 7.625 0 9.5625 L 0 15.1875 C 0 17.125 1.578125 18.703125 3.515625 18.703125 L 4.171875 18.703125 L 4.171875 21.890625 C 4.171875 23.054688 5.117188 24 6.28125 24 L 17.71875 24 C 18.882812 24 19.828125 23.054688 19.828125 21.890625 L 19.828125 18.703125 L 20.484375 18.703125 C 22.421875 18.703125 24 17.125 24 15.1875 L 24 9.5625 C 24 7.625 22.421875 6.046875 20.484375 6.046875 Z M 5.578125 3.515625 C 5.578125 2.351562 6.523438 1.40625 7.6875 1.40625 L 16.3125 1.40625 C 17.476562 1.40625 18.421875 2.351562 18.421875 3.515625 L 18.421875 6.046875 L 5.578125 6.046875 Z M 18.421875 21.890625 C 18.421875 22.277344 18.105469 22.59375 17.71875 22.59375 L 6.28125 22.59375 C 5.894531 22.59375 5.578125 22.277344 5.578125 21.890625 L 5.578125 14.953125 L 18.421875 14.953125 Z M 22.59375 15.1875 C 22.59375 16.351562 21.648438 17.296875 20.484375 17.296875 L 19.828125 17.296875 L 19.828125 14.953125 L 20.25 14.953125 C 20.636719 14.953125 20.953125 14.636719 20.953125 14.25 C 20.953125 13.863281 20.636719 13.546875 20.25 13.546875 L 3.75 13.546875 C 3.363281 13.546875 3.046875 13.863281 3.046875 14.25 C 3.046875 14.636719 3.363281 14.953125 3.75 14.953125 L 4.171875 14.953125 L 4.171875 17.296875 L 3.515625 17.296875 C 2.351562 17.296875 1.40625 16.351562 1.40625 15.1875 L 1.40625 9.5625 C 1.40625 8.398438 2.351562 7.453125 3.515625 7.453125 L 20.484375 7.453125 C 21.648438 7.453125 22.59375 8.398438 22.59375 9.5625 Z M 22.59375 15.1875 "], ["d", "M 13.875 16.546875 L 10.125 16.546875 C 9.738281 16.546875 9.421875 16.863281 9.421875 17.25 C 9.421875 17.636719 9.738281 17.953125 10.125 17.953125 L 13.875 17.953125 C 14.261719 17.953125 14.578125 17.636719 14.578125 17.25 C 14.578125 16.863281 14.261719 16.546875 13.875 16.546875 Z M 13.875 16.546875 "], ["d", "M 13.875 19.546875 L 10.125 19.546875 C 9.738281 19.546875 9.421875 19.863281 9.421875 20.25 C 9.421875 20.636719 9.738281 20.953125 10.125 20.953125 L 13.875 20.953125 C 14.261719 20.953125 14.578125 20.636719 14.578125 20.25 C 14.578125 19.863281 14.261719 19.546875 13.875 19.546875 Z M 13.875 19.546875 "], ["d", "M 6 9.046875 L 3.75 9.046875 C 3.363281 9.046875 3.046875 9.363281 3.046875 9.75 C 3.046875 10.136719 3.363281 10.453125 3.75 10.453125 L 6 10.453125 C 6.386719 10.453125 6.703125 10.136719 6.703125 9.75 C 6.703125 9.363281 6.386719 9.046875 6 9.046875 Z M 6 9.046875 "], ["id", "icons-corner-right", "viewBox", "0 0 16 16", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M5.27337 2.27036C4.90888 2.63085 4.90888 3.21531 5.27337 3.57579L9.74673 8L5.27337 12.4242C4.90888 12.7847 4.90888 13.3692 5.27337 13.7296C5.63786 14.0901 6.22881 14.0901 6.5933 13.7296L11.7266 8.65271C12.0911 8.29223 12.0911 7.70777 11.7266 7.34729L6.5933 2.27036C6.22881 1.90988 5.63786 1.90988 5.27337 2.27036Z"], ["id", "icons-corner-left", "viewBox", "0 0 16 16", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M10.7266 2.27036C11.0911 2.63085 11.0911 3.21531 10.7266 3.57579L6.25327 8L10.7266 12.4242C11.0911 12.7847 11.0911 13.3692 10.7266 13.7296C10.3621 14.0901 9.77119 14.0901 9.4067 13.7296L4.27337 8.65271C3.90888 8.29223 3.90888 7.70777 4.27337 7.34729L9.4067 2.27036C9.77119 1.90988 10.3621 1.90988 10.7266 2.27036Z"], ["id", "icons-facebook", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M13.1133 21.2885V12.0547H15.6622L16 8.87263H13.1133L13.1176 7.28C13.1176 6.45007 13.1965 6.00538 14.3885 6.00538H15.982V2.823H13.4327C10.3705 2.823 9.29276 4.36662 9.29276 6.96251V8.87299H7.38403V12.055H9.29276V21.2885H13.1133Z"], ["id", "icons-vkontakte", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M12.9808 18.1533C12.9808 18.1533 13.3417 18.1139 13.5266 17.919C13.6958 17.7404 13.69 17.4033 13.69 17.4033C13.69 17.4033 13.6675 15.8296 14.4119 15.5972C15.1455 15.3687 16.0876 17.1191 17.0873 17.7922C17.8425 18.3011 18.4157 18.1897 18.4157 18.1897L21.0872 18.1533C21.0872 18.1533 22.484 18.0688 21.8218 16.9904C21.767 16.9021 21.4354 16.1925 19.836 14.7349C18.1604 13.2092 18.3854 13.4559 20.4024 10.8163C21.6311 9.20895 22.1221 8.22762 21.9685 7.80801C21.8228 7.40665 20.9189 7.51323 20.9189 7.51323L17.9119 7.53147C17.9119 7.53147 17.6889 7.50171 17.5236 7.59869C17.3622 7.69375 17.2575 7.91556 17.2575 7.91556C17.2575 7.91556 16.7821 9.15902 16.1472 10.2172C14.8081 12.4487 14.273 12.5668 14.0539 12.4285C13.5442 12.1049 13.6714 11.1303 13.6714 10.438C13.6714 8.27467 14.0059 7.37304 13.0209 7.13971C12.6942 7.06194 12.4535 7.01104 11.6172 7.0024C10.5441 6.99184 9.63628 7.00624 9.12175 7.25302C8.77937 7.41721 8.51526 7.78401 8.67666 7.80513C8.87524 7.83106 9.32521 7.9242 9.5639 8.24299C9.87203 8.65491 9.86127 9.57863 9.86127 9.57863C9.86127 9.57863 10.0383 12.1251 9.44749 12.441C9.04251 12.658 8.48689 12.2153 7.2925 10.1903C6.68112 9.15326 6.21941 8.00678 6.21941 8.00678C6.21941 8.00678 6.13039 7.79265 5.97094 7.67743C5.77824 7.5382 5.50923 7.49499 5.50923 7.49499L2.65189 7.51323C2.65189 7.51323 2.22246 7.52475 2.06497 7.70815C1.92508 7.87043 2.05421 8.20746 2.05421 8.20746C2.05421 8.20746 4.29136 13.3455 6.82492 15.9352C9.14816 18.3088 11.7854 18.1533 11.7854 18.1533H12.9808Z"], ["id", "icons-vs", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M3.29184 3.36914L7.99403 15.0831H10.2537L11.462 12.0731C11.5025 12.3626 11.5709 12.626 11.6671 12.8634C11.8444 13.2622 12.1157 13.5945 12.4813 13.8603C12.8579 14.1262 13.2511 14.3422 13.661 14.5083C14.0708 14.6634 14.6081 14.824 15.2727 14.9902C16.2142 15.2339 16.8401 15.461 17.1502 15.6714C17.4604 15.8708 17.6155 16.1367 17.6155 16.469C17.6155 16.8234 17.4659 17.1004 17.1669 17.2998C16.8678 17.4991 16.4579 17.5988 15.9373 17.5988C14.7631 17.5988 13.6056 17.1281 12.4647 16.1865L10.9527 17.9976C12.3373 19.2382 13.9822 19.8585 15.8875 19.8585C17.1724 19.8585 18.2026 19.5428 18.9779 18.9115C19.7644 18.269 20.1576 17.3828 20.1576 16.253C20.1576 15.2782 19.8586 14.5305 19.2604 14.0099C18.6623 13.4893 17.7318 13.0628 16.469 12.7305C15.4388 12.4646 14.7631 12.2376 14.4419 12.0492C14.1207 11.8609 13.9601 11.5785 13.9601 11.2019C13.9601 10.8917 14.0874 10.6425 14.3422 10.4542C14.6081 10.2548 14.9791 10.1551 15.4555 10.1551C16.3748 10.1551 17.3829 10.5372 18.4795 11.3016L19.8087 9.37415C18.5792 8.3883 17.1392 7.89537 15.4887 7.89537C14.4408 7.89537 13.5586 8.14183 12.8422 8.63476L14.9559 3.36914H12.1978L9.15712 11.5606L6.11648 3.36914H3.29184Z"], ["id", "icons-burger", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 1024 1024"], ["d", "M250.665 288h522.666c20.62 0 37.335 16.715 37.335 37.335s-16.715 37.335-37.335 37.335h-522.666c-20.62 0-37.335-16.715-37.335-37.335s16.715-37.335 37.335-37.335z"], ["d", "M250.665 474.665h522.666c20.62 0 37.335 16.715 37.335 37.335s-16.715 37.335-37.335 37.335h-522.666c-20.62 0-37.335-16.715-37.335-37.335s16.715-37.335 37.335-37.335z"], ["d", "M250.665 661.335h522.666c20.62 0 37.335 16.715 37.335 37.335s-16.715 37.335-37.335 37.335h-522.666c-20.62 0-37.335-16.715-37.335-37.335s16.715-37.335 37.335-37.335z"], ["id", "icons-cloud-download", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M9.3336 8.46237C10.0993 6.4567 12.1114 5 14.5 5C17.5708 5 20 7.39519 20 10.2769C20 11.441 19.6082 12.5172 18.9391 13.3929C18.6038 13.8317 18.6877 14.4593 19.1266 14.7946C19.5654 15.1299 20.193 15.046 20.5283 14.6071C21.451 13.3996 22 11.9005 22 10.2769C22 6.22537 18.6089 3 14.5 3C11.6139 3 9.0915 4.58527 7.83819 6.9309C7.5652 6.88603 7.28511 6.86273 7 6.86273C4.27178 6.86273 2 9.00722 2 11.7255C2 12.8035 2.36174 13.7995 2.96883 14.6029C3.30179 15.0435 3.92891 15.1308 4.36954 14.7978C4.81017 14.4649 4.89746 13.8378 4.5645 13.3971C4.20732 12.9244 4 12.3481 4 11.7255C4 10.177 5.30994 8.86273 7 8.86273C7.37537 8.86273 7.73216 8.92812 8.06009 9.04639C8.57282 9.23132 9.1392 8.97158 9.3336 8.46237ZM9.70711 15.7929C9.31658 15.4024 8.68342 15.4024 8.29289 15.7929C7.90237 16.1834 7.90237 16.8166 8.29289 17.2071L11.2929 20.2071C11.6834 20.5976 12.3166 20.5976 12.7071 20.2071L15.7071 17.2071C16.0976 16.8166 16.0976 16.1834 15.7071 15.7929C15.3166 15.4024 14.6834 15.4024 14.2929 15.7929L13 17.0858V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V17.0858L9.70711 15.7929Z"], ["id", "icons-full-screen", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M8.06633 18.0663L10.1464 20.1464C10.4614 20.4614 10.2383 21 9.79289 21H3.5C3.22386 21 3 20.7761 3 20.5V14.2071C3 13.7617 3.53857 13.5386 3.85355 13.8536L5.94501 15.945L8.3354 13.5546C8.53066 13.3594 8.84724 13.3594 9.0425 13.5546L10.4567 14.9688C10.652 15.1641 10.652 15.4807 10.4567 15.6759L8.06633 18.0663Z"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M15.9337 5.93369L13.8536 3.85357C13.5386 3.53858 13.7617 3.00001 14.2071 3.00001H20.5C20.7761 3.00001 21 3.22387 21 3.50001V9.79291C21 10.2384 20.4614 10.4614 20.1464 10.1465L18.055 8.05501L16.0182 10.0918C15.6276 10.4824 14.9945 10.4824 14.6039 10.0918L13.8968 9.38473C13.5063 8.99421 13.5063 8.36105 13.8968 7.97052L15.9337 5.93369Z"], ["id", "icons-full-screen-off", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M5.53682 16.3418L3.4567 14.2617C3.14172 13.9467 3.3648 13.4082 3.81026 13.4082H10.1031C10.3793 13.4082 10.6031 13.632 10.6031 13.9082V20.2011C10.6031 20.6465 10.0646 20.8696 9.7496 20.5546L7.65814 18.4632L5.26775 20.8536C5.07249 21.0488 4.75591 21.0488 4.56065 20.8536L3.14643 19.4393C2.95117 19.2441 2.95117 18.9275 3.14643 18.7322L5.53682 16.3418Z"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M18.6703 7.45105L20.7504 9.53117C21.0654 9.84615 20.8423 10.3847 20.3968 10.3847H14.1039C13.8278 10.3847 13.6039 10.1609 13.6039 9.88472V3.59183C13.6039 3.14637 14.1425 2.92329 14.4575 3.23827L16.549 5.32973L18.5858 3.29289C18.9763 2.90237 19.6095 2.90237 20 3.29289L20.7071 4C21.0976 4.39052 21.0976 5.02369 20.7071 5.41421L18.6703 7.45105Z"], ["id", "icons-settings", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M9 9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9ZM9 5C10.3062 5 11.4175 5.83481 11.8293 7H19C19.5523 7 20 7.44772 20 8C20 8.55228 19.5523 9 19 9H11.8293C11.4175 10.1652 10.3062 11 9 11C7.68867 11 6.57385 10.1586 6.1659 8.9863C6.11194 8.99531 6.05652 9 6 9H5C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7H6C6.05652 7 6.11194 7.00469 6.1659 7.0137C6.57385 5.84136 7.68867 5 9 5ZM18 17C17.4477 17 17 16.5523 17 16C17 15.4477 17.4477 15 18 15C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17ZM15.1707 17C15.5825 18.1652 16.6938 19 18 19C19.6569 19 21 17.6569 21 16C21 14.3431 19.6569 13 18 13C16.6938 13 15.5825 13.8348 15.1707 15H5C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H15.1707Z"], ["id", "icons-media", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M6 3H12C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19H18C19.6569 19 21 17.6569 21 16V8C21 6.34315 19.6569 5 18 5C17.4477 5 17 4.55228 17 4C17 3.44772 17.4477 3 18 3C20.7614 3 23 5.23858 23 8V16C23 18.7614 20.7614 21 18 21H6C3.23858 21 1 18.7614 1 16V8C1 5.23858 3.23858 3 6 3ZM9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5Z"], ["id", "icons-close-circle", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9.70711 8.29289C9.31658 7.90237 8.68342 7.90237 8.29289 8.29289C7.90237 8.68342 7.90237 9.31658 8.29289 9.70711L10.5858 12L8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071C8.68342 16.0976 9.31658 16.0976 9.70711 15.7071L12 13.4142L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13.4142 12L15.7071 9.70711C16.0976 9.31658 16.0976 8.68342 15.7071 8.29289C15.3166 7.90237 14.6834 7.90237 14.2929 8.29289L12 10.5858L9.70711 8.29289Z"], ["id", "icons-valleyball", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4 5.99903C2.74418 7.67051 2 9.74835 2 12C2 13.5841 2.36832 15.0821 3.024 16.4132C4.30473 16.0296 5.50843 15.4675 6.60625 14.7557C4.95846 12.2398 4 9.23066 4 6C4 5.99968 4 5.99935 4 5.99903ZM8.20648 13.5475C9.09769 12.7689 9.88945 11.8791 10.5602 10.8995C9.55986 8.80946 9 6.46887 9 4C9 3.47192 9.02562 2.94964 9.0757 2.43436C8.01839 2.75719 7.03547 3.25051 6.15899 3.88228C6.05432 4.57254 6 5.2797 6 6C6 8.78061 6.80971 11.3699 8.20648 13.5475ZM21.7654 14.1634C19.2415 11.8668 15.9788 10.3653 12.3749 10.0584C11.9141 9.09999 11.5592 8.08087 11.3255 7.01595C11.5489 7.00536 11.7738 7 12 7C15.8998 7 19.4273 8.59457 21.9658 11.1673C21.9885 11.4419 22 11.7196 22 12C22 12.7428 21.919 13.4668 21.7654 14.1634ZM12 5C11.6768 5 11.3558 5.0096 11.0372 5.02853C11.0125 4.68895 11 4.34597 11 4C11 3.33334 11.0465 2.67794 11.1364 2.03677C11.4211 2.01242 11.7091 2 12 2C16.0359 2 19.5133 4.39083 21.0933 7.83344C18.5111 6.0467 15.3778 5 12 5ZM21.052 16.2554C19.4533 19.6502 16.001 22 12 22C11.1058 22 10.2389 21.8826 9.41411 21.6624C13.0216 20.082 15.9335 17.2094 17.5651 13.6315C18.862 14.3213 20.0377 15.2093 21.052 16.2554ZM12.196 12.0505C10.2562 14.8735 7.43254 17.0441 4.12351 18.162C4.84642 19.0847 5.72796 19.8772 6.72708 20.4984C10.7391 19.3932 14.0305 16.5471 15.7363 12.8214C14.6155 12.4185 13.4284 12.1547 12.196 12.0505Z"], ["id", "icons-search", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M6.75736 5.75736C9.10051 3.41421 12.8995 3.41421 15.2426 5.75736C17.5858 8.1005 17.5858 11.8995 15.2426 14.2426C12.8995 16.5858 9.1005 16.5858 6.75736 14.2426C4.41421 11.8995 4.41421 8.1005 6.75736 5.75736ZM16.6569 4.34315C13.5327 1.21895 8.46734 1.21895 5.34315 4.34315C2.21895 7.46734 2.21895 12.5327 5.34315 15.6569C8.05307 18.3668 12.2235 18.7261 15.3207 16.7349L20.3033 21.7174C20.6938 22.108 21.327 22.108 21.7175 21.7174C22.108 21.3269 22.108 20.6938 21.7175 20.3032L16.8603 15.446C19.7795 12.3087 19.7117 7.39799 16.6569 4.34315Z"], ["id", "icons-basketball", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M7.99895 2.83255C6.29783 3.57603 4.84353 4.77912 3.79302 6.28485C4.8337 6.0977 5.90544 6 7 6C7.21739 6 7.43389 6.00385 7.64942 6.0115C7.87866 5.04496 8 4.03665 8 3C8 2.9441 7.99965 2.88828 7.99895 2.83255ZM7.00367 8C7.00245 8 7.00122 8 7 8C5.46927 8 3.98874 8.21496 2.58696 8.61634C2.20703 9.67312 2 10.8124 2 12C2 12.6306 2.05836 13.2475 2.16998 13.8457C4.30903 12.4287 6.00455 10.3959 7.00367 8ZM9.97926 2.20427C10.6319 2.07034 11.3077 2 12 2C13.0097 2 13.9844 2.14963 14.9032 2.42793L12.9869 7.01963C11.9201 6.64349 10.8072 6.36505 9.659 6.19503C9.88236 5.16546 10 4.09647 10 3C10 2.73307 9.99303 2.46777 9.97926 2.20427ZM2.76285 15.8376C5.663 14.0801 7.91996 11.3676 9.09757 8.13626C10.1741 8.27722 11.2169 8.5252 12.2151 8.86916L7.23792 20.7955C5.2348 19.7087 3.64458 17.9575 2.76285 15.8376ZM12 22C10.9852 22 10.0057 21.8488 9.0828 21.5678L14.0612 9.63846C14.9092 10.0562 15.7148 10.5468 16.4699 11.1021C14.9071 13.522 14 16.4051 14 19.5C14 20.2694 14.0561 21.0258 14.1643 21.7652C13.4674 21.9189 12.7432 22 12 22ZM17.6609 9.49523C16.7765 8.84411 15.8304 8.27195 14.833 7.78912L16.7492 3.19751C18.322 4.0479 19.6412 5.30755 20.5638 6.83373C19.4867 7.59504 18.511 8.49029 17.6609 9.49523ZM16 19.5C16 16.8941 16.7384 14.4606 18.0173 12.3974C19.2112 13.5315 20.2303 14.8479 21.0299 16.3021C20.0111 18.4367 18.2577 20.1533 16.0968 21.125C16.0329 20.5923 16 20.05 16 19.5ZM19.2036 10.7684C20.1898 11.6785 21.0741 12.6974 21.8373 13.8062C21.9442 13.2203 22 12.6167 22 12C22 10.8339 21.8004 9.71446 21.4335 8.67391C20.6133 9.28603 19.865 9.98918 19.2036 10.7684Z"], ["id", "icons-share", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M19 5.5C19 6.88071 17.8807 8 16.5 8C15.1193 8 14 6.88071 14 5.5C14 4.11929 15.1193 3 16.5 3C17.8807 3 19 4.11929 19 5.5ZM12.5145 9.25749C12.9881 8.97334 13.1416 8.35908 12.8575 7.8855C12.5733 7.41192 11.9591 7.25836 11.4855 7.54251L7.70653 9.80989C7.34881 9.6124 6.93753 9.5 6.5 9.5C5.11929 9.5 4 10.6193 4 12C4 13.3807 5.11929 14.5 6.5 14.5C6.8992 14.5 7.27655 14.4064 7.61131 14.24L14.0022 18.3941C14.0007 18.4292 14 18.4645 14 18.5C14 19.8807 15.1193 21 16.5 21C17.8807 21 19 19.8807 19 18.5C19 17.1193 17.8807 16 16.5 16C15.8872 16 15.3259 16.2205 14.891 16.5865L8.90244 12.6939C8.96596 12.4736 9 12.2408 9 12C9 11.7962 8.97561 11.5981 8.9296 11.4084L12.5145 9.25749Z"], ["id", "icons-edit", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M13.5557 5.28411C14.1509 4.25944 15.4691 3.90836 16.5 4.49996C17.5309 5.09155 17.8841 6.4018 17.2889 7.42647L11 17.5C10.2772 18.7444 8.45342 19.947 7.35936 20.4112C6.67629 20.7009 6.55057 20.4831 6.55057 19.947C6.55057 19.6338 6.5466 16.5974 7.26674 15.3576L13.5557 5.28411Z"], ["id", "icons-change", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M18.738 15.4396C19.2633 15.6102 19.5507 16.1744 19.38 16.6997L18.069 20.7346C17.8983 21.2599 17.3342 21.5473 16.8089 21.3767C16.2837 21.206 15.9962 20.6419 16.1669 20.1166L16.7006 18.474C15.3814 19.4334 13.7568 20.0001 12 20.0001C9.08871 20.0001 6.54174 18.4444 5.14344 16.1237C4.85841 15.6507 5.01083 15.0361 5.48388 14.7511C5.95693 14.4661 6.57147 14.6185 6.8565 15.0915C7.90798 16.8366 9.81861 18.0001 12 18.0001C13.4644 18.0001 14.8062 17.4761 15.8485 16.6036L14.085 16.0306C13.5597 15.86 13.2723 15.2958 13.4429 14.7706C13.6136 14.2453 14.1778 13.9579 14.703 14.1285L18.738 15.4396ZM5.29692 8.54894C4.77166 8.37828 4.48421 7.81413 4.65488 7.28887L5.96593 3.25388C6.13659 2.72863 6.70075 2.44118 7.226 2.61184C7.75125 2.78251 8.0387 3.34666 7.86804 3.87191L7.34016 5.49657C8.652 4.55513 10.2612 4 11.9998 4C14.9111 4 17.4581 5.55572 18.8564 7.8764C19.1414 8.34945 18.989 8.96399 18.516 9.24902C18.0429 9.53405 17.4284 9.38163 17.1433 8.90858C16.0919 7.16351 14.1812 6 11.9998 6C10.5447 6 9.21068 6.51737 8.17122 7.37994L9.94994 7.95788C10.4752 8.12854 10.7626 8.6927 10.592 9.21795C10.4213 9.74321 9.85716 10.0307 9.33191 9.85999L5.29692 8.54894ZM17.8 12C17.8 11.3373 18.3373 10.8 19 10.8C19.6628 10.8 20.2 11.3373 20.2 12C20.2 12.6627 19.6628 13.2 19 13.2C18.3373 13.2 17.8 12.6627 17.8 12ZM3.80001 12C3.80001 11.3373 4.33727 10.8 5.00001 10.8C5.66275 10.8 6.20001 11.3373 6.20001 12C6.20001 12.6627 5.66275 13.2 5.00001 13.2C4.33727 13.2 3.80001 12.6627 3.80001 12Z"], ["id", "icons-next", "viewBox", "0 0 1024 1024", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M426.667 213.333l469.333 298.667-469.333 298.667v-597.333z"], ["d", "M256 213.333c23.564 0 42.667 19.103 42.667 42.667v512c0 23.564-19.103 42.667-42.667 42.667s-42.667-19.103-42.667-42.667v-512c0-23.564 19.103-42.667 42.667-42.667z"], ["id", "icons-alert", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M10.1811 4.99179C10.0838 3.9222 10.926 3 12 3C13.074 3 13.9162 3.9222 13.8189 4.99179L13.0905 13.0041C13.0393 13.5681 12.5664 14 12 14C11.4336 14 10.9607 13.5681 10.9095 13.0041L10.1811 4.99179Z"], ["cx", "12", "cy", "18", "r", "1.5"], ["id", "icons-finish", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M18.2348 3.74143C18.3777 3.20796 18.9261 2.89138 19.4595 3.03432C19.993 3.17726 20.3096 3.7256 20.1666 4.25907L15.5638 21.437C15.4209 21.9705 14.8725 22.2871 14.3391 22.1441C13.8056 22.0012 13.489 21.4529 13.632 20.9194L15.1012 15.436C13.9315 15.2167 13.103 15.2246 12.4546 15.3266C11.7203 15.4422 11.1601 15.6842 10.4761 15.9796L10.4415 15.9946C9.74604 16.2949 8.93858 16.6382 7.85855 16.7834C6.77869 16.9284 5.4871 16.8694 3.77514 16.4744C3.50372 16.4117 3.27073 16.2387 3.13227 15.997C2.99382 15.7553 2.96246 15.4668 3.04575 15.201C3.48463 13.8002 3.92448 12.2555 4.36887 10.6947L4.37108 10.6869L4.37109 10.6869L4.37109 10.6869C4.81308 9.1344 5.25957 7.56611 5.70703 6.13796C5.84842 5.6867 6.28657 5.39617 6.75728 5.44156C8.11391 5.57238 9.0263 5.46388 9.73805 5.27659C10.3032 5.12788 10.7446 4.93373 11.2543 4.70958L11.2543 4.70957C11.4194 4.63697 11.5916 4.56122 11.7776 4.48285C12.5218 4.16913 13.3653 3.87523 14.5224 3.79865C15.4966 3.73418 16.6529 3.826 18.1268 4.14446L18.2348 3.74143ZM6.40633 10.8423C8.83024 11.0537 9.68318 10.7631 10.9756 10.1414L9.77177 14.1052C10.4201 13.8248 11.1737 13.5036 12.1437 13.351C12.9842 13.2187 13.9496 13.2164 15.15 13.414C15.3332 12.814 15.5725 11.9911 15.8423 11.0637L15.8423 11.0635L15.8424 11.0632L15.8426 11.0624C15.9324 10.7538 16.0255 10.4337 16.121 10.1064C16.1931 9.85942 16.2664 9.609 16.3403 9.35744C13.8445 8.86381 12.3497 9.1965 10.9756 10.1414L12.1481 6.5025C12.146 6.50343 12.1439 6.50436 12.1418 6.50529C11.6073 6.74104 10.9796 7.01797 10.247 7.21075C9.45712 7.4186 8.54357 7.5353 7.38351 7.48889C7.05913 8.55765 6.73388 9.69261 6.40633 10.8423Z"], ["id", "icons-trash", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M10.1671 4.85219C10.3985 4.50436 10.8887 4 12 4C13.1113 4 13.6015 4.50436 13.8329 4.85219C14.1805 5.37459 14.8496 6 15.7808 6H17H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H17H15.7816C15.7762 3.99927 15.7511 3.99398 15.7048 3.96282C15.641 3.91988 15.5652 3.84531 15.4981 3.74438C14.9626 2.93945 13.8927 2 12 2C10.1073 2 9.03741 2.93945 8.5019 3.74438C8.43475 3.84531 8.35903 3.91988 8.29523 3.96282C8.24894 3.99398 8.22381 3.99927 8.2184 4H7H5C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6H7H8.21922C9.15037 6 9.81951 5.37459 10.1671 4.85219ZM5.46997 10C5.46997 9.44772 5.91769 9 6.46997 9H17.53C18.0823 9 18.53 9.44772 18.53 10L17.6656 18.28C17.5211 19.8216 16.2271 21 14.6787 21H9.32126C7.77289 21 6.47888 19.8216 6.33436 18.28L5.46997 10ZM10.7071 12.2929C10.3166 11.9024 9.68342 11.9024 9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071L10.5858 15L9.29289 16.2929C8.90237 16.6834 8.90237 17.3166 9.29289 17.7071C9.68342 18.0976 10.3166 18.0976 10.7071 17.7071L12 16.4142L13.2929 17.7071C13.6834 18.0976 14.3166 18.0976 14.7071 17.7071C15.0976 17.3166 15.0976 16.6834 14.7071 16.2929L13.4142 15L14.7071 13.7071C15.0976 13.3166 15.0976 12.6834 14.7071 12.2929C14.3166 11.9024 13.6834 11.9024 13.2929 12.2929L12 13.5858L10.7071 12.2929Z"], ["id", "icons-plus", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12 5.34315C12.5523 5.34315 13 5.79086 13 6.34315L13 11H17.6568C18.2091 11 18.6568 11.4477 18.6568 12C18.6568 12.5523 18.2091 13 17.6568 13L13 13V17.6569C13 18.2091 12.5523 18.6569 12 18.6569C11.4477 18.6569 11 18.2091 11 17.6569V13L6.34314 13C5.79085 13 5.34314 12.5523 5.34314 12C5.34314 11.4477 5.79085 11 6.34314 11H11V6.34315C11 5.79086 11.4477 5.34315 12 5.34315Z"], ["id", "icons-play", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M7 4L20 12L7 20V4Z"], ["id", "icons-color", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M17.1716 11.9999L11 5.82837L4.82844 11.9999H17.1716ZM12.4142 4.41416C11.6332 3.63311 10.3668 3.63311 9.58579 4.41416L3.22183 10.7781C2.44079 11.5592 2.44079 12.8255 3.22183 13.6065L9.58579 19.9705C10.3668 20.7516 11.6332 20.7516 12.4142 19.9705L18.7782 13.6065C19.5592 12.8255 19.5592 11.5592 18.7782 10.7781L12.4142 4.41416ZM20 14.4003C19.8415 14.4003 19.6829 14.4768 19.5859 14.6288C18.9999 15.5448 18 17.2219 18 17.9999C18 19.0999 18.9 19.9999 20 19.9999C21.1 19.9999 22 19.0999 22 17.9999C22 17.2219 21.0001 15.5448 20.4141 14.6288C20.3171 14.4768 20.1585 14.4003 20 14.4003Z"], ["id", "icons-pause", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M8.5 5C7.67157 5 7 5.67157 7 6.5V17.5C7 18.3284 7.67157 19 8.5 19C9.32843 19 10 18.3284 10 17.5V6.5C10 5.67157 9.32843 5 8.5 5ZM15.5 5C14.6716 5 14 5.67157 14 6.5V17.5C14 18.3284 14.6716 19 15.5 19C16.3284 19 17 18.3284 17 17.5V6.5C17 5.67157 16.3284 5 15.5 5Z"], ["id", "icons-award-left", "viewBox", "0 0 80 80", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M36.4862 14.6976C37.0497 8.53084 42.136 2.75984 48.1637 1.26213C45.8649 6.67919 41.304 11.4711 36.4862 14.6976ZM27.0695 35.0798L26.6596 37.177C26.5773 37.6241 26.8326 38.0512 27.2772 38.104C27.7015 38.1796 28.1348 37.8511 28.2131 37.4189L28.6236 35.3279C33.358 33.0695 36.352 28.9029 38.8304 24.5034C34.0247 24.5231 29.8066 28.7885 28.2926 33.0346C28.29 33.0339 28.2876 33.0324 28.2851 33.0309C28.2824 33.0292 28.2795 33.0274 28.2761 33.0265C28.9114 28.2443 28.8403 22.5867 26.4523 18.2206C24.2185 23.4554 22.8187 30.4088 27.0695 35.0798ZM31.6267 25.8109C31.2032 25.6304 31.0049 25.1529 31.2198 24.7325L32.0898 22.928C28.1328 16.0903 34.449 6.679 34.696 6.97445C35.8792 11.6686 35.3556 16.6064 33.7251 21.1201C33.7346 21.1234 33.7435 21.1275 33.7527 21.1317C33.7584 21.1343 33.7642 21.137 33.7704 21.1396C36.0483 17.7007 41.0083 14.3467 45.3657 15.5682C41.8992 19.0486 38.7185 22.553 33.6101 23.5037L32.7 25.3681C32.4917 25.7635 32.0261 25.9826 31.6267 25.8109ZM31.908 59.9753C32.4224 60.8484 33.3803 62.4377 33.4758 62.3698C33.7805 62.7297 34.3147 62.8237 34.6665 62.5638C35.0166 62.301 35.0948 61.8123 34.8091 61.4821C34.7152 61.5306 33.7532 59.9472 33.2692 59.1395C37.1466 51.0279 36.0837 44.0941 36.4555 43.677C36.4555 43.677 33.9901 44.5957 32.414 47.1496C30.7907 49.3529 29.5606 53.6372 31.9267 58.3263C31.9171 58.3315 31.9074 58.3351 31.8978 58.3387C31.8873 58.3426 31.8769 58.3464 31.8669 58.3523C31.8476 58.3618 31.833 58.3762 31.8186 58.3905C31.8136 58.3954 31.8087 58.4003 31.8036 58.405C31.7986 58.4095 31.7935 58.4138 31.7881 58.4177C28.9157 53.9881 26.4066 50.7347 24.0157 48.1431C21.5688 45.684 19.7704 44.2164 19.3125 43.8427C19.237 43.7811 19.1984 43.7476 19.1984 43.7476C19.0327 43.6657 19.2251 47.5854 21.2834 51.9535C23.1818 55.948 27.1733 59.6302 31.908 59.9753ZM42.4632 72.5202L39.9597 70.6951C32.5437 73.3218 26.1769 67.3409 22.4038 61.7026C21.4894 60.2503 21.2438 59.2278 21.2438 59.2278C27.6721 61.3026 34.2519 65.2546 39.5053 69.3262C39.5271 69.301 39.5525 69.282 39.5775 69.2632C39.5903 69.2536 39.603 69.2441 39.615 69.2339C35.3276 65.3101 34.4611 60.5787 35.3417 57.471C35.9677 54.1762 37.9148 52.4034 37.9594 52.3631C37.9286 52.3936 38.0245 52.65 38.1917 53.0967C40.117 58.2405 41.3097 63.8813 40.9095 69.3795L43.3461 71.1687C43.6876 71.4445 43.827 71.9024 43.5867 72.3079C43.3595 72.6688 42.8263 72.8139 42.4632 72.5202ZM57.0126 77.2132L54.1002 76.2158C52.9456 71.5823 50.3989 68.1113 48.3302 65.6667C46.2012 62.9867 44.4324 61.3436 44.4324 61.3436C43.7561 63.0681 43.6696 65.2136 44.1734 66.9775C44.7837 70.0149 47.3481 74.0449 52.7441 76.4452C52.7418 76.4489 52.7393 76.4525 52.7367 76.456C52.7313 76.4634 52.7255 76.4706 52.7196 76.4779C52.7054 76.4954 52.691 76.5132 52.6822 76.5348C52.6796 76.5399 52.6793 76.5457 52.6764 76.5519C47.1357 74.6052 42.5379 74.0897 38.753 73.7931C34.6234 73.6153 31.822 73.8413 31.822 73.8413C31.822 73.8413 31.839 73.8558 31.8715 73.8859C32.2838 74.2676 35.2374 77.0018 39.5904 78.6158C44.0261 80.1742 49.5131 80.4917 53.551 77.6859L56.5413 78.7123C56.9685 78.8653 57.4366 78.6465 57.5644 78.2245C57.6916 77.8 57.4356 77.3639 57.0126 77.2132ZM27.4559 51.1279L26.9908 48.2858C20.8727 45.3934 18.6277 35.3475 21.0302 29.1911C25.0146 34.0567 26.6354 40.7062 27.5629 46.7747C27.6052 46.7723 27.6458 46.7806 27.6868 46.789C27.7027 46.7922 27.7185 46.7955 27.7346 46.7981C27.4919 41.2016 31.4073 34.6216 37.3832 33.7682C37.34 33.7749 37.2833 33.9867 37.1847 34.3553C35.7766 39.6172 32.6557 44.4488 28.5872 48.0416L29.0322 50.7747C29.0994 51.2061 28.809 51.6477 28.3714 51.764C27.9349 51.8805 27.5327 51.5774 27.4559 51.1279Z"], ["id", "icons-award-right", "viewBox", "0 0 80 80", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M43.5138 14.6976C42.9503 8.53084 37.8641 2.75984 31.8363 1.26213C34.1351 6.67919 38.696 11.4711 43.5138 14.6976ZM52.9305 35.0798L53.3404 37.177C53.4227 37.6241 53.1674 38.0512 52.7228 38.104C52.2985 38.1796 51.8652 37.8511 51.7869 37.4189L51.3764 35.3279C46.642 33.0695 43.648 28.9029 41.1696 24.5034C45.9753 24.5231 50.1934 28.7885 51.7074 33.0346C51.71 33.0339 51.7124 33.0324 51.7149 33.0309C51.7176 33.0292 51.7205 33.0274 51.7239 33.0265C51.0886 28.2443 51.1597 22.5867 53.5477 18.2206C55.7815 23.4554 57.1813 30.4088 52.9305 35.0798ZM48.3733 25.8109C48.7968 25.6304 48.9951 25.1529 48.7802 24.7325L47.9102 22.928C51.8672 16.0903 45.551 6.679 45.304 6.97445C44.1208 11.6686 44.6444 16.6064 46.2749 21.1201C46.2654 21.1234 46.2565 21.1275 46.2473 21.1317C46.2416 21.1343 46.2358 21.137 46.2296 21.1396C43.9517 17.7007 38.9917 14.3467 34.6343 15.5682C38.1008 19.0486 41.2815 22.553 46.39 23.5037L47.3 25.3681C47.5083 25.7635 47.9739 25.9826 48.3733 25.8109ZM48.092 59.9753C47.5776 60.8484 46.6197 62.4377 46.5242 62.3698C46.2195 62.7297 45.6853 62.8237 45.3335 62.5638C44.9834 62.301 44.9052 61.8123 45.1909 61.4821C45.2848 61.5306 46.2468 59.9472 46.7308 59.1395C42.8534 51.0279 43.9163 44.0941 43.5445 43.677C43.5445 43.677 46.0099 44.5957 47.586 47.1496C49.2093 49.3529 50.4395 53.6372 48.0733 58.3263C48.0829 58.3315 48.0926 58.3351 48.1022 58.3387C48.1127 58.3426 48.1231 58.3464 48.1331 58.3523C48.1524 58.3618 48.167 58.3762 48.1814 58.3905C48.1864 58.3954 48.1913 58.4003 48.1964 58.405C48.2014 58.4095 48.2065 58.4138 48.2119 58.4177C51.0843 53.9881 53.5934 50.7347 55.9843 48.1431C58.4312 45.684 60.2296 44.2164 60.6875 43.8427C60.763 43.7811 60.8016 43.7476 60.8016 43.7476C60.9674 43.6657 60.7749 47.5854 58.7166 51.9535C56.8182 55.948 52.8267 59.6302 48.092 59.9753ZM37.5368 72.5202L40.0403 70.6951C47.4563 73.3218 53.8231 67.3409 57.5962 61.7026C58.5106 60.2503 58.7562 59.2278 58.7562 59.2278C52.3279 61.3026 45.7481 65.2546 40.4947 69.3262C40.4729 69.301 40.4475 69.282 40.4225 69.2632C40.4097 69.2536 40.397 69.2441 40.385 69.2339C44.6724 65.3101 45.5389 60.5787 44.6583 57.471C44.0323 54.1762 42.0852 52.4034 42.0406 52.3631C42.0714 52.3936 41.9755 52.65 41.8083 53.0967C39.883 58.2405 38.6903 63.8813 39.0905 69.3795L36.6539 71.1687C36.3124 71.4445 36.173 71.9024 36.4133 72.3079C36.6405 72.6688 37.1737 72.8139 37.5368 72.5202ZM22.9874 77.2132L25.8998 76.2158C27.0544 71.5823 29.6011 68.1113 31.6698 65.6667C33.7988 62.9867 35.5676 61.3436 35.5676 61.3436C36.2439 63.0681 36.3304 65.2136 35.8266 66.9775C35.2163 70.0149 32.6519 74.0449 27.2559 76.4452C27.2583 76.4489 27.2607 76.4525 27.2633 76.456C27.2687 76.4634 27.2745 76.4706 27.2804 76.4779C27.2946 76.4954 27.309 76.5132 27.3178 76.5348C27.3204 76.5399 27.3207 76.5457 27.3236 76.5519C32.8643 74.6052 37.4621 74.0897 41.247 73.7931C45.3766 73.6153 48.178 73.8413 48.178 73.8413C48.178 73.8413 48.161 73.8558 48.1285 73.8859C47.7162 74.2676 44.7626 77.0018 40.4096 78.6158C35.9739 80.1742 30.4869 80.4917 26.449 77.6859L23.4587 78.7123C23.0315 78.8653 22.5634 78.6465 22.4356 78.2245C22.3084 77.8 22.5644 77.3639 22.9874 77.2132ZM52.5441 51.1279L53.0092 48.2858C59.1273 45.3934 61.3723 35.3475 58.9698 29.1911C54.9854 34.0567 53.3647 40.7062 52.4371 46.7747C52.3948 46.7723 52.3542 46.7806 52.3132 46.789C52.2973 46.7922 52.2815 46.7955 52.2654 46.7981C52.5081 41.2016 48.5927 34.6216 42.6168 33.7682C42.66 33.7749 42.7167 33.9867 42.8153 34.3553C44.2234 39.6172 47.3443 44.4488 51.4128 48.0416L50.9678 50.7747C50.9006 51.2061 51.191 51.6477 51.6286 51.764C52.0651 51.8805 52.4673 51.5774 52.5441 51.1279Z"], ["id", "icons-exit", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M16 19C16.3411 19 16.6423 18.8293 16.8227 18.5686L19 16.576L19 18C19 19.6569 17.6569 21 16 21L8.00002 21C6.34316 21 5.00002 19.6569 5.00002 18L5.00002 6C5.00002 4.34314 6.34316 3 8.00002 3L16 3C17.6569 3 19 4.34314 19 6L19 7.42403L16.8227 5.4314C16.6423 5.17074 16.3411 5 16 5L8.00002 5C7.44773 5 7.00002 5.44771 7.00002 6L7.00002 18C7.00002 18.5523 7.44773 19 8.00002 19L16 19ZM16 9L16 11L10 11L10 13L16 13L16 15L20 12L16 9Z"], ["id", "icons-turn-device", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M21.5 6.5H20.4725C20.2238 4.25002 18.3163 2.5 16 2.5V3.5C17.7632 3.5 19.2219 4.80385 19.4646 6.5H18.5L20 9L21.5 6.5ZM2 5C2 3.89543 2.89543 3 4 3H12C13.1046 3 14 3.89543 14 5V20C14 21.1046 13.1046 22 12 22H4C2.89543 22 2 21.1046 2 20V5ZM12 5H4V16H12V5ZM20 10C21.1046 10 22 10.8954 22 12V20C22 21.1046 21.1046 22 20 22H16L16 20H20V12H16V10H20ZM9.5 18.5C9.5 19.3284 8.82843 20 8 20C7.17157 20 6.5 19.3284 6.5 18.5C6.5 17.6716 7.17157 17 8 17C8.82843 17 9.5 17.6716 9.5 18.5Z"], ["id", "icons-video", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M4.5 6.5C3.11929 6.5 2 7.61929 2 9V15C2 16.3807 3.11929 17.5 4.5 17.5H13.5C14.8807 17.5 16 16.3807 16 15V9C16 7.61929 14.8807 6.5 13.5 6.5H4.5ZM18.47 9.20625C18.1776 9.38899 18 9.70946 18 10.0542V13.9458C18 14.2905 18.1776 14.611 18.47 14.7938L20.47 16.0438C21.136 16.46 22 15.9812 22 15.1958V8.80425C22 8.01881 21.136 7.53997 20.47 7.95625L18.47 9.20625Z"], ["id", "icons-more", "viewBox", "0 0 1024 1024", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M175.158 426.667c-49.609 0-89.824 40.218-89.824 89.826s40.216 89.826 89.824 89.826c49.609 0 89.825-40.218 89.825-89.826s-40.216-89.826-89.825-89.826zM512 426.667c-49.609 0-89.824 40.218-89.824 89.826s40.216 89.826 89.824 89.826c49.609 0 89.826-40.218 89.826-89.826s-40.218-89.826-89.826-89.826zM848.841 426.667c-49.609 0-89.822 40.218-89.822 89.826s40.213 89.826 89.822 89.826c49.609 0 89.826-40.218 89.826-89.826s-40.218-89.826-89.826-89.826z"], ["id", "icons-user", "viewBox", "0 0 1024 1024", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M153.723 1023.979c-142.948 2.223-200.717-154.099-110.486-256.414 72.175-81.877 166.1-127.305 264.722-163.238 76.376-27.721 80.331-39.782 31.885-103.949-71.927-95.226-95.409-201.486-62.782-318.269 34.357-122.687 140.889-195.067 260.026-180.18 126.554 15.913 210.837 110.88 220.727 248.454 7.168 99.073-23.236 184.801-83.793 260.261-37.572 46.967-29.909 64.422 23.236 88.806 108.356 49.523 228.843 95.654 299.819 195.068 67.767 94.161-0.201 228.945-116.911 228.945-242.069-1.003-484.392-2.633-726.444 0.516z"], ["id", "icons-timer", "viewBox", "0 0 1024 1024", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M512 143.36c-243.182 0-440.32 197.138-440.32 440.32s197.138 440.32 440.32 440.32c243.182 0 440.32-197.138 440.32-440.32-0.282-243.065-197.255-440.038-440.32-440.32zM699.904 784.896c-9.706 11.048-23.694 17.389-38.4 17.41-12.622 0.106-24.838-4.453-34.304-12.802l-148.992-132.096c-11.048-9.706-17.389-23.694-17.408-38.4v-256c0-28.277 22.923-51.2 51.2-51.2s51.2 22.923 51.2 51.2v230.912l132.096 116.736c10.8 9.019 17.413 22.085 18.285 36.128s-4.075 27.827-13.677 38.112zM382.464 65.024l283.136 37.376h-307.2c-28.277 0-51.2-22.923-51.2-51.2s22.923-51.2 51.2-51.2h307.2c28.277 0 51.2 22.923 51.2 51.2s-22.923 51.2-51.2 51.2l-283.136-37.376z"], ["id", "icons-team", "viewBox", "0 0 1024 1024", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M123.438 375.135c0-73.269 48.822-153.102 129.149-153.102 22.381 0 43.61 6.959 63.726 20.866-12.902 32.106-19.354 65.336-19.354 99.749 0 53.76 14.428 102.255 43.246 145.575-9.113 8.886-17.646 16.041-25.599 21.458l-117.202 55.094c-33.004 16.015-52.907 52.674-52.907 88.743v147.883h-115.485c-17.946 0-29.013-17.775-29.013-34.217v-140.926c0-15.365 7.267-26.706 18.193-31.895l175.229-82.943c-46.631-28.862-69.985-82.708-69.985-136.284zM681.529 485.323c27.694-43.705 41.528-91.247 41.528-142.675 0-32.847-6.062-65.509-18.215-97.998 20.48-15.090 42.668-22.606 66.57-22.606 79.885 0 129.14 80.198 129.14 153.102 0 52.22-23.040 106.064-68.268 134.544l173.512 84.682c12.13 6.182 18.204 16.806 18.204 31.898v140.923c0 16.433-11.077 34.217-29.012 34.217h-119.468v-147.906c0-36.585-18.967-71.040-51.769-88.151l-112.072-53.934c-11.003-7.34-21.048-16.041-30.152-26.097zM670.152 342.648c0 64.207-28.977 131.567-84.196 167.021l214.471 104.389c14.917 7.616 22.197 23.155 22.197 39.447v173.98c0 19.933-13.903 42.916-35.84 42.916h-553.541c-21.939 0-35.84-22.979-35.84-42.916v-173.98c0-16.156 8.092-31.936 22.756-39.447l216.177-103.23c-56.84-35.431-85.891-102.8-85.891-168.18 0-56.225 21.993-114.157 64.274-151.943 28.068-24.74 59.732-37.104 95.017-37.104 36.396 0 68.823 12.933 97.267 38.855 40.248 37.084 63.148 95.514 63.148 150.191z"], ["id", "icons-reset", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M6.55173 4C6.55173 3.44772 6.10401 3 5.55173 3C4.99944 3 4.55173 3.44772 4.55173 4V8.27586C4.55173 8.82815 4.99944 9.27586 5.55173 9.27586H9.82759C10.3799 9.27586 10.8276 8.82815 10.8276 8.27586C10.8276 7.72358 10.3799 7.27586 9.82759 7.27586H7.5444C10.0863 4.9027 14.0715 4.95516 16.5495 7.43324C19.0812 9.96492 19.0812 14.0696 16.5495 16.6012C14.0179 19.1329 9.91321 19.1329 7.38153 16.6012C6.99101 16.2107 6.35784 16.2107 5.96732 16.6012C5.57679 16.9918 5.57679 17.6249 5.96732 18.0155C9.28004 21.3282 14.651 21.3282 17.9637 18.0155C21.2765 14.7027 21.2765 9.33175 17.9637 6.01903C14.8394 2.8947 9.88429 2.71702 6.55173 5.48597V4Z"], ["id", "icons-link", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M19.4003 4.55857C17.3222 2.48048 13.953 2.48048 11.8749 4.55857L10.4939 5.93959C10.1034 6.33011 10.1034 6.96328 10.4939 7.3538C10.8844 7.74433 11.5176 7.74433 11.9081 7.3538L13.2891 5.97278C14.5862 4.67574 16.6891 4.67574 17.9861 5.97278C19.2832 7.26983 19.2832 9.37275 17.9861 10.6698L16.6051 12.0508C16.2146 12.4413 16.2146 13.0745 16.6051 13.465C16.9956 13.8556 17.6288 13.8556 18.0193 13.465L19.4003 12.084C21.4784 10.0059 21.4784 6.63666 19.4003 4.55857ZM7.7437 11.5182C8.13422 11.1277 8.13422 10.4945 7.7437 10.104C7.35317 9.71346 6.72001 9.71346 6.32948 10.104L4.59968 11.8338C2.52158 13.9119 2.52158 17.2811 4.59968 19.3592C6.67777 21.4373 10.047 21.4373 12.1251 19.3592L13.8549 17.6294C14.2454 17.2389 14.2454 16.6057 13.8549 16.2152C13.4644 15.8247 12.8312 15.8247 12.4407 16.2152L10.7109 17.945C9.41386 19.2421 7.31093 19.2421 6.01389 17.945C4.71685 16.648 4.71685 14.5451 6.01389 13.248L7.7437 11.5182ZM7.89113 14.6171C7.50061 15.0077 7.50061 15.6408 7.89113 16.0314C8.28166 16.4219 8.91482 16.4219 9.30535 16.0314L16.1095 9.2272C16.5 8.83668 16.5 8.20351 16.1095 7.81299C15.719 7.42246 15.0858 7.42246 14.6953 7.81299L7.89113 14.6171Z"], ["id", "icons-bell", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M7.70587 8.32963C8.42058 5.6623 11.1623 4.07939 13.8296 4.7941C16.4969 5.5088 18.0798 8.25049 17.3651 10.9178L16.1846 15.3236C16.1117 15.5956 16.147 15.8851 16.283 16.1316L16.7506 16.9793C16.9295 17.3037 16.8848 17.7057 16.639 17.9829C16.4357 18.2122 16.1203 18.3069 15.8243 18.2276L5.1812 15.3758C4.89621 15.2994 4.67882 15.0686 4.61967 14.7795C4.54414 14.4105 4.72271 14.0361 5.05705 13.8625L5.98847 13.379C6.25816 13.239 6.45658 12.9921 6.53522 12.6986L7.70587 8.32963Z"], ["d", "M13.3444 3.91065C13.5119 3.38435 14.0742 3.09342 14.6005 3.26084C15.1268 3.42826 15.4178 3.99063 15.2503 4.51693L14.9472 5.46987C14.7798 5.99617 14.2174 6.2871 13.6911 6.11968C13.1648 5.95226 12.8739 5.38989 13.0413 4.86359L13.3444 3.91065Z"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M8.3172 18.2866C8.68895 19.0216 9.36007 19.6013 10.2183 19.8313C11.0765 20.0613 11.9476 19.8948 12.637 19.4441L8.3172 18.2866Z"], ["id", "icons-phone", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 1024 1024"], ["d", "M706.216 944.341c-61.44-2.261-235.563-26.325-417.92-208.64-182.315-182.357-206.336-356.437-208.64-417.92-3.413-93.696 68.352-184.704 151.253-220.245 9.984-4.311 20.915-5.952 31.725-4.763 10.808 1.189 21.122 5.168 29.93 11.547 68.266 49.749 115.37 125.013 155.818 184.193 8.901 13.002 12.706 28.822 10.691 44.45s-9.707 29.966-21.613 40.286l-83.243 61.824c-4.022 2.904-6.853 7.168-7.966 12.003-1.115 4.834-0.437 9.907 1.907 14.278 18.859 34.262 52.395 85.291 90.795 123.691 38.443 38.4 91.861 74.155 128.512 95.147 4.595 2.579 10.005 3.301 15.115 2.014 5.11-1.285 9.534-4.48 12.362-8.926l54.187-82.475c9.962-13.234 24.658-22.099 41.010-24.739s33.093 1.149 46.714 10.574c60.032 41.557 130.090 87.85 181.376 153.514 6.896 8.87 11.282 19.432 12.701 30.578s-0.182 22.467-4.637 32.782c-35.712 83.328-126.080 154.283-220.075 150.827z"], ["id", "icons-mail", "viewBox", "0 0 64 64", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M55.0906 25.8875C55.4562 25.5969 56 25.8687 56 26.3281V45.5C56 47.9844 53.9844 50 51.5 50H12.5C10.0156 50 8 47.9844 8 45.5V26.3375C8 25.8688 8.53437 25.6062 8.90937 25.8969C11.0094 27.5281 13.7938 29.6 23.3563 36.5469C25.3344 37.9906 28.6719 41.0281 32 41.0094C35.3469 41.0375 38.75 37.9344 40.6531 36.5469C50.2156 29.6 52.9906 27.5188 55.0906 25.8875ZM32 38C34.175 38.0375 37.3062 35.2625 38.8812 34.1188C51.3219 25.0906 52.2687 24.3031 55.1375 22.0531C55.6812 21.6312 56 20.975 56 20.2812V18.5C56 16.0156 53.9844 14 51.5 14H12.5C10.0156 14 8 16.0156 8 18.5V20.2812C8 20.975 8.31875 21.6219 8.8625 22.0531C11.7313 24.2937 12.6781 25.0906 25.1188 34.1188C26.6938 35.2625 29.825 38.0375 32 38Z"], ["id", "icons-instagram", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 1024 1024"], ["d", "M682.667 512c0 94.257-76.41 170.667-170.667 170.667s-170.667-76.41-170.667-170.667c0-94.257 76.41-170.667 170.667-170.667s170.667 76.41 170.667 170.667z"], ["d", "M725.291 0h-426.667c-164.651 0-298.624 134.016-298.624 298.709v426.667c0 164.651 134.016 298.624 298.709 298.624h426.667c164.651 0 298.624-134.016 298.624-298.709v-426.667c0-164.651-134.016-298.624-298.709-298.624zM512 768c-141.184 0-256-114.816-256-256s114.816-256 256-256c141.184 0 256 114.816 256 256s-114.816 256-256 256zM810.667 256c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667z"], ["id", "icons-hockey", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12 12C16.9706 12 21 10.433 21 8.5C21 6.567 16.9706 5 12 5C7.02944 5 3 6.567 3 8.5C3 10.433 7.02944 12 12 12ZM12 14.0001C15.5841 14.0001 18.8012 13.2799 21 12.1381V15.5001C21 17.4331 16.9706 19.0001 12 19.0001C7.02944 19.0001 3 17.4331 3 15.5001V12.1381C5.19883 13.2799 8.41592 14.0001 12 14.0001Z"], ["id", "icons-mask", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12.25 11.9304C11.3834 13.0937 10.9749 14.7149 10.877 15.4076H12.2322H12.2678H13.623C13.5251 14.7149 13.1166 13.0937 12.25 11.9304ZM12.25 23.5754C10.7899 23.6607 7.40962 22.591 5.42068 17.6187C4.68482 15.779 4.25263 14.116 4.0474 12.6259H4.24385C4.99229 12.6259 5.59902 12.0192 5.59902 11.2708V10.9141C5.59902 10.1657 4.99229 9.55896 4.24385 9.55896H3.93658C4.08832 7.5367 4.69608 5.97294 5.42068 4.85153C6.91294 2.54208 9.04236 1.01139 12.2322 1.00006V1C12.2381 1 12.2441 1.00001 12.25 1.00002C12.2559 1.00001 12.2619 1 12.2678 1V1.00006C15.4576 1.01139 17.5871 2.54208 19.0793 4.85153C19.8039 5.97294 20.4117 7.5367 20.5634 9.55896H20.2561C19.5077 9.55896 18.901 10.1657 18.901 10.9141V11.2708C18.901 12.0192 19.5077 12.6259 20.2561 12.6259H20.4526C20.2474 14.116 19.8152 15.779 19.0793 17.6187C17.0904 22.591 13.7101 23.6607 12.25 23.5754ZM12.25 9.07387C12.2561 9.07585 12.2621 9.07782 12.2678 9.07979V9.06827C12.4823 9.00264 12.8888 8.93519 13.33 8.88133C13.7648 8.82825 14.6323 8.77438 15.1921 8.77438C15.1433 8.79194 15.0697 8.81632 14.9784 8.84655L14.9783 8.84657L14.9782 8.84661L14.9781 8.84665L14.9781 8.84667C14.6367 8.95972 14.0486 9.1545 13.5856 9.38064C12.9554 9.68842 12.5336 9.92537 12.25 10.1144C11.9664 9.92537 11.5446 9.68842 10.9144 9.38064C10.4514 9.1545 9.86327 8.95972 9.52195 8.84667L9.52195 8.84667L9.5219 8.84665L9.52177 8.84661L9.52166 8.84657L9.52159 8.84655C9.43031 8.81632 9.3567 8.79194 9.30791 8.77438C9.86775 8.77438 10.7352 8.82825 11.17 8.88133C11.6112 8.93519 12.0177 9.00264 12.2322 9.06827V9.07979C12.2379 9.07782 12.2439 9.07585 12.25 9.07387ZM10.8414 11.4846C10.8414 12.4103 9.82724 13 9.00001 13C8.17279 13 7.00001 11.9257 7.00001 11C7.00001 9.93013 8.40388 9.60855 9.27224 9.73721C10.2351 9.87988 10.8414 10.5589 10.8414 11.4846ZM8.44173 16.7565C8.42641 16.3868 8.40417 15.8502 8.45199 15.3719C8.52332 14.6587 8.63031 13.9098 8.80862 13.4818C8.59464 13.8265 8.10964 14.7086 7.8814 15.4789C7.65316 16.2492 7.57232 16.6795 7.56044 16.7984C7.72686 16.7984 8.13817 16.8555 8.45199 17.0837C8.45199 17.0042 8.44732 16.8915 8.44173 16.7565ZM11.5189 7.63315C11.5189 7.8695 11.3273 8.0611 11.091 8.0611C10.8546 8.0611 10.663 7.8695 10.663 7.63315C10.663 7.3968 10.8546 7.2052 11.091 7.2052C11.3273 7.2052 11.5189 7.3968 11.5189 7.63315ZM11.2337 18.4745C11.47 18.4745 11.6616 18.2829 11.6616 18.0466C11.6616 17.8102 11.47 17.6186 11.2337 17.6186C10.9973 17.6186 10.8057 17.8102 10.8057 18.0466C10.8057 18.2829 10.9973 18.4745 11.2337 18.4745ZM9.18066 6.95614C9.26639 7.06841 9.18362 7.2757 8.99578 7.41915C8.80794 7.5626 8.58616 7.58787 8.50043 7.4756C8.41469 7.36333 8.49747 7.15604 8.68531 7.01259C8.87315 6.86914 9.09492 6.84387 9.18066 6.95614ZM9.06085 5.84798C9.22425 5.67721 9.27397 5.4596 9.1719 5.36194C9.06983 5.26428 8.85463 5.32355 8.69124 5.49432C8.52784 5.6651 8.47812 5.8827 8.58019 5.98036C8.68226 6.07802 8.89746 6.01875 9.06085 5.84798ZM9.1572 3.53051C9.25926 3.62817 9.20955 3.84578 9.04615 4.01655C8.88276 4.18732 8.66756 4.24659 8.56549 4.14893C8.46342 4.05127 8.51314 3.83367 8.67654 3.6629C8.83993 3.49212 9.05513 3.43286 9.1572 3.53051ZM6.60139 6.21964C6.69151 6.00115 6.65871 5.78036 6.52812 5.7265C6.39754 5.67263 6.21861 5.80609 6.12849 6.02458C6.03837 6.24307 6.07117 6.46386 6.20176 6.51773C6.33235 6.57159 6.51127 6.43814 6.60139 6.21964ZM6.63008 14.406C6.76621 14.3683 6.92773 14.5224 6.99084 14.7501C7.05395 14.9779 6.99475 15.1931 6.85862 15.2308C6.72249 15.2685 6.56097 15.1145 6.49786 14.8867C6.43475 14.6589 6.49394 14.4437 6.63008 14.406ZM6.42025 15.6773C6.35714 15.4496 6.19562 15.2955 6.05949 15.3332C5.92336 15.371 5.86416 15.5862 5.92727 15.8139C5.99038 16.0417 6.1519 16.1958 6.28803 16.1581C6.42416 16.1203 6.48336 15.9051 6.42025 15.6773ZM7.83066 18.5756C7.95597 18.5104 8.146 18.6275 8.25508 18.8371C8.36417 19.0468 8.35102 19.2696 8.22571 19.3348C8.10039 19.4 7.91037 19.2829 7.80128 19.0733C7.69219 18.8636 7.70535 18.6408 7.83066 18.5756ZM9.7492 18.0362C9.69734 17.8056 9.51366 17.6505 9.33894 17.6898C9.16422 17.7291 9.06462 17.9479 9.11648 18.1785C9.16834 18.4091 9.35202 18.5641 9.52674 18.5248C9.70146 18.4855 9.80105 18.2668 9.7492 18.0362ZM10.7594 19.9062C10.8914 19.7852 11.1279 19.8283 11.2876 20.0025C11.4473 20.1767 11.4698 20.416 11.3378 20.5371C11.2058 20.6581 10.9694 20.615 10.8096 20.4408C10.6499 20.2666 10.6274 20.0272 10.7594 19.9062ZM11.3786 21.5974C11.1857 21.4609 10.9455 21.4687 10.842 21.6148C10.7385 21.761 10.811 21.9902 11.0039 22.1267C11.1968 22.2633 11.4371 22.2555 11.5406 22.1094C11.644 21.9632 11.5715 21.734 11.3786 21.5974ZM6.36176 8.12634C6.503 8.12849 6.61459 8.32181 6.61099 8.55813C6.6074 8.79445 6.48998 8.98429 6.34874 8.98214C6.20749 8.97999 6.09591 8.78667 6.0995 8.55035C6.1031 8.31403 6.22051 8.1242 6.36176 8.12634ZM5.68485 13.7958C5.64192 13.5634 5.49452 13.3958 5.35561 13.4215C5.2167 13.4471 5.13888 13.6563 5.1818 13.8887C5.22472 14.1212 5.37213 14.2888 5.51104 14.2631C5.64995 14.2375 5.72777 14.0283 5.68485 13.7958ZM5.54299 7.20595C5.65845 7.22035 5.73251 7.38862 5.70842 7.58179C5.68433 7.77496 5.57121 7.91988 5.45575 7.90548C5.3403 7.89108 5.26624 7.72282 5.29033 7.52965C5.31442 7.33648 5.42754 7.19155 5.54299 7.20595ZM4.17248 9.84424H2.95996V12.3406H4.17248C4.80275 12.3406 5.31368 11.8297 5.31368 11.1994V10.9854C5.31368 10.3552 4.80275 9.84424 4.17248 9.84424ZM4.10114 11.4847C4.33749 11.4847 4.52908 11.2931 4.52908 11.0568C4.52908 10.8204 4.33749 10.6288 4.10114 10.6288C3.86479 10.6288 3.67319 10.8204 3.67319 11.0568C3.67319 11.2931 3.86479 11.4847 4.10114 11.4847ZM13.6586 11.4846C13.6586 12.4103 14.5788 12.9824 15.4061 12.9824C16.2333 12.9824 17.5 11.9257 17.5 11C17.5 9.93013 16.0961 9.60855 15.2278 9.73721C14.2649 9.87988 13.6586 10.5589 13.6586 11.4846ZM16.0583 16.7565C16.0736 16.3868 16.0958 15.8502 16.048 15.3719C15.9767 14.6587 15.8697 13.9098 15.6914 13.4818C15.9054 13.8265 16.3904 14.7086 16.6186 15.4789C16.8468 16.2492 16.9277 16.6795 16.9396 16.7984C16.7731 16.7984 16.3618 16.8555 16.048 17.0837C16.048 17.0042 16.0527 16.8915 16.0583 16.7565L16.0583 16.7565ZM12.9811 7.63315C12.9811 7.8695 13.1727 8.0611 13.409 8.0611C13.6454 8.0611 13.837 7.8695 13.837 7.63315C13.837 7.3968 13.6454 7.2052 13.409 7.2052C13.1727 7.2052 12.9811 7.3968 12.9811 7.63315ZM13.2663 18.4745C13.03 18.4745 12.8384 18.2829 12.8384 18.0466C12.8384 17.8102 13.03 17.6186 13.2663 17.6186C13.5027 17.6186 13.6943 17.8102 13.6943 18.0466C13.6943 18.2829 13.5027 18.4745 13.2663 18.4745ZM15.3193 6.95614C15.2336 7.06841 15.3164 7.2757 15.5042 7.41915C15.6921 7.5626 15.9138 7.58787 15.9996 7.4756C16.0853 7.36333 16.0025 7.15604 15.8147 7.01259C15.6269 6.86914 15.4051 6.84387 15.3193 6.95614ZM15.4391 5.84798C15.2758 5.67721 15.226 5.4596 15.3281 5.36194C15.4302 5.26428 15.6454 5.32355 15.8088 5.49432C15.9722 5.6651 16.0219 5.8827 15.9198 5.98036C15.8177 6.07802 15.6025 6.01875 15.4391 5.84798ZM15.3428 3.53051C15.2407 3.62817 15.2905 3.84578 15.4538 4.01655C15.6172 4.18732 15.8324 4.24659 15.9345 4.14893C16.0366 4.05127 15.9869 3.83367 15.8235 3.6629C15.6601 3.49212 15.4449 3.43286 15.3428 3.53051ZM17.8986 6.21964C17.8085 6.00115 17.8413 5.78036 17.9719 5.7265C18.1025 5.67263 18.2814 5.80609 18.3715 6.02458C18.4616 6.24307 18.4288 6.46386 18.2982 6.51773C18.1677 6.57159 17.9887 6.43814 17.8986 6.21964ZM17.8699 14.406C17.7338 14.3683 17.5723 14.5224 17.5092 14.7501C17.4461 14.9779 17.5052 15.1931 17.6414 15.2308C17.7775 15.2685 17.939 15.1145 18.0021 14.8867C18.0653 14.6589 18.0061 14.4437 17.8699 14.406ZM18.0798 15.6773C18.1429 15.4496 18.3044 15.2955 18.4405 15.3332C18.5766 15.371 18.6358 15.5862 18.5727 15.8139C18.5096 16.0417 18.3481 16.1958 18.212 16.1581C18.0758 16.1203 18.0166 15.9051 18.0798 15.6773ZM16.6693 18.5756C16.544 18.5104 16.354 18.6275 16.2449 18.8371C16.1358 19.0468 16.149 19.2696 16.2743 19.3348C16.3996 19.4 16.5896 19.2829 16.6987 19.0733C16.8078 18.8636 16.7947 18.6408 16.6693 18.5756ZM14.7508 18.0362C14.8027 17.8056 14.9863 17.6505 15.1611 17.6898C15.3358 17.7291 15.4354 17.9479 15.3835 18.1785C15.3317 18.4091 15.148 18.5641 14.9733 18.5248C14.7985 18.4855 14.6989 18.2668 14.7508 18.0362ZM13.7406 19.9062C13.6086 19.7852 13.3721 19.8283 13.2124 20.0025C13.0527 20.1767 13.0302 20.416 13.1622 20.5371C13.2942 20.6581 13.5306 20.615 13.6904 20.4408C13.8501 20.2666 13.8726 20.0272 13.7406 19.9062ZM13.1214 21.5974C13.3143 21.4609 13.5545 21.4687 13.658 21.6148C13.7615 21.761 13.689 21.9902 13.4961 22.1267C13.3032 22.2633 13.0629 22.2555 12.9594 22.1094C12.856 21.9632 12.9285 21.734 13.1214 21.5974ZM18.1382 8.12634C17.997 8.12849 17.8854 8.32181 17.889 8.55813C17.8926 8.79445 18.01 8.98429 18.1513 8.98214C18.2925 8.97999 18.4041 8.78667 18.4005 8.55035C18.3969 8.31403 18.2795 8.1242 18.1382 8.12634ZM18.8152 13.7958C18.8581 13.5634 19.0055 13.3958 19.1444 13.4215C19.2833 13.4471 19.3611 13.6563 19.3182 13.8887C19.2753 14.1212 19.1279 14.2888 18.989 14.2631C18.85 14.2375 18.7722 14.0283 18.8152 13.7958ZM18.957 7.20595C18.8416 7.22035 18.7675 7.38862 18.7916 7.58179C18.8157 7.77496 18.9288 7.91988 19.0442 7.90548C19.1597 7.89108 19.2338 7.72282 19.2097 7.52965C19.1856 7.33648 19.0725 7.19155 18.957 7.20595ZM20.3275 9.84424H21.54V12.3406H20.3275C19.6973 12.3406 19.1863 11.8297 19.1863 11.1994V10.9854C19.1863 10.3552 19.6973 9.84424 20.3275 9.84424ZM20.3989 11.4847C20.1625 11.4847 19.9709 11.2931 19.9709 11.0568C19.9709 10.8204 20.1625 10.6288 20.3989 10.6288C20.6352 10.6288 20.8268 10.8204 20.8268 11.0568C20.8268 11.2931 20.6352 11.4847 20.3989 11.4847Z"], ["id", "icons-arrow-left", "viewBox", "0 0 42 16", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0.292892 7.2929C-0.0976296 7.68342 -0.0976295 8.31659 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41422 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928935C7.68054 0.538411 7.04738 0.538411 6.65685 0.928935L0.292892 7.2929ZM42 7L1 7L1 9L42 9L42 7Z"], ["id", "icons-arrow-right", "viewBox", "0 0 42 16", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M41.7071 8.70711C42.0976 8.31659 42.0976 7.68342 41.7071 7.2929L35.3431 0.928938C34.9526 0.538414 34.3195 0.538414 33.9289 0.928938C33.5384 1.31946 33.5384 1.95263 33.9289 2.34315L39.5858 8.00001L33.9289 13.6569C33.5384 14.0474 33.5384 14.6805 33.9289 15.0711C34.3195 15.4616 34.9526 15.4616 35.3431 15.0711L41.7071 8.70711ZM-1.74846e-07 9L41 9.00001L41 7.00001L1.74846e-07 7L-1.74846e-07 9Z"], ["id", "icons-pin", "viewBox", "0 0 7 9", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M6.74889 3.67853C6.7347 4.4547 6.47934 5.2457 5.94024 5.93288C5.18361 6.90186 4.41752 7.86589 3.65615 8.83487C3.48591 9.04745 3.26365 9.05733 3.10287 8.8497C2.31313 7.84612 1.51394 6.85737 0.743118 5.83895C-0.391832 4.34099 -0.207403 2.12125 1.16399 0.85565C1.87807 0.193187 2.72928 -0.0688318 3.6798 0.015212C4.73909 0.109143 5.56665 0.628237 6.17196 1.53789C6.54082 2.09159 6.75362 2.85293 6.74889 3.67853ZM3.37715 2.07181C2.63943 2.07181 2.05304 2.68978 2.05304 3.46595C2.05304 4.22729 2.64889 4.84031 3.38188 4.84031C4.11013 4.84031 4.70125 4.2174 4.70125 3.45606C4.70125 2.68978 4.11013 2.07181 3.37715 2.07181Z"], ["id", "icons-instagram", "viewBox", "0 0 16 16", "xmlns", "http://www.w3.org/2000/svg"], ["clip-path", "url(#clip0)"], ["d", "M7.73741 4.32275C5.56049 4.32275 3.7981 6.08706 3.7981 8.26206C3.7981 10.439 5.5624 12.2014 7.73741 12.2014C9.91433 12.2014 11.6767 10.4371 11.6767 8.26206C11.6767 6.08514 9.91241 4.32275 7.73741 4.32275ZM7.73741 10.819C6.32429 10.819 5.1805 9.67453 5.1805 8.26206C5.1805 6.84959 6.32493 5.70516 7.73741 5.70516C9.14988 5.70516 10.2943 6.84959 10.2943 8.26206C10.295 9.67453 9.15052 10.819 7.73741 10.819Z"], ["d", "M10.9005 0.636848C9.488 0.570959 5.98945 0.574157 4.5757 0.636848C3.33339 0.695062 2.23758 0.995084 1.35414 1.87852C-0.122298 3.35496 0.0664156 5.34445 0.0664156 8.26215C0.0664156 11.2483 -0.0999079 13.1917 1.35414 14.6458C2.83634 16.1273 4.85461 15.9335 7.73777 15.9335C10.6958 15.9335 11.7167 15.9354 12.7627 15.5305C14.1847 14.9784 15.2581 13.7073 15.3631 11.4242C15.4296 10.0111 15.4258 6.51319 15.3631 5.09944C15.2364 2.40436 13.79 0.769907 10.9005 0.636848ZM13.1362 13.6689C12.1684 14.6368 10.8256 14.5505 7.71922 14.5505C4.52069 14.5505 3.23808 14.5978 2.30219 13.6593C1.22428 12.5866 1.41939 10.8638 1.41939 8.25191C1.41939 4.71753 1.05668 2.17214 4.60385 1.99047C5.41883 1.96168 5.65872 1.95208 7.71026 1.95208L7.73905 1.97128C11.148 1.97128 13.8226 1.61432 13.9832 5.16085C14.0197 5.97008 14.028 6.21317 14.028 8.26151C14.0274 11.4229 14.0875 12.7132 13.1362 13.6689Z"], ["d", "M11.8326 5.08765C12.341 5.08765 12.7532 4.67551 12.7532 4.16712C12.7532 3.65872 12.341 3.24658 11.8326 3.24658C11.3242 3.24658 10.9121 3.65872 10.9121 4.16712C10.9121 4.67551 11.3242 5.08765 11.8326 5.08765Z"], ["id", "clip0"], ["width", "15.3529", "height", "15.3529", "transform", "translate(0.0588379 0.587891)"], ["id", "icons-tiktok", "viewBox", "0 0 16 16", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M14.4929 4.305C13.6469 4.305 12.8664 4.02475 12.2396 3.55196C11.5207 3.00997 11.0042 2.21494 10.8218 1.29861C10.7766 1.0722 10.7523 0.838556 10.75 0.599121H8.33332V7.20254L8.33043 10.8195C8.33043 11.7865 7.70072 12.6065 6.82781 12.8948C6.57448 12.9785 6.30088 13.0182 6.01599 13.0025C5.65235 12.9826 5.31158 12.8728 5.0154 12.6956C4.38511 12.3187 3.95778 11.6348 3.9462 10.8525C3.92796 9.62989 4.91638 8.63307 6.13817 8.63307C6.37934 8.63307 6.61096 8.67244 6.82781 8.74395V6.93907V6.29026C6.59909 6.25638 6.36631 6.23872 6.13093 6.23872C4.79363 6.23872 3.54289 6.7946 2.64885 7.79606C1.9731 8.55287 1.56777 9.51843 1.50523 10.5309C1.4233 11.8609 1.90999 13.1253 2.85383 14.0581C2.99251 14.1951 3.13814 14.3222 3.29043 14.4394C4.09964 15.0622 5.08894 15.3998 6.13093 15.3998C6.36631 15.3998 6.59909 15.3824 6.82781 15.3485C7.80118 15.2043 8.69928 14.7588 9.40803 14.0581C10.2789 13.1974 10.7601 12.0546 10.7653 10.8384L10.7529 5.43703C11.1683 5.75754 11.6226 6.02274 12.1101 6.22859C12.8684 6.54851 13.6724 6.71064 14.4999 6.71035V4.95556V4.30442C14.5004 4.305 14.4935 4.305 14.4929 4.305Z"], ["width", "14.8235", "height", "14.8235", "transform", "translate(0.587158 0.587891)"], ["id", "icons-telegram", "viewBox", "0 0 16 16", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M6.55328 10.2992L6.29931 13.8713C6.66267 13.8713 6.82003 13.7152 7.00875 13.5278L8.71228 11.8997L12.2422 14.4848C12.8896 14.8456 13.3457 14.6556 13.5203 13.8892L15.8373 3.03211L15.838 3.03147C16.0433 2.07447 15.4919 1.70024 14.8611 1.93501L1.2418 7.14926C0.312306 7.51005 0.32638 8.02821 1.08379 8.26298L4.56571 9.34601L12.6535 4.28529C13.0341 4.03325 13.3802 4.1727 13.0955 4.42475L6.55328 10.2992Z"], ["width", "15.3529", "height", "15.3529", "transform", "translate(0.529297 0.587891)"], ["id", "icons-youtube", "viewBox", "0 0 18 18", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M17.081 4.78214C16.8865 4.05921 16.3165 3.48933 15.5937 3.29466C14.2732 2.93335 8.991 2.93335 8.991 2.93335C8.991 2.93335 3.70902 2.93335 2.3885 3.28096C1.67957 3.47542 1.09568 4.05931 0.901222 4.78214C0.553711 6.10256 0.553711 8.84094 0.553711 8.84094C0.553711 8.84094 0.553711 11.5931 0.901222 12.8997C1.09589 13.6226 1.66566 14.1924 2.3886 14.3871C3.72292 14.7485 8.99121 14.7485 8.99121 14.7485C8.99121 14.7485 14.2732 14.7485 15.5937 14.4009C16.3167 14.2064 16.8865 13.6365 17.0812 12.9136C17.4286 11.5931 17.4286 8.85484 17.4286 8.85484C17.4286 8.85484 17.4425 6.10256 17.081 4.78214ZM7.30927 11.3707V6.31113L11.7017 8.84094L7.30927 11.3707Z"], ["id", "icons-football", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["clip-rule", "evenodd", "d", "M6.58798 9.02996L11.0145 5.9314V2C7.69185 2.32503 4.84607 4.27621 3.28346 7.04724L6.58798 9.02996ZM2.47589 8.89508C2.16686 9.85864 2 10.8859 2 11.9521C2 14.5966 3.02653 17.0013 4.70286 18.7896L7.40853 15.6974L6.15545 11.1028L2.47589 8.89508ZM6.20895 20.1056C7.84306 21.2683 9.84168 21.9521 12 21.9521C14.1662 21.9521 16.1715 21.2633 17.8089 20.0928L15.4982 17.4521H8.53076L6.20895 20.1056ZM19.3121 18.7736C20.9796 16.987 22 14.5887 22 11.9521C22 10.8912 21.8348 9.86901 21.5288 8.90967L17.8735 11.1028L16.6205 15.6974L19.3121 18.7736ZM20.7239 7.06024C19.1674 4.29038 16.3299 2.33691 13.0145 2.00288V5.94283L17.3414 9.0897L20.7239 7.06024ZM15.9509 10.5514L14.6143 15.4521H9.41466L8.04989 10.4479L12.0034 7.68048L15.9509 10.5514Z"], ["id", "icons-mini-football", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M8.48 10.86L9.83 15H14.17L15.52 10.87L12 8.3L8.48 10.86ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM15.16 16.35L13.88 20.28C12.6438 20.5734 11.3562 20.5734 10.12 20.28L8.84 16.35H4.71C4.05595 15.2597 3.65604 14.0361 3.54 12.77L6.88 10.34L5.61 6.41C6.43545 5.45932 7.45956 4.70148 8.61 4.19L12 6.62L15.35 4.19C16.5005 4.70148 17.5246 5.45932 18.35 6.41L17.08 10.34L20.42 12.77C20.304 14.0361 19.9041 15.2597 19.25 16.35H15.16Z"], ["id", "icons-pdf-file", "viewBox", "0 0 36 40", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M36 36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4C4 1.79086 5.79086 0 8 0H24L36 12V36Z", "fill", "#525562", "fill-opacity", "0.64"], ["d", "M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z", "fill", "#525562"], ["y", "24", "width", "28", "height", "12", "rx", "6", "fill", "#E04141"], ["d", "M4.6321 34V26.7273H7.50142C8.05303 26.7273 8.52296 26.8326 8.91122 27.0433C9.29948 27.2517 9.59541 27.5417 9.79901 27.9134C10.005 28.2827 10.108 28.7088 10.108 29.1918C10.108 29.6747 10.0038 30.1009 9.79545 30.4702C9.58712 30.8395 9.28527 31.1271 8.88991 31.3331C8.49692 31.5391 8.02107 31.642 7.46236 31.642H5.63352V30.4098H7.21378C7.50971 30.4098 7.75355 30.3589 7.94531 30.2571C8.13944 30.1529 8.28385 30.0097 8.37855 29.8274C8.47562 29.6428 8.52415 29.4309 8.52415 29.1918C8.52415 28.9503 8.47562 28.7396 8.37855 28.5597C8.28385 28.3774 8.13944 28.2365 7.94531 28.1371C7.75118 28.0353 7.50497 27.9844 7.20668 27.9844H6.16974V34H4.6321ZM13.6848 34H11.1067V26.7273H13.7061C14.4377 26.7273 15.0674 26.8729 15.5953 27.1641C16.1233 27.4529 16.5293 27.8684 16.8134 28.4105C17.0998 28.9527 17.2431 29.6013 17.2431 30.3565C17.2431 31.1141 17.0998 31.7652 16.8134 32.3097C16.5293 32.8542 16.1209 33.272 15.5882 33.5632C15.0579 33.8544 14.4235 34 13.6848 34ZM12.6444 32.6825H13.6209C14.0755 32.6825 14.4578 32.602 14.7679 32.4411C15.0804 32.2777 15.3148 32.0256 15.4711 31.6847C15.6297 31.3414 15.709 30.8987 15.709 30.3565C15.709 29.8191 15.6297 29.38 15.4711 29.0391C15.3148 28.6982 15.0816 28.4472 14.7715 28.2862C14.4614 28.1252 14.079 28.0447 13.6245 28.0447H12.6444V32.6825ZM18.3821 34V26.7273H23.1974V27.995H19.9197V29.728H22.8778V30.9957H19.9197V34H18.3821Z", "fill", "white"], ["id", "icons-img-file", "viewBox", "0 0 36 40", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M6.16974 26.7273V34H4.6321V26.7273H6.16974ZM7.43484 26.7273H9.33114L11.334 31.6136H11.4192L13.4221 26.7273H15.3184V34H13.8269V29.2663H13.7665L11.8844 33.9645H10.8688L8.98668 29.2486H8.92631V34H7.43484V26.7273ZM21.4077 29.0781C21.358 28.9053 21.2881 28.7526 21.1982 28.62C21.1082 28.4851 20.9981 28.3714 20.8679 28.2791C20.7401 28.1844 20.5933 28.1122 20.4276 28.0625C20.2642 28.0128 20.0831 27.9879 19.8842 27.9879C19.5125 27.9879 19.1858 28.0803 18.9041 28.2649C18.6248 28.4496 18.407 28.7183 18.2507 29.071C18.0945 29.4214 18.0163 29.8499 18.0163 30.3565C18.0163 30.8632 18.0933 31.294 18.2472 31.6491C18.401 32.0043 18.6188 32.2753 18.9006 32.4624C19.1823 32.647 19.5149 32.7393 19.8984 32.7393C20.2464 32.7393 20.5436 32.6778 20.7898 32.5547C21.0384 32.4292 21.2277 32.2528 21.358 32.0256C21.4905 31.7983 21.5568 31.5296 21.5568 31.2195L21.8693 31.2656H19.9943V30.108H23.0376V31.0241C23.0376 31.6634 22.9027 32.2126 22.6328 32.6719C22.3629 33.1288 21.9912 33.4815 21.5178 33.7301C21.0443 33.9763 20.5021 34.0994 19.8913 34.0994C19.2095 34.0994 18.6106 33.9491 18.0945 33.6484C17.5784 33.3454 17.1759 32.9157 16.8871 32.3594C16.6006 31.8007 16.4574 31.1378 16.4574 30.3707C16.4574 29.7812 16.5426 29.2557 16.7131 28.794C16.8859 28.33 17.1274 27.937 17.4375 27.6151C17.7476 27.2931 18.1087 27.0481 18.5206 26.88C18.9325 26.7119 19.3788 26.6278 19.8594 26.6278C20.2713 26.6278 20.6548 26.6882 21.0099 26.8089C21.3651 26.9273 21.6799 27.0954 21.9545 27.3132C22.2315 27.531 22.4576 27.7902 22.6328 28.0909C22.808 28.3892 22.9205 28.7183 22.9702 29.0781H21.4077Z", "fill", "white"], ["id", "icons-doc-file", "viewBox", "0 0 36 40", "xmlns", "http://www.w3.org/2000/svg"], ["y", "24", "width", "31", "height", "12", "rx", "6", "fill", "#E04141"], ["d", "M7.21023 34H4.6321V26.7273H7.23153C7.96307 26.7273 8.5928 26.8729 9.12074 27.1641C9.64867 27.4529 10.0547 27.8684 10.3388 28.4105C10.6252 28.9527 10.7685 29.6013 10.7685 30.3565C10.7685 31.1141 10.6252 31.7652 10.3388 32.3097C10.0547 32.8542 9.64631 33.272 9.11364 33.5632C8.58333 33.8544 7.94886 34 7.21023 34ZM6.16974 32.6825H7.14631C7.60085 32.6825 7.98319 32.602 8.29332 32.4411C8.60582 32.2777 8.8402 32.0256 8.99645 31.6847C9.15507 31.3414 9.23438 30.8987 9.23438 30.3565C9.23438 29.8191 9.15507 29.38 8.99645 29.0391C8.8402 28.6982 8.60701 28.4472 8.29688 28.2862C7.98674 28.1252 7.6044 28.0447 7.14986 28.0447H6.16974V32.6825ZM18.5907 30.3636C18.5907 31.1567 18.4404 31.8314 18.1397 32.3878C17.8414 32.9441 17.4342 33.3691 16.9181 33.6626C16.4044 33.9538 15.8268 34.0994 15.1852 34.0994C14.5389 34.0994 13.9589 33.9527 13.4451 33.6591C12.9314 33.3655 12.5254 32.9406 12.2271 32.3842C11.9288 31.8279 11.7797 31.1544 11.7797 30.3636C11.7797 29.5705 11.9288 28.8958 12.2271 28.3395C12.5254 27.7831 12.9314 27.3594 13.4451 27.0682C13.9589 26.7746 14.5389 26.6278 15.1852 26.6278C15.8268 26.6278 16.4044 26.7746 16.9181 27.0682C17.4342 27.3594 17.8414 27.7831 18.1397 28.3395C18.4404 28.8958 18.5907 29.5705 18.5907 30.3636ZM17.0318 30.3636C17.0318 29.8499 16.9548 29.4167 16.801 29.0639C16.6494 28.7112 16.4352 28.4437 16.1582 28.2614C15.8812 28.0791 15.5569 27.9879 15.1852 27.9879C14.8135 27.9879 14.4892 28.0791 14.2122 28.2614C13.9352 28.4437 13.7198 28.7112 13.5659 29.0639C13.4144 29.4167 13.3386 29.8499 13.3386 30.3636C13.3386 30.8774 13.4144 31.3106 13.5659 31.6634C13.7198 32.0161 13.9352 32.2836 14.2122 32.4659C14.4892 32.6482 14.8135 32.7393 15.1852 32.7393C15.5569 32.7393 15.8812 32.6482 16.1582 32.4659C16.4352 32.2836 16.6494 32.0161 16.801 31.6634C16.9548 31.3106 17.0318 30.8774 17.0318 30.3636ZM26.1467 29.2734H24.5913C24.5629 29.0722 24.5049 28.8935 24.4173 28.7372C24.3297 28.5786 24.2172 28.4437 24.0799 28.3324C23.9426 28.2211 23.784 28.1359 23.604 28.0767C23.4265 28.0175 23.2335 27.9879 23.0252 27.9879C22.6488 27.9879 22.3209 28.0814 22.0415 28.2685C21.7622 28.4531 21.5456 28.723 21.3917 29.0781C21.2378 29.4309 21.1609 29.8594 21.1609 30.3636C21.1609 30.8821 21.2378 31.3177 21.3917 31.6705C21.5479 32.0232 21.7657 32.2895 22.0451 32.4695C22.3245 32.6494 22.6476 32.7393 23.0146 32.7393C23.2205 32.7393 23.4111 32.7121 23.5863 32.6577C23.7638 32.6032 23.9213 32.5239 24.0586 32.4197C24.1959 32.3132 24.3095 32.1842 24.3995 32.0327C24.4918 31.8812 24.5558 31.7083 24.5913 31.5142L26.1467 31.5213C26.1064 31.8551 26.0058 32.1771 25.8448 32.4872C25.6862 32.795 25.4719 33.0708 25.2021 33.3146C24.9345 33.5561 24.6149 33.7479 24.2433 33.8899C23.8739 34.0296 23.4561 34.0994 22.9897 34.0994C22.341 34.0994 21.761 33.9527 21.2496 33.6591C20.7406 33.3655 20.3382 32.9406 20.0423 32.3842C19.7487 31.8279 19.6019 31.1544 19.6019 30.3636C19.6019 29.5705 19.7511 28.8958 20.0494 28.3395C20.3477 27.7831 20.7525 27.3594 21.2638 27.0682C21.7752 26.7746 22.3505 26.6278 22.9897 26.6278C23.4111 26.6278 23.8017 26.687 24.1616 26.8054C24.5238 26.9238 24.8446 27.0966 25.1239 27.3239C25.4033 27.5488 25.6306 27.8246 25.8058 28.1513C25.9833 28.478 26.0969 28.852 26.1467 29.2734Z", "fill", "white"], ["id", "icons-handball", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["id", "svg_1", "d", "m5.69062,11.54986c0.03,-0.2607 0.06923,-0.76142 0.14769,-1.25287c0.02539,-0.1569 0.11077,-0.35302 0.23538,-0.43609c0.70844,-0.48915 1.42149,-0.97599 2.16917,-1.40284c0.17538,-0.09922 0.52383,-0.03231 0.72921,0.07844c0.79382,0.42916 1.57842,0.8814 2.33068,1.37747c0.4892,0.32303 0.8931,0.30226 1.3731,-0.00923c0.7407,-0.47992 1.5253,-0.89062 2.273,-1.36362c0.3346,-0.20997 0.6415,-0.23765 0.9623,-0.0323c0.6299,0.40378 1.2715,0.79141 1.8599,1.25056c0.2146,0.16613 0.3854,0.503 0.4108,0.77757c0.0692,0.70371 0.0346,1.41671 0.0623,2.12501c0.0253,0.6968 -0.3393,1.1237 -0.8862,1.4998c-1.7838,1.2275 -1.7653,1.2229 -3.6276,0.1338c-2.0976,-1.2252 -1.4122,-1.1998 -3.50524,0.0046c-0.23307,0.1338 -0.49152,0.24 -0.68998,0.4153c-0.69921,0.623 -1.37304,0.5053 -2.0561,-0.0161c-0.06,-0.0462 -0.12923,-0.0831 -0.19615,-0.1223c-1.45842,-0.8606 -1.59918,-1.1075 -1.59226,-3.0272z"], ["id", "svg_2", "d", "m8.92632,19.14356c-0.03692,0.0693 -0.06,0.1754 -0.12693,0.2285c-0.50998,0.4084 -1.01305,0.8214 -1.55073,1.1905c-0.10845,0.0762 -0.37844,0.0185 -0.5169,-0.0669c-1.57842,-0.9667 -2.78532,-2.2865 -3.62068,-3.9339c-0.06923,-0.1385 0.04846,-0.3877 0.11307,-0.5723c0.02769,-0.0761 0.13846,-0.1292 0.21692,-0.1822c0.49845,-0.3254 0.97844,-0.8584 1.50458,-0.9068c0.45922,-0.0438 0.95305,0.5076 1.46534,0.706c1.17228,0.4546 1.92688,1.2068 2.10226,2.5012c0.04615,0.3484 0.26307,0.676 0.41307,1.0359z"], ["id", "svg_3", "d", "m20.99665,16.28736c-0.0715,0.1662 -0.1223,0.3115 -0.1939,0.4453c-0.8422,1.5483 -1.9937,2.815 -3.5052,3.7287c-0.1777,0.1084 -0.4754,0.0253 -0.7154,0.0184c-0.0485,-0.0023 -0.1015,-0.053 -0.1454,-0.0877c-0.4177,-0.3368 -1.0153,-0.5999 -1.1953,-1.0359c-0.15,-0.3646 0.1846,-0.9322 0.3138,-1.4075c0.1038,-0.3876 0.1985,-0.7822 0.3438,-1.156c0.067,-0.1753 0.2123,-0.353 0.3693,-0.4545c0.7407,-0.4753 1.4953,-0.9322 2.2545,-1.3775c0.1477,-0.0853 0.4015,-0.1776 0.51,-0.1107c0.6208,0.3761 1.2161,0.7983 1.8115,1.2136c0.0692,0.0485 0.1015,0.15 0.1523,0.2238z"], ["id", "svg_4", "d", "m16.33235,3.01806c0.1962,0.09229 0.3208,0.14074 0.4362,0.20535c1.6176,0.89062 2.8984,2.12965 3.8537,3.71016c0.21,0.34841 0.2239,0.59298 -0.15,0.80295c-0.0323,0.01845 -0.06,0.04845 -0.0923,0.06922c-0.4754,0.32302 -0.9369,0.86524 -1.433,0.90216c-0.4385,0.0323 -0.8931,-0.5653 -1.3869,-0.76603c-1.2531,-0.50992 -1.9638,-1.43054 -2.4276,-2.6788c-0.3577,-0.96676 -0.4592,-0.93677 0.3553,-1.62896c0.2723,-0.22842 0.577,-0.42224 0.8446,-0.61605z"], ["id", "svg_5", "d", "m5.11658,8.83318c-0.38307,-0.24919 -0.77075,-0.46377 -1.11459,-0.73373c-0.94382,-0.73834 -1.11458,-0.45685 -0.31152,-1.66127c0.89997,-1.34747 2.07224,-2.40884 3.49143,-3.20256c0.35768,-0.20073 0.64383,-0.19842 0.93228,0.08076c0.02769,0.02538 0.06,0.04846 0.09,0.07153c1.09612,0.86063 1.00612,0.82602 0.53537,2.09735c-0.40384,1.09367 -1.00151,1.86431 -2.09302,2.3027c-0.43152,0.17305 -0.78459,0.54453 -1.17458,0.82372c-0.10384,0.07383 -0.21922,0.13613 -0.35537,0.2215z"], ["id", "svg_6", "d", "m12.00465,19.03906c-0.473,-0.0715 -0.95304,-0.1246 -1.42149,-0.2215c-0.14999,-0.0323 -0.28384,-0.1707 -0.40614,-0.2815c-0.06692,-0.06 -0.09923,-0.1615 -0.14538,-0.2469c-0.88614,-1.6497 -0.85844,-1.8089 0.74305,-2.7411c1.50916,-0.8791 0.88846,-0.8721 2.42076,-0.0069c0.2007,0.1131 0.3992,0.2331 0.5976,0.3507c0.8769,0.5192 0.8769,0.5192 0.5562,1.4721c-0.4869,1.4305 -0.7754,1.6336 -2.3446,1.6751z"], ["id", "svg_7", "d", "m14.56605,6.90945c-0.1246,0.23996 -0.1592,0.3484 -0.2261,0.42685c-0.06,0.06922 -0.1569,0.10845 -0.2377,0.15921c-2.1553,1.38438 -2.1507,1.37977 -4.30141,-0.03923c-0.27692,-0.18228 -0.3623,-0.35532 -0.20769,-0.65528c0.13846,-0.27226 0.23308,-0.56759 0.37615,-0.83755c0.62537,-1.18134 2.14145,-1.74202 3.24455,-0.98753c0.6184,0.42685 0.93,1.30133 1.3522,1.93353z"], ["id", "svg_8", "d", "m21.43615,8.74405c0.7154,2.02582 0.7662,3.99861 0.1454,6.10051c-0.6923,-0.443 -1.3361,-0.8375 -1.9569,-1.2667c-0.0853,-0.06 -0.0853,-0.2769 -0.0877,-0.4199c-0.0092,-0.9183 -0.0115,-1.8366 -0.0023,-2.75495c0.0023,-0.1569 0.0277,-0.38071 0.127,-0.45686c0.5561,-0.40377 1.1353,-0.77294 1.7745,-1.2021z"], ["id", "svg_9", "d", "m2.39739,14.84976c-0.58614,-2.065 -0.54921,-4.03319 0.14538,-6.09824c0.65306,0.43377 1.2415,0.80987 1.80687,1.21826c0.08538,0.0623 0.08308,0.27688 0.08308,0.42224c0.00461,0.91834 0.00923,1.83894 -0.00692,2.75724c-0.00231,0.1708 -0.04385,0.4153 -0.15923,0.4961c-0.5746,0.4061 -1.1792,0.7683 -1.86918,1.2044z"], ["id", "svg_10", "d", "m15.34795,21.30536c-1.3777,0.9206 -5.23832,0.9298 -6.71982,0.0092c0.45922,-0.3923 0.89306,-0.7776 1.34997,-1.1375c0.08307,-0.0669 0.26076,-0.0531 0.38306,-0.0254c1.08459,0.2423 2.16459,0.2353 3.24919,0.0092c0.1384,-0.03 0.3369,-0.0392 0.4338,0.0369c0.4431,0.3485 0.863,0.7292 1.3038,1.1076z"], ["id", "svg_11", "d", "m9.18877,2.4283c1.92226,-0.56991 3.68298,-0.55376 5.46448,-0.05768c-0.3485,0.8214 -1.0084,1.16289 -1.7907,1.08675c-0.6231,-0.05999 -1.2738,-0.07384 -1.88537,0.03922c-0.43844,0.07845 -0.72228,0.04384 -1.00151,-0.29534c-0.20076,-0.24688 -0.45691,-0.45223 -0.7869,-0.77295z"], ["id", "icons-rugby", "viewBox", "0 0 1024 1024", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M86.292 739.219c4.565-216.499 68.831-387.715 227.454-515.018 110.056-88.279 238.781-126.020 377.821-130.293 47.77-1.496 95.646 4.661 143.624 6.552 20.866 0.796 26.128 10.025 23.935 30.286-9.733 90.278-39.728 174.287-82.235 253.148-104.695 194.354-256.846 339.737-461.258 425.342-61.079 25.618-128.122 36.653-192.484 54.524-15.095 4.178-23.137 0.192-24.828-16.783-4.078-42.012-9.341-83.715-12.025-107.75z"], ["d", "M160.858 924.293c400.472-107.16 652.755-359.707 759.932-766.279 30.887 206.764 9.826 398.435-125.349 561.108-167.163 201.106-390.543 240.036-634.579 205.17z"], ["id", "icons-skip-next", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "m6 18 8.5-6L6 6v12zM16 6v12h2V6h-2z"], ["id", "icons-skip-prev", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M6 6h2v12H6zm3.5 6 8.5 6V6z"], ["id", "icons-note", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M 18.964844 15.261719 C 19.710938 14.015625 20.207031 12.4375 20.300781 10.875 C 20.363281 9.871094 20.140625 8.820312 19.65625 7.828125 C 18.898438 6.273438 17.59375 5.402344 16.335938 4.558594 C 15.394531 3.929688 14.507812 3.335938 13.878906 2.484375 L 13.765625 2.332031 C 13.394531 1.835938 12.976562 1.269531 12.910156 0.796875 C 12.84375 0.316406 12.40625 -0.0273438 11.929688 0 C 11.449219 0.0351562 11.074219 0.433594 11.074219 0.921875 L 11.074219 17.371094 C 10.300781 16.902344 9.347656 16.613281 8.304688 16.613281 C 5.757812 16.613281 3.6875 18.269531 3.6875 20.308594 C 3.6875 22.34375 5.757812 24 8.304688 24 C 10.847656 24 12.917969 22.34375 12.917969 20.308594 L 12.917969 9.546875 C 14.304688 10.078125 16.574219 11.425781 17.199219 14.578125 C 17.082031 14.75 16.972656 14.933594 16.84375 15.082031 C 16.503906 15.464844 16.542969 16.046875 16.925781 16.382812 C 17.304688 16.722656 17.890625 16.683594 18.226562 16.300781 C 18.476562 16.019531 18.695312 15.691406 18.90625 15.347656 C 18.925781 15.324219 18.949219 15.292969 18.964844 15.261719 Z M 18.964844 15.261719 "], ["id", "icons-court", "viewBox", "0 0 1024 1024", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M933.333 415.667v149.999h-101.666v-149.999h101.666z"], ["d", "M631.667 490.652c0-60.367-43.012-110.87-100.002-122.485v244.97c56.99-11.614 100.002-62.118 100.002-122.485z"], ["d", "M531.665 317.46c84.693 12.168 150.003 85.198 150.003 173.207s-65.31 161.037-150.003 173.205v151.795h326.669c41.353 0 74.999-33.647 74.999-74.999v-125.001h-126.669c-13.803 0-24.998-11.196-24.998-25.003v-199.998c0-13.807 11.196-25 24.998-25h126.669v-125c0-41.355-33.647-75-74.999-75h-326.669v151.793z"], ["d", "M481.667 663.872c-84.693-12.169-150-85.197-150-173.205s65.306-161.039 150-173.207v-151.793h-326.667c-41.355 0-75 33.645-75 75v125h126.667c13.807 0 25 11.194 25 25v199.998c0 13.807-11.194 25.003-25 25.003h-126.667v125.001c0 41.353 33.645 74.999 75 74.999h326.667v-151.795z"], ["d", "M181.667 415.667v149.999h-101.667v-149.999h101.667z"], ["d", "M381.667 490.652c0 60.367 43.014 110.871 100 122.485v-244.97c-56.986 11.615-100 62.118-100 122.485z"], ["id", "icons-rupor", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 359.35 335.39"], ["id", "Layer_2", "data-name", "Layer 2"], ["id", "Layer_1-2", "data-name", "Layer 1"], ["d", "M359.35,178.22c-.94,6.69-1.63,13.42-2.86,20.06-6.32,34.11-21.95,63.34-46.48,87.82a11.93,11.93,0,1,1-16.85-16.88,148.83,148.83,0,0,0,29.9-43.35C346.46,173.73,336,111.52,296.76,70c-1.2-1.28-2.46-2.51-3.63-3.81-4.67-5.13-4.59-12.44.15-17s12-4.57,17,.36a165,165,0,0,1,48.48,105,18.39,18.39,0,0,0,.6,2.7Z", 1, "cls-1"], ["d", "M215.18,321.06c0,2.82,1.28,6,0,8.4-3.47,6.6-13.23,7.86-19.51,2.91-11.38-9-22.65-18.11-34-27.16Q122,273.42,82.21,241.74a10.94,10.94,0,0,0-6.29-2.13c-16.72-.18-33.45-.08-50.17-.11C9.86,239.48,0,229.55,0,213.62q0-46,0-91.93c0-15.9,9.86-25.77,25.82-25.81,16.84,0,33.68.05,50.52-.1a9.93,9.93,0,0,0,5.66-2q56.1-44.68,112.05-89.58C198,1.09,202-1.11,207.22.59a11.5,11.5,0,0,1,8,10.65c.08,1.4,0,2.81,0,4.21C215.18,66.21,215.27,270,215.18,321.06Z", 1, "cls-1"], ["d", "M311.47,169.56c-.48,30.61-11.64,58.76-34.53,82.07-4.31,4.39-9.83,5.38-14.69,2.81a11.33,11.33,0,0,1-6-13,18.15,18.15,0,0,1,4.4-7.33c15-15.66,24-34.22,26.16-55.73,3-29.25-5.46-54.92-25.63-76.58A21.22,21.22,0,0,1,256.3,94c-1.55-5.25,1.19-10.5,5.87-13s10.32-1.69,14.46,2.43a116.68,116.68,0,0,1,23.53,33.34C307.74,132.85,311.31,149.87,311.47,169.56Z", 1, "cls-1"], ["id", "icons-list", "viewBox", "0 0 1385 1024"], ["d", "M207.312 112.068c0 47.274-38.323 85.597-85.597 85.597s-85.597-38.323-85.597-85.597c0-47.274 38.323-85.597 85.597-85.597s85.597 38.323 85.597 85.597z"], ["d", "M207.312 497.156c0 47.274-38.323 85.597-85.597 85.597s-85.597-38.323-85.597-85.597c0-47.274 38.323-85.597 85.597-85.597s85.597 38.323 85.597 85.597z"], ["d", "M207.312 882.405c0 47.274-38.323 85.597-85.597 85.597s-85.597-38.323-85.597-85.597c0-47.274 38.323-85.597 85.597-85.597s85.597 38.323 85.597 85.597z"], ["d", "M352.821 69.309h941.571c23.637 0 42.799 19.162 42.799 42.799v0c0 23.637-19.162 42.799-42.799 42.799h-941.571c-23.637 0-42.799-19.162-42.799-42.799v0c0-23.637 19.162-42.799 42.799-42.799z"], ["d", "M352.821 454.573h941.571c23.637 0 42.799 19.162 42.799 42.799v0c0 23.637-19.162 42.799-42.799 42.799h-941.571c-23.637 0-42.799-19.162-42.799-42.799v0c0-23.637 19.162-42.799 42.799-42.799z"], ["d", "M352.821 839.662h941.571c23.637 0 42.799 19.162 42.799 42.799v0c0 23.637-19.162 42.799-42.799 42.799h-941.571c-23.637 0-42.799-19.162-42.799-42.799v0c0-23.637 19.162-42.799 42.799-42.799z"], ["id", "icons-chess-old", "viewBox", "0 0 1024 1024"], ["fill", "#141416", "d", "M75.474 0h308.025c29.765 0 53.895 24.129 53.895 53.895v308.025c0 29.765-24.129 53.895-53.895 53.895h-308.025c-29.765 0-53.895-24.129-53.895-53.895v-308.025c0-29.765 24.129-53.895 53.895-53.895z"], ["fill", "#fff", "d", "M75.474 554.41h308.025c29.765 0 53.895 24.129 53.895 53.895v308.025c0 29.765-24.129 53.895-53.895 53.895h-308.025c-29.765 0-53.895-24.129-53.895-53.895v-308.025c0-29.765 24.129-53.895 53.895-53.895z"], ["fill", "#fff", "d", "M629.884 0h308.025c29.765 0 53.895 24.129 53.895 53.895v308.025c0 29.765-24.129 53.895-53.895 53.895h-308.025c-29.765 0-53.895-24.129-53.895-53.895v-308.025c0-29.765 24.129-53.895 53.895-53.895z"], ["fill", "#141416", "d", "M629.873 554.41h308.025c29.765 0 53.895 24.129 53.895 53.895v308.025c0 29.765-24.129 53.895-53.895 53.895h-308.025c-29.765 0-53.895-24.129-53.895-53.895v-308.025c0-29.765 24.129-53.895 53.895-53.895z"], ["id", "icons-chess", "width", "24", "height", "24", "viewBox", "0 0 24 24", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M2.6 12V2.6H12V12H2.6ZM12 21.4V12H21.4V21.4H12ZM1 2C1 1.44772 1.44772 1 2 1H22C22.5523 1 23 1.44772 23 2V22C23 22.5523 22.5523 23 22 23H2C1.44772 23 1 22.5523 1 22V2Z", "fill", "white"], ["id", "icons-details", "viewBox", "0 0 1024 1024", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M271.059 240.941h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z"], ["d", "M271.059 440.669h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z"], ["d", "M271.059 640.398h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z"], ["d", "M470.766 240.941h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z"], ["d", "M470.766 440.669h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z"], ["d", "M470.766 640.398h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z"], ["d", "M670.5 240.941h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z"], ["d", "M670.5 440.669h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z"], ["d", "M670.5 640.398h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z"], ["id", "icons-arrows", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 1024 1024"], ["d", "M189.023 346.351c-0.289 0.431-0.539 0.877-0.8 1.308-0.228 0.39-0.478 0.785-0.707 1.191-0.238 0.451-0.443 0.922-0.666 1.374-0.195 0.428-0.41 0.841-0.595 1.269-0.185 0.449-0.338 0.912-0.5 1.373-0.168 0.467-0.349 0.923-0.484 1.384-0.144 0.467-0.238 0.923-0.355 1.394s-0.256 0.955-0.349 1.435c-0.103 0.549-0.178 1.087-0.25 1.634-0.062 0.422-0.144 0.83-0.185 1.251-0.185 1.956-0.185 3.932 0 5.888 0.045 0.428 0.121 0.838 0.185 1.251 0.072 0.554 0.144 1.087 0.25 1.634 0.103 0.484 0.226 0.964 0.349 1.435 0.117 0.472 0.226 0.927 0.355 1.394 0.144 0.472 0.316 0.923 0.484 1.384 0.162 0.457 0.308 0.922 0.5 1.373 0.185 0.431 0.39 0.843 0.595 1.269 0.223 0.463 0.428 0.923 0.666 1.374 0.226 0.406 0.472 0.8 0.707 1.191 0.267 0.433 0.513 0.882 0.8 1.308 0.299 0.439 0.629 0.863 0.951 1.292 0.267 0.349 0.512 0.717 0.789 1.046 0.633 0.759 1.291 1.497 1.989 2.194l149.089 149.095c5.822 5.826 13.458 8.735 21.092 8.735s15.27-2.909 21.088-8.735c11.646-11.642 11.646-30.525 0-42.169l-98.183-98.183h524.37c16.462 0 29.825-13.346 29.825-29.825s-13.346-29.825-29.825-29.825h-524.37l98.183-98.187c11.646-11.642 11.646-30.525 0-42.169-11.642-11.646-30.525-11.646-42.169 0l-149.089 149.093c-0.699 0.695-1.361 1.427-1.989 2.194-0.279 0.349-0.521 0.705-0.789 1.046-0.318 0.431-0.65 0.841-0.951 1.292z"], ["d", "M839.667 656.898c-0.072-0.554-0.144-1.087-0.25-1.634-0.103-0.484-0.226-0.964-0.349-1.435-0.117-0.472-0.226-0.927-0.355-1.394-0.144-0.472-0.316-0.923-0.484-1.384-0.162-0.457-0.308-0.922-0.5-1.369-0.185-0.431-0.39-0.843-0.595-1.269-0.223-0.463-0.428-0.923-0.666-1.374-0.226-0.406-0.472-0.8-0.707-1.191-0.267-0.433-0.513-0.882-0.8-1.308-0.299-0.439-0.629-0.863-0.951-1.292-0.267-0.349-0.512-0.717-0.791-1.046-0.629-0.759-1.291-1.497-1.989-2.194l-149.089-149.093c-11.642-11.646-30.525-11.646-42.169 0-11.646 11.642-11.646 30.525 0 42.169l98.189 98.177h-524.37c-16.462 0.002-29.825 13.346-29.825 29.825s13.346 29.825 29.825 29.825h524.37l-98.187 98.187c-11.646 11.642-11.646 30.525 0 42.169 5.822 5.822 13.458 8.733 21.092 8.733s15.27-2.909 21.088-8.735l149.089-149.089c0.699-0.695 1.361-1.427 1.989-2.194 0.279-0.349 0.521-0.705 0.791-1.046 0.318-0.431 0.65-0.841 0.951-1.292 0.289-0.431 0.539-0.879 0.8-1.308 0.228-0.39 0.478-0.785 0.707-1.191 0.238-0.451 0.443-0.918 0.666-1.374 0.195-0.428 0.41-0.841 0.595-1.269 0.185-0.449 0.338-0.912 0.5-1.373 0.168-0.467 0.349-0.923 0.484-1.384 0.144-0.467 0.238-0.923 0.355-1.394s0.256-0.955 0.349-1.435c0.103-0.549 0.178-1.087 0.25-1.634 0.062-0.422 0.144-0.83 0.185-1.251 0.185-1.956 0.185-3.932 0-5.888-0.049-0.431-0.127-0.841-0.185-1.251z"], ["id", "icons-info", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 1024 1024"], ["d", "M512 168.96c-189.282 0-343.040 153.758-343.040 343.040s153.758 343.040 343.040 343.040c189.282 0 343.040-153.758 343.040-343.040s-153.758-343.040-343.040-343.040zM512 198.784c173.161 0 313.216 140.055 313.216 313.216s-140.055 313.216-313.216 313.216c-173.161 0-313.216-140.055-313.216-313.216s140.055-313.216 313.216-313.216zM512 303.197c-24.716 0-44.744 20.036-44.744 44.744v0c0 24.716 20.036 44.744 44.744 44.744v0c24.716 0 44.744-20.036 44.744-44.744v0c0-24.716-20.036-44.744-44.744-44.744v0zM452.336 452.336v29.822h29.822v193.888h-29.822v29.822h119.315v-29.822h-29.822v-223.725h-89.488z"], ["id", "icons-waterpolo"], ["id", "Group 390"], ["id", "Vector", "d", "M19.2064 14.7737C19.069 14.6501 18.95 14.5654 18.8561 14.4601C16.8117 12.1732 14.3299 10.5777 11.3697 9.76281C10.9393 9.64378 10.6989 9.45835 10.6783 9.01198C10.6256 7.81706 10.5638 6.62215 10.5157 5.42724C10.502 5.09989 10.6622 4.99459 10.9873 5.0747C14.2956 5.88734 17.2673 7.36611 19.8749 9.56137C20.0054 9.67125 20.113 9.86582 20.1405 10.0352C20.3351 11.2576 19.8772 13.6062 19.2064 14.7737Z"], ["id", "Vector_2", "d", "M6.06636 12.3976C5.27193 10.912 4.87814 9.41257 4.73162 7.8491C4.54618 5.88733 4.79572 3.97364 5.52833 2.13319C5.59015 1.97982 5.66571 1.78524 5.79391 1.71657C7.14467 1.00007 8.58701 0.658992 10.2102 0.668148C10.0637 1.13971 9.94234 1.53115 9.821 1.9203C9.04489 4.40857 8.93271 6.92889 9.40891 9.48583C9.43867 9.65065 9.43181 9.90245 9.33108 10.0032C8.38783 10.9509 7.30951 11.72 6.06636 12.3976Z"], ["id", "Vector_3", "d", "M14.4209 12.3307C13.299 14.13 12.0307 15.4714 10.4304 16.4901C10.3113 16.5656 10.1419 16.5931 9.99538 16.6C9.15745 16.6366 8.44315 16.9708 7.82272 17.5042C7.54799 17.7399 7.35796 17.7972 7.04889 17.5339C5.8332 16.497 4.46641 16.3092 2.99889 16.9227C2.70126 17.0463 2.49979 17.0097 2.3235 16.735C2.01901 16.2635 1.6985 15.801 1.40316 15.3615C2.74706 14.9587 4.02227 14.6405 5.2494 14.1964C7.02371 13.5531 8.58509 12.5299 9.96562 11.2457C10.2884 10.9458 10.5815 10.8565 10.9867 11.0145C12.0925 11.4471 13.2075 11.8661 14.4209 12.3307Z"], ["id", "Vector_4", "d", "M3.73575 3.14313C3.63272 3.86878 3.51595 4.55781 3.43811 5.24912C3.15422 7.79005 3.57547 10.2188 4.64006 12.5377C4.78429 12.8513 4.75225 13.0367 4.39281 13.1214C3.33967 13.3732 2.2911 13.6502 1.23339 13.8677C1.07313 13.8997 0.738873 13.712 0.690795 13.5609C-0.458498 9.94869 0.567167 5.81683 3.51137 3.25302C3.56403 3.20953 3.64188 3.18891 3.73575 3.14313Z"], ["id", "Vector_5", "d", "M18.632 20.6675C18.1191 20.3653 17.5697 20.1158 17.1049 19.7519C16.2258 19.0628 15.848 19.0331 15.017 19.7587C13.7784 20.8369 12.5627 20.8369 11.3264 19.7541C10.4999 19.0308 10.0878 19.0331 9.24992 19.7633C8.02965 20.8255 6.83687 20.8323 5.60516 19.7793C4.72373 19.0262 4.34597 19.0193 3.48285 19.7793C2.98147 20.2211 2.43888 20.5416 1.7429 20.5347C1.33538 20.5302 1.0698 20.347 1.03317 19.9464C0.996535 19.5687 1.2438 19.3856 1.58263 19.2482C1.99473 19.0834 2.42972 18.9095 2.76626 18.6348C3.91784 17.6939 5.16787 17.6688 6.2874 18.6302C7.24438 19.452 7.58779 19.452 8.54706 18.6302C9.67117 17.6688 10.9418 17.6733 12.059 18.6439C12.984 19.4451 13.3617 19.4474 14.2752 18.6577C15.4245 17.6642 16.6608 17.6756 17.8376 18.6462C18.1489 18.9026 18.5313 19.1017 18.9136 19.2276C19.3051 19.3581 19.6004 19.5229 19.55 19.9625C19.4951 20.4409 19.1471 20.5691 18.7098 20.521C18.6846 20.5714 18.6595 20.6194 18.632 20.6675Z"], ["id", "Vector_6", "d", "M19.6363 7.60047C18.8098 7.08542 18.0863 6.60928 17.34 6.17663C15.4329 5.07557 13.4067 4.26523 11.2547 3.79138C10.8769 3.70897 10.7281 3.56476 10.8678 3.16645C11.099 2.5049 11.2982 1.82961 11.5157 1.16348C11.6118 0.865894 11.795 0.74685 12.1224 0.82468C15.671 1.65792 18.1916 3.69753 19.5264 7.12662C19.5722 7.24108 19.5836 7.36927 19.6363 7.60047Z"], ["id", "Vector_7", "d", "M15.5924 13.2681C16.6203 13.9755 17.543 14.8751 18.3099 15.9212C18.4061 16.0517 18.2573 16.4431 18.1153 16.6354C18.0077 16.7796 17.6895 16.9101 17.5338 16.8552C16.0617 16.3447 14.7178 16.521 13.5273 17.5465C13.2457 17.7891 13.0488 17.7731 12.8016 17.5236C12.6298 17.3496 12.4169 17.2168 12.2269 17.0589C12.2017 17.0383 12.2017 16.9902 12.2132 17.0245C13.3373 15.7793 14.4339 14.5569 15.5924 13.2681Z"], ["id", "icons-eye", "viewBox", "0 0 1152 1024"], ["d", "M576 339.337c-17.284 0.277-33.81 3.078-49.376 8.046l1.208-0.334c6.925 11.969 11.049 26.299 11.158 41.595v0.030c0 47.677-38.649 86.337-86.337 86.337v0c-15.326-0.109-29.656-4.236-42.039-11.377l0.414 0.219c-4.275 14.295-6.744 30.717-6.744 47.711 0 95.11 77.105 172.216 172.216 172.216s172.216-77.105 172.216-172.216c0-95.11-77.105-172.216-172.216-172.216-0.182 0-0.364 0-0.546 0.001h0.026zM1014.635 489.488c-83.601-163.121-249.117-273.488-438.635-273.488s-355.073 110.445-438.635 273.508c-3.385 6.548-5.364 14.296-5.364 22.502s1.979 15.954 5.494 22.777l-0.129-0.277c83.601 163.121 249.117 273.488 438.635 273.488s355.073-110.445 438.635-273.508c3.385-6.548 5.364-14.296 5.364-22.502s-1.979-15.954-5.494-22.777l0.129 0.277zM576 734c-152.088 0-291.511-84.788-366.806-222 75.295-137.212 214.707-222 366.806-222s291.511 84.788 366.806 222c-75.276 137.212-214.707 222-366.806 222z"], ["id", "icons-slash", "viewBox", "0 0 1280 1024"], ["d", "M218.905 180.221c-18.288-14.86-45.16-12.080-60.019 6.209s-12.080 45.16 6.209 60.020l682.666 554.665c18.287 14.861 45.158 12.083 60.019-6.208 14.861-18.287 12.079-45.158-6.208-60.019l-102.579-83.345c0.725-0.687 1.451-1.374 2.167-2.061 30.507-29.227 52.838-58.389 67.601-80.32 7.403-10.995 12.962-20.262 16.751-26.94 1.894-3.341 3.349-6.042 4.373-7.996 0.512-0.973 0.917-1.766 1.216-2.355l0.371-0.734 0.124-0.256 0.068-0.137c0.009-0.017 0.017-0.034-38.332-18.739l38.349 18.705c5.756-11.806 5.756-25.609 0-37.41l-38.349 18.705c38.349-18.705 38.34-18.726 38.332-18.743l-0.021-0.038-0.047-0.098-0.124-0.252-0.371-0.738c-0.209-0.41-0.465-0.917-0.777-1.515-0.137-0.265-0.282-0.542-0.439-0.841-1.024-1.954-2.479-4.655-4.373-7.996-3.789-6.673-9.348-15.945-16.751-26.94-14.763-21.931-37.094-51.092-67.601-80.318-61.15-58.58-156.527-118.523-289.161-118.523-61.205 0-114.474 12.764-160.109 32.268l-132.986-108.050zM429.841 351.605l302.225 245.562c3.46-3.089 6.814-6.195 10.065-9.31 25.165-24.107 43.678-48.277 55.842-66.347 2.295-3.413 4.361-6.601 6.191-9.506-1.83-2.91-3.895-6.093-6.191-9.51-12.164-18.069-30.677-42.24-55.842-66.347-50.197-48.087-125.487-94.811-230.131-94.811-29.722 0-57.075 3.77-82.159 10.269zM511.863 682.671l91.465 75.324c-28.207 6.366-58.637 10.010-91.328 10.010-132.633 0-228.009-59.942-289.16-118.524-30.509-29.227-52.839-58.389-67.601-80.32-7.402-10.995-12.963-20.262-16.749-26.94-1.895-3.341-3.351-6.042-4.375-7.996-0.512-0.973-0.917-1.766-1.216-2.355l-0.369-0.734-0.125-0.256-0.048-0.094-0.020-0.043c-0.009-0.017-0.017-0.034 38.33-18.739-38.348-18.705-38.339-18.726-38.33-18.743l0.020-0.038 0.048-0.098 0.125-0.252 0.369-0.738c0.299-0.589 0.704-1.378 1.216-2.355 1.025-1.954 2.481-4.655 4.375-7.996 3.787-6.673 9.347-15.945 16.749-26.94 7.963-11.827 18.127-25.762 30.589-40.673l65.873 54.25c-10.486 12.51-19.027 24.201-25.673 34.074-2.299 3.418-4.362 6.601-6.192 9.51 1.83 2.906 3.893 6.093 6.192 9.506 12.163 18.069 30.677 42.24 55.843 66.347 50.174 48.068 125.421 94.771 229.993 94.814zM170.667 512.004l-38.348 18.705c-5.758-11.806-5.758-25.609 0-37.41l38.348 18.705z"]], template: function SvgIconDefinitionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0)(1, "defs")(2, "symbol", 1);
        ɵngcc0.ɵɵelement(3, "path", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "symbol", 3);
        ɵngcc0.ɵɵelement(5, "path", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "symbol", 5);
        ɵngcc0.ɵɵelement(7, "path", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "symbol", 7);
        ɵngcc0.ɵɵelement(9, "path", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "symbol", 9);
        ɵngcc0.ɵɵelement(11, "path", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "symbol", 11);
        ɵngcc0.ɵɵelement(13, "path", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "symbol", 13);
        ɵngcc0.ɵɵelement(15, "path", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "symbol", 15);
        ɵngcc0.ɵɵelement(17, "path", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "symbol", 17);
        ɵngcc0.ɵɵelement(19, "path", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "symbol", 19);
        ɵngcc0.ɵɵelement(21, "path", 20)(22, "path", 21)(23, "path", 22)(24, "path", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "symbol", 24);
        ɵngcc0.ɵɵelement(26, "path", 25);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "symbol", 26);
        ɵngcc0.ɵɵelement(28, "path", 27);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "symbol", 28);
        ɵngcc0.ɵɵelement(30, "path", 29);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "symbol", 30);
        ɵngcc0.ɵɵelement(32, "path", 31);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "symbol", 32);
        ɵngcc0.ɵɵelement(34, "path", 33);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "svg", 34);
        ɵngcc0.ɵɵelement(36, "path", 35)(37, "path", 36)(38, "path", 37);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(39, "symbol", 38);
        ɵngcc0.ɵɵelement(40, "path", 39);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "symbol", 40);
        ɵngcc0.ɵɵelement(42, "path", 41)(43, "path", 42);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(44, "symbol", 43);
        ɵngcc0.ɵɵelement(45, "path", 44)(46, "path", 45);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "symbol", 46);
        ɵngcc0.ɵɵelement(48, "path", 47);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(49, "symbol", 48);
        ɵngcc0.ɵɵelement(50, "path", 49);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "symbol", 50);
        ɵngcc0.ɵɵelement(52, "path", 51);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(53, "symbol", 52);
        ɵngcc0.ɵɵelement(54, "path", 53);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(55, "symbol", 54);
        ɵngcc0.ɵɵelement(56, "path", 55);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(57, "symbol", 56);
        ɵngcc0.ɵɵelement(58, "path", 57);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(59, "symbol", 58);
        ɵngcc0.ɵɵelement(60, "path", 59);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(61, "symbol", 60);
        ɵngcc0.ɵɵelement(62, "path", 61);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(63, "symbol", 62);
        ɵngcc0.ɵɵelement(64, "path", 63);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(65, "symbol", 64);
        ɵngcc0.ɵɵelement(66, "path", 65)(67, "path", 66);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(68, "symbol", 67);
        ɵngcc0.ɵɵelement(69, "path", 68)(70, "circle", 69);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(71, "symbol", 70);
        ɵngcc0.ɵɵelement(72, "path", 71);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(73, "symbol", 72);
        ɵngcc0.ɵɵelement(74, "path", 73);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(75, "symbol", 74);
        ɵngcc0.ɵɵelement(76, "path", 75);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(77, "symbol", 76);
        ɵngcc0.ɵɵelement(78, "path", 77);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(79, "symbol", 78);
        ɵngcc0.ɵɵelement(80, "path", 79);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(81, "symbol", 80);
        ɵngcc0.ɵɵelement(82, "path", 81);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(83, "symbol", 82);
        ɵngcc0.ɵɵelement(84, "path", 83);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(85, "symbol", 84);
        ɵngcc0.ɵɵelement(86, "path", 85);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(87, "symbol", 15);
        ɵngcc0.ɵɵelement(88, "path", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(89, "symbol", 86);
        ɵngcc0.ɵɵelement(90, "path", 87);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(91, "symbol", 88);
        ɵngcc0.ɵɵelement(92, "path", 89);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(93, "symbol", 90);
        ɵngcc0.ɵɵelement(94, "path", 91);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(95, "symbol", 92);
        ɵngcc0.ɵɵelement(96, "path", 93);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(97, "symbol", 94);
        ɵngcc0.ɵɵelement(98, "path", 95);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(99, "symbol", 96);
        ɵngcc0.ɵɵelement(100, "path", 97);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(101, "symbol", 98);
        ɵngcc0.ɵɵelement(102, "path", 99);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(103, "symbol", 100);
        ɵngcc0.ɵɵelement(104, "path", 101);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(105, "symbol", 102);
        ɵngcc0.ɵɵelement(106, "path", 103);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(107, "symbol", 104);
        ɵngcc0.ɵɵelement(108, "path", 105)(109, "path", 106)(110, "path", 107);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(111, "symbol", 108);
        ɵngcc0.ɵɵelement(112, "path", 109);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(113, "symbol", 110);
        ɵngcc0.ɵɵelement(114, "path", 111);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(115, "symbol", 112);
        ɵngcc0.ɵɵelement(116, "path", 113)(117, "path", 114);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(118, "symbol", 115);
        ɵngcc0.ɵɵelement(119, "path", 116);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(120, "symbol", 117);
        ɵngcc0.ɵɵelement(121, "path", 118);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(122, "svg", 119);
        ɵngcc0.ɵɵelement(123, "path", 120);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(124, "svg", 121);
        ɵngcc0.ɵɵelement(125, "path", 122);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(126, "symbol", 123);
        ɵngcc0.ɵɵelement(127, "path", 124);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(128, "symbol", 125)(129, "g", 126);
        ɵngcc0.ɵɵelement(130, "path", 127)(131, "path", 128)(132, "path", 129);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(133, "defs")(134, "clipPath", 130);
        ɵngcc0.ɵɵelement(135, "rect", 131);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(136, "symbol", 132)(137, "g", 126);
        ɵngcc0.ɵɵelement(138, "path", 133);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(139, "defs")(140, "clipPath", 130);
        ɵngcc0.ɵɵelement(141, "rect", 134);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(142, "symbol", 135)(143, "g", 126);
        ɵngcc0.ɵɵelement(144, "path", 136);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(145, "defs")(146, "clipPath", 130);
        ɵngcc0.ɵɵelement(147, "rect", 137);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(148, "symbol", 138);
        ɵngcc0.ɵɵelement(149, "path", 139);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(150, "symbol", 140);
        ɵngcc0.ɵɵelement(151, "path", 141);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(152, "symbol", 142);
        ɵngcc0.ɵɵelement(153, "path", 143);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(154, "symbol", 144);
        ɵngcc0.ɵɵelement(155, "path", 145)(156, "path", 146)(157, "rect", 147)(158, "path", 148);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(159, "symbol", 149);
        ɵngcc0.ɵɵelement(160, "path", 145)(161, "path", 146)(162, "rect", 147)(163, "path", 150);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(164, "symbol", 151);
        ɵngcc0.ɵɵelement(165, "path", 145)(166, "path", 146)(167, "rect", 152)(168, "path", 153);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(169, "symbol", 154)(170, "g");
        ɵngcc0.ɵɵelement(171, "path", 155)(172, "path", 156)(173, "path", 157)(174, "path", 158)(175, "path", 159)(176, "path", 160)(177, "path", 161)(178, "path", 162)(179, "path", 163)(180, "path", 164)(181, "path", 165);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(182, "symbol", 166);
        ɵngcc0.ɵɵelement(183, "path", 167)(184, "path", 168);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(185, "symbol", 169);
        ɵngcc0.ɵɵelement(186, "path", 170);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(187, "symbol", 171);
        ɵngcc0.ɵɵelement(188, "path", 172);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(189, "symbol", 173);
        ɵngcc0.ɵɵelement(190, "path", 174);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(191, "symbol", 175);
        ɵngcc0.ɵɵelement(192, "path", 176)(193, "path", 177)(194, "path", 178)(195, "path", 179)(196, "path", 180)(197, "path", 181);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(198, "symbol", 182)(199, "g", 183)(200, "g", 184);
        ɵngcc0.ɵɵelement(201, "path", 185)(202, "path", 186)(203, "path", 187);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(204, "symbol", 188);
        ɵngcc0.ɵɵelement(205, "path", 189)(206, "path", 190)(207, "path", 191)(208, "path", 192)(209, "path", 193)(210, "path", 194);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(211, "svg", 195);
        ɵngcc0.ɵɵelement(212, "path", 196)(213, "path", 197)(214, "path", 198)(215, "path", 199);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(216, "svg", 200);
        ɵngcc0.ɵɵelement(217, "path", 201);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(218, "symbol", 202);
        ɵngcc0.ɵɵtext(219, "> ");
        ɵngcc0.ɵɵelement(220, "path", 203)(221, "path", 204)(222, "path", 205)(223, "path", 206)(224, "path", 207)(225, "path", 208)(226, "path", 209)(227, "path", 210)(228, "path", 211);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(229, "symbol", 212);
        ɵngcc0.ɵɵelement(230, "path", 213)(231, "path", 214);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(232, "symbol", 215);
        ɵngcc0.ɵɵelement(233, "path", 216);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(234, "symbol", 217)(235, "g", 218);
        ɵngcc0.ɵɵelement(236, "path", 219)(237, "path", 220)(238, "path", 221)(239, "path", 222)(240, "path", 223)(241, "path", 224)(242, "path", 225);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(243, "symbol", 226);
        ɵngcc0.ɵɵelement(244, "path", 227);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(245, "symbol", 228);
        ɵngcc0.ɵɵelement(246, "path", 229);
        ɵngcc0.ɵɵelementEnd()()();
    } }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgIconDefinitionsComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-svg-icon-definitions',
                template: "<svg aria-hidden=\"true\" style=\"position: absolute; width: 0; height: 0; overflow: hidden;\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n<defs>\n<symbol id=\"icons-switcher\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z\"/>\n</symbol>\n\n<symbol id=\"icons-date\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 3C6 2.44772 6.44772 2 7 2C7.55228 2 8 2.44772 8 3L8 4H16V3C16 2.44772 16.4477 2 17 2C17.5523 2 18 2.44772 18 3V4.12602C19.7252 4.57006 21 6.13616 21 8V17C21 19.2091 19.2091 21 17 21H7C4.79086 21 3 19.2091 3 17V8C3 6.13616 4.27477 4.57006 6 4.12602L6 3ZM5 16V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V16H5Z\"/>\n</symbol>\n\n<symbol id=\"icons-done\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.9476 7.08676C19.3524 7.46256 19.3758 8.09529 19 8.50001L11.2328 16.6804C11.0479 16.8795 10.7901 16.9948 10.5185 16.9998C10.2469 17.0049 9.98496 16.8992 9.79288 16.7071L5.50006 12.4142C5.10954 12.0237 5.10954 11.3905 5.50006 11C5.89059 10.6094 6.52375 10.6094 6.91427 11L10.4733 14.5591L17.5344 7.1391C17.9102 6.73439 18.5429 6.71096 18.9476 7.08676Z\"/>\n</symbol>\n\n<symbol id=\"icons-selector-down\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M3 5H13L8 11L3 5Z\"/>\n</symbol>\n\n<symbol id=\"icons-selector-up\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M13 11L3 11L8 5L13 11Z\"/>\n</symbol>\n\n<symbol id=\"icons-star-outline\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.807 2.60164C12.6554 2.29446 12.3426 2.1 12 2.1C11.6574 2.1 11.3446 2.29446 11.193 2.60164L8.62117 7.81182L2.86984 8.65246C2.53093 8.702 2.24952 8.9396 2.14388 9.26541C2.03824 9.59122 2.12669 9.94874 2.37204 10.1877L6.53293 14.2404L5.55095 19.9659C5.49304 20.3035 5.63186 20.6448 5.90904 20.8461C6.18622 21.0475 6.55368 21.074 6.85691 20.9146L12 18.2099L17.1431 20.9146C17.4463 21.074 17.8138 21.0475 18.091 20.8461C18.3681 20.6448 18.507 20.3035 18.449 19.9659L17.4671 14.2404L21.628 10.1877C21.8733 9.94874 21.9618 9.59122 21.8561 9.26541C21.7505 8.9396 21.4691 8.702 21.1302 8.65246L15.3788 7.81182L12.807 2.60164ZM10.026 9.03236L12 5.03333L13.974 9.03236C14.105 9.29772 14.358 9.48174 14.6508 9.52454L19.0664 10.1699L15.872 13.2813C15.6598 13.488 15.5629 13.7861 15.613 14.0781L16.3666 18.4725L12.4189 16.3964C12.1567 16.2585 11.8433 16.2585 11.5811 16.3964L7.63336 18.4725L8.38705 14.0781C8.43714 13.7861 8.34025 13.488 8.12796 13.2813L4.93357 10.1699L9.34917 9.52454C9.64199 9.48174 9.89505 9.29772 10.026 9.03236Z\"/>\n</symbol>\n\n<symbol id=\"icons-star-filled\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M12 2.1C12.3426 2.1 12.6554 2.29446 12.807 2.60164L15.3788 7.81182L21.1302 8.65246C21.4691 8.702 21.7505 8.9396 21.8561 9.26541C21.9618 9.59122 21.8733 9.94874 21.628 10.1877L17.4671 14.2404L18.449 19.9659C18.507 20.3035 18.3681 20.6448 18.091 20.8461C17.8138 21.0475 17.4463 21.074 17.1431 20.9146L12 18.2099L6.85691 20.9146C6.55368 21.074 6.18622 21.0475 5.90904 20.8461C5.63186 20.6448 5.49304 20.3035 5.55095 19.9659L6.53293 14.2404L2.37204 10.1877C2.12669 9.94874 2.03824 9.59122 2.14388 9.26541C2.24952 8.9396 2.53093 8.702 2.86984 8.65246L8.62117 7.81182L11.193 2.60164C11.3446 2.29446 11.6574 2.1 12 2.1Z\"/>\n</symbol>\n\n<symbol id=\"icons-enter\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 6C7 5.44772 7.44772 5 8 5H16C16.5523 5 17 5.44772 17 6V18C17 18.5523 16.5523 19 16 19H8C7.44772 19 7 18.5523 7 18V16C7 15.4477 6.55228 15 6 15C5.44772 15 5 15.4477 5 16V18C5 19.6569 6.34315 21 8 21H16C17.6569 21 19 19.6569 19 18V6C19 4.34315 17.6569 3 16 3H8C6.34315 3 5 4.34315 5 6V7V8V10C5 11.6569 6.34315 13 8 13H10V15L14 12L10 9V11H8C7.44772 11 7 10.5523 7 10V8V7V6Z\"/>\n</symbol>\n\n<symbol id=\"icons-close\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L8 6.58579L11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289C13.0976 3.68342 13.0976 4.31658 12.7071 4.70711L9.41421 8L12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L8 9.41421L4.70711 12.7071C4.31658 13.0976 3.68342 13.0976 3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L6.58579 8L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z\"/>\n</symbol>\n\n<symbol id=\"icons-printer\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M 20.484375 6.046875 L 19.828125 6.046875 L 19.828125 3.515625 C 19.828125 1.578125 18.25 0 16.3125 0 L 7.6875 0 C 5.75 0 4.171875 1.578125 4.171875 3.515625 L 4.171875 6.046875 L 3.515625 6.046875 C 1.578125 6.046875 0 7.625 0 9.5625 L 0 15.1875 C 0 17.125 1.578125 18.703125 3.515625 18.703125 L 4.171875 18.703125 L 4.171875 21.890625 C 4.171875 23.054688 5.117188 24 6.28125 24 L 17.71875 24 C 18.882812 24 19.828125 23.054688 19.828125 21.890625 L 19.828125 18.703125 L 20.484375 18.703125 C 22.421875 18.703125 24 17.125 24 15.1875 L 24 9.5625 C 24 7.625 22.421875 6.046875 20.484375 6.046875 Z M 5.578125 3.515625 C 5.578125 2.351562 6.523438 1.40625 7.6875 1.40625 L 16.3125 1.40625 C 17.476562 1.40625 18.421875 2.351562 18.421875 3.515625 L 18.421875 6.046875 L 5.578125 6.046875 Z M 18.421875 21.890625 C 18.421875 22.277344 18.105469 22.59375 17.71875 22.59375 L 6.28125 22.59375 C 5.894531 22.59375 5.578125 22.277344 5.578125 21.890625 L 5.578125 14.953125 L 18.421875 14.953125 Z M 22.59375 15.1875 C 22.59375 16.351562 21.648438 17.296875 20.484375 17.296875 L 19.828125 17.296875 L 19.828125 14.953125 L 20.25 14.953125 C 20.636719 14.953125 20.953125 14.636719 20.953125 14.25 C 20.953125 13.863281 20.636719 13.546875 20.25 13.546875 L 3.75 13.546875 C 3.363281 13.546875 3.046875 13.863281 3.046875 14.25 C 3.046875 14.636719 3.363281 14.953125 3.75 14.953125 L 4.171875 14.953125 L 4.171875 17.296875 L 3.515625 17.296875 C 2.351562 17.296875 1.40625 16.351562 1.40625 15.1875 L 1.40625 9.5625 C 1.40625 8.398438 2.351562 7.453125 3.515625 7.453125 L 20.484375 7.453125 C 21.648438 7.453125 22.59375 8.398438 22.59375 9.5625 Z M 22.59375 15.1875 \"/>\n<path d=\"M 13.875 16.546875 L 10.125 16.546875 C 9.738281 16.546875 9.421875 16.863281 9.421875 17.25 C 9.421875 17.636719 9.738281 17.953125 10.125 17.953125 L 13.875 17.953125 C 14.261719 17.953125 14.578125 17.636719 14.578125 17.25 C 14.578125 16.863281 14.261719 16.546875 13.875 16.546875 Z M 13.875 16.546875 \"/>\n<path  d=\"M 13.875 19.546875 L 10.125 19.546875 C 9.738281 19.546875 9.421875 19.863281 9.421875 20.25 C 9.421875 20.636719 9.738281 20.953125 10.125 20.953125 L 13.875 20.953125 C 14.261719 20.953125 14.578125 20.636719 14.578125 20.25 C 14.578125 19.863281 14.261719 19.546875 13.875 19.546875 Z M 13.875 19.546875 \"/>\n<path  d=\"M 6 9.046875 L 3.75 9.046875 C 3.363281 9.046875 3.046875 9.363281 3.046875 9.75 C 3.046875 10.136719 3.363281 10.453125 3.75 10.453125 L 6 10.453125 C 6.386719 10.453125 6.703125 10.136719 6.703125 9.75 C 6.703125 9.363281 6.386719 9.046875 6 9.046875 Z M 6 9.046875 \"/>\n</symbol>\n\n<symbol id=\"icons-corner-right\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.27337 2.27036C4.90888 2.63085 4.90888 3.21531 5.27337 3.57579L9.74673 8L5.27337 12.4242C4.90888 12.7847 4.90888 13.3692 5.27337 13.7296C5.63786 14.0901 6.22881 14.0901 6.5933 13.7296L11.7266 8.65271C12.0911 8.29223 12.0911 7.70777 11.7266 7.34729L6.5933 2.27036C6.22881 1.90988 5.63786 1.90988 5.27337 2.27036Z\"/>\n</symbol>\n\n<symbol id=\"icons-corner-left\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.7266 2.27036C11.0911 2.63085 11.0911 3.21531 10.7266 3.57579L6.25327 8L10.7266 12.4242C11.0911 12.7847 11.0911 13.3692 10.7266 13.7296C10.3621 14.0901 9.77119 14.0901 9.4067 13.7296L4.27337 8.65271C3.90888 8.29223 3.90888 7.70777 4.27337 7.34729L9.4067 2.27036C9.77119 1.90988 10.3621 1.90988 10.7266 2.27036Z\"/>\n</symbol>\n\n<symbol id=\"icons-facebook\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M13.1133 21.2885V12.0547H15.6622L16 8.87263H13.1133L13.1176 7.28C13.1176 6.45007 13.1965 6.00538 14.3885 6.00538H15.982V2.823H13.4327C10.3705 2.823 9.29276 4.36662 9.29276 6.96251V8.87299H7.38403V12.055H9.29276V21.2885H13.1133Z\"/>\n</symbol>\n\n<symbol id=\"icons-vkontakte\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M12.9808 18.1533C12.9808 18.1533 13.3417 18.1139 13.5266 17.919C13.6958 17.7404 13.69 17.4033 13.69 17.4033C13.69 17.4033 13.6675 15.8296 14.4119 15.5972C15.1455 15.3687 16.0876 17.1191 17.0873 17.7922C17.8425 18.3011 18.4157 18.1897 18.4157 18.1897L21.0872 18.1533C21.0872 18.1533 22.484 18.0688 21.8218 16.9904C21.767 16.9021 21.4354 16.1925 19.836 14.7349C18.1604 13.2092 18.3854 13.4559 20.4024 10.8163C21.6311 9.20895 22.1221 8.22762 21.9685 7.80801C21.8228 7.40665 20.9189 7.51323 20.9189 7.51323L17.9119 7.53147C17.9119 7.53147 17.6889 7.50171 17.5236 7.59869C17.3622 7.69375 17.2575 7.91556 17.2575 7.91556C17.2575 7.91556 16.7821 9.15902 16.1472 10.2172C14.8081 12.4487 14.273 12.5668 14.0539 12.4285C13.5442 12.1049 13.6714 11.1303 13.6714 10.438C13.6714 8.27467 14.0059 7.37304 13.0209 7.13971C12.6942 7.06194 12.4535 7.01104 11.6172 7.0024C10.5441 6.99184 9.63628 7.00624 9.12175 7.25302C8.77937 7.41721 8.51526 7.78401 8.67666 7.80513C8.87524 7.83106 9.32521 7.9242 9.5639 8.24299C9.87203 8.65491 9.86127 9.57863 9.86127 9.57863C9.86127 9.57863 10.0383 12.1251 9.44749 12.441C9.04251 12.658 8.48689 12.2153 7.2925 10.1903C6.68112 9.15326 6.21941 8.00678 6.21941 8.00678C6.21941 8.00678 6.13039 7.79265 5.97094 7.67743C5.77824 7.5382 5.50923 7.49499 5.50923 7.49499L2.65189 7.51323C2.65189 7.51323 2.22246 7.52475 2.06497 7.70815C1.92508 7.87043 2.05421 8.20746 2.05421 8.20746C2.05421 8.20746 4.29136 13.3455 6.82492 15.9352C9.14816 18.3088 11.7854 18.1533 11.7854 18.1533H12.9808Z\"/>\n</symbol>\n\n<symbol id=\"icons-vs\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M3.29184 3.36914L7.99403 15.0831H10.2537L11.462 12.0731C11.5025 12.3626 11.5709 12.626 11.6671 12.8634C11.8444 13.2622 12.1157 13.5945 12.4813 13.8603C12.8579 14.1262 13.2511 14.3422 13.661 14.5083C14.0708 14.6634 14.6081 14.824 15.2727 14.9902C16.2142 15.2339 16.8401 15.461 17.1502 15.6714C17.4604 15.8708 17.6155 16.1367 17.6155 16.469C17.6155 16.8234 17.4659 17.1004 17.1669 17.2998C16.8678 17.4991 16.4579 17.5988 15.9373 17.5988C14.7631 17.5988 13.6056 17.1281 12.4647 16.1865L10.9527 17.9976C12.3373 19.2382 13.9822 19.8585 15.8875 19.8585C17.1724 19.8585 18.2026 19.5428 18.9779 18.9115C19.7644 18.269 20.1576 17.3828 20.1576 16.253C20.1576 15.2782 19.8586 14.5305 19.2604 14.0099C18.6623 13.4893 17.7318 13.0628 16.469 12.7305C15.4388 12.4646 14.7631 12.2376 14.4419 12.0492C14.1207 11.8609 13.9601 11.5785 13.9601 11.2019C13.9601 10.8917 14.0874 10.6425 14.3422 10.4542C14.6081 10.2548 14.9791 10.1551 15.4555 10.1551C16.3748 10.1551 17.3829 10.5372 18.4795 11.3016L19.8087 9.37415C18.5792 8.3883 17.1392 7.89537 15.4887 7.89537C14.4408 7.89537 13.5586 8.14183 12.8422 8.63476L14.9559 3.36914H12.1978L9.15712 11.5606L6.11648 3.36914H3.29184Z\"/>\n</symbol>\n\n  <svg id=\"icons-burger\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\">\n    <path d=\"M250.665 288h522.666c20.62 0 37.335 16.715 37.335 37.335s-16.715 37.335-37.335 37.335h-522.666c-20.62 0-37.335-16.715-37.335-37.335s16.715-37.335 37.335-37.335z\"></path>\n    <path d=\"M250.665 474.665h522.666c20.62 0 37.335 16.715 37.335 37.335s-16.715 37.335-37.335 37.335h-522.666c-20.62 0-37.335-16.715-37.335-37.335s16.715-37.335 37.335-37.335z\"></path>\n    <path d=\"M250.665 661.335h522.666c20.62 0 37.335 16.715 37.335 37.335s-16.715 37.335-37.335 37.335h-522.666c-20.62 0-37.335-16.715-37.335-37.335s16.715-37.335 37.335-37.335z\"></path>\n  </svg>\n\n\n  <symbol id=\"icons-cloud-download\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.3336 8.46237C10.0993 6.4567 12.1114 5 14.5 5C17.5708 5 20 7.39519 20 10.2769C20 11.441 19.6082 12.5172 18.9391 13.3929C18.6038 13.8317 18.6877 14.4593 19.1266 14.7946C19.5654 15.1299 20.193 15.046 20.5283 14.6071C21.451 13.3996 22 11.9005 22 10.2769C22 6.22537 18.6089 3 14.5 3C11.6139 3 9.0915 4.58527 7.83819 6.9309C7.5652 6.88603 7.28511 6.86273 7 6.86273C4.27178 6.86273 2 9.00722 2 11.7255C2 12.8035 2.36174 13.7995 2.96883 14.6029C3.30179 15.0435 3.92891 15.1308 4.36954 14.7978C4.81017 14.4649 4.89746 13.8378 4.5645 13.3971C4.20732 12.9244 4 12.3481 4 11.7255C4 10.177 5.30994 8.86273 7 8.86273C7.37537 8.86273 7.73216 8.92812 8.06009 9.04639C8.57282 9.23132 9.1392 8.97158 9.3336 8.46237ZM9.70711 15.7929C9.31658 15.4024 8.68342 15.4024 8.29289 15.7929C7.90237 16.1834 7.90237 16.8166 8.29289 17.2071L11.2929 20.2071C11.6834 20.5976 12.3166 20.5976 12.7071 20.2071L15.7071 17.2071C16.0976 16.8166 16.0976 16.1834 15.7071 15.7929C15.3166 15.4024 14.6834 15.4024 14.2929 15.7929L13 17.0858V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V17.0858L9.70711 15.7929Z\"/>\n</symbol>\n\n<symbol id=\"icons-full-screen\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.06633 18.0663L10.1464 20.1464C10.4614 20.4614 10.2383 21 9.79289 21H3.5C3.22386 21 3 20.7761 3 20.5V14.2071C3 13.7617 3.53857 13.5386 3.85355 13.8536L5.94501 15.945L8.3354 13.5546C8.53066 13.3594 8.84724 13.3594 9.0425 13.5546L10.4567 14.9688C10.652 15.1641 10.652 15.4807 10.4567 15.6759L8.06633 18.0663Z\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.9337 5.93369L13.8536 3.85357C13.5386 3.53858 13.7617 3.00001 14.2071 3.00001H20.5C20.7761 3.00001 21 3.22387 21 3.50001V9.79291C21 10.2384 20.4614 10.4614 20.1464 10.1465L18.055 8.05501L16.0182 10.0918C15.6276 10.4824 14.9945 10.4824 14.6039 10.0918L13.8968 9.38473C13.5063 8.99421 13.5063 8.36105 13.8968 7.97052L15.9337 5.93369Z\"/>\n</symbol>\n\n<symbol id=\"icons-full-screen-off\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.53682 16.3418L3.4567 14.2617C3.14172 13.9467 3.3648 13.4082 3.81026 13.4082H10.1031C10.3793 13.4082 10.6031 13.632 10.6031 13.9082V20.2011C10.6031 20.6465 10.0646 20.8696 9.7496 20.5546L7.65814 18.4632L5.26775 20.8536C5.07249 21.0488 4.75591 21.0488 4.56065 20.8536L3.14643 19.4393C2.95117 19.2441 2.95117 18.9275 3.14643 18.7322L5.53682 16.3418Z\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.6703 7.45105L20.7504 9.53117C21.0654 9.84615 20.8423 10.3847 20.3968 10.3847H14.1039C13.8278 10.3847 13.6039 10.1609 13.6039 9.88472V3.59183C13.6039 3.14637 14.1425 2.92329 14.4575 3.23827L16.549 5.32973L18.5858 3.29289C18.9763 2.90237 19.6095 2.90237 20 3.29289L20.7071 4C21.0976 4.39052 21.0976 5.02369 20.7071 5.41421L18.6703 7.45105Z\"/>\n</symbol>\n\n<symbol id=\"icons-settings\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7C9.55228 7 10 7.44772 10 8C10 8.55228 9.55228 9 9 9ZM9 5C10.3062 5 11.4175 5.83481 11.8293 7H19C19.5523 7 20 7.44772 20 8C20 8.55228 19.5523 9 19 9H11.8293C11.4175 10.1652 10.3062 11 9 11C7.68867 11 6.57385 10.1586 6.1659 8.9863C6.11194 8.99531 6.05652 9 6 9H5C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7H6C6.05652 7 6.11194 7.00469 6.1659 7.0137C6.57385 5.84136 7.68867 5 9 5ZM18 17C17.4477 17 17 16.5523 17 16C17 15.4477 17.4477 15 18 15C18.5523 15 19 15.4477 19 16C19 16.5523 18.5523 17 18 17ZM15.1707 17C15.5825 18.1652 16.6938 19 18 19C19.6569 19 21 17.6569 21 16C21 14.3431 19.6569 13 18 13C16.6938 13 15.5825 13.8348 15.1707 15H5C4.44772 15 4 15.4477 4 16C4 16.5523 4.44772 17 5 17H15.1707Z\"/>\n</symbol>\n\n<symbol id=\"icons-media\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 3H12C12.5523 3 13 3.44772 13 4C13 4.55228 12.5523 5 12 5H6C4.34315 5 3 6.34315 3 8V16C3 17.6569 4.34315 19 6 19H18C19.6569 19 21 17.6569 21 16V8C21 6.34315 19.6569 5 18 5C17.4477 5 17 4.55228 17 4C17 3.44772 17.4477 3 18 3C20.7614 3 23 5.23858 23 8V16C23 18.7614 20.7614 21 18 21H6C3.23858 21 1 18.7614 1 16V8C1 5.23858 3.23858 3 6 3ZM9.5 12C9.5 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5Z\"/>\n</symbol>\n\n<symbol id=\"icons-close-circle\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM9.70711 8.29289C9.31658 7.90237 8.68342 7.90237 8.29289 8.29289C7.90237 8.68342 7.90237 9.31658 8.29289 9.70711L10.5858 12L8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071C8.68342 16.0976 9.31658 16.0976 9.70711 15.7071L12 13.4142L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13.4142 12L15.7071 9.70711C16.0976 9.31658 16.0976 8.68342 15.7071 8.29289C15.3166 7.90237 14.6834 7.90237 14.2929 8.29289L12 10.5858L9.70711 8.29289Z\"/>\n</symbol>\n\n<symbol id=\"icons-valleyball\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 5.99903C2.74418 7.67051 2 9.74835 2 12C2 13.5841 2.36832 15.0821 3.024 16.4132C4.30473 16.0296 5.50843 15.4675 6.60625 14.7557C4.95846 12.2398 4 9.23066 4 6C4 5.99968 4 5.99935 4 5.99903ZM8.20648 13.5475C9.09769 12.7689 9.88945 11.8791 10.5602 10.8995C9.55986 8.80946 9 6.46887 9 4C9 3.47192 9.02562 2.94964 9.0757 2.43436C8.01839 2.75719 7.03547 3.25051 6.15899 3.88228C6.05432 4.57254 6 5.2797 6 6C6 8.78061 6.80971 11.3699 8.20648 13.5475ZM21.7654 14.1634C19.2415 11.8668 15.9788 10.3653 12.3749 10.0584C11.9141 9.09999 11.5592 8.08087 11.3255 7.01595C11.5489 7.00536 11.7738 7 12 7C15.8998 7 19.4273 8.59457 21.9658 11.1673C21.9885 11.4419 22 11.7196 22 12C22 12.7428 21.919 13.4668 21.7654 14.1634ZM12 5C11.6768 5 11.3558 5.0096 11.0372 5.02853C11.0125 4.68895 11 4.34597 11 4C11 3.33334 11.0465 2.67794 11.1364 2.03677C11.4211 2.01242 11.7091 2 12 2C16.0359 2 19.5133 4.39083 21.0933 7.83344C18.5111 6.0467 15.3778 5 12 5ZM21.052 16.2554C19.4533 19.6502 16.001 22 12 22C11.1058 22 10.2389 21.8826 9.41411 21.6624C13.0216 20.082 15.9335 17.2094 17.5651 13.6315C18.862 14.3213 20.0377 15.2093 21.052 16.2554ZM12.196 12.0505C10.2562 14.8735 7.43254 17.0441 4.12351 18.162C4.84642 19.0847 5.72796 19.8772 6.72708 20.4984C10.7391 19.3932 14.0305 16.5471 15.7363 12.8214C14.6155 12.4185 13.4284 12.1547 12.196 12.0505Z\"/>\n</symbol>\n\n<symbol id=\"icons-search\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75736 5.75736C9.10051 3.41421 12.8995 3.41421 15.2426 5.75736C17.5858 8.1005 17.5858 11.8995 15.2426 14.2426C12.8995 16.5858 9.1005 16.5858 6.75736 14.2426C4.41421 11.8995 4.41421 8.1005 6.75736 5.75736ZM16.6569 4.34315C13.5327 1.21895 8.46734 1.21895 5.34315 4.34315C2.21895 7.46734 2.21895 12.5327 5.34315 15.6569C8.05307 18.3668 12.2235 18.7261 15.3207 16.7349L20.3033 21.7174C20.6938 22.108 21.327 22.108 21.7175 21.7174C22.108 21.3269 22.108 20.6938 21.7175 20.3032L16.8603 15.446C19.7795 12.3087 19.7117 7.39799 16.6569 4.34315Z\"/>\n</symbol>\n\n<symbol id=\"icons-basketball\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.99895 2.83255C6.29783 3.57603 4.84353 4.77912 3.79302 6.28485C4.8337 6.0977 5.90544 6 7 6C7.21739 6 7.43389 6.00385 7.64942 6.0115C7.87866 5.04496 8 4.03665 8 3C8 2.9441 7.99965 2.88828 7.99895 2.83255ZM7.00367 8C7.00245 8 7.00122 8 7 8C5.46927 8 3.98874 8.21496 2.58696 8.61634C2.20703 9.67312 2 10.8124 2 12C2 12.6306 2.05836 13.2475 2.16998 13.8457C4.30903 12.4287 6.00455 10.3959 7.00367 8ZM9.97926 2.20427C10.6319 2.07034 11.3077 2 12 2C13.0097 2 13.9844 2.14963 14.9032 2.42793L12.9869 7.01963C11.9201 6.64349 10.8072 6.36505 9.659 6.19503C9.88236 5.16546 10 4.09647 10 3C10 2.73307 9.99303 2.46777 9.97926 2.20427ZM2.76285 15.8376C5.663 14.0801 7.91996 11.3676 9.09757 8.13626C10.1741 8.27722 11.2169 8.5252 12.2151 8.86916L7.23792 20.7955C5.2348 19.7087 3.64458 17.9575 2.76285 15.8376ZM12 22C10.9852 22 10.0057 21.8488 9.0828 21.5678L14.0612 9.63846C14.9092 10.0562 15.7148 10.5468 16.4699 11.1021C14.9071 13.522 14 16.4051 14 19.5C14 20.2694 14.0561 21.0258 14.1643 21.7652C13.4674 21.9189 12.7432 22 12 22ZM17.6609 9.49523C16.7765 8.84411 15.8304 8.27195 14.833 7.78912L16.7492 3.19751C18.322 4.0479 19.6412 5.30755 20.5638 6.83373C19.4867 7.59504 18.511 8.49029 17.6609 9.49523ZM16 19.5C16 16.8941 16.7384 14.4606 18.0173 12.3974C19.2112 13.5315 20.2303 14.8479 21.0299 16.3021C20.0111 18.4367 18.2577 20.1533 16.0968 21.125C16.0329 20.5923 16 20.05 16 19.5ZM19.2036 10.7684C20.1898 11.6785 21.0741 12.6974 21.8373 13.8062C21.9442 13.2203 22 12.6167 22 12C22 10.8339 21.8004 9.71446 21.4335 8.67391C20.6133 9.28603 19.865 9.98918 19.2036 10.7684Z\"/>\n</symbol>\n\n<symbol id=\"icons-share\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 5.5C19 6.88071 17.8807 8 16.5 8C15.1193 8 14 6.88071 14 5.5C14 4.11929 15.1193 3 16.5 3C17.8807 3 19 4.11929 19 5.5ZM12.5145 9.25749C12.9881 8.97334 13.1416 8.35908 12.8575 7.8855C12.5733 7.41192 11.9591 7.25836 11.4855 7.54251L7.70653 9.80989C7.34881 9.6124 6.93753 9.5 6.5 9.5C5.11929 9.5 4 10.6193 4 12C4 13.3807 5.11929 14.5 6.5 14.5C6.8992 14.5 7.27655 14.4064 7.61131 14.24L14.0022 18.3941C14.0007 18.4292 14 18.4645 14 18.5C14 19.8807 15.1193 21 16.5 21C17.8807 21 19 19.8807 19 18.5C19 17.1193 17.8807 16 16.5 16C15.8872 16 15.3259 16.2205 14.891 16.5865L8.90244 12.6939C8.96596 12.4736 9 12.2408 9 12C9 11.7962 8.97561 11.5981 8.9296 11.4084L12.5145 9.25749Z\"/>\n</symbol>\n\n<symbol id=\"icons-edit\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M13.5557 5.28411C14.1509 4.25944 15.4691 3.90836 16.5 4.49996C17.5309 5.09155 17.8841 6.4018 17.2889 7.42647L11 17.5C10.2772 18.7444 8.45342 19.947 7.35936 20.4112C6.67629 20.7009 6.55057 20.4831 6.55057 19.947C6.55057 19.6338 6.5466 16.5974 7.26674 15.3576L13.5557 5.28411Z\"/>\n</symbol>\n\n<symbol id=\"icons-change\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.738 15.4396C19.2633 15.6102 19.5507 16.1744 19.38 16.6997L18.069 20.7346C17.8983 21.2599 17.3342 21.5473 16.8089 21.3767C16.2837 21.206 15.9962 20.6419 16.1669 20.1166L16.7006 18.474C15.3814 19.4334 13.7568 20.0001 12 20.0001C9.08871 20.0001 6.54174 18.4444 5.14344 16.1237C4.85841 15.6507 5.01083 15.0361 5.48388 14.7511C5.95693 14.4661 6.57147 14.6185 6.8565 15.0915C7.90798 16.8366 9.81861 18.0001 12 18.0001C13.4644 18.0001 14.8062 17.4761 15.8485 16.6036L14.085 16.0306C13.5597 15.86 13.2723 15.2958 13.4429 14.7706C13.6136 14.2453 14.1778 13.9579 14.703 14.1285L18.738 15.4396ZM5.29692 8.54894C4.77166 8.37828 4.48421 7.81413 4.65488 7.28887L5.96593 3.25388C6.13659 2.72863 6.70075 2.44118 7.226 2.61184C7.75125 2.78251 8.0387 3.34666 7.86804 3.87191L7.34016 5.49657C8.652 4.55513 10.2612 4 11.9998 4C14.9111 4 17.4581 5.55572 18.8564 7.8764C19.1414 8.34945 18.989 8.96399 18.516 9.24902C18.0429 9.53405 17.4284 9.38163 17.1433 8.90858C16.0919 7.16351 14.1812 6 11.9998 6C10.5447 6 9.21068 6.51737 8.17122 7.37994L9.94994 7.95788C10.4752 8.12854 10.7626 8.6927 10.592 9.21795C10.4213 9.74321 9.85716 10.0307 9.33191 9.85999L5.29692 8.54894ZM17.8 12C17.8 11.3373 18.3373 10.8 19 10.8C19.6628 10.8 20.2 11.3373 20.2 12C20.2 12.6627 19.6628 13.2 19 13.2C18.3373 13.2 17.8 12.6627 17.8 12ZM3.80001 12C3.80001 11.3373 4.33727 10.8 5.00001 10.8C5.66275 10.8 6.20001 11.3373 6.20001 12C6.20001 12.6627 5.66275 13.2 5.00001 13.2C4.33727 13.2 3.80001 12.6627 3.80001 12Z\"/>\n</symbol>\n\n<symbol id=\"icons-next\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M426.667 213.333l469.333 298.667-469.333 298.667v-597.333z\"></path>\n  <path d=\"M256 213.333c23.564 0 42.667 19.103 42.667 42.667v512c0 23.564-19.103 42.667-42.667 42.667s-42.667-19.103-42.667-42.667v-512c0-23.564 19.103-42.667 42.667-42.667z\"></path>\n</symbol>\n\n<symbol id=\"icons-alert\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M10.1811 4.99179C10.0838 3.9222 10.926 3 12 3C13.074 3 13.9162 3.9222 13.8189 4.99179L13.0905 13.0041C13.0393 13.5681 12.5664 14 12 14C11.4336 14 10.9607 13.5681 10.9095 13.0041L10.1811 4.99179Z\"/>\n<circle cx=\"12\" cy=\"18\" r=\"1.5\"/>\n</symbol>\n\n<symbol id=\"icons-finish\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.2348 3.74143C18.3777 3.20796 18.9261 2.89138 19.4595 3.03432C19.993 3.17726 20.3096 3.7256 20.1666 4.25907L15.5638 21.437C15.4209 21.9705 14.8725 22.2871 14.3391 22.1441C13.8056 22.0012 13.489 21.4529 13.632 20.9194L15.1012 15.436C13.9315 15.2167 13.103 15.2246 12.4546 15.3266C11.7203 15.4422 11.1601 15.6842 10.4761 15.9796L10.4415 15.9946C9.74604 16.2949 8.93858 16.6382 7.85855 16.7834C6.77869 16.9284 5.4871 16.8694 3.77514 16.4744C3.50372 16.4117 3.27073 16.2387 3.13227 15.997C2.99382 15.7553 2.96246 15.4668 3.04575 15.201C3.48463 13.8002 3.92448 12.2555 4.36887 10.6947L4.37108 10.6869L4.37109 10.6869L4.37109 10.6869C4.81308 9.1344 5.25957 7.56611 5.70703 6.13796C5.84842 5.6867 6.28657 5.39617 6.75728 5.44156C8.11391 5.57238 9.0263 5.46388 9.73805 5.27659C10.3032 5.12788 10.7446 4.93373 11.2543 4.70958L11.2543 4.70957C11.4194 4.63697 11.5916 4.56122 11.7776 4.48285C12.5218 4.16913 13.3653 3.87523 14.5224 3.79865C15.4966 3.73418 16.6529 3.826 18.1268 4.14446L18.2348 3.74143ZM6.40633 10.8423C8.83024 11.0537 9.68318 10.7631 10.9756 10.1414L9.77177 14.1052C10.4201 13.8248 11.1737 13.5036 12.1437 13.351C12.9842 13.2187 13.9496 13.2164 15.15 13.414C15.3332 12.814 15.5725 11.9911 15.8423 11.0637L15.8423 11.0635L15.8424 11.0632L15.8426 11.0624C15.9324 10.7538 16.0255 10.4337 16.121 10.1064C16.1931 9.85942 16.2664 9.609 16.3403 9.35744C13.8445 8.86381 12.3497 9.1965 10.9756 10.1414L12.1481 6.5025C12.146 6.50343 12.1439 6.50436 12.1418 6.50529C11.6073 6.74104 10.9796 7.01797 10.247 7.21075C9.45712 7.4186 8.54357 7.5353 7.38351 7.48889C7.05913 8.55765 6.73388 9.69261 6.40633 10.8423Z\"/>\n</symbol>\n\n<symbol id=\"icons-trash\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.1671 4.85219C10.3985 4.50436 10.8887 4 12 4C13.1113 4 13.6015 4.50436 13.8329 4.85219C14.1805 5.37459 14.8496 6 15.7808 6H17H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H17H15.7816C15.7762 3.99927 15.7511 3.99398 15.7048 3.96282C15.641 3.91988 15.5652 3.84531 15.4981 3.74438C14.9626 2.93945 13.8927 2 12 2C10.1073 2 9.03741 2.93945 8.5019 3.74438C8.43475 3.84531 8.35903 3.91988 8.29523 3.96282C8.24894 3.99398 8.22381 3.99927 8.2184 4H7H5C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6H7H8.21922C9.15037 6 9.81951 5.37459 10.1671 4.85219ZM5.46997 10C5.46997 9.44772 5.91769 9 6.46997 9H17.53C18.0823 9 18.53 9.44772 18.53 10L17.6656 18.28C17.5211 19.8216 16.2271 21 14.6787 21H9.32126C7.77289 21 6.47888 19.8216 6.33436 18.28L5.46997 10ZM10.7071 12.2929C10.3166 11.9024 9.68342 11.9024 9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071L10.5858 15L9.29289 16.2929C8.90237 16.6834 8.90237 17.3166 9.29289 17.7071C9.68342 18.0976 10.3166 18.0976 10.7071 17.7071L12 16.4142L13.2929 17.7071C13.6834 18.0976 14.3166 18.0976 14.7071 17.7071C15.0976 17.3166 15.0976 16.6834 14.7071 16.2929L13.4142 15L14.7071 13.7071C15.0976 13.3166 15.0976 12.6834 14.7071 12.2929C14.3166 11.9024 13.6834 11.9024 13.2929 12.2929L12 13.5858L10.7071 12.2929Z\"/>\n</symbol>\n\n<symbol id=\"icons-plus\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 5.34315C12.5523 5.34315 13 5.79086 13 6.34315L13 11H17.6568C18.2091 11 18.6568 11.4477 18.6568 12C18.6568 12.5523 18.2091 13 17.6568 13L13 13V17.6569C13 18.2091 12.5523 18.6569 12 18.6569C11.4477 18.6569 11 18.2091 11 17.6569V13L6.34314 13C5.79085 13 5.34314 12.5523 5.34314 12C5.34314 11.4477 5.79085 11 6.34314 11H11V6.34315C11 5.79086 11.4477 5.34315 12 5.34315Z\"/>\n</symbol>\n\n<symbol id=\"icons-play\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M7 4L20 12L7 20V4Z\"/>\n</symbol>\n\n<symbol id=\"icons-color\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.1716 11.9999L11 5.82837L4.82844 11.9999H17.1716ZM12.4142 4.41416C11.6332 3.63311 10.3668 3.63311 9.58579 4.41416L3.22183 10.7781C2.44079 11.5592 2.44079 12.8255 3.22183 13.6065L9.58579 19.9705C10.3668 20.7516 11.6332 20.7516 12.4142 19.9705L18.7782 13.6065C19.5592 12.8255 19.5592 11.5592 18.7782 10.7781L12.4142 4.41416ZM20 14.4003C19.8415 14.4003 19.6829 14.4768 19.5859 14.6288C18.9999 15.5448 18 17.2219 18 17.9999C18 19.0999 18.9 19.9999 20 19.9999C21.1 19.9999 22 19.0999 22 17.9999C22 17.2219 21.0001 15.5448 20.4141 14.6288C20.3171 14.4768 20.1585 14.4003 20 14.4003Z\"/>\n</symbol>\n\n<symbol id=\"icons-pause\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.5 5C7.67157 5 7 5.67157 7 6.5V17.5C7 18.3284 7.67157 19 8.5 19C9.32843 19 10 18.3284 10 17.5V6.5C10 5.67157 9.32843 5 8.5 5ZM15.5 5C14.6716 5 14 5.67157 14 6.5V17.5C14 18.3284 14.6716 19 15.5 19C16.3284 19 17 18.3284 17 17.5V6.5C17 5.67157 16.3284 5 15.5 5Z\"/>\n</symbol>\n\n<symbol id=\"icons-award-left\" viewBox=\"0 0 80 80\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M36.4862 14.6976C37.0497 8.53084 42.136 2.75984 48.1637 1.26213C45.8649 6.67919 41.304 11.4711 36.4862 14.6976ZM27.0695 35.0798L26.6596 37.177C26.5773 37.6241 26.8326 38.0512 27.2772 38.104C27.7015 38.1796 28.1348 37.8511 28.2131 37.4189L28.6236 35.3279C33.358 33.0695 36.352 28.9029 38.8304 24.5034C34.0247 24.5231 29.8066 28.7885 28.2926 33.0346C28.29 33.0339 28.2876 33.0324 28.2851 33.0309C28.2824 33.0292 28.2795 33.0274 28.2761 33.0265C28.9114 28.2443 28.8403 22.5867 26.4523 18.2206C24.2185 23.4554 22.8187 30.4088 27.0695 35.0798ZM31.6267 25.8109C31.2032 25.6304 31.0049 25.1529 31.2198 24.7325L32.0898 22.928C28.1328 16.0903 34.449 6.679 34.696 6.97445C35.8792 11.6686 35.3556 16.6064 33.7251 21.1201C33.7346 21.1234 33.7435 21.1275 33.7527 21.1317C33.7584 21.1343 33.7642 21.137 33.7704 21.1396C36.0483 17.7007 41.0083 14.3467 45.3657 15.5682C41.8992 19.0486 38.7185 22.553 33.6101 23.5037L32.7 25.3681C32.4917 25.7635 32.0261 25.9826 31.6267 25.8109ZM31.908 59.9753C32.4224 60.8484 33.3803 62.4377 33.4758 62.3698C33.7805 62.7297 34.3147 62.8237 34.6665 62.5638C35.0166 62.301 35.0948 61.8123 34.8091 61.4821C34.7152 61.5306 33.7532 59.9472 33.2692 59.1395C37.1466 51.0279 36.0837 44.0941 36.4555 43.677C36.4555 43.677 33.9901 44.5957 32.414 47.1496C30.7907 49.3529 29.5606 53.6372 31.9267 58.3263C31.9171 58.3315 31.9074 58.3351 31.8978 58.3387C31.8873 58.3426 31.8769 58.3464 31.8669 58.3523C31.8476 58.3618 31.833 58.3762 31.8186 58.3905C31.8136 58.3954 31.8087 58.4003 31.8036 58.405C31.7986 58.4095 31.7935 58.4138 31.7881 58.4177C28.9157 53.9881 26.4066 50.7347 24.0157 48.1431C21.5688 45.684 19.7704 44.2164 19.3125 43.8427C19.237 43.7811 19.1984 43.7476 19.1984 43.7476C19.0327 43.6657 19.2251 47.5854 21.2834 51.9535C23.1818 55.948 27.1733 59.6302 31.908 59.9753ZM42.4632 72.5202L39.9597 70.6951C32.5437 73.3218 26.1769 67.3409 22.4038 61.7026C21.4894 60.2503 21.2438 59.2278 21.2438 59.2278C27.6721 61.3026 34.2519 65.2546 39.5053 69.3262C39.5271 69.301 39.5525 69.282 39.5775 69.2632C39.5903 69.2536 39.603 69.2441 39.615 69.2339C35.3276 65.3101 34.4611 60.5787 35.3417 57.471C35.9677 54.1762 37.9148 52.4034 37.9594 52.3631C37.9286 52.3936 38.0245 52.65 38.1917 53.0967C40.117 58.2405 41.3097 63.8813 40.9095 69.3795L43.3461 71.1687C43.6876 71.4445 43.827 71.9024 43.5867 72.3079C43.3595 72.6688 42.8263 72.8139 42.4632 72.5202ZM57.0126 77.2132L54.1002 76.2158C52.9456 71.5823 50.3989 68.1113 48.3302 65.6667C46.2012 62.9867 44.4324 61.3436 44.4324 61.3436C43.7561 63.0681 43.6696 65.2136 44.1734 66.9775C44.7837 70.0149 47.3481 74.0449 52.7441 76.4452C52.7418 76.4489 52.7393 76.4525 52.7367 76.456C52.7313 76.4634 52.7255 76.4706 52.7196 76.4779C52.7054 76.4954 52.691 76.5132 52.6822 76.5348C52.6796 76.5399 52.6793 76.5457 52.6764 76.5519C47.1357 74.6052 42.5379 74.0897 38.753 73.7931C34.6234 73.6153 31.822 73.8413 31.822 73.8413C31.822 73.8413 31.839 73.8558 31.8715 73.8859C32.2838 74.2676 35.2374 77.0018 39.5904 78.6158C44.0261 80.1742 49.5131 80.4917 53.551 77.6859L56.5413 78.7123C56.9685 78.8653 57.4366 78.6465 57.5644 78.2245C57.6916 77.8 57.4356 77.3639 57.0126 77.2132ZM27.4559 51.1279L26.9908 48.2858C20.8727 45.3934 18.6277 35.3475 21.0302 29.1911C25.0146 34.0567 26.6354 40.7062 27.5629 46.7747C27.6052 46.7723 27.6458 46.7806 27.6868 46.789C27.7027 46.7922 27.7185 46.7955 27.7346 46.7981C27.4919 41.2016 31.4073 34.6216 37.3832 33.7682C37.34 33.7749 37.2833 33.9867 37.1847 34.3553C35.7766 39.6172 32.6557 44.4488 28.5872 48.0416L29.0322 50.7747C29.0994 51.2061 28.809 51.6477 28.3714 51.764C27.9349 51.8805 27.5327 51.5774 27.4559 51.1279Z\"/>\n</symbol>\n\n<symbol id=\"icons-award-right\" viewBox=\"0 0 80 80\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M43.5138 14.6976C42.9503 8.53084 37.8641 2.75984 31.8363 1.26213C34.1351 6.67919 38.696 11.4711 43.5138 14.6976ZM52.9305 35.0798L53.3404 37.177C53.4227 37.6241 53.1674 38.0512 52.7228 38.104C52.2985 38.1796 51.8652 37.8511 51.7869 37.4189L51.3764 35.3279C46.642 33.0695 43.648 28.9029 41.1696 24.5034C45.9753 24.5231 50.1934 28.7885 51.7074 33.0346C51.71 33.0339 51.7124 33.0324 51.7149 33.0309C51.7176 33.0292 51.7205 33.0274 51.7239 33.0265C51.0886 28.2443 51.1597 22.5867 53.5477 18.2206C55.7815 23.4554 57.1813 30.4088 52.9305 35.0798ZM48.3733 25.8109C48.7968 25.6304 48.9951 25.1529 48.7802 24.7325L47.9102 22.928C51.8672 16.0903 45.551 6.679 45.304 6.97445C44.1208 11.6686 44.6444 16.6064 46.2749 21.1201C46.2654 21.1234 46.2565 21.1275 46.2473 21.1317C46.2416 21.1343 46.2358 21.137 46.2296 21.1396C43.9517 17.7007 38.9917 14.3467 34.6343 15.5682C38.1008 19.0486 41.2815 22.553 46.39 23.5037L47.3 25.3681C47.5083 25.7635 47.9739 25.9826 48.3733 25.8109ZM48.092 59.9753C47.5776 60.8484 46.6197 62.4377 46.5242 62.3698C46.2195 62.7297 45.6853 62.8237 45.3335 62.5638C44.9834 62.301 44.9052 61.8123 45.1909 61.4821C45.2848 61.5306 46.2468 59.9472 46.7308 59.1395C42.8534 51.0279 43.9163 44.0941 43.5445 43.677C43.5445 43.677 46.0099 44.5957 47.586 47.1496C49.2093 49.3529 50.4395 53.6372 48.0733 58.3263C48.0829 58.3315 48.0926 58.3351 48.1022 58.3387C48.1127 58.3426 48.1231 58.3464 48.1331 58.3523C48.1524 58.3618 48.167 58.3762 48.1814 58.3905C48.1864 58.3954 48.1913 58.4003 48.1964 58.405C48.2014 58.4095 48.2065 58.4138 48.2119 58.4177C51.0843 53.9881 53.5934 50.7347 55.9843 48.1431C58.4312 45.684 60.2296 44.2164 60.6875 43.8427C60.763 43.7811 60.8016 43.7476 60.8016 43.7476C60.9674 43.6657 60.7749 47.5854 58.7166 51.9535C56.8182 55.948 52.8267 59.6302 48.092 59.9753ZM37.5368 72.5202L40.0403 70.6951C47.4563 73.3218 53.8231 67.3409 57.5962 61.7026C58.5106 60.2503 58.7562 59.2278 58.7562 59.2278C52.3279 61.3026 45.7481 65.2546 40.4947 69.3262C40.4729 69.301 40.4475 69.282 40.4225 69.2632C40.4097 69.2536 40.397 69.2441 40.385 69.2339C44.6724 65.3101 45.5389 60.5787 44.6583 57.471C44.0323 54.1762 42.0852 52.4034 42.0406 52.3631C42.0714 52.3936 41.9755 52.65 41.8083 53.0967C39.883 58.2405 38.6903 63.8813 39.0905 69.3795L36.6539 71.1687C36.3124 71.4445 36.173 71.9024 36.4133 72.3079C36.6405 72.6688 37.1737 72.8139 37.5368 72.5202ZM22.9874 77.2132L25.8998 76.2158C27.0544 71.5823 29.6011 68.1113 31.6698 65.6667C33.7988 62.9867 35.5676 61.3436 35.5676 61.3436C36.2439 63.0681 36.3304 65.2136 35.8266 66.9775C35.2163 70.0149 32.6519 74.0449 27.2559 76.4452C27.2583 76.4489 27.2607 76.4525 27.2633 76.456C27.2687 76.4634 27.2745 76.4706 27.2804 76.4779C27.2946 76.4954 27.309 76.5132 27.3178 76.5348C27.3204 76.5399 27.3207 76.5457 27.3236 76.5519C32.8643 74.6052 37.4621 74.0897 41.247 73.7931C45.3766 73.6153 48.178 73.8413 48.178 73.8413C48.178 73.8413 48.161 73.8558 48.1285 73.8859C47.7162 74.2676 44.7626 77.0018 40.4096 78.6158C35.9739 80.1742 30.4869 80.4917 26.449 77.6859L23.4587 78.7123C23.0315 78.8653 22.5634 78.6465 22.4356 78.2245C22.3084 77.8 22.5644 77.3639 22.9874 77.2132ZM52.5441 51.1279L53.0092 48.2858C59.1273 45.3934 61.3723 35.3475 58.9698 29.1911C54.9854 34.0567 53.3647 40.7062 52.4371 46.7747C52.3948 46.7723 52.3542 46.7806 52.3132 46.789C52.2973 46.7922 52.2815 46.7955 52.2654 46.7981C52.5081 41.2016 48.5927 34.6216 42.6168 33.7682C42.66 33.7749 42.7167 33.9867 42.8153 34.3553C44.2234 39.6172 47.3443 44.4488 51.4128 48.0416L50.9678 50.7747C50.9006 51.2061 51.191 51.6477 51.6286 51.764C52.0651 51.8805 52.4673 51.5774 52.5441 51.1279Z\"/>\n</symbol>\n\n<symbol id=\"icons-enter\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 6C7 5.44772 7.44772 5 8 5H16C16.5523 5 17 5.44772 17 6V18C17 18.5523 16.5523 19 16 19H8C7.44772 19 7 18.5523 7 18V16C7 15.4477 6.55228 15 6 15C5.44772 15 5 15.4477 5 16V18C5 19.6569 6.34315 21 8 21H16C17.6569 21 19 19.6569 19 18V6C19 4.34315 17.6569 3 16 3H8C6.34315 3 5 4.34315 5 6V7V8V10C5 11.6569 6.34315 13 8 13H10V15L14 12L10 9V11H8C7.44772 11 7 10.5523 7 10V8V7V6Z\"/>\n</symbol>\n\n<symbol id=\"icons-exit\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 19C16.3411 19 16.6423 18.8293 16.8227 18.5686L19 16.576L19 18C19 19.6569 17.6569 21 16 21L8.00002 21C6.34316 21 5.00002 19.6569 5.00002 18L5.00002 6C5.00002 4.34314 6.34316 3 8.00002 3L16 3C17.6569 3 19 4.34314 19 6L19 7.42403L16.8227 5.4314C16.6423 5.17074 16.3411 5 16 5L8.00002 5C7.44773 5 7.00002 5.44771 7.00002 6L7.00002 18C7.00002 18.5523 7.44773 19 8.00002 19L16 19ZM16 9L16 11L10 11L10 13L16 13L16 15L20 12L16 9Z\"/>\n</symbol>\n\n<symbol id=\"icons-turn-device\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.5 6.5H20.4725C20.2238 4.25002 18.3163 2.5 16 2.5V3.5C17.7632 3.5 19.2219 4.80385 19.4646 6.5H18.5L20 9L21.5 6.5ZM2 5C2 3.89543 2.89543 3 4 3H12C13.1046 3 14 3.89543 14 5V20C14 21.1046 13.1046 22 12 22H4C2.89543 22 2 21.1046 2 20V5ZM12 5H4V16H12V5ZM20 10C21.1046 10 22 10.8954 22 12V20C22 21.1046 21.1046 22 20 22H16L16 20H20V12H16V10H20ZM9.5 18.5C9.5 19.3284 8.82843 20 8 20C7.17157 20 6.5 19.3284 6.5 18.5C6.5 17.6716 7.17157 17 8 17C8.82843 17 9.5 17.6716 9.5 18.5Z\"/>\n</symbol>\n\n<symbol id=\"icons-video\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.5 6.5C3.11929 6.5 2 7.61929 2 9V15C2 16.3807 3.11929 17.5 4.5 17.5H13.5C14.8807 17.5 16 16.3807 16 15V9C16 7.61929 14.8807 6.5 13.5 6.5H4.5ZM18.47 9.20625C18.1776 9.38899 18 9.70946 18 10.0542V13.9458C18 14.2905 18.1776 14.611 18.47 14.7938L20.47 16.0438C21.136 16.46 22 15.9812 22 15.1958V8.80425C22 8.01881 21.136 7.53997 20.47 7.95625L18.47 9.20625Z\"/>\n</symbol>\n\n<symbol id=\"icons-more\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M175.158 426.667c-49.609 0-89.824 40.218-89.824 89.826s40.216 89.826 89.824 89.826c49.609 0 89.825-40.218 89.825-89.826s-40.216-89.826-89.825-89.826zM512 426.667c-49.609 0-89.824 40.218-89.824 89.826s40.216 89.826 89.824 89.826c49.609 0 89.826-40.218 89.826-89.826s-40.218-89.826-89.826-89.826zM848.841 426.667c-49.609 0-89.822 40.218-89.822 89.826s40.213 89.826 89.822 89.826c49.609 0 89.826-40.218 89.826-89.826s-40.218-89.826-89.826-89.826z\"></path>\n</symbol>\n\n<symbol id=\"icons-user\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M153.723 1023.979c-142.948 2.223-200.717-154.099-110.486-256.414 72.175-81.877 166.1-127.305 264.722-163.238 76.376-27.721 80.331-39.782 31.885-103.949-71.927-95.226-95.409-201.486-62.782-318.269 34.357-122.687 140.889-195.067 260.026-180.18 126.554 15.913 210.837 110.88 220.727 248.454 7.168 99.073-23.236 184.801-83.793 260.261-37.572 46.967-29.909 64.422 23.236 88.806 108.356 49.523 228.843 95.654 299.819 195.068 67.767 94.161-0.201 228.945-116.911 228.945-242.069-1.003-484.392-2.633-726.444 0.516z\"></path>\n</symbol>\n\n<symbol id=\"icons-timer\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M512 143.36c-243.182 0-440.32 197.138-440.32 440.32s197.138 440.32 440.32 440.32c243.182 0 440.32-197.138 440.32-440.32-0.282-243.065-197.255-440.038-440.32-440.32zM699.904 784.896c-9.706 11.048-23.694 17.389-38.4 17.41-12.622 0.106-24.838-4.453-34.304-12.802l-148.992-132.096c-11.048-9.706-17.389-23.694-17.408-38.4v-256c0-28.277 22.923-51.2 51.2-51.2s51.2 22.923 51.2 51.2v230.912l132.096 116.736c10.8 9.019 17.413 22.085 18.285 36.128s-4.075 27.827-13.677 38.112zM382.464 65.024l283.136 37.376h-307.2c-28.277 0-51.2-22.923-51.2-51.2s22.923-51.2 51.2-51.2h307.2c28.277 0 51.2 22.923 51.2 51.2s-22.923 51.2-51.2 51.2l-283.136-37.376z\"></path>\n</symbol>\n\n<symbol id=\"icons-team\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M123.438 375.135c0-73.269 48.822-153.102 129.149-153.102 22.381 0 43.61 6.959 63.726 20.866-12.902 32.106-19.354 65.336-19.354 99.749 0 53.76 14.428 102.255 43.246 145.575-9.113 8.886-17.646 16.041-25.599 21.458l-117.202 55.094c-33.004 16.015-52.907 52.674-52.907 88.743v147.883h-115.485c-17.946 0-29.013-17.775-29.013-34.217v-140.926c0-15.365 7.267-26.706 18.193-31.895l175.229-82.943c-46.631-28.862-69.985-82.708-69.985-136.284zM681.529 485.323c27.694-43.705 41.528-91.247 41.528-142.675 0-32.847-6.062-65.509-18.215-97.998 20.48-15.090 42.668-22.606 66.57-22.606 79.885 0 129.14 80.198 129.14 153.102 0 52.22-23.040 106.064-68.268 134.544l173.512 84.682c12.13 6.182 18.204 16.806 18.204 31.898v140.923c0 16.433-11.077 34.217-29.012 34.217h-119.468v-147.906c0-36.585-18.967-71.040-51.769-88.151l-112.072-53.934c-11.003-7.34-21.048-16.041-30.152-26.097zM670.152 342.648c0 64.207-28.977 131.567-84.196 167.021l214.471 104.389c14.917 7.616 22.197 23.155 22.197 39.447v173.98c0 19.933-13.903 42.916-35.84 42.916h-553.541c-21.939 0-35.84-22.979-35.84-42.916v-173.98c0-16.156 8.092-31.936 22.756-39.447l216.177-103.23c-56.84-35.431-85.891-102.8-85.891-168.18 0-56.225 21.993-114.157 64.274-151.943 28.068-24.74 59.732-37.104 95.017-37.104 36.396 0 68.823 12.933 97.267 38.855 40.248 37.084 63.148 95.514 63.148 150.191z\"></path>\n</symbol>\n\n<symbol id=\"icons-reset\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.55173 4C6.55173 3.44772 6.10401 3 5.55173 3C4.99944 3 4.55173 3.44772 4.55173 4V8.27586C4.55173 8.82815 4.99944 9.27586 5.55173 9.27586H9.82759C10.3799 9.27586 10.8276 8.82815 10.8276 8.27586C10.8276 7.72358 10.3799 7.27586 9.82759 7.27586H7.5444C10.0863 4.9027 14.0715 4.95516 16.5495 7.43324C19.0812 9.96492 19.0812 14.0696 16.5495 16.6012C14.0179 19.1329 9.91321 19.1329 7.38153 16.6012C6.99101 16.2107 6.35784 16.2107 5.96732 16.6012C5.57679 16.9918 5.57679 17.6249 5.96732 18.0155C9.28004 21.3282 14.651 21.3282 17.9637 18.0155C21.2765 14.7027 21.2765 9.33175 17.9637 6.01903C14.8394 2.8947 9.88429 2.71702 6.55173 5.48597V4Z\"/>\n</symbol>\n\n<symbol id=\"icons-link\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.4003 4.55857C17.3222 2.48048 13.953 2.48048 11.8749 4.55857L10.4939 5.93959C10.1034 6.33011 10.1034 6.96328 10.4939 7.3538C10.8844 7.74433 11.5176 7.74433 11.9081 7.3538L13.2891 5.97278C14.5862 4.67574 16.6891 4.67574 17.9861 5.97278C19.2832 7.26983 19.2832 9.37275 17.9861 10.6698L16.6051 12.0508C16.2146 12.4413 16.2146 13.0745 16.6051 13.465C16.9956 13.8556 17.6288 13.8556 18.0193 13.465L19.4003 12.084C21.4784 10.0059 21.4784 6.63666 19.4003 4.55857ZM7.7437 11.5182C8.13422 11.1277 8.13422 10.4945 7.7437 10.104C7.35317 9.71346 6.72001 9.71346 6.32948 10.104L4.59968 11.8338C2.52158 13.9119 2.52158 17.2811 4.59968 19.3592C6.67777 21.4373 10.047 21.4373 12.1251 19.3592L13.8549 17.6294C14.2454 17.2389 14.2454 16.6057 13.8549 16.2152C13.4644 15.8247 12.8312 15.8247 12.4407 16.2152L10.7109 17.945C9.41386 19.2421 7.31093 19.2421 6.01389 17.945C4.71685 16.648 4.71685 14.5451 6.01389 13.248L7.7437 11.5182ZM7.89113 14.6171C7.50061 15.0077 7.50061 15.6408 7.89113 16.0314C8.28166 16.4219 8.91482 16.4219 9.30535 16.0314L16.1095 9.2272C16.5 8.83668 16.5 8.20351 16.1095 7.81299C15.719 7.42246 15.0858 7.42246 14.6953 7.81299L7.89113 14.6171Z\" />\n</symbol>\n\n<symbol id=\"icons-bell\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M7.70587 8.32963C8.42058 5.6623 11.1623 4.07939 13.8296 4.7941C16.4969 5.5088 18.0798 8.25049 17.3651 10.9178L16.1846 15.3236C16.1117 15.5956 16.147 15.8851 16.283 16.1316L16.7506 16.9793C16.9295 17.3037 16.8848 17.7057 16.639 17.9829C16.4357 18.2122 16.1203 18.3069 15.8243 18.2276L5.1812 15.3758C4.89621 15.2994 4.67882 15.0686 4.61967 14.7795C4.54414 14.4105 4.72271 14.0361 5.05705 13.8625L5.98847 13.379C6.25816 13.239 6.45658 12.9921 6.53522 12.6986L7.70587 8.32963Z\"/>\n  <path d=\"M13.3444 3.91065C13.5119 3.38435 14.0742 3.09342 14.6005 3.26084C15.1268 3.42826 15.4178 3.99063 15.2503 4.51693L14.9472 5.46987C14.7798 5.99617 14.2174 6.2871 13.6911 6.11968C13.1648 5.95226 12.8739 5.38989 13.0413 4.86359L13.3444 3.91065Z\"/>\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.3172 18.2866C8.68895 19.0216 9.36007 19.6013 10.2183 19.8313C11.0765 20.0613 11.9476 19.8948 12.637 19.4441L8.3172 18.2866Z\"/>\n</symbol>\n\n<!--  <symbol id=\"icons-pin\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">-->\n<!--    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.75 5.25007C3.8505 8.14957 3.8505 12.8506 6.75001 15.7501L12 20.5001L17.25 15.7501C20.1495 12.8506 20.1495 8.14957 17.25 5.25007C14.3505 2.35056 9.64951 2.35056 6.75 5.25007ZM13.9198 12.4201C15.0381 11.3018 15.0381 9.48865 13.9198 8.37033C12.8015 7.25201 10.9883 7.25201 9.87001 8.37033C8.75169 9.48865 8.75169 11.3018 9.87001 12.4201C10.9883 13.5385 12.8015 13.5385 13.9198 12.4201Z\" />-->\n<!--  </symbol>-->\n\n\n<symbol id=\"icons-phone\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\">\n  <path  d=\"M706.216 944.341c-61.44-2.261-235.563-26.325-417.92-208.64-182.315-182.357-206.336-356.437-208.64-417.92-3.413-93.696 68.352-184.704 151.253-220.245 9.984-4.311 20.915-5.952 31.725-4.763 10.808 1.189 21.122 5.168 29.93 11.547 68.266 49.749 115.37 125.013 155.818 184.193 8.901 13.002 12.706 28.822 10.691 44.45s-9.707 29.966-21.613 40.286l-83.243 61.824c-4.022 2.904-6.853 7.168-7.966 12.003-1.115 4.834-0.437 9.907 1.907 14.278 18.859 34.262 52.395 85.291 90.795 123.691 38.443 38.4 91.861 74.155 128.512 95.147 4.595 2.579 10.005 3.301 15.115 2.014 5.11-1.285 9.534-4.48 12.362-8.926l54.187-82.475c9.962-13.234 24.658-22.099 41.010-24.739s33.093 1.149 46.714 10.574c60.032 41.557 130.090 87.85 181.376 153.514 6.896 8.87 11.282 19.432 12.701 30.578s-0.182 22.467-4.637 32.782c-35.712 83.328-126.080 154.283-220.075 150.827z\"></path>\n</symbol>\n\n<symbol id=\"icons-mail\" viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M55.0906 25.8875C55.4562 25.5969 56 25.8687 56 26.3281V45.5C56 47.9844 53.9844 50 51.5 50H12.5C10.0156 50 8 47.9844 8 45.5V26.3375C8 25.8688 8.53437 25.6062 8.90937 25.8969C11.0094 27.5281 13.7938 29.6 23.3563 36.5469C25.3344 37.9906 28.6719 41.0281 32 41.0094C35.3469 41.0375 38.75 37.9344 40.6531 36.5469C50.2156 29.6 52.9906 27.5188 55.0906 25.8875ZM32 38C34.175 38.0375 37.3062 35.2625 38.8812 34.1188C51.3219 25.0906 52.2687 24.3031 55.1375 22.0531C55.6812 21.6312 56 20.975 56 20.2812V18.5C56 16.0156 53.9844 14 51.5 14H12.5C10.0156 14 8 16.0156 8 18.5V20.2812C8 20.975 8.31875 21.6219 8.8625 22.0531C11.7313 24.2937 12.6781 25.0906 25.1188 34.1188C26.6938 35.2625 29.825 38.0375 32 38Z\"/>\n</symbol>\n\n<symbol id=\"icons-instagram\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\">\n  <path d=\"M682.667 512c0 94.257-76.41 170.667-170.667 170.667s-170.667-76.41-170.667-170.667c0-94.257 76.41-170.667 170.667-170.667s170.667 76.41 170.667 170.667z\"></path>\n  <path d=\"M725.291 0h-426.667c-164.651 0-298.624 134.016-298.624 298.709v426.667c0 164.651 134.016 298.624 298.709 298.624h426.667c164.651 0 298.624-134.016 298.624-298.709v-426.667c0-164.651-134.016-298.624-298.709-298.624zM512 768c-141.184 0-256-114.816-256-256s114.816-256 256-256c141.184 0 256 114.816 256 256s-114.816 256-256 256zM810.667 256c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667z\"></path>\n</symbol>\n\n<symbol id=\"icons-hockey\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 12C16.9706 12 21 10.433 21 8.5C21 6.567 16.9706 5 12 5C7.02944 5 3 6.567 3 8.5C3 10.433 7.02944 12 12 12ZM12 14.0001C15.5841 14.0001 18.8012 13.2799 21 12.1381V15.5001C21 17.4331 16.9706 19.0001 12 19.0001C7.02944 19.0001 3 17.4331 3 15.5001V12.1381C5.19883 13.2799 8.41592 14.0001 12 14.0001Z\"/>\n</symbol>\n\n<symbol id=\"icons-mask\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.25 11.9304C11.3834 13.0937 10.9749 14.7149 10.877 15.4076H12.2322H12.2678H13.623C13.5251 14.7149 13.1166 13.0937 12.25 11.9304ZM12.25 23.5754C10.7899 23.6607 7.40962 22.591 5.42068 17.6187C4.68482 15.779 4.25263 14.116 4.0474 12.6259H4.24385C4.99229 12.6259 5.59902 12.0192 5.59902 11.2708V10.9141C5.59902 10.1657 4.99229 9.55896 4.24385 9.55896H3.93658C4.08832 7.5367 4.69608 5.97294 5.42068 4.85153C6.91294 2.54208 9.04236 1.01139 12.2322 1.00006V1C12.2381 1 12.2441 1.00001 12.25 1.00002C12.2559 1.00001 12.2619 1 12.2678 1V1.00006C15.4576 1.01139 17.5871 2.54208 19.0793 4.85153C19.8039 5.97294 20.4117 7.5367 20.5634 9.55896H20.2561C19.5077 9.55896 18.901 10.1657 18.901 10.9141V11.2708C18.901 12.0192 19.5077 12.6259 20.2561 12.6259H20.4526C20.2474 14.116 19.8152 15.779 19.0793 17.6187C17.0904 22.591 13.7101 23.6607 12.25 23.5754ZM12.25 9.07387C12.2561 9.07585 12.2621 9.07782 12.2678 9.07979V9.06827C12.4823 9.00264 12.8888 8.93519 13.33 8.88133C13.7648 8.82825 14.6323 8.77438 15.1921 8.77438C15.1433 8.79194 15.0697 8.81632 14.9784 8.84655L14.9783 8.84657L14.9782 8.84661L14.9781 8.84665L14.9781 8.84667C14.6367 8.95972 14.0486 9.1545 13.5856 9.38064C12.9554 9.68842 12.5336 9.92537 12.25 10.1144C11.9664 9.92537 11.5446 9.68842 10.9144 9.38064C10.4514 9.1545 9.86327 8.95972 9.52195 8.84667L9.52195 8.84667L9.5219 8.84665L9.52177 8.84661L9.52166 8.84657L9.52159 8.84655C9.43031 8.81632 9.3567 8.79194 9.30791 8.77438C9.86775 8.77438 10.7352 8.82825 11.17 8.88133C11.6112 8.93519 12.0177 9.00264 12.2322 9.06827V9.07979C12.2379 9.07782 12.2439 9.07585 12.25 9.07387ZM10.8414 11.4846C10.8414 12.4103 9.82724 13 9.00001 13C8.17279 13 7.00001 11.9257 7.00001 11C7.00001 9.93013 8.40388 9.60855 9.27224 9.73721C10.2351 9.87988 10.8414 10.5589 10.8414 11.4846ZM8.44173 16.7565C8.42641 16.3868 8.40417 15.8502 8.45199 15.3719C8.52332 14.6587 8.63031 13.9098 8.80862 13.4818C8.59464 13.8265 8.10964 14.7086 7.8814 15.4789C7.65316 16.2492 7.57232 16.6795 7.56044 16.7984C7.72686 16.7984 8.13817 16.8555 8.45199 17.0837C8.45199 17.0042 8.44732 16.8915 8.44173 16.7565ZM11.5189 7.63315C11.5189 7.8695 11.3273 8.0611 11.091 8.0611C10.8546 8.0611 10.663 7.8695 10.663 7.63315C10.663 7.3968 10.8546 7.2052 11.091 7.2052C11.3273 7.2052 11.5189 7.3968 11.5189 7.63315ZM11.2337 18.4745C11.47 18.4745 11.6616 18.2829 11.6616 18.0466C11.6616 17.8102 11.47 17.6186 11.2337 17.6186C10.9973 17.6186 10.8057 17.8102 10.8057 18.0466C10.8057 18.2829 10.9973 18.4745 11.2337 18.4745ZM9.18066 6.95614C9.26639 7.06841 9.18362 7.2757 8.99578 7.41915C8.80794 7.5626 8.58616 7.58787 8.50043 7.4756C8.41469 7.36333 8.49747 7.15604 8.68531 7.01259C8.87315 6.86914 9.09492 6.84387 9.18066 6.95614ZM9.06085 5.84798C9.22425 5.67721 9.27397 5.4596 9.1719 5.36194C9.06983 5.26428 8.85463 5.32355 8.69124 5.49432C8.52784 5.6651 8.47812 5.8827 8.58019 5.98036C8.68226 6.07802 8.89746 6.01875 9.06085 5.84798ZM9.1572 3.53051C9.25926 3.62817 9.20955 3.84578 9.04615 4.01655C8.88276 4.18732 8.66756 4.24659 8.56549 4.14893C8.46342 4.05127 8.51314 3.83367 8.67654 3.6629C8.83993 3.49212 9.05513 3.43286 9.1572 3.53051ZM6.60139 6.21964C6.69151 6.00115 6.65871 5.78036 6.52812 5.7265C6.39754 5.67263 6.21861 5.80609 6.12849 6.02458C6.03837 6.24307 6.07117 6.46386 6.20176 6.51773C6.33235 6.57159 6.51127 6.43814 6.60139 6.21964ZM6.63008 14.406C6.76621 14.3683 6.92773 14.5224 6.99084 14.7501C7.05395 14.9779 6.99475 15.1931 6.85862 15.2308C6.72249 15.2685 6.56097 15.1145 6.49786 14.8867C6.43475 14.6589 6.49394 14.4437 6.63008 14.406ZM6.42025 15.6773C6.35714 15.4496 6.19562 15.2955 6.05949 15.3332C5.92336 15.371 5.86416 15.5862 5.92727 15.8139C5.99038 16.0417 6.1519 16.1958 6.28803 16.1581C6.42416 16.1203 6.48336 15.9051 6.42025 15.6773ZM7.83066 18.5756C7.95597 18.5104 8.146 18.6275 8.25508 18.8371C8.36417 19.0468 8.35102 19.2696 8.22571 19.3348C8.10039 19.4 7.91037 19.2829 7.80128 19.0733C7.69219 18.8636 7.70535 18.6408 7.83066 18.5756ZM9.7492 18.0362C9.69734 17.8056 9.51366 17.6505 9.33894 17.6898C9.16422 17.7291 9.06462 17.9479 9.11648 18.1785C9.16834 18.4091 9.35202 18.5641 9.52674 18.5248C9.70146 18.4855 9.80105 18.2668 9.7492 18.0362ZM10.7594 19.9062C10.8914 19.7852 11.1279 19.8283 11.2876 20.0025C11.4473 20.1767 11.4698 20.416 11.3378 20.5371C11.2058 20.6581 10.9694 20.615 10.8096 20.4408C10.6499 20.2666 10.6274 20.0272 10.7594 19.9062ZM11.3786 21.5974C11.1857 21.4609 10.9455 21.4687 10.842 21.6148C10.7385 21.761 10.811 21.9902 11.0039 22.1267C11.1968 22.2633 11.4371 22.2555 11.5406 22.1094C11.644 21.9632 11.5715 21.734 11.3786 21.5974ZM6.36176 8.12634C6.503 8.12849 6.61459 8.32181 6.61099 8.55813C6.6074 8.79445 6.48998 8.98429 6.34874 8.98214C6.20749 8.97999 6.09591 8.78667 6.0995 8.55035C6.1031 8.31403 6.22051 8.1242 6.36176 8.12634ZM5.68485 13.7958C5.64192 13.5634 5.49452 13.3958 5.35561 13.4215C5.2167 13.4471 5.13888 13.6563 5.1818 13.8887C5.22472 14.1212 5.37213 14.2888 5.51104 14.2631C5.64995 14.2375 5.72777 14.0283 5.68485 13.7958ZM5.54299 7.20595C5.65845 7.22035 5.73251 7.38862 5.70842 7.58179C5.68433 7.77496 5.57121 7.91988 5.45575 7.90548C5.3403 7.89108 5.26624 7.72282 5.29033 7.52965C5.31442 7.33648 5.42754 7.19155 5.54299 7.20595ZM4.17248 9.84424H2.95996V12.3406H4.17248C4.80275 12.3406 5.31368 11.8297 5.31368 11.1994V10.9854C5.31368 10.3552 4.80275 9.84424 4.17248 9.84424ZM4.10114 11.4847C4.33749 11.4847 4.52908 11.2931 4.52908 11.0568C4.52908 10.8204 4.33749 10.6288 4.10114 10.6288C3.86479 10.6288 3.67319 10.8204 3.67319 11.0568C3.67319 11.2931 3.86479 11.4847 4.10114 11.4847ZM13.6586 11.4846C13.6586 12.4103 14.5788 12.9824 15.4061 12.9824C16.2333 12.9824 17.5 11.9257 17.5 11C17.5 9.93013 16.0961 9.60855 15.2278 9.73721C14.2649 9.87988 13.6586 10.5589 13.6586 11.4846ZM16.0583 16.7565C16.0736 16.3868 16.0958 15.8502 16.048 15.3719C15.9767 14.6587 15.8697 13.9098 15.6914 13.4818C15.9054 13.8265 16.3904 14.7086 16.6186 15.4789C16.8468 16.2492 16.9277 16.6795 16.9396 16.7984C16.7731 16.7984 16.3618 16.8555 16.048 17.0837C16.048 17.0042 16.0527 16.8915 16.0583 16.7565L16.0583 16.7565ZM12.9811 7.63315C12.9811 7.8695 13.1727 8.0611 13.409 8.0611C13.6454 8.0611 13.837 7.8695 13.837 7.63315C13.837 7.3968 13.6454 7.2052 13.409 7.2052C13.1727 7.2052 12.9811 7.3968 12.9811 7.63315ZM13.2663 18.4745C13.03 18.4745 12.8384 18.2829 12.8384 18.0466C12.8384 17.8102 13.03 17.6186 13.2663 17.6186C13.5027 17.6186 13.6943 17.8102 13.6943 18.0466C13.6943 18.2829 13.5027 18.4745 13.2663 18.4745ZM15.3193 6.95614C15.2336 7.06841 15.3164 7.2757 15.5042 7.41915C15.6921 7.5626 15.9138 7.58787 15.9996 7.4756C16.0853 7.36333 16.0025 7.15604 15.8147 7.01259C15.6269 6.86914 15.4051 6.84387 15.3193 6.95614ZM15.4391 5.84798C15.2758 5.67721 15.226 5.4596 15.3281 5.36194C15.4302 5.26428 15.6454 5.32355 15.8088 5.49432C15.9722 5.6651 16.0219 5.8827 15.9198 5.98036C15.8177 6.07802 15.6025 6.01875 15.4391 5.84798ZM15.3428 3.53051C15.2407 3.62817 15.2905 3.84578 15.4538 4.01655C15.6172 4.18732 15.8324 4.24659 15.9345 4.14893C16.0366 4.05127 15.9869 3.83367 15.8235 3.6629C15.6601 3.49212 15.4449 3.43286 15.3428 3.53051ZM17.8986 6.21964C17.8085 6.00115 17.8413 5.78036 17.9719 5.7265C18.1025 5.67263 18.2814 5.80609 18.3715 6.02458C18.4616 6.24307 18.4288 6.46386 18.2982 6.51773C18.1677 6.57159 17.9887 6.43814 17.8986 6.21964ZM17.8699 14.406C17.7338 14.3683 17.5723 14.5224 17.5092 14.7501C17.4461 14.9779 17.5052 15.1931 17.6414 15.2308C17.7775 15.2685 17.939 15.1145 18.0021 14.8867C18.0653 14.6589 18.0061 14.4437 17.8699 14.406ZM18.0798 15.6773C18.1429 15.4496 18.3044 15.2955 18.4405 15.3332C18.5766 15.371 18.6358 15.5862 18.5727 15.8139C18.5096 16.0417 18.3481 16.1958 18.212 16.1581C18.0758 16.1203 18.0166 15.9051 18.0798 15.6773ZM16.6693 18.5756C16.544 18.5104 16.354 18.6275 16.2449 18.8371C16.1358 19.0468 16.149 19.2696 16.2743 19.3348C16.3996 19.4 16.5896 19.2829 16.6987 19.0733C16.8078 18.8636 16.7947 18.6408 16.6693 18.5756ZM14.7508 18.0362C14.8027 17.8056 14.9863 17.6505 15.1611 17.6898C15.3358 17.7291 15.4354 17.9479 15.3835 18.1785C15.3317 18.4091 15.148 18.5641 14.9733 18.5248C14.7985 18.4855 14.6989 18.2668 14.7508 18.0362ZM13.7406 19.9062C13.6086 19.7852 13.3721 19.8283 13.2124 20.0025C13.0527 20.1767 13.0302 20.416 13.1622 20.5371C13.2942 20.6581 13.5306 20.615 13.6904 20.4408C13.8501 20.2666 13.8726 20.0272 13.7406 19.9062ZM13.1214 21.5974C13.3143 21.4609 13.5545 21.4687 13.658 21.6148C13.7615 21.761 13.689 21.9902 13.4961 22.1267C13.3032 22.2633 13.0629 22.2555 12.9594 22.1094C12.856 21.9632 12.9285 21.734 13.1214 21.5974ZM18.1382 8.12634C17.997 8.12849 17.8854 8.32181 17.889 8.55813C17.8926 8.79445 18.01 8.98429 18.1513 8.98214C18.2925 8.97999 18.4041 8.78667 18.4005 8.55035C18.3969 8.31403 18.2795 8.1242 18.1382 8.12634ZM18.8152 13.7958C18.8581 13.5634 19.0055 13.3958 19.1444 13.4215C19.2833 13.4471 19.3611 13.6563 19.3182 13.8887C19.2753 14.1212 19.1279 14.2888 18.989 14.2631C18.85 14.2375 18.7722 14.0283 18.8152 13.7958ZM18.957 7.20595C18.8416 7.22035 18.7675 7.38862 18.7916 7.58179C18.8157 7.77496 18.9288 7.91988 19.0442 7.90548C19.1597 7.89108 19.2338 7.72282 19.2097 7.52965C19.1856 7.33648 19.0725 7.19155 18.957 7.20595ZM20.3275 9.84424H21.54V12.3406H20.3275C19.6973 12.3406 19.1863 11.8297 19.1863 11.1994V10.9854C19.1863 10.3552 19.6973 9.84424 20.3275 9.84424ZM20.3989 11.4847C20.1625 11.4847 19.9709 11.2931 19.9709 11.0568C19.9709 10.8204 20.1625 10.6288 20.3989 10.6288C20.6352 10.6288 20.8268 10.8204 20.8268 11.0568C20.8268 11.2931 20.6352 11.4847 20.3989 11.4847Z\" />\n</symbol>\n\n<svg id=\"icons-arrow-left\" viewBox=\"0 0 42 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M0.292892 7.2929C-0.0976296 7.68342 -0.0976295 8.31659 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41422 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928935C7.68054 0.538411 7.04738 0.538411 6.65685 0.928935L0.292892 7.2929ZM42 7L1 7L1 9L42 9L42 7Z\" />\n</svg>\n\n<svg id=\"icons-arrow-right\" viewBox=\"0 0 42 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M41.7071 8.70711C42.0976 8.31659 42.0976 7.68342 41.7071 7.2929L35.3431 0.928938C34.9526 0.538414 34.3195 0.538414 33.9289 0.928938C33.5384 1.31946 33.5384 1.95263 33.9289 2.34315L39.5858 8.00001L33.9289 13.6569C33.5384 14.0474 33.5384 14.6805 33.9289 15.0711C34.3195 15.4616 34.9526 15.4616 35.3431 15.0711L41.7071 8.70711ZM-1.74846e-07 9L41 9.00001L41 7.00001L1.74846e-07 7L-1.74846e-07 9Z\" />\n</svg>\n\n<symbol id=\"icons-pin\" viewBox=\"0 0 7 9\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M6.74889 3.67853C6.7347 4.4547 6.47934 5.2457 5.94024 5.93288C5.18361 6.90186 4.41752 7.86589 3.65615 8.83487C3.48591 9.04745 3.26365 9.05733 3.10287 8.8497C2.31313 7.84612 1.51394 6.85737 0.743118 5.83895C-0.391832 4.34099 -0.207403 2.12125 1.16399 0.85565C1.87807 0.193187 2.72928 -0.0688318 3.6798 0.015212C4.73909 0.109143 5.56665 0.628237 6.17196 1.53789C6.54082 2.09159 6.75362 2.85293 6.74889 3.67853ZM3.37715 2.07181C2.63943 2.07181 2.05304 2.68978 2.05304 3.46595C2.05304 4.22729 2.64889 4.84031 3.38188 4.84031C4.11013 4.84031 4.70125 4.2174 4.70125 3.45606C4.70125 2.68978 4.11013 2.07181 3.37715 2.07181Z\" />\n</symbol>\n\n<symbol id=\"icons-instagram\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g clip-path=\"url(#clip0)\">\n    <path d=\"M7.73741 4.32275C5.56049 4.32275 3.7981 6.08706 3.7981 8.26206C3.7981 10.439 5.5624 12.2014 7.73741 12.2014C9.91433 12.2014 11.6767 10.4371 11.6767 8.26206C11.6767 6.08514 9.91241 4.32275 7.73741 4.32275ZM7.73741 10.819C6.32429 10.819 5.1805 9.67453 5.1805 8.26206C5.1805 6.84959 6.32493 5.70516 7.73741 5.70516C9.14988 5.70516 10.2943 6.84959 10.2943 8.26206C10.295 9.67453 9.15052 10.819 7.73741 10.819Z\" />\n    <path d=\"M10.9005 0.636848C9.488 0.570959 5.98945 0.574157 4.5757 0.636848C3.33339 0.695062 2.23758 0.995084 1.35414 1.87852C-0.122298 3.35496 0.0664156 5.34445 0.0664156 8.26215C0.0664156 11.2483 -0.0999079 13.1917 1.35414 14.6458C2.83634 16.1273 4.85461 15.9335 7.73777 15.9335C10.6958 15.9335 11.7167 15.9354 12.7627 15.5305C14.1847 14.9784 15.2581 13.7073 15.3631 11.4242C15.4296 10.0111 15.4258 6.51319 15.3631 5.09944C15.2364 2.40436 13.79 0.769907 10.9005 0.636848ZM13.1362 13.6689C12.1684 14.6368 10.8256 14.5505 7.71922 14.5505C4.52069 14.5505 3.23808 14.5978 2.30219 13.6593C1.22428 12.5866 1.41939 10.8638 1.41939 8.25191C1.41939 4.71753 1.05668 2.17214 4.60385 1.99047C5.41883 1.96168 5.65872 1.95208 7.71026 1.95208L7.73905 1.97128C11.148 1.97128 13.8226 1.61432 13.9832 5.16085C14.0197 5.97008 14.028 6.21317 14.028 8.26151C14.0274 11.4229 14.0875 12.7132 13.1362 13.6689Z\" />\n    <path d=\"M11.8326 5.08765C12.341 5.08765 12.7532 4.67551 12.7532 4.16712C12.7532 3.65872 12.341 3.24658 11.8326 3.24658C11.3242 3.24658 10.9121 3.65872 10.9121 4.16712C10.9121 4.67551 11.3242 5.08765 11.8326 5.08765Z\" />\n  </g>\n  <defs>\n    <clipPath id=\"clip0\">\n      <rect width=\"15.3529\" height=\"15.3529\" transform=\"translate(0.0588379 0.587891)\"/>\n    </clipPath>\n  </defs>\n</symbol>\n\n<symbol id=\"icons-tiktok\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g clip-path=\"url(#clip0)\">\n    <path d=\"M14.4929 4.305C13.6469 4.305 12.8664 4.02475 12.2396 3.55196C11.5207 3.00997 11.0042 2.21494 10.8218 1.29861C10.7766 1.0722 10.7523 0.838556 10.75 0.599121H8.33332V7.20254L8.33043 10.8195C8.33043 11.7865 7.70072 12.6065 6.82781 12.8948C6.57448 12.9785 6.30088 13.0182 6.01599 13.0025C5.65235 12.9826 5.31158 12.8728 5.0154 12.6956C4.38511 12.3187 3.95778 11.6348 3.9462 10.8525C3.92796 9.62989 4.91638 8.63307 6.13817 8.63307C6.37934 8.63307 6.61096 8.67244 6.82781 8.74395V6.93907V6.29026C6.59909 6.25638 6.36631 6.23872 6.13093 6.23872C4.79363 6.23872 3.54289 6.7946 2.64885 7.79606C1.9731 8.55287 1.56777 9.51843 1.50523 10.5309C1.4233 11.8609 1.90999 13.1253 2.85383 14.0581C2.99251 14.1951 3.13814 14.3222 3.29043 14.4394C4.09964 15.0622 5.08894 15.3998 6.13093 15.3998C6.36631 15.3998 6.59909 15.3824 6.82781 15.3485C7.80118 15.2043 8.69928 14.7588 9.40803 14.0581C10.2789 13.1974 10.7601 12.0546 10.7653 10.8384L10.7529 5.43703C11.1683 5.75754 11.6226 6.02274 12.1101 6.22859C12.8684 6.54851 13.6724 6.71064 14.4999 6.71035V4.95556V4.30442C14.5004 4.305 14.4935 4.305 14.4929 4.305Z\" />\n  </g>\n  <defs>\n    <clipPath id=\"clip0\">\n      <rect width=\"14.8235\" height=\"14.8235\" transform=\"translate(0.587158 0.587891)\"/>\n    </clipPath>\n  </defs>\n</symbol>\n\n<symbol id=\"icons-telegram\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g clip-path=\"url(#clip0)\">\n    <path d=\"M6.55328 10.2992L6.29931 13.8713C6.66267 13.8713 6.82003 13.7152 7.00875 13.5278L8.71228 11.8997L12.2422 14.4848C12.8896 14.8456 13.3457 14.6556 13.5203 13.8892L15.8373 3.03211L15.838 3.03147C16.0433 2.07447 15.4919 1.70024 14.8611 1.93501L1.2418 7.14926C0.312306 7.51005 0.32638 8.02821 1.08379 8.26298L4.56571 9.34601L12.6535 4.28529C13.0341 4.03325 13.3802 4.1727 13.0955 4.42475L6.55328 10.2992Z\"/>\n  </g>\n  <defs>\n    <clipPath id=\"clip0\">\n      <rect width=\"15.3529\" height=\"15.3529\" transform=\"translate(0.529297 0.587891)\"/>\n    </clipPath>\n  </defs>\n</symbol>\n\n<symbol id=\"icons-youtube\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M17.081 4.78214C16.8865 4.05921 16.3165 3.48933 15.5937 3.29466C14.2732 2.93335 8.991 2.93335 8.991 2.93335C8.991 2.93335 3.70902 2.93335 2.3885 3.28096C1.67957 3.47542 1.09568 4.05931 0.901222 4.78214C0.553711 6.10256 0.553711 8.84094 0.553711 8.84094C0.553711 8.84094 0.553711 11.5931 0.901222 12.8997C1.09589 13.6226 1.66566 14.1924 2.3886 14.3871C3.72292 14.7485 8.99121 14.7485 8.99121 14.7485C8.99121 14.7485 14.2732 14.7485 15.5937 14.4009C16.3167 14.2064 16.8865 13.6365 17.0812 12.9136C17.4286 11.5931 17.4286 8.85484 17.4286 8.85484C17.4286 8.85484 17.4425 6.10256 17.081 4.78214ZM7.30927 11.3707V6.31113L11.7017 8.84094L7.30927 11.3707Z\" />\n</symbol>\n\n<symbol id=\"icons-football\" viewBox=\"0 0 24 24\"  xmlns=\"http://www.w3.org/2000/svg\">\n  <path clip-rule=\"evenodd\" d=\"M6.58798 9.02996L11.0145 5.9314V2C7.69185 2.32503 4.84607 4.27621 3.28346 7.04724L6.58798 9.02996ZM2.47589 8.89508C2.16686 9.85864 2 10.8859 2 11.9521C2 14.5966 3.02653 17.0013 4.70286 18.7896L7.40853 15.6974L6.15545 11.1028L2.47589 8.89508ZM6.20895 20.1056C7.84306 21.2683 9.84168 21.9521 12 21.9521C14.1662 21.9521 16.1715 21.2633 17.8089 20.0928L15.4982 17.4521H8.53076L6.20895 20.1056ZM19.3121 18.7736C20.9796 16.987 22 14.5887 22 11.9521C22 10.8912 21.8348 9.86901 21.5288 8.90967L17.8735 11.1028L16.6205 15.6974L19.3121 18.7736ZM20.7239 7.06024C19.1674 4.29038 16.3299 2.33691 13.0145 2.00288V5.94283L17.3414 9.0897L20.7239 7.06024ZM15.9509 10.5514L14.6143 15.4521H9.41466L8.04989 10.4479L12.0034 7.68048L15.9509 10.5514Z\" />\n</symbol>\n\n<symbol id=\"icons-mini-football\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M8.48 10.86L9.83 15H14.17L15.52 10.87L12 8.3L8.48 10.86ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM15.16 16.35L13.88 20.28C12.6438 20.5734 11.3562 20.5734 10.12 20.28L8.84 16.35H4.71C4.05595 15.2597 3.65604 14.0361 3.54 12.77L6.88 10.34L5.61 6.41C6.43545 5.45932 7.45956 4.70148 8.61 4.19L12 6.62L15.35 4.19C16.5005 4.70148 17.5246 5.45932 18.35 6.41L17.08 10.34L20.42 12.77C20.304 14.0361 19.9041 15.2597 19.25 16.35H15.16Z\"/>\n</symbol>\n\n<symbol id=\"icons-pdf-file\" viewBox=\"0 0 36 40\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M36 36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4C4 1.79086 5.79086 0 8 0H24L36 12V36Z\" fill=\"#525562\" fill-opacity=\"0.64\"/>\n  <path d=\"M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z\" fill=\"#525562\"/>\n  <rect y=\"24\" width=\"28\" height=\"12\" rx=\"6\" fill=\"#E04141\"/>\n  <path d=\"M4.6321 34V26.7273H7.50142C8.05303 26.7273 8.52296 26.8326 8.91122 27.0433C9.29948 27.2517 9.59541 27.5417 9.79901 27.9134C10.005 28.2827 10.108 28.7088 10.108 29.1918C10.108 29.6747 10.0038 30.1009 9.79545 30.4702C9.58712 30.8395 9.28527 31.1271 8.88991 31.3331C8.49692 31.5391 8.02107 31.642 7.46236 31.642H5.63352V30.4098H7.21378C7.50971 30.4098 7.75355 30.3589 7.94531 30.2571C8.13944 30.1529 8.28385 30.0097 8.37855 29.8274C8.47562 29.6428 8.52415 29.4309 8.52415 29.1918C8.52415 28.9503 8.47562 28.7396 8.37855 28.5597C8.28385 28.3774 8.13944 28.2365 7.94531 28.1371C7.75118 28.0353 7.50497 27.9844 7.20668 27.9844H6.16974V34H4.6321ZM13.6848 34H11.1067V26.7273H13.7061C14.4377 26.7273 15.0674 26.8729 15.5953 27.1641C16.1233 27.4529 16.5293 27.8684 16.8134 28.4105C17.0998 28.9527 17.2431 29.6013 17.2431 30.3565C17.2431 31.1141 17.0998 31.7652 16.8134 32.3097C16.5293 32.8542 16.1209 33.272 15.5882 33.5632C15.0579 33.8544 14.4235 34 13.6848 34ZM12.6444 32.6825H13.6209C14.0755 32.6825 14.4578 32.602 14.7679 32.4411C15.0804 32.2777 15.3148 32.0256 15.4711 31.6847C15.6297 31.3414 15.709 30.8987 15.709 30.3565C15.709 29.8191 15.6297 29.38 15.4711 29.0391C15.3148 28.6982 15.0816 28.4472 14.7715 28.2862C14.4614 28.1252 14.079 28.0447 13.6245 28.0447H12.6444V32.6825ZM18.3821 34V26.7273H23.1974V27.995H19.9197V29.728H22.8778V30.9957H19.9197V34H18.3821Z\" fill=\"white\"/>\n</symbol>\n\n<symbol id=\"icons-img-file\" viewBox=\"0 0 36 40\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M36 36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4C4 1.79086 5.79086 0 8 0H24L36 12V36Z\" fill=\"#525562\" fill-opacity=\"0.64\"/>\n  <path d=\"M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z\" fill=\"#525562\"/>\n  <rect y=\"24\" width=\"28\" height=\"12\" rx=\"6\" fill=\"#E04141\"/>\n  <path d=\"M6.16974 26.7273V34H4.6321V26.7273H6.16974ZM7.43484 26.7273H9.33114L11.334 31.6136H11.4192L13.4221 26.7273H15.3184V34H13.8269V29.2663H13.7665L11.8844 33.9645H10.8688L8.98668 29.2486H8.92631V34H7.43484V26.7273ZM21.4077 29.0781C21.358 28.9053 21.2881 28.7526 21.1982 28.62C21.1082 28.4851 20.9981 28.3714 20.8679 28.2791C20.7401 28.1844 20.5933 28.1122 20.4276 28.0625C20.2642 28.0128 20.0831 27.9879 19.8842 27.9879C19.5125 27.9879 19.1858 28.0803 18.9041 28.2649C18.6248 28.4496 18.407 28.7183 18.2507 29.071C18.0945 29.4214 18.0163 29.8499 18.0163 30.3565C18.0163 30.8632 18.0933 31.294 18.2472 31.6491C18.401 32.0043 18.6188 32.2753 18.9006 32.4624C19.1823 32.647 19.5149 32.7393 19.8984 32.7393C20.2464 32.7393 20.5436 32.6778 20.7898 32.5547C21.0384 32.4292 21.2277 32.2528 21.358 32.0256C21.4905 31.7983 21.5568 31.5296 21.5568 31.2195L21.8693 31.2656H19.9943V30.108H23.0376V31.0241C23.0376 31.6634 22.9027 32.2126 22.6328 32.6719C22.3629 33.1288 21.9912 33.4815 21.5178 33.7301C21.0443 33.9763 20.5021 34.0994 19.8913 34.0994C19.2095 34.0994 18.6106 33.9491 18.0945 33.6484C17.5784 33.3454 17.1759 32.9157 16.8871 32.3594C16.6006 31.8007 16.4574 31.1378 16.4574 30.3707C16.4574 29.7812 16.5426 29.2557 16.7131 28.794C16.8859 28.33 17.1274 27.937 17.4375 27.6151C17.7476 27.2931 18.1087 27.0481 18.5206 26.88C18.9325 26.7119 19.3788 26.6278 19.8594 26.6278C20.2713 26.6278 20.6548 26.6882 21.0099 26.8089C21.3651 26.9273 21.6799 27.0954 21.9545 27.3132C22.2315 27.531 22.4576 27.7902 22.6328 28.0909C22.808 28.3892 22.9205 28.7183 22.9702 29.0781H21.4077Z\" fill=\"white\"/>\n</symbol>\n\n<symbol id=\"icons-doc-file\" viewBox=\"0 0 36 40\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M36 36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4C4 1.79086 5.79086 0 8 0H24L36 12V36Z\" fill=\"#525562\" fill-opacity=\"0.64\"/>\n  <path d=\"M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z\" fill=\"#525562\"/>\n  <rect y=\"24\" width=\"31\" height=\"12\" rx=\"6\" fill=\"#E04141\"/>\n  <path d=\"M7.21023 34H4.6321V26.7273H7.23153C7.96307 26.7273 8.5928 26.8729 9.12074 27.1641C9.64867 27.4529 10.0547 27.8684 10.3388 28.4105C10.6252 28.9527 10.7685 29.6013 10.7685 30.3565C10.7685 31.1141 10.6252 31.7652 10.3388 32.3097C10.0547 32.8542 9.64631 33.272 9.11364 33.5632C8.58333 33.8544 7.94886 34 7.21023 34ZM6.16974 32.6825H7.14631C7.60085 32.6825 7.98319 32.602 8.29332 32.4411C8.60582 32.2777 8.8402 32.0256 8.99645 31.6847C9.15507 31.3414 9.23438 30.8987 9.23438 30.3565C9.23438 29.8191 9.15507 29.38 8.99645 29.0391C8.8402 28.6982 8.60701 28.4472 8.29688 28.2862C7.98674 28.1252 7.6044 28.0447 7.14986 28.0447H6.16974V32.6825ZM18.5907 30.3636C18.5907 31.1567 18.4404 31.8314 18.1397 32.3878C17.8414 32.9441 17.4342 33.3691 16.9181 33.6626C16.4044 33.9538 15.8268 34.0994 15.1852 34.0994C14.5389 34.0994 13.9589 33.9527 13.4451 33.6591C12.9314 33.3655 12.5254 32.9406 12.2271 32.3842C11.9288 31.8279 11.7797 31.1544 11.7797 30.3636C11.7797 29.5705 11.9288 28.8958 12.2271 28.3395C12.5254 27.7831 12.9314 27.3594 13.4451 27.0682C13.9589 26.7746 14.5389 26.6278 15.1852 26.6278C15.8268 26.6278 16.4044 26.7746 16.9181 27.0682C17.4342 27.3594 17.8414 27.7831 18.1397 28.3395C18.4404 28.8958 18.5907 29.5705 18.5907 30.3636ZM17.0318 30.3636C17.0318 29.8499 16.9548 29.4167 16.801 29.0639C16.6494 28.7112 16.4352 28.4437 16.1582 28.2614C15.8812 28.0791 15.5569 27.9879 15.1852 27.9879C14.8135 27.9879 14.4892 28.0791 14.2122 28.2614C13.9352 28.4437 13.7198 28.7112 13.5659 29.0639C13.4144 29.4167 13.3386 29.8499 13.3386 30.3636C13.3386 30.8774 13.4144 31.3106 13.5659 31.6634C13.7198 32.0161 13.9352 32.2836 14.2122 32.4659C14.4892 32.6482 14.8135 32.7393 15.1852 32.7393C15.5569 32.7393 15.8812 32.6482 16.1582 32.4659C16.4352 32.2836 16.6494 32.0161 16.801 31.6634C16.9548 31.3106 17.0318 30.8774 17.0318 30.3636ZM26.1467 29.2734H24.5913C24.5629 29.0722 24.5049 28.8935 24.4173 28.7372C24.3297 28.5786 24.2172 28.4437 24.0799 28.3324C23.9426 28.2211 23.784 28.1359 23.604 28.0767C23.4265 28.0175 23.2335 27.9879 23.0252 27.9879C22.6488 27.9879 22.3209 28.0814 22.0415 28.2685C21.7622 28.4531 21.5456 28.723 21.3917 29.0781C21.2378 29.4309 21.1609 29.8594 21.1609 30.3636C21.1609 30.8821 21.2378 31.3177 21.3917 31.6705C21.5479 32.0232 21.7657 32.2895 22.0451 32.4695C22.3245 32.6494 22.6476 32.7393 23.0146 32.7393C23.2205 32.7393 23.4111 32.7121 23.5863 32.6577C23.7638 32.6032 23.9213 32.5239 24.0586 32.4197C24.1959 32.3132 24.3095 32.1842 24.3995 32.0327C24.4918 31.8812 24.5558 31.7083 24.5913 31.5142L26.1467 31.5213C26.1064 31.8551 26.0058 32.1771 25.8448 32.4872C25.6862 32.795 25.4719 33.0708 25.2021 33.3146C24.9345 33.5561 24.6149 33.7479 24.2433 33.8899C23.8739 34.0296 23.4561 34.0994 22.9897 34.0994C22.341 34.0994 21.761 33.9527 21.2496 33.6591C20.7406 33.3655 20.3382 32.9406 20.0423 32.3842C19.7487 31.8279 19.6019 31.1544 19.6019 30.3636C19.6019 29.5705 19.7511 28.8958 20.0494 28.3395C20.3477 27.7831 20.7525 27.3594 21.2638 27.0682C21.7752 26.7746 22.3505 26.6278 22.9897 26.6278C23.4111 26.6278 23.8017 26.687 24.1616 26.8054C24.5238 26.9238 24.8446 27.0966 25.1239 27.3239C25.4033 27.5488 25.6306 27.8246 25.8058 28.1513C25.9833 28.478 26.0969 28.852 26.1467 29.2734Z\" fill=\"white\"/>\n</symbol>\n\n<symbol id=\"icons-handball\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <g>\n    <path id=\"svg_1\" d=\"m5.69062,11.54986c0.03,-0.2607 0.06923,-0.76142 0.14769,-1.25287c0.02539,-0.1569 0.11077,-0.35302 0.23538,-0.43609c0.70844,-0.48915 1.42149,-0.97599 2.16917,-1.40284c0.17538,-0.09922 0.52383,-0.03231 0.72921,0.07844c0.79382,0.42916 1.57842,0.8814 2.33068,1.37747c0.4892,0.32303 0.8931,0.30226 1.3731,-0.00923c0.7407,-0.47992 1.5253,-0.89062 2.273,-1.36362c0.3346,-0.20997 0.6415,-0.23765 0.9623,-0.0323c0.6299,0.40378 1.2715,0.79141 1.8599,1.25056c0.2146,0.16613 0.3854,0.503 0.4108,0.77757c0.0692,0.70371 0.0346,1.41671 0.0623,2.12501c0.0253,0.6968 -0.3393,1.1237 -0.8862,1.4998c-1.7838,1.2275 -1.7653,1.2229 -3.6276,0.1338c-2.0976,-1.2252 -1.4122,-1.1998 -3.50524,0.0046c-0.23307,0.1338 -0.49152,0.24 -0.68998,0.4153c-0.69921,0.623 -1.37304,0.5053 -2.0561,-0.0161c-0.06,-0.0462 -0.12923,-0.0831 -0.19615,-0.1223c-1.45842,-0.8606 -1.59918,-1.1075 -1.59226,-3.0272z\"/>\n    <path id=\"svg_2\" d=\"m8.92632,19.14356c-0.03692,0.0693 -0.06,0.1754 -0.12693,0.2285c-0.50998,0.4084 -1.01305,0.8214 -1.55073,1.1905c-0.10845,0.0762 -0.37844,0.0185 -0.5169,-0.0669c-1.57842,-0.9667 -2.78532,-2.2865 -3.62068,-3.9339c-0.06923,-0.1385 0.04846,-0.3877 0.11307,-0.5723c0.02769,-0.0761 0.13846,-0.1292 0.21692,-0.1822c0.49845,-0.3254 0.97844,-0.8584 1.50458,-0.9068c0.45922,-0.0438 0.95305,0.5076 1.46534,0.706c1.17228,0.4546 1.92688,1.2068 2.10226,2.5012c0.04615,0.3484 0.26307,0.676 0.41307,1.0359z\"/>\n    <path id=\"svg_3\" d=\"m20.99665,16.28736c-0.0715,0.1662 -0.1223,0.3115 -0.1939,0.4453c-0.8422,1.5483 -1.9937,2.815 -3.5052,3.7287c-0.1777,0.1084 -0.4754,0.0253 -0.7154,0.0184c-0.0485,-0.0023 -0.1015,-0.053 -0.1454,-0.0877c-0.4177,-0.3368 -1.0153,-0.5999 -1.1953,-1.0359c-0.15,-0.3646 0.1846,-0.9322 0.3138,-1.4075c0.1038,-0.3876 0.1985,-0.7822 0.3438,-1.156c0.067,-0.1753 0.2123,-0.353 0.3693,-0.4545c0.7407,-0.4753 1.4953,-0.9322 2.2545,-1.3775c0.1477,-0.0853 0.4015,-0.1776 0.51,-0.1107c0.6208,0.3761 1.2161,0.7983 1.8115,1.2136c0.0692,0.0485 0.1015,0.15 0.1523,0.2238z\"/>\n    <path id=\"svg_4\" d=\"m16.33235,3.01806c0.1962,0.09229 0.3208,0.14074 0.4362,0.20535c1.6176,0.89062 2.8984,2.12965 3.8537,3.71016c0.21,0.34841 0.2239,0.59298 -0.15,0.80295c-0.0323,0.01845 -0.06,0.04845 -0.0923,0.06922c-0.4754,0.32302 -0.9369,0.86524 -1.433,0.90216c-0.4385,0.0323 -0.8931,-0.5653 -1.3869,-0.76603c-1.2531,-0.50992 -1.9638,-1.43054 -2.4276,-2.6788c-0.3577,-0.96676 -0.4592,-0.93677 0.3553,-1.62896c0.2723,-0.22842 0.577,-0.42224 0.8446,-0.61605z\"/>\n    <path id=\"svg_5\" d=\"m5.11658,8.83318c-0.38307,-0.24919 -0.77075,-0.46377 -1.11459,-0.73373c-0.94382,-0.73834 -1.11458,-0.45685 -0.31152,-1.66127c0.89997,-1.34747 2.07224,-2.40884 3.49143,-3.20256c0.35768,-0.20073 0.64383,-0.19842 0.93228,0.08076c0.02769,0.02538 0.06,0.04846 0.09,0.07153c1.09612,0.86063 1.00612,0.82602 0.53537,2.09735c-0.40384,1.09367 -1.00151,1.86431 -2.09302,2.3027c-0.43152,0.17305 -0.78459,0.54453 -1.17458,0.82372c-0.10384,0.07383 -0.21922,0.13613 -0.35537,0.2215z\"/>\n    <path id=\"svg_6\" d=\"m12.00465,19.03906c-0.473,-0.0715 -0.95304,-0.1246 -1.42149,-0.2215c-0.14999,-0.0323 -0.28384,-0.1707 -0.40614,-0.2815c-0.06692,-0.06 -0.09923,-0.1615 -0.14538,-0.2469c-0.88614,-1.6497 -0.85844,-1.8089 0.74305,-2.7411c1.50916,-0.8791 0.88846,-0.8721 2.42076,-0.0069c0.2007,0.1131 0.3992,0.2331 0.5976,0.3507c0.8769,0.5192 0.8769,0.5192 0.5562,1.4721c-0.4869,1.4305 -0.7754,1.6336 -2.3446,1.6751z\"/>\n    <path id=\"svg_7\" d=\"m14.56605,6.90945c-0.1246,0.23996 -0.1592,0.3484 -0.2261,0.42685c-0.06,0.06922 -0.1569,0.10845 -0.2377,0.15921c-2.1553,1.38438 -2.1507,1.37977 -4.30141,-0.03923c-0.27692,-0.18228 -0.3623,-0.35532 -0.20769,-0.65528c0.13846,-0.27226 0.23308,-0.56759 0.37615,-0.83755c0.62537,-1.18134 2.14145,-1.74202 3.24455,-0.98753c0.6184,0.42685 0.93,1.30133 1.3522,1.93353z\"/>\n    <path id=\"svg_8\" d=\"m21.43615,8.74405c0.7154,2.02582 0.7662,3.99861 0.1454,6.10051c-0.6923,-0.443 -1.3361,-0.8375 -1.9569,-1.2667c-0.0853,-0.06 -0.0853,-0.2769 -0.0877,-0.4199c-0.0092,-0.9183 -0.0115,-1.8366 -0.0023,-2.75495c0.0023,-0.1569 0.0277,-0.38071 0.127,-0.45686c0.5561,-0.40377 1.1353,-0.77294 1.7745,-1.2021z\"/>\n    <path id=\"svg_9\" d=\"m2.39739,14.84976c-0.58614,-2.065 -0.54921,-4.03319 0.14538,-6.09824c0.65306,0.43377 1.2415,0.80987 1.80687,1.21826c0.08538,0.0623 0.08308,0.27688 0.08308,0.42224c0.00461,0.91834 0.00923,1.83894 -0.00692,2.75724c-0.00231,0.1708 -0.04385,0.4153 -0.15923,0.4961c-0.5746,0.4061 -1.1792,0.7683 -1.86918,1.2044z\"/>\n    <path id=\"svg_10\" d=\"m15.34795,21.30536c-1.3777,0.9206 -5.23832,0.9298 -6.71982,0.0092c0.45922,-0.3923 0.89306,-0.7776 1.34997,-1.1375c0.08307,-0.0669 0.26076,-0.0531 0.38306,-0.0254c1.08459,0.2423 2.16459,0.2353 3.24919,0.0092c0.1384,-0.03 0.3369,-0.0392 0.4338,0.0369c0.4431,0.3485 0.863,0.7292 1.3038,1.1076z\"/>\n    <path id=\"svg_11\" d=\"m9.18877,2.4283c1.92226,-0.56991 3.68298,-0.55376 5.46448,-0.05768c-0.3485,0.8214 -1.0084,1.16289 -1.7907,1.08675c-0.6231,-0.05999 -1.2738,-0.07384 -1.88537,0.03922c-0.43844,0.07845 -0.72228,0.04384 -1.00151,-0.29534c-0.20076,-0.24688 -0.45691,-0.45223 -0.7869,-0.77295z\"/>\n  </g>\n</symbol>\n\n<symbol id=\"icons-rugby\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M86.292 739.219c4.565-216.499 68.831-387.715 227.454-515.018 110.056-88.279 238.781-126.020 377.821-130.293 47.77-1.496 95.646 4.661 143.624 6.552 20.866 0.796 26.128 10.025 23.935 30.286-9.733 90.278-39.728 174.287-82.235 253.148-104.695 194.354-256.846 339.737-461.258 425.342-61.079 25.618-128.122 36.653-192.484 54.524-15.095 4.178-23.137 0.192-24.828-16.783-4.078-42.012-9.341-83.715-12.025-107.75z\"></path>\n  <path d=\"M160.858 924.293c400.472-107.16 652.755-359.707 759.932-766.279 30.887 206.764 9.826 398.435-125.349 561.108-167.163 201.106-390.543 240.036-634.579 205.17z\"></path>\n</symbol>\n\n<symbol id=\"icons-skip-next\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"m6 18 8.5-6L6 6v12zM16 6v12h2V6h-2z\"></path>\n</symbol>\n\n<symbol id=\"icons-skip-prev\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M6 6h2v12H6zm3.5 6 8.5 6V6z\"></path>\n</symbol>\n\n<symbol id=\"icons-note\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n <path d=\"M 18.964844 15.261719 C 19.710938 14.015625 20.207031 12.4375 20.300781 10.875 C 20.363281 9.871094 20.140625 8.820312 19.65625 7.828125 C 18.898438 6.273438 17.59375 5.402344 16.335938 4.558594 C 15.394531 3.929688 14.507812 3.335938 13.878906 2.484375 L 13.765625 2.332031 C 13.394531 1.835938 12.976562 1.269531 12.910156 0.796875 C 12.84375 0.316406 12.40625 -0.0273438 11.929688 0 C 11.449219 0.0351562 11.074219 0.433594 11.074219 0.921875 L 11.074219 17.371094 C 10.300781 16.902344 9.347656 16.613281 8.304688 16.613281 C 5.757812 16.613281 3.6875 18.269531 3.6875 20.308594 C 3.6875 22.34375 5.757812 24 8.304688 24 C 10.847656 24 12.917969 22.34375 12.917969 20.308594 L 12.917969 9.546875 C 14.304688 10.078125 16.574219 11.425781 17.199219 14.578125 C 17.082031 14.75 16.972656 14.933594 16.84375 15.082031 C 16.503906 15.464844 16.542969 16.046875 16.925781 16.382812 C 17.304688 16.722656 17.890625 16.683594 18.226562 16.300781 C 18.476562 16.019531 18.695312 15.691406 18.90625 15.347656 C 18.925781 15.324219 18.949219 15.292969 18.964844 15.261719 Z M 18.964844 15.261719 \"/>\n</symbol>\n\n<symbol id=\"icons-court\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M933.333 415.667v149.999h-101.666v-149.999h101.666z\"></path>\n  <path d=\"M631.667 490.652c0-60.367-43.012-110.87-100.002-122.485v244.97c56.99-11.614 100.002-62.118 100.002-122.485z\"></path>\n  <path d=\"M531.665 317.46c84.693 12.168 150.003 85.198 150.003 173.207s-65.31 161.037-150.003 173.205v151.795h326.669c41.353 0 74.999-33.647 74.999-74.999v-125.001h-126.669c-13.803 0-24.998-11.196-24.998-25.003v-199.998c0-13.807 11.196-25 24.998-25h126.669v-125c0-41.355-33.647-75-74.999-75h-326.669v151.793z\"></path>\n  <path d=\"M481.667 663.872c-84.693-12.169-150-85.197-150-173.205s65.306-161.039 150-173.207v-151.793h-326.667c-41.355 0-75 33.645-75 75v125h126.667c13.807 0 25 11.194 25 25v199.998c0 13.807-11.194 25.003-25 25.003h-126.667v125.001c0 41.353 33.645 74.999 75 74.999h326.667v-151.795z\"></path>\n  <path d=\"M181.667 415.667v149.999h-101.667v-149.999h101.667z\"></path>\n  <path d=\"M381.667 490.652c0 60.367 43.014 110.871 100 122.485v-244.97c-56.986 11.615-100 62.118-100 122.485z\"></path>\n</symbol>\n<symbol id=\"icons-rupor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 359.35 335.39\">\n\n  <g id=\"Layer_2\" data-name=\"Layer 2\">\n    <g id=\"Layer_1-2\" data-name=\"Layer 1\">\n      <path class=\"cls-1\" d=\"M359.35,178.22c-.94,6.69-1.63,13.42-2.86,20.06-6.32,34.11-21.95,63.34-46.48,87.82a11.93,11.93,0,1,1-16.85-16.88,148.83,148.83,0,0,0,29.9-43.35C346.46,173.73,336,111.52,296.76,70c-1.2-1.28-2.46-2.51-3.63-3.81-4.67-5.13-4.59-12.44.15-17s12-4.57,17,.36a165,165,0,0,1,48.48,105,18.39,18.39,0,0,0,.6,2.7Z\"/><path class=\"cls-1\" d=\"M215.18,321.06c0,2.82,1.28,6,0,8.4-3.47,6.6-13.23,7.86-19.51,2.91-11.38-9-22.65-18.11-34-27.16Q122,273.42,82.21,241.74a10.94,10.94,0,0,0-6.29-2.13c-16.72-.18-33.45-.08-50.17-.11C9.86,239.48,0,229.55,0,213.62q0-46,0-91.93c0-15.9,9.86-25.77,25.82-25.81,16.84,0,33.68.05,50.52-.1a9.93,9.93,0,0,0,5.66-2q56.1-44.68,112.05-89.58C198,1.09,202-1.11,207.22.59a11.5,11.5,0,0,1,8,10.65c.08,1.4,0,2.81,0,4.21C215.18,66.21,215.27,270,215.18,321.06Z\"/><path class=\"cls-1\" d=\"M311.47,169.56c-.48,30.61-11.64,58.76-34.53,82.07-4.31,4.39-9.83,5.38-14.69,2.81a11.33,11.33,0,0,1-6-13,18.15,18.15,0,0,1,4.4-7.33c15-15.66,24-34.22,26.16-55.73,3-29.25-5.46-54.92-25.63-76.58A21.22,21.22,0,0,1,256.3,94c-1.55-5.25,1.19-10.5,5.87-13s10.32-1.69,14.46,2.43a116.68,116.68,0,0,1,23.53,33.34C307.74,132.85,311.31,149.87,311.47,169.56Z\"/>\n    </g>\n  </g>\n</symbol>\n  <!-- Generated by IcoMoon.io -->\n  <symbol id=\"icons-list\" viewBox=\"0 0 1385 1024\">\n\n    <path d=\"M207.312 112.068c0 47.274-38.323 85.597-85.597 85.597s-85.597-38.323-85.597-85.597c0-47.274 38.323-85.597 85.597-85.597s85.597 38.323 85.597 85.597z\"></path>\n    <path d=\"M207.312 497.156c0 47.274-38.323 85.597-85.597 85.597s-85.597-38.323-85.597-85.597c0-47.274 38.323-85.597 85.597-85.597s85.597 38.323 85.597 85.597z\"></path>\n    <path d=\"M207.312 882.405c0 47.274-38.323 85.597-85.597 85.597s-85.597-38.323-85.597-85.597c0-47.274 38.323-85.597 85.597-85.597s85.597 38.323 85.597 85.597z\"></path>\n    <path d=\"M352.821 69.309h941.571c23.637 0 42.799 19.162 42.799 42.799v0c0 23.637-19.162 42.799-42.799 42.799h-941.571c-23.637 0-42.799-19.162-42.799-42.799v0c0-23.637 19.162-42.799 42.799-42.799z\"></path>\n    <path d=\"M352.821 454.573h941.571c23.637 0 42.799 19.162 42.799 42.799v0c0 23.637-19.162 42.799-42.799 42.799h-941.571c-23.637 0-42.799-19.162-42.799-42.799v0c0-23.637 19.162-42.799 42.799-42.799z\"></path>\n    <path d=\"M352.821 839.662h941.571c23.637 0 42.799 19.162 42.799 42.799v0c0 23.637-19.162 42.799-42.799 42.799h-941.571c-23.637 0-42.799-19.162-42.799-42.799v0c0-23.637 19.162-42.799 42.799-42.799z\"></path>\n  </symbol>\n  <svg id=\"icons-chess-old\" viewBox=\"0 0 1024 1024\">\n    <path fill=\"#141416\" d=\"M75.474 0h308.025c29.765 0 53.895 24.129 53.895 53.895v308.025c0 29.765-24.129 53.895-53.895 53.895h-308.025c-29.765 0-53.895-24.129-53.895-53.895v-308.025c0-29.765 24.129-53.895 53.895-53.895z\"></path>\n    <path fill=\"#fff\" d=\"M75.474 554.41h308.025c29.765 0 53.895 24.129 53.895 53.895v308.025c0 29.765-24.129 53.895-53.895 53.895h-308.025c-29.765 0-53.895-24.129-53.895-53.895v-308.025c0-29.765 24.129-53.895 53.895-53.895z\"></path>\n    <path fill=\"#fff\" d=\"M629.884 0h308.025c29.765 0 53.895 24.129 53.895 53.895v308.025c0 29.765-24.129 53.895-53.895 53.895h-308.025c-29.765 0-53.895-24.129-53.895-53.895v-308.025c0-29.765 24.129-53.895 53.895-53.895z\"></path>\n    <path fill=\"#141416\" d=\"M629.873 554.41h308.025c29.765 0 53.895 24.129 53.895 53.895v308.025c0 29.765-24.129 53.895-53.895 53.895h-308.025c-29.765 0-53.895-24.129-53.895-53.895v-308.025c0-29.765 24.129-53.895 53.895-53.895z\"></path>\n  </svg>\n  <svg id=\"icons-chess\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.6 12V2.6H12V12H2.6ZM12 21.4V12H21.4V21.4H12ZM1 2C1 1.44772 1.44772 1 2 1H22C22.5523 1 23 1.44772 23 2V22C23 22.5523 22.5523 23 22 23H2C1.44772 23 1 22.5523 1 22V2Z\" fill=\"white\"/>\n  </svg>\n\n  <symbol id=\"icons-details\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\">>\n    <path d=\"M271.059 240.941h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z\"></path>\n    <path d=\"M271.059 440.669h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z\"></path>\n    <path d=\"M271.059 640.398h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z\"></path>\n    <path d=\"M470.766 240.941h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z\"></path>\n    <path d=\"M470.766 440.669h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z\"></path>\n    <path d=\"M470.766 640.398h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z\"></path>\n    <path d=\"M670.5 240.941h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z\"></path>\n    <path d=\"M670.5 440.669h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z\"></path>\n    <path d=\"M670.5 640.398h82.427c16.634 0 30.118 13.484 30.118 30.118v82.427c0 16.634-13.484 30.118-30.118 30.118h-82.427c-16.634 0-30.118-13.484-30.118-30.118v-82.427c0-16.634 13.484-30.118 30.118-30.118z\"></path>\n  </symbol>\n\n  <symbol id=\"icons-arrows\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\">\n    <path d=\"M189.023 346.351c-0.289 0.431-0.539 0.877-0.8 1.308-0.228 0.39-0.478 0.785-0.707 1.191-0.238 0.451-0.443 0.922-0.666 1.374-0.195 0.428-0.41 0.841-0.595 1.269-0.185 0.449-0.338 0.912-0.5 1.373-0.168 0.467-0.349 0.923-0.484 1.384-0.144 0.467-0.238 0.923-0.355 1.394s-0.256 0.955-0.349 1.435c-0.103 0.549-0.178 1.087-0.25 1.634-0.062 0.422-0.144 0.83-0.185 1.251-0.185 1.956-0.185 3.932 0 5.888 0.045 0.428 0.121 0.838 0.185 1.251 0.072 0.554 0.144 1.087 0.25 1.634 0.103 0.484 0.226 0.964 0.349 1.435 0.117 0.472 0.226 0.927 0.355 1.394 0.144 0.472 0.316 0.923 0.484 1.384 0.162 0.457 0.308 0.922 0.5 1.373 0.185 0.431 0.39 0.843 0.595 1.269 0.223 0.463 0.428 0.923 0.666 1.374 0.226 0.406 0.472 0.8 0.707 1.191 0.267 0.433 0.513 0.882 0.8 1.308 0.299 0.439 0.629 0.863 0.951 1.292 0.267 0.349 0.512 0.717 0.789 1.046 0.633 0.759 1.291 1.497 1.989 2.194l149.089 149.095c5.822 5.826 13.458 8.735 21.092 8.735s15.27-2.909 21.088-8.735c11.646-11.642 11.646-30.525 0-42.169l-98.183-98.183h524.37c16.462 0 29.825-13.346 29.825-29.825s-13.346-29.825-29.825-29.825h-524.37l98.183-98.187c11.646-11.642 11.646-30.525 0-42.169-11.642-11.646-30.525-11.646-42.169 0l-149.089 149.093c-0.699 0.695-1.361 1.427-1.989 2.194-0.279 0.349-0.521 0.705-0.789 1.046-0.318 0.431-0.65 0.841-0.951 1.292z\"></path>\n    <path d=\"M839.667 656.898c-0.072-0.554-0.144-1.087-0.25-1.634-0.103-0.484-0.226-0.964-0.349-1.435-0.117-0.472-0.226-0.927-0.355-1.394-0.144-0.472-0.316-0.923-0.484-1.384-0.162-0.457-0.308-0.922-0.5-1.369-0.185-0.431-0.39-0.843-0.595-1.269-0.223-0.463-0.428-0.923-0.666-1.374-0.226-0.406-0.472-0.8-0.707-1.191-0.267-0.433-0.513-0.882-0.8-1.308-0.299-0.439-0.629-0.863-0.951-1.292-0.267-0.349-0.512-0.717-0.791-1.046-0.629-0.759-1.291-1.497-1.989-2.194l-149.089-149.093c-11.642-11.646-30.525-11.646-42.169 0-11.646 11.642-11.646 30.525 0 42.169l98.189 98.177h-524.37c-16.462 0.002-29.825 13.346-29.825 29.825s13.346 29.825 29.825 29.825h524.37l-98.187 98.187c-11.646 11.642-11.646 30.525 0 42.169 5.822 5.822 13.458 8.733 21.092 8.733s15.27-2.909 21.088-8.735l149.089-149.089c0.699-0.695 1.361-1.427 1.989-2.194 0.279-0.349 0.521-0.705 0.791-1.046 0.318-0.431 0.65-0.841 0.951-1.292 0.289-0.431 0.539-0.879 0.8-1.308 0.228-0.39 0.478-0.785 0.707-1.191 0.238-0.451 0.443-0.918 0.666-1.374 0.195-0.428 0.41-0.841 0.595-1.269 0.185-0.449 0.338-0.912 0.5-1.373 0.168-0.467 0.349-0.923 0.484-1.384 0.144-0.467 0.238-0.923 0.355-1.394s0.256-0.955 0.349-1.435c0.103-0.549 0.178-1.087 0.25-1.634 0.062-0.422 0.144-0.83 0.185-1.251 0.185-1.956 0.185-3.932 0-5.888-0.049-0.431-0.127-0.841-0.185-1.251z\"></path>\n  </symbol>\n\n  <symbol id=\"icons-info\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\">\n    <path d=\"M512 168.96c-189.282 0-343.040 153.758-343.040 343.040s153.758 343.040 343.040 343.040c189.282 0 343.040-153.758 343.040-343.040s-153.758-343.040-343.040-343.040zM512 198.784c173.161 0 313.216 140.055 313.216 313.216s-140.055 313.216-313.216 313.216c-173.161 0-313.216-140.055-313.216-313.216s140.055-313.216 313.216-313.216zM512 303.197c-24.716 0-44.744 20.036-44.744 44.744v0c0 24.716 20.036 44.744 44.744 44.744v0c24.716 0 44.744-20.036 44.744-44.744v0c0-24.716-20.036-44.744-44.744-44.744v0zM452.336 452.336v29.822h29.822v193.888h-29.822v29.822h119.315v-29.822h-29.822v-223.725h-89.488z\"></path>\n  </symbol>\n  <symbol id=\"icons-waterpolo\" >\n    <g id=\"Group 390\">\n      <path id=\"Vector\" d=\"M19.2064 14.7737C19.069 14.6501 18.95 14.5654 18.8561 14.4601C16.8117 12.1732 14.3299 10.5777 11.3697 9.76281C10.9393 9.64378 10.6989 9.45835 10.6783 9.01198C10.6256 7.81706 10.5638 6.62215 10.5157 5.42724C10.502 5.09989 10.6622 4.99459 10.9873 5.0747C14.2956 5.88734 17.2673 7.36611 19.8749 9.56137C20.0054 9.67125 20.113 9.86582 20.1405 10.0352C20.3351 11.2576 19.8772 13.6062 19.2064 14.7737Z\" />\n      <path id=\"Vector_2\" d=\"M6.06636 12.3976C5.27193 10.912 4.87814 9.41257 4.73162 7.8491C4.54618 5.88733 4.79572 3.97364 5.52833 2.13319C5.59015 1.97982 5.66571 1.78524 5.79391 1.71657C7.14467 1.00007 8.58701 0.658992 10.2102 0.668148C10.0637 1.13971 9.94234 1.53115 9.821 1.9203C9.04489 4.40857 8.93271 6.92889 9.40891 9.48583C9.43867 9.65065 9.43181 9.90245 9.33108 10.0032C8.38783 10.9509 7.30951 11.72 6.06636 12.3976Z\" />\n      <path id=\"Vector_3\" d=\"M14.4209 12.3307C13.299 14.13 12.0307 15.4714 10.4304 16.4901C10.3113 16.5656 10.1419 16.5931 9.99538 16.6C9.15745 16.6366 8.44315 16.9708 7.82272 17.5042C7.54799 17.7399 7.35796 17.7972 7.04889 17.5339C5.8332 16.497 4.46641 16.3092 2.99889 16.9227C2.70126 17.0463 2.49979 17.0097 2.3235 16.735C2.01901 16.2635 1.6985 15.801 1.40316 15.3615C2.74706 14.9587 4.02227 14.6405 5.2494 14.1964C7.02371 13.5531 8.58509 12.5299 9.96562 11.2457C10.2884 10.9458 10.5815 10.8565 10.9867 11.0145C12.0925 11.4471 13.2075 11.8661 14.4209 12.3307Z\" />\n      <path id=\"Vector_4\" d=\"M3.73575 3.14313C3.63272 3.86878 3.51595 4.55781 3.43811 5.24912C3.15422 7.79005 3.57547 10.2188 4.64006 12.5377C4.78429 12.8513 4.75225 13.0367 4.39281 13.1214C3.33967 13.3732 2.2911 13.6502 1.23339 13.8677C1.07313 13.8997 0.738873 13.712 0.690795 13.5609C-0.458498 9.94869 0.567167 5.81683 3.51137 3.25302C3.56403 3.20953 3.64188 3.18891 3.73575 3.14313Z\" />\n      <path id=\"Vector_5\" d=\"M18.632 20.6675C18.1191 20.3653 17.5697 20.1158 17.1049 19.7519C16.2258 19.0628 15.848 19.0331 15.017 19.7587C13.7784 20.8369 12.5627 20.8369 11.3264 19.7541C10.4999 19.0308 10.0878 19.0331 9.24992 19.7633C8.02965 20.8255 6.83687 20.8323 5.60516 19.7793C4.72373 19.0262 4.34597 19.0193 3.48285 19.7793C2.98147 20.2211 2.43888 20.5416 1.7429 20.5347C1.33538 20.5302 1.0698 20.347 1.03317 19.9464C0.996535 19.5687 1.2438 19.3856 1.58263 19.2482C1.99473 19.0834 2.42972 18.9095 2.76626 18.6348C3.91784 17.6939 5.16787 17.6688 6.2874 18.6302C7.24438 19.452 7.58779 19.452 8.54706 18.6302C9.67117 17.6688 10.9418 17.6733 12.059 18.6439C12.984 19.4451 13.3617 19.4474 14.2752 18.6577C15.4245 17.6642 16.6608 17.6756 17.8376 18.6462C18.1489 18.9026 18.5313 19.1017 18.9136 19.2276C19.3051 19.3581 19.6004 19.5229 19.55 19.9625C19.4951 20.4409 19.1471 20.5691 18.7098 20.521C18.6846 20.5714 18.6595 20.6194 18.632 20.6675Z\" />\n      <path id=\"Vector_6\" d=\"M19.6363 7.60047C18.8098 7.08542 18.0863 6.60928 17.34 6.17663C15.4329 5.07557 13.4067 4.26523 11.2547 3.79138C10.8769 3.70897 10.7281 3.56476 10.8678 3.16645C11.099 2.5049 11.2982 1.82961 11.5157 1.16348C11.6118 0.865894 11.795 0.74685 12.1224 0.82468C15.671 1.65792 18.1916 3.69753 19.5264 7.12662C19.5722 7.24108 19.5836 7.36927 19.6363 7.60047Z\" />\n      <path id=\"Vector_7\" d=\"M15.5924 13.2681C16.6203 13.9755 17.543 14.8751 18.3099 15.9212C18.4061 16.0517 18.2573 16.4431 18.1153 16.6354C18.0077 16.7796 17.6895 16.9101 17.5338 16.8552C16.0617 16.3447 14.7178 16.521 13.5273 17.5465C13.2457 17.7891 13.0488 17.7731 12.8016 17.5236C12.6298 17.3496 12.4169 17.2168 12.2269 17.0589C12.2017 17.0383 12.2017 16.9902 12.2132 17.0245C13.3373 15.7793 14.4339 14.5569 15.5924 13.2681Z\" />\n    </g>\n  </symbol>\n\n  <symbol id=\"icons-eye\"  viewBox=\"0 0 1152 1024\">\n    <path d=\"M576 339.337c-17.284 0.277-33.81 3.078-49.376 8.046l1.208-0.334c6.925 11.969 11.049 26.299 11.158 41.595v0.030c0 47.677-38.649 86.337-86.337 86.337v0c-15.326-0.109-29.656-4.236-42.039-11.377l0.414 0.219c-4.275 14.295-6.744 30.717-6.744 47.711 0 95.11 77.105 172.216 172.216 172.216s172.216-77.105 172.216-172.216c0-95.11-77.105-172.216-172.216-172.216-0.182 0-0.364 0-0.546 0.001h0.026zM1014.635 489.488c-83.601-163.121-249.117-273.488-438.635-273.488s-355.073 110.445-438.635 273.508c-3.385 6.548-5.364 14.296-5.364 22.502s1.979 15.954 5.494 22.777l-0.129-0.277c83.601 163.121 249.117 273.488 438.635 273.488s355.073-110.445 438.635-273.508c3.385-6.548 5.364-14.296 5.364-22.502s-1.979-15.954-5.494-22.777l0.129 0.277zM576 734c-152.088 0-291.511-84.788-366.806-222 75.295-137.212 214.707-222 366.806-222s291.511 84.788 366.806 222c-75.276 137.212-214.707 222-366.806 222z\"></path>\n  </symbol>\n  <symbol id=\"icons-slash\" viewBox=\"0 0 1280 1024\">\n    <path d=\"M218.905 180.221c-18.288-14.86-45.16-12.080-60.019 6.209s-12.080 45.16 6.209 60.020l682.666 554.665c18.287 14.861 45.158 12.083 60.019-6.208 14.861-18.287 12.079-45.158-6.208-60.019l-102.579-83.345c0.725-0.687 1.451-1.374 2.167-2.061 30.507-29.227 52.838-58.389 67.601-80.32 7.403-10.995 12.962-20.262 16.751-26.94 1.894-3.341 3.349-6.042 4.373-7.996 0.512-0.973 0.917-1.766 1.216-2.355l0.371-0.734 0.124-0.256 0.068-0.137c0.009-0.017 0.017-0.034-38.332-18.739l38.349 18.705c5.756-11.806 5.756-25.609 0-37.41l-38.349 18.705c38.349-18.705 38.34-18.726 38.332-18.743l-0.021-0.038-0.047-0.098-0.124-0.252-0.371-0.738c-0.209-0.41-0.465-0.917-0.777-1.515-0.137-0.265-0.282-0.542-0.439-0.841-1.024-1.954-2.479-4.655-4.373-7.996-3.789-6.673-9.348-15.945-16.751-26.94-14.763-21.931-37.094-51.092-67.601-80.318-61.15-58.58-156.527-118.523-289.161-118.523-61.205 0-114.474 12.764-160.109 32.268l-132.986-108.050zM429.841 351.605l302.225 245.562c3.46-3.089 6.814-6.195 10.065-9.31 25.165-24.107 43.678-48.277 55.842-66.347 2.295-3.413 4.361-6.601 6.191-9.506-1.83-2.91-3.895-6.093-6.191-9.51-12.164-18.069-30.677-42.24-55.842-66.347-50.197-48.087-125.487-94.811-230.131-94.811-29.722 0-57.075 3.77-82.159 10.269zM511.863 682.671l91.465 75.324c-28.207 6.366-58.637 10.010-91.328 10.010-132.633 0-228.009-59.942-289.16-118.524-30.509-29.227-52.839-58.389-67.601-80.32-7.402-10.995-12.963-20.262-16.749-26.94-1.895-3.341-3.351-6.042-4.375-7.996-0.512-0.973-0.917-1.766-1.216-2.355l-0.369-0.734-0.125-0.256-0.048-0.094-0.020-0.043c-0.009-0.017-0.017-0.034 38.33-18.739-38.348-18.705-38.339-18.726-38.33-18.743l0.020-0.038 0.048-0.098 0.125-0.252 0.369-0.738c0.299-0.589 0.704-1.378 1.216-2.355 1.025-1.954 2.481-4.655 4.375-7.996 3.787-6.673 9.347-15.945 16.749-26.94 7.963-11.827 18.127-25.762 30.589-40.673l65.873 54.25c-10.486 12.51-19.027 24.201-25.673 34.074-2.299 3.418-4.362 6.601-6.192 9.51 1.83 2.906 3.893 6.093 6.192 9.506 12.163 18.069 30.677 42.24 55.843 66.347 50.174 48.068 125.421 94.771 229.993 94.814zM170.667 512.004l-38.348 18.705c-5.758-11.806-5.758-25.609 0-37.41l38.348 18.705z\"></path>\n  </symbol>\n\n\n</defs>\n</svg>\n"
            }]
    }], null, null); })();

class SvgIconModule {
}
SvgIconModule.ɵfac = function SvgIconModule_Factory(t) { return new (t || SvgIconModule)(); };
SvgIconModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SvgIconModule });
SvgIconModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgIconModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    SvgIconComponent,
                    SvgIconDefinitionsComponent,
                ],
                exports: [
                    SvgIconComponent,
                    SvgIconDefinitionsComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SvgIconModule, { declarations: function () { return [SvgIconComponent, SvgIconDefinitionsComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SvgIconComponent, SvgIconDefinitionsComponent]; } }); })();

class SpinnerComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.defaultClass = true;
    }
    setProgress(progress) {
        this.progress = progress;
        this.cdr.detectChanges();
    }
}
SpinnerComponent.ɵfac = function SpinnerComponent_Factory(t) { return new (t || SpinnerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SpinnerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SpinnerComponent, selectors: [["mtg-spinner"]], hostVars: 2, hostBindings: function SpinnerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("spinner", ctx.defaultClass);
    } }, inputs: { progress: "progress" }, decls: 5, vars: 1, consts: [["class", "progress", 4, "ngIf"], [1, "progress"]], template: function SpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div")(1, "div")(2, "div")(3, "div");
        ɵngcc0.ɵɵtemplate(4, SpinnerComponent_span_4_Template, 2, 1, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.progress);
    } }, dependencies: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
SpinnerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
SpinnerComponent.propDecorators = {
    progress: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.spinner',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-spinner',
                template: "<div></div><div></div><div></div><div></div>\n<span class=\"progress\" *ngIf=\"progress\">{{ +progress }}%</span>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.spinner']
        }], progress: [{
            type: Input
        }] }); })();

class LinearProgressComponent {
    constructor() {
        this.defaultClass = true;
    }
}
LinearProgressComponent.ɵfac = function LinearProgressComponent_Factory(t) { return new (t || LinearProgressComponent)(); };
LinearProgressComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LinearProgressComponent, selectors: [["mtg-linear-progress"]], hostVars: 2, hostBindings: function LinearProgressComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("linear-progress", ctx.defaultClass);
    } }, decls: 5, vars: 0, consts: [[1, "progress-buffer"], [1, "progress", "progress--primary"], [1, "progress-inner"], [1, "progress", "progress--secondary"]], template: function LinearProgressComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
LinearProgressComponent.propDecorators = {
    defaultClass: [{ type: HostBinding, args: ['class.linear-progress',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LinearProgressComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-linear-progress',
                template: "<div class=\"progress-buffer\"></div>\n<div class=\"progress progress--primary\"><div class=\"progress-inner\"></div></div>\n<div class=\"progress progress--secondary\"><div class=\"progress-inner\"></div></div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.linear-progress']
        }] }); })();

class ProgressModule {
}
ProgressModule.ɵfac = function ProgressModule_Factory(t) { return new (t || ProgressModule)(); };
ProgressModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ProgressModule });
ProgressModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        OverlayModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    OverlayModule,
                ],
                declarations: [
                    SpinnerComponent,
                    LinearProgressComponent,
                ],
                exports: [
                    SpinnerComponent,
                    LinearProgressComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ProgressModule, { declarations: function () { return [SpinnerComponent, LinearProgressComponent]; }, imports: function () { return [CommonModule,
        OverlayModule]; }, exports: function () { return [SpinnerComponent, LinearProgressComponent]; } }); })();

class ButtonModule {
}
ButtonModule.ɵfac = function ButtonModule_Factory(t) { return new (t || ButtonModule)(); };
ButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ButtonModule });
ButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, SvgIconModule, ProgressModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, SvgIconModule, ProgressModule],
                declarations: [ButtonComponent],
                exports: [ButtonComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ButtonModule, { declarations: function () { return [ButtonComponent]; }, imports: function () { return [CommonModule, SvgIconModule, ProgressModule]; }, exports: function () { return [ButtonComponent]; } }); })();

class AudioModule {
}
AudioModule.ɵfac = function AudioModule_Factory(t) { return new (t || AudioModule)(); };
AudioModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AudioModule });
AudioModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        ButtonModule,
        SvgIconModule,
        ProgressModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AudioModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ButtonModule,
                    SvgIconModule,
                    ProgressModule,
                ],
                declarations: [
                    AudioComponent
                ],
                exports: [
                    AudioComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AudioModule, { declarations: function () { return [AudioComponent]; }, imports: function () { return [CommonModule, ButtonModule, SvgIconModule, ProgressModule]; }, exports: function () { return [AudioComponent]; } }); })();

class CheckboxGroupComponent {
    constructor(parentFormGroup) {
        this.parentFormGroup = parentFormGroup;
        this.value = [];
        this.checkboxes = [];
    }
    get defaultClass() {
        return true;
    }
    ngOnInit() {
        if (this.parentFormGroup) {
            this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
        }
        else {
            this.control = this.formControl;
        }
    }
    addCheckbox(checkbox) {
        this.checkboxes.push(checkbox);
    }
    removeCheckbox(checkbox) {
        if (this.checkboxes.indexOf(checkbox) > -1) {
            this.checkboxes.splice(this.checkboxes.indexOf(checkbox), 1);
        }
    }
    writeValue(obj) {
        this.value = obj || [];
        for (const checkbox of this.checkboxes) {
            if (this.value.indexOf(checkbox.value) > -1) {
                checkbox.changeValue(true, true);
            }
            else {
                checkbox.changeValue(false, true);
            }
        }
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    onItemChanged(value, checked) {
        if (checked) {
            if (this.value.indexOf(value) < 0) {
                this.value.push(value);
            }
        }
        else if (this.value.indexOf(value) > -1) {
            this.value.splice(this.value.indexOf(value), 1);
        }
        if (this.onTouch) {
            this.onTouch();
        }
        if (this.onChange) {
            this.onChange(this.value);
        }
    }
}
CheckboxGroupComponent.ɵfac = function CheckboxGroupComponent_Factory(t) { return new (t || CheckboxGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 8)); };
CheckboxGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxGroupComponent, selectors: [["mtg-checkbox-group"]], hostVars: 2, hostBindings: function CheckboxGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("checkbox-group", ctx.defaultClass);
    } }, inputs: { formControl: "formControl", formControlName: "formControlName", reverse: "reverse" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CheckboxGroupComponent),
                multi: true
            }
        ])], ngContentSelectors: _c2, decls: 1, vars: 0, template: function CheckboxGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
CheckboxGroupComponent.ctorParameters = () => [
    { type: FormGroupDirective, decorators: [{ type: Optional }] }
];
CheckboxGroupComponent.propDecorators = {
    formControl: [{ type: Input }],
    formControlName: [{ type: Input }],
    reverse: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.checkbox-group',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxGroupComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-checkbox-group',
                template: "<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxGroupComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Optional
            }] }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.checkbox-group']
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], reverse: [{
            type: Input
        }] }); })();

class CheckboxComponent {
    constructor(parentFormGroup, checkboxGroupComponent, cdr) {
        this.parentFormGroup = parentFormGroup;
        this.checkboxGroupComponent = checkboxGroupComponent;
        this.cdr = cdr;
        this.value = true;
    }
    get isReverse() {
        var _a;
        return this.reverse || ((_a = this.checkboxGroupComponent) === null || _a === void 0 ? void 0 : _a.reverse);
    }
    get defaultClass() {
        return true;
    }
    ngOnInit() {
        if (this.parentFormGroup) {
            this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
        }
        if (this.checkboxGroupComponent) {
            this.checked = (this.checkboxGroupComponent.value || []).indexOf(this.value) > -1;
            this.checkboxGroupComponent.addCheckbox(this);
        }
    }
    ngOnDestroy() {
        if (this.checkboxGroupComponent) {
            this.checkboxGroupComponent.removeCheckbox(this);
        }
    }
    writeValue(obj) {
        this.checked = obj === this.value;
        this.cdr.markForCheck();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    changeValue(checked, fromCheckboxGroup) {
        this.checked = checked;
        if (this.checkboxGroupComponent && !fromCheckboxGroup) {
            this.checkboxGroupComponent.onItemChanged(this.value, this.checked);
        }
        if (fromCheckboxGroup) {
            this.cdr.detectChanges();
        }
        if (this.onTouch) {
            this.onTouch();
        }
        if (this.onChange) {
            this.onChange(this.checked ? this.value : null);
        }
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 8), ɵngcc0.ɵɵdirectiveInject(CheckboxGroupComponent, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["mtg-checkbox"]], hostVars: 2, hostBindings: function CheckboxComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("checkbox-container", ctx.defaultClass);
    } }, inputs: { value: "value", formControl: "formControl", formControlName: "formControlName", reverse: "reverse" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => CheckboxComponent),
                multi: true
            }
        ])], ngContentSelectors: _c2, decls: 7, vars: 4, consts: [[3, "ngClass"], [1, "checkbox"], ["type", "checkbox", 3, "checked", "change"], [1, "checkbox-appearance"], ["icon", "icons-done"], [1, "label"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "label", 0)(1, "div", 1)(2, "input", 2);
        ɵngcc0.ɵɵlistener("change", function CheckboxComponent_Template_input_change_2_listener($event) { return ctx.changeValue($event.target.checked); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "mtg-svg-icon", 4);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c3, ctx.isReverse));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("checked", ctx.checked);
    } }, dependencies: [ɵngcc1.NgClass, SvgIconComponent], encapsulation: 2, changeDetection: 0 });
CheckboxComponent.ctorParameters = () => [
    { type: FormGroupDirective, decorators: [{ type: Optional }] },
    { type: CheckboxGroupComponent, decorators: [{ type: Optional }] },
    { type: ChangeDetectorRef }
];
CheckboxComponent.propDecorators = {
    formControl: [{ type: Input }],
    formControlName: [{ type: Input }],
    value: [{ type: Input }],
    reverse: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.checkbox-container',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-checkbox',
                template: "<label [ngClass]=\"{reverse: isReverse}\">\n  <div class=\"checkbox\">\n    <input type=\"checkbox\" [checked]=\"checked\" (change)=\"changeValue($event.target.checked)\" />\n    <div class=\"checkbox-appearance\">\n      <mtg-svg-icon icon=\"icons-done\"></mtg-svg-icon>\n    </div>\n  </div>\n  <div class=\"label\"><ng-content></ng-content></div>\n</label>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => CheckboxComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Optional
            }] }, { type: CheckboxGroupComponent, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, { value: [{
            type: Input
        }], defaultClass: [{
            type: HostBinding,
            args: ['class.checkbox-container']
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], reverse: [{
            type: Input
        }] }); })();

class CheckboxModule {
}
CheckboxModule.ɵfac = function CheckboxModule_Factory(t) { return new (t || CheckboxModule)(); };
CheckboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CheckboxModule });
CheckboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        SvgIconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SvgIconModule,
                ],
                declarations: [
                    CheckboxComponent,
                    CheckboxGroupComponent,
                ],
                exports: [
                    CheckboxComponent,
                    CheckboxGroupComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CheckboxModule, { declarations: function () { return [CheckboxComponent, CheckboxGroupComponent]; }, imports: function () { return [CommonModule, SvgIconModule]; }, exports: function () { return [CheckboxComponent, CheckboxGroupComponent]; } }); })();

class ChipsComponent {
    constructor() {
        this.color = 'primary';
    }
    get defaultClass() {
        return true;
    }
    get primaryColorClass() {
        return this.color === 'primary';
    }
    get secondaryColorClass() {
        return this.color === 'secondary';
    }
    get borderedColorClass() {
        return this.color === 'bordered';
    }
}
ChipsComponent.ɵfac = function ChipsComponent_Factory(t) { return new (t || ChipsComponent)(); };
ChipsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ChipsComponent, selectors: [["mtg-chips"]], hostVars: 8, hostBindings: function ChipsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("chips", ctx.defaultClass)("chips--color-primary", ctx.primaryColorClass)("chips--color-secondary", ctx.secondaryColorClass)("chips--color-bordered", ctx.borderedColorClass);
    } }, inputs: { color: "color" }, ngContentSelectors: _c2, decls: 1, vars: 0, template: function ChipsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
ChipsComponent.propDecorators = {
    color: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.chips',] }],
    primaryColorClass: [{ type: HostBinding, args: ['class.chips--color-primary',] }],
    secondaryColorClass: [{ type: HostBinding, args: ['class.chips--color-secondary',] }],
    borderedColorClass: [{ type: HostBinding, args: ['class.chips--color-bordered',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChipsComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-chips',
                template: "<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { color: [{
            type: Input
        }], defaultClass: [{
            type: HostBinding,
            args: ['class.chips']
        }], primaryColorClass: [{
            type: HostBinding,
            args: ['class.chips--color-primary']
        }], secondaryColorClass: [{
            type: HostBinding,
            args: ['class.chips--color-secondary']
        }], borderedColorClass: [{
            type: HostBinding,
            args: ['class.chips--color-bordered']
        }] }); })();

class ChipsModule {
}
ChipsModule.ɵfac = function ChipsModule_Factory(t) { return new (t || ChipsModule)(); };
ChipsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ChipsModule });
ChipsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ChipsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    ChipsComponent
                ],
                exports: [
                    ChipsComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ChipsModule, { declarations: function () { return [ChipsComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ChipsComponent]; } }); })();

class DropdownMenuComponent {
    hide() {
        if (this.trigger) {
            this.trigger.hideMenu();
        }
    }
}
DropdownMenuComponent.ɵfac = function DropdownMenuComponent_Factory(t) { return new (t || DropdownMenuComponent)(); };
DropdownMenuComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownMenuComponent, selectors: [["mtg-dropdown-menu"]], viewQuery: function DropdownMenuComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c4, 5, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, ngContentSelectors: _c2, decls: 2, vars: 0, consts: [["content", ""], [1, "dropdown-menu"]], template: function DropdownMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DropdownMenuComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, encapsulation: 2, changeDetection: 0 });
DropdownMenuComponent.propDecorators = {
    templateRef: [{ type: ViewChild, args: ['content', { read: TemplateRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownMenuComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-dropdown-menu',
                template: "<ng-template #content>\n  <div class=\"dropdown-menu\"><ng-content></ng-content></div>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, { templateRef: [{
            type: ViewChild,
            args: ['content', { read: TemplateRef }]
        }] }); })();

class DropdownItemComponent {
    constructor(dropdownComponent, dropdownMenuComponent, elementRef, cdr) {
        this.dropdownComponent = dropdownComponent;
        this.dropdownMenuComponent = dropdownMenuComponent;
        this.elementRef = elementRef;
        this.cdr = cdr;
        this.defaultClass = true;
    }
    ngOnInit() {
        if (this.dropdownComponent) {
            this.dropdownComponent.value$.subscribe(value => {
                this.dropdownValue = value;
                this.cdr.markForCheck();
            });
            this.dropdownComponent.search$.subscribe((search) => {
                this.hidden = search && this.viewValue.toLowerCase().indexOf(search.toLowerCase()) < 0;
                this.cdr.markForCheck();
            });
            this.dropdownComponent.updateView();
        }
    }
    onClick() {
        if (this.dropdownComponent) {
            this.dropdownComponent.onItemClick(this);
        }
        else if (this.dropdownMenuComponent) {
            this.dropdownMenuComponent.hide();
        }
    }
    get viewValue() {
        return (this.elementRef.nativeElement.textContent || '').trim();
    }
    get activeClass() {
        return this.active;
    }
    get active() {
        if (!this.dropdownComponent) {
            return false;
        }
        if (this.dropdownComponent.multi) {
            return this.dropdownComponent.value.indexOf(this.value) > -1;
        }
        else {
            return this.dropdownComponent.value === this.value;
        }
    }
}
DropdownItemComponent.ɵfac = function DropdownItemComponent_Factory(t) { return new (t || DropdownItemComponent)(ɵngcc0.ɵɵdirectiveInject(DropdownComponent, 8), ɵngcc0.ɵɵdirectiveInject(DropdownMenuComponent, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DropdownItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownItemComponent, selectors: [["mtg-dropdown-item"]], hostVars: 6, hostBindings: function DropdownItemComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DropdownItemComponent_click_HostBindingHandler() { return ctx.onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dropdown-item", ctx.defaultClass)("hidden", ctx.hidden)("active", ctx.activeClass);
    } }, inputs: { value: "value" }, ngContentSelectors: _c2, decls: 2, vars: 1, consts: [["class", "check-icon", "icon", "icons-done", 4, "ngIf"], ["icon", "icons-done", 1, "check-icon"]], template: function DropdownItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵtemplate(1, DropdownItemComponent_mtg_svg_icon_1_Template, 1, 0, "mtg-svg-icon", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.active);
    } }, dependencies: [ɵngcc1.NgIf, SvgIconComponent], encapsulation: 2, changeDetection: 0 });
DropdownItemComponent.ctorParameters = () => [
    { type: DropdownComponent, decorators: [{ type: Optional }] },
    { type: DropdownMenuComponent, decorators: [{ type: Optional }] },
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
DropdownItemComponent.propDecorators = {
    value: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.dropdown-item',] }],
    hidden: [{ type: HostBinding, args: ['class.hidden',] }],
    onClick: [{ type: HostListener, args: ['click',] }],
    activeClass: [{ type: HostBinding, args: ['class.active',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownItemComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-dropdown-item',
                template: "<ng-content></ng-content>\n<mtg-svg-icon class=\"check-icon\" icon=\"icons-done\" *ngIf=\"active\"></mtg-svg-icon>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: DropdownComponent, decorators: [{
                type: Optional
            }] }, { type: DropdownMenuComponent, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.dropdown-item']
        }], hidden: [{
            type: HostBinding,
            args: ['class.hidden']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], activeClass: [{
            type: HostBinding,
            args: ['class.active']
        }], value: [{
            type: Input
        }] }); })();

class DropdownGroupComponent {
    constructor() {
        this.defaultClass = true;
    }
}
DropdownGroupComponent.ɵfac = function DropdownGroupComponent_Factory(t) { return new (t || DropdownGroupComponent)(); };
DropdownGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownGroupComponent, selectors: [["mtg-dropdown-group"]], contentQueries: function DropdownGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DropdownItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, hostVars: 2, hostBindings: function DropdownGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dropdown-group", ctx.defaultClass);
    } }, inputs: { title: "title" }, ngContentSelectors: _c2, decls: 3, vars: 1, consts: [[1, "title"]], template: function DropdownGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
    } }, encapsulation: 2, changeDetection: 0 });
DropdownGroupComponent.propDecorators = {
    title: [{ type: Input }],
    items: [{ type: ContentChildren, args: [DropdownItemComponent,] }],
    defaultClass: [{ type: HostBinding, args: ['class.dropdown-group',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownGroupComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-dropdown-group',
                template: "<div class=\"title\">{{ title }}</div>\n<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.dropdown-group']
        }], title: [{
            type: Input
        }], items: [{
            type: ContentChildren,
            args: [DropdownItemComponent]
        }] }); })();

const LOCALIZATION_DATA = new InjectionToken('localizationData');
const FORM_ERROR_LOCALIZATION = new InjectionToken('formErrorLocalization');
const FORM_ERROR_LIST = new InjectionToken('ErrorList');
const LOCALIZATION_DATA_LIST = new InjectionToken('LocalizationDataList');
const CURRENT_LANG = new InjectionToken('CURRENT_LANG');

var Locales;
(function (Locales) {
    Locales["ru"] = "ru-RU";
    Locales["en"] = "en-US";
})(Locales || (Locales = {}));

const localStorageKey = 'lang';
const localeSubject = new BehaviorSubject(null);
class LocalizationService {
    constructor(injector, platformId) {
        this.injector = injector;
        this.platformId = platformId;
        this.localeSubject = localeSubject;
        this.localizationData = {};
        this.formErrorLocalization = {};
    }
    get locale$() {
        return this.localeSubject.asObservable().pipe(map(lang => {
            if (!lang) {
                this.initializeLang();
            }
            return this.localeSubject.value;
        }));
    }
    localize(key) {
        const localeId = this.getLocale();
        if (!this.localizationData[localeId]) {
            this.localizationData[localeId] = (this.injector.get(LOCALIZATION_DATA_LIST) || {})[localeId];
        }
        return this.localizationData[localeId][key];
    }
    formErrorLocalize(key) {
        const localeId = this.getLocale();
        if (!this.formErrorLocalization[localeId]) {
            this.formErrorLocalization[localeId] = (this.injector.get(FORM_ERROR_LIST) || {})[localeId];
        }
        return this.formErrorLocalization[localeId][key];
    }
    setLocale(localeId) {
        if (this.getLocale() !== localeId) {
            this.localeSubject.next(localeId);
        }
    }
    getLocale() {
        if (!this.localeSubject.value) {
            this.initializeLang();
        }
        return this.localeSubject.value;
    }
    initializeLang() {
        this.localeSubject.next(Locales.ru);
    }
}
LocalizationService.ɵfac = function LocalizationService_Factory(t) { return new (t || LocalizationService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(PLATFORM_ID)); };
LocalizationService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LocalizationService, factory: LocalizationService.ɵfac });
LocalizationService.ctorParameters = () => [
    { type: Injector },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizationService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
function getLang(lang) {
    if (!lang) {
        return null;
    }
    // @ts-ignore
    return Locales[Object.keys(Locales)[Object.values(Locales).indexOf(lang)]];
}

var dropdownLocalization = {
    [Locales.ru]: {
        search: 'Поиск',
        selected: 'Выбрано',
    },
    [Locales.en]: {
        search: 'Search',
        selected: 'Selected',
    }
};

class DropdownComponent {
    constructor(parentFormGroup, localizationService, cdr) {
        this.parentFormGroup = parentFormGroup;
        this.localizationService = localizationService;
        this.cdr = cdr;
        this.variant = 'outline';
        this.errorVisible = true;
        this.resetVisible = true;
        this.size = 'md';
        this.value$ = new Subject();
        this.search$ = new BehaviorSubject(null);
        this.localization = dropdownLocalization;
    }
    get class() {
        const classList = ['dropdown'];
        const control = this.control || this.formControl;
        if (control && control.touched && !control.valid) {
            classList.push('dropdown--error');
        }
        if (this.valueText) {
            classList.push('dropdown--filled');
        }
        if (!this.label) {
            classList.push('dropdown--without-label');
        }
        if (this.dropdownTrigger && this.dropdownTrigger.isVisible) {
            classList.push('dropdown--opened');
        }
        if (this.size === 'sm') {
            classList.push('dropdown--size-sm');
        }
        else {
            classList.push('dropdown--size-md');
        }
        if (this.withSearch) {
            classList.push('dropdown--with-search');
        }
        if (this.disabled) {
            classList.push('dropdown--disabled');
        }
        return classList.join(' ');
    }
    ngOnInit() {
        if (this.parentFormGroup) {
            this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
        }
    }
    ngOnDestroy() {
        this.value$.complete();
    }
    ngAfterViewInit() {
        this.getValueText();
    }
    updateView() {
        this.cdr.markForCheck();
    }
    searchValue(value) {
        this.search = value;
        this.search$.next(value);
    }
    writeValue(value) {
        this.searchValue('');
        this.value = value;
        this.value$.next(value);
        this.getValueText();
    }
    getValueText() {
        if (!this.items || !this.groups) {
            return;
        }
        let value;
        this.items.forEach(item => {
            if (item.value === this.value) {
                this.valueText = item.viewValue;
                this.value = item.value;
                value = item.value;
            }
        });
        this.groups.forEach(group => {
            group.items.forEach(item => {
                if (item.value === this.value) {
                    this.valueText = item.viewValue;
                    this.value = item.value;
                    value = item.value;
                }
            });
        });
        setTimeout(() => {
            if (value === undefined) {
                this.value = this.multi ? [] : undefined;
                this.valueText = '';
            }
            this.cdr.markForCheck();
        });
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    changeValue(value) {
        this.searchValue('');
        this.value = value;
        this.value$.next(value);
        this.search$.next('');
        if (this.onTouch) {
            this.onTouch();
        }
        if (this.onChange) {
            this.onChange(value);
        }
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.cdr.markForCheck();
    }
    onItemClick(item) {
        let newValue = '';
        if (this.multi) {
            const currentValue = this.value;
            if (currentValue.indexOf(item.value) > -1) {
                currentValue.splice(this.value.indexOf(item.value), 1);
            }
            else {
                currentValue.push(item.value);
            }
            newValue = currentValue;
            this.valueText = newValue.length > 0 ? item.viewValue : '';
        }
        else {
            newValue = item.value;
            this.valueText = item.viewValue;
            this.dropdownTrigger.hideMenu();
        }
        this.changeValue(newValue);
        this.cdr.markForCheck();
    }
    getErrors() {
        const control = (this.control || this.formControl);
        let errors = {};
        if (control && control.touched && control.errors) {
            errors = control.errors;
        }
        return Object.keys(errors)
            .filter(k => errors[k])
            .reduce((acc, value) => {
            let error = this.localizationService.formErrorLocalize(value);
            if (!error) {
                return acc;
            }
            if (typeof errors[value] === 'object') {
                for (const errorKey of Object.keys(errors[value])) {
                    error = error.replace(`{${errorKey}}`, errors[value][errorKey]);
                }
            }
            acc.push(error);
            return acc;
        }, []);
    }
    reset() {
        this.changeValue(this.multi ? [] : undefined);
        this.valueText = null;
        this.cdr.markForCheck();
    }
}
DropdownComponent.ɵfac = function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 8), ɵngcc0.ɵɵdirectiveInject(LocalizationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["mtg-dropdown"]], contentQueries: function DropdownComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DropdownGroupComponent, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, DropdownItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.groups = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.items = _t);
    } }, viewQuery: function DropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DropdownTriggerDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropdownTrigger = _t.first);
    } }, hostVars: 2, hostBindings: function DropdownComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { variant: "variant", errorVisible: "errorVisible", resetVisible: "resetVisible", size: "size", disabled: "disabled", label: "label", formControl: "formControl", formControlName: "formControlName", fluid: "fluid", withSearch: "withSearch", multi: "multi" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DropdownComponent),
                multi: true
            }
        ])], ngContentSelectors: _c2, decls: 6, vars: 3, consts: [["class", "handle", 3, "mtgDropdownTriggerFor", "mtgDropdownDisabled", 4, "ngIf"], [3, "color", "variant", "mtgDropdownTriggerFor", "fluid", 4, "ngIf"], ["class", "error-text", 4, "ngIf"], ["dropdownMenu", ""], [1, "handle", 3, "mtgDropdownTriggerFor", "mtgDropdownDisabled"], [1, "value"], [1, "value-text"], ["class", "value-text", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [1, "active"], ["class", "search", 4, "ngIf"], [1, "outline"], [1, "start"], [1, "center"], [1, "label"], [1, "end"], [1, "selector"], ["icon", "icons-selector-down"], [1, "search"], [3, "value", "placeholder", "input"], [3, "color", "variant", "mtgDropdownTriggerFor", "fluid"], ["icon", "icons-close", "mtgStopPropagation", "", "class", "reset", 3, "click", 4, "ngIf"], [4, "ngIf"], ["icon", "icons-close", "mtgStopPropagation", "", 1, "reset", 3, "click"], [1, "error-text"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DropdownComponent_div_0_Template, 17, 8, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DropdownComponent_mtg_button_1_Template, 4, 7, "mtg-button", 1);
        ɵngcc0.ɵɵtemplate(2, DropdownComponent_div_2_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "mtg-dropdown-menu", null, 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.variant === "outline");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.variant === "button" || ctx.variant === "link");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorVisible);
    } }, dependencies: function () { return [ɵngcc1.NgForOf, ɵngcc1.NgIf, SvgIconComponent, ButtonComponent, StopPropagationDirective, DropdownMenuComponent, DropdownTriggerDirective, TranslatePipe]; }, encapsulation: 2, changeDetection: 0 });
DropdownComponent.ctorParameters = () => [
    { type: FormGroupDirective, decorators: [{ type: Optional }] },
    { type: LocalizationService },
    { type: ChangeDetectorRef }
];
DropdownComponent.propDecorators = {
    label: [{ type: Input }],
    formControl: [{ type: Input }],
    formControlName: [{ type: Input }],
    variant: [{ type: Input }],
    errorVisible: [{ type: Input }],
    resetVisible: [{ type: Input }],
    size: [{ type: Input }],
    fluid: [{ type: Input }],
    withSearch: [{ type: Input }],
    disabled: [{ type: Input }],
    multi: [{ type: Input }],
    groups: [{ type: ContentChildren, args: [DropdownGroupComponent,] }],
    items: [{ type: ContentChildren, args: [DropdownItemComponent,] }],
    dropdownTrigger: [{ type: ViewChild, args: [DropdownTriggerDirective,] }],
    class: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-dropdown',
                template: "<div\n  *ngIf=\"variant === 'outline'\"\n  class=\"handle\"\n  [mtgDropdownTriggerFor]=\"dropdownMenu\"\n  [mtgDropdownDisabled]=\"disabled\"\n>\n  <div class=\"value\">\n    <div class=\"value-text\">{{ label }}</div>\n    <div class=\"value-text\" *ngFor=\"let item of items\">{{ item.viewValue }}</div>\n    <ng-container *ngFor=\"let group of groups\">\n      <div class=\"value-text\" *ngFor=\"let item of group.items\">{{ item.viewValue }}</div>\n    </ng-container>\n    <div class=\"active\">{{ valueText }}</div>\n  </div>\n  <div class=\"search\" *ngIf=\"withSearch\">\n    <input\n      [value]=\"search\"\n      (input)=\"searchValue($event.target.value)\"\n      [placeholder]=\"localization | mtgTranslate: 'search'\"\n    />\n  </div>\n\n  <div class=\"outline\">\n    <div class=\"start\"></div>\n    <div class=\"center\">\n      <div class=\"label\">{{ label }}</div>\n    </div>\n    <div class=\"end\"></div>\n  </div>\n\n  <div class=\"selector\">\n    <mtg-svg-icon icon=\"icons-selector-down\"></mtg-svg-icon>\n  </div>\n</div>\n\n<mtg-button\n  *ngIf=\"variant === 'button' || variant === 'link'\"\n  [color]=\"!valueText ? 'secondary' : 'primary'\"\n  [variant]=\"variant\"\n  [mtgDropdownTriggerFor]=\"dropdownMenu\"\n  [fluid]=\"fluid\"\n>\n  <mtg-svg-icon *ngIf=\"valueText && resetVisible\" icon=\"icons-close\" mtgStopPropagation class=\"reset\" (click)=\"reset()\"></mtg-svg-icon>\n  <ng-container *ngIf=\"multi\">\n    <ng-container *ngIf=\"value.length > 0\">\n      {{ localization | mtgTranslate: 'selected' }}: {{ value.length }}\n    </ng-container>\n    <ng-container *ngIf=\"value.length <= 0\">\n      {{ label }}\n    </ng-container>\n  </ng-container>\n  <ng-container *ngIf=\"!multi\">\n    {{ valueText || label }}\n  </ng-container>\n</mtg-button>\n\n<div class=\"error-text\" *ngIf=\"errorVisible\">\n  <ng-container *ngIf=\"getErrors().length\">\n    {{ getErrors().join(', ') }}\n  </ng-container>\n</div>\n\n<mtg-dropdown-menu #dropdownMenu>\n  <ng-content></ng-content>\n</mtg-dropdown-menu>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DropdownComponent),
                        multi: true
                    }
                ],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Optional
            }] }, { type: LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { variant: [{
            type: Input
        }], errorVisible: [{
            type: Input
        }], resetVisible: [{
            type: Input
        }], size: [{
            type: Input
        }], class: [{
            type: HostBinding,
            args: ['class']
        }], disabled: [{
            type: Input
        }], label: [{
            type: Input
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], fluid: [{
            type: Input
        }], withSearch: [{
            type: Input
        }], multi: [{
            type: Input
        }], groups: [{
            type: ContentChildren,
            args: [DropdownGroupComponent]
        }], items: [{
            type: ContentChildren,
            args: [DropdownItemComponent]
        }], dropdownTrigger: [{
            type: ViewChild,
            args: [DropdownTriggerDirective]
        }] }); })();

class PaginationScrollDirective {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.subscriptions = [];
        this.change = new EventEmitter();
        // tslint:disable-next-line:no-input-rename
        this.scrollDirection = 'vertical';
    }
    onScroll() {
        if (this.scrollDirection === 'horizontal') {
            this.checkHorizontalScroll();
        }
    }
    ngOnInit() {
        this.subscriptions.push(this.renderer.listen('window', 'scroll', $event => {
            if (this.scrollDirection === 'vertical') {
                this.checkVerticalScroll();
            }
        }));
    }
    ngOnDestroy() {
        for (const unsubscribe of this.subscriptions) {
            unsubscribe();
        }
    }
    checkVerticalScroll() {
        if (this.elementRef.nativeElement.offsetParent === null) {
            return;
        }
        const position = this.elementRef.nativeElement.getBoundingClientRect();
        if (window.innerHeight >= position.bottom) {
            this.change.emit();
        }
    }
    checkHorizontalScroll() {
        if (this.elementRef.nativeElement.offsetParent === null) {
            return;
        }
        const position = this.elementRef.nativeElement.getBoundingClientRect();
        if (this.elementRef.nativeElement.scrollWidth <= (this.elementRef.nativeElement.scrollLeft + position.width)) {
            this.change.emit();
        }
    }
}
PaginationScrollDirective.ɵfac = function PaginationScrollDirective_Factory(t) { return new (t || PaginationScrollDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
PaginationScrollDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PaginationScrollDirective, selectors: [["", "mtgPaginationScroll", ""]], hostBindings: function PaginationScrollDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function PaginationScrollDirective_scroll_HostBindingHandler() { return ctx.onScroll(); });
    } }, inputs: { scrollDirection: ["mtgPaginationScrollDirection", "scrollDirection"] }, outputs: { change: "mtgPaginationScroll" } });
PaginationScrollDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
PaginationScrollDirective.propDecorators = {
    change: [{ type: Output, args: ['mtgPaginationScroll',] }],
    scrollDirection: [{ type: Input, args: ['mtgPaginationScrollDirection',] }],
    onScroll: [{ type: HostListener, args: ['scroll',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaginationScrollDirective, [{
        type: Directive,
        args: [{
                selector: '[mtgPaginationScroll]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { change: [{
            type: Output,
            args: ['mtgPaginationScroll']
        }], scrollDirection: [{
            type: Input,
            args: ['mtgPaginationScrollDirection']
        }], onScroll: [{
            type: HostListener,
            args: ['scroll']
        }] }); })();

class StickyDirective {
    constructor(platformId, elementRef, renderer) {
        this.platformId = platformId;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.stickTo = 'top';
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    ngAfterViewInit() {
        if (!this.isBrowser) {
            return;
        }
        setTimeout(() => {
            const node = this.getScrollParent(this.elementRef.nativeElement);
            this.parent = node;
            const func = () => {
                this.check();
            };
            if (node) {
                node.addEventListener('scroll', func);
                this.unsubscribe = () => {
                    node.removeEventListener('scroll', func);
                };
            }
            else {
                window.addEventListener('scroll', func);
                this.unsubscribe = () => {
                    window.removeEventListener('scroll', func);
                };
            }
            func();
        });
        this.renderer.listen('window', 'resize', () => {
            this.check();
        });
    }
    ngOnDestroy() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }
    check() {
        if (!this.isBrowser) {
            return;
        }
        if (this.stickTo === 'left') {
            const position = this.elementRef.nativeElement.parentNode.getBoundingClientRect();
            let parentPositionLeft;
            if (this.parent) {
                parentPositionLeft = this.parent.getBoundingClientRect().left;
            }
            else {
                parentPositionLeft = 0;
            }
            const left = +this.left + (parentPositionLeft - position.left);
            if (left > 0) {
                this.elementRef.nativeElement.style.position = 'relative';
                this.elementRef.nativeElement.style.left = `${left}px`;
                this.elementRef.nativeElement.classList.add('stick');
            }
            else {
                this.elementRef.nativeElement.style.position = null;
                this.elementRef.nativeElement.style.left = null;
                this.elementRef.nativeElement.classList.remove('stick');
            }
        }
        else {
            const position = this.elementRef.nativeElement.parentNode.getBoundingClientRect();
            let parentPositionTop;
            if (this.parent) {
                parentPositionTop = this.parent.getBoundingClientRect().top;
            }
            else {
                parentPositionTop = 0;
            }
            const top = +this.top + (parentPositionTop - position.top);
            if (top > 0) {
                this.elementRef.nativeElement.style.position = 'relative';
                this.elementRef.nativeElement.style.top = `${top}px`;
                this.elementRef.nativeElement.classList.add('stick');
            }
            else {
                this.elementRef.nativeElement.style.position = null;
                this.elementRef.nativeElement.style.top = null;
                this.elementRef.nativeElement.classList.remove('stick');
            }
        }
    }
    getScrollParent(node) {
        if (node == null) {
            return null;
        }
        if (this.stickTo === 'left') {
            if (node.scrollWidth > node.clientWidth) {
                const overflowX = window.getComputedStyle(node).overflowX;
                const isScrollable = overflowX !== 'visible' && overflowX !== 'hidden';
                if (isScrollable) {
                    return node;
                }
            }
        }
        else {
            if (node.scrollHeight > node.clientHeight) {
                const overflowY = window.getComputedStyle(node).overflowY;
                const isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';
                if (isScrollable) {
                    return node;
                }
            }
        }
        return this.getScrollParent(node.parentNode);
    }
}
StickyDirective.ɵfac = function StickyDirective_Factory(t) { return new (t || StickyDirective)(ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
StickyDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: StickyDirective, selectors: [["", "mtgSticky", ""]], inputs: { stickTo: ["mtgSticky", "stickTo"], top: "top", left: "left" } });
StickyDirective.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ElementRef },
    { type: Renderer2 }
];
StickyDirective.propDecorators = {
    top: [{ type: Input }],
    left: [{ type: Input }],
    stickTo: [{ type: Input, args: ['mtgSticky',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyDirective, [{
        type: Directive,
        args: [{
                selector: '[mtgSticky]'
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { stickTo: [{
            type: Input,
            args: ['mtgSticky']
        }], top: [{
            type: Input
        }], left: [{
            type: Input
        }] }); })();

class StopPropagationDirective {
    onClick($event) {
        $event.stopPropagation();
    }
}
StopPropagationDirective.ɵfac = function StopPropagationDirective_Factory(t) { return new (t || StopPropagationDirective)(); };
StopPropagationDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: StopPropagationDirective, selectors: [["", "mtgStopPropagation", ""]], hostBindings: function StopPropagationDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function StopPropagationDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } } });
StopPropagationDirective.propDecorators = {
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StopPropagationDirective, [{
        type: Directive,
        args: [{
                selector: '[mtgStopPropagation]'
            }]
    }], null, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

class FilterPipe {
    transform(value, func) {
        return value.filter(item => func(item));
    }
}
FilterPipe.ɵfac = function FilterPipe_Factory(t) { return new (t || FilterPipe)(); };
FilterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "filter", type: FilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filter'
            }]
    }], null, null); })();

class LocalizationPipe {
    constructor(localizationService) {
        this.localizationService = localizationService;
    }
    transform(value, dictionary) {
        const locale = this.localizationService.getLocale();
        return dictionary[locale] && dictionary[locale][value] || value;
    }
}
LocalizationPipe.ɵfac = function LocalizationPipe_Factory(t) { return new (t || LocalizationPipe)(ɵngcc0.ɵɵdirectiveInject(LocalizationService, 16)); };
LocalizationPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "localization", type: LocalizationPipe, pure: true });
LocalizationPipe.ctorParameters = () => [
    { type: LocalizationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizationPipe, [{
        type: Pipe,
        args: [{
                name: 'localization'
            }]
    }], function () { return [{ type: LocalizationService }]; }, null); })();

const PHONE_MASK_LIST = [
    { code: '+247 ####' },
    { code: '+290 ####' },
    { code: '+290 ####' },
    { code: '+683 ####' },
    { code: '+690 ####' },
    { code: '+500 #####' },
    { code: '+676 #####' },
    { code: '+677 #####' },
    { code: '+678 #####' },
    { code: '+688 2####' },
    { code: '+49 ### ###' },
    { code: '+682 ## ###' },
    { code: '+686 ## ###' },
    { code: '+688 90####' },
    { code: '+95 ### ###' },
    { code: '+298 ### ###' },
    { code: '+376 ### ###' },
    { code: '+387 ## ####' },
    { code: '+508 ## ####' },
    { code: '+597 ### ###' },
    { code: '+672 1## ###' },
    { code: '+672 3## ###' },
    { code: '+681 ## ####' },
    { code: '+685 ## ####' },
    { code: '+687 ## ####' },
    { code: '+850 ### ###' },
    { code: '+230 ### ####' },
    { code: '+239 ## #####' },
    { code: '+245 # ######' },
    { code: '+246 ### ####' },
    { code: '+263 # ######' },
    { code: '+269 ## #####' },
    { code: '+297 ### ####' },
    { code: '+299 ## ## ##' },
    { code: '+354 ### ####' },
    { code: '+372 ### ####' },
    { code: '+387 ## #####' },
    { code: '+49 ### ## ##' },
    { code: '+501 ### ####' },
    { code: '+507 ### ####' },
    { code: '+592 ### ####' },
    { code: '+597 ### ####' },
    { code: '+599 ### ####' },
    { code: '+599 ### ####' },
    { code: '+599 ### ####' },
    { code: '+60 # ### ###' },
    { code: '+62 ## ### ##' },
    { code: '+65 #### ####' },
    { code: '+670 ### ####' },
    { code: '+673 ### ####' },
    { code: '+674 ### ####' },
    { code: '+677 ### ####' },
    { code: '+678 ## #####' },
    { code: '+679 ## #####' },
    { code: '+680 ### ####' },
    { code: '+689 ## ## ##' },
    { code: '+691 ### ####' },
    { code: '+692 ### ####' },
    { code: '+95 # ### ###' },
    { code: '+960 ### ####' },
    { code: '+220 ### ## ##' },
    { code: '+232 ## ######' },
    { code: '+234 ## ### ##' },
    { code: '+237 #### ####' },
    { code: '+238 ### ## ##' },
    { code: '+248 # ### ###' },
    { code: '+252 # ### ###' },
    { code: '+252 # ### ###' },
    { code: '+265 1 ### ###' },
    { code: '+291 # ### ###' },
    { code: '+350 ### #####' },
    { code: '+356 #### ####' },
    { code: '+372 #### ####' },
    { code: '+373 #### ####' },
    { code: '+47 ### ## ###' },
    { code: '+49 ### ## ###' },
    { code: '+504 #### ####' },
    { code: '+505 #### ####' },
    { code: '+506 #### ####' },
    { code: '+52 ## ## ####' },
    { code: '+53 # ### ####' },
    { code: '+599 9### ####' },
    { code: '+60 ## ### ###' },
    { code: '+62 ## ### ###' },
    { code: '+64 ## ### ###' },
    { code: '+66 ## ### ###' },
    { code: '+670 77# #####' },
    { code: '+670 78# #####' },
    { code: '+850 #### ####' },
    { code: '+852 #### ####' },
    { code: '+853 #### ####' },
    { code: '+886 #### ####' },
    { code: '+95 ## ### ###' },
    { code: '+961 # ### ###' },
    { code: '+965 #### ####' },
    { code: '+967 # ### ###' },
    { code: '+973 #### ####' },
    { code: '+974 #### ####' },
    { code: '+975 # ### ###' },
    { code: '+1 ### ### ####' },
    { code: '+1 242 ### ####' },
    { code: '+1 246 ### ####' },
    { code: '+1 264 ### ####' },
    { code: '+1 268 ### ####' },
    { code: '+1 284 ### ####' },
    { code: '+1 340 ### ####' },
    { code: '+1 345 ### ####' },
    { code: '+1 441 ### ####' },
    { code: '+1 473 ### ####' },
    { code: '+1 649 ### ####' },
    { code: '+1 664 ### ####' },
    { code: '+1 670 ### ####' },
    { code: '+1 671 ### ####' },
    { code: '+1 684 ### ####' },
    { code: '+1 721 ### ####' },
    { code: '+1 758 ### ####' },
    { code: '+1 767 ### ####' },
    { code: '+1 784 ### ####' },
    { code: '+1 809 ### ####' },
    { code: '+1 829 ### ####' },
    { code: '+1 849 ### ####' },
    { code: '+1 868 ### ####' },
    { code: '+1 869 ### ####' },
    { code: '+1 876 ### ####' },
    { code: '+216 ## ### ###' },
    { code: '+218 ## ### ###' },
    { code: '+222 ## ## ####' },
    { code: '+223 ## ## ####' },
    { code: '+224 ## ### ###' },
    { code: '+225 ## ### ###' },
    { code: '+226 ## ## ####' },
    { code: '+227 ## ## ####' },
    { code: '+228 ## ### ###' },
    { code: '+229 ## ## ####' },
    { code: '+231 ## ### ###' },
    { code: '+234 ## ### ###' },
    { code: '+236 ## ## ####' },
    { code: '+241 # ## ## ##' },
    { code: '+252 ## ### ###' },
    { code: '+254 ### ######' },
    { code: '+257 ## ## ####' },
    { code: '+258 ## ### ###' },
    { code: '+262 ##### ####' },
    { code: '+262 ##### ####' },
    { code: '+266 # ### ####' },
    { code: '+267 ## ### ###' },
    { code: '+268 ## ## ####' },
    { code: '+27 ## ### ####' },
    { code: '+31 ## ### ####' },
    { code: '+32 ### ### ###' },
    { code: '+33 ### ### ###' },
    { code: '+34 ### ### ###' },
    { code: '+357 ## ### ###' },
    { code: '+36 ### ### ###' },
    { code: '+370 ### ## ###' },
    { code: '+371 ## ### ###' },
    { code: '+374 ## ### ###' },
    { code: '+377 ## ### ###' },
    { code: '+382 ## ### ###' },
    { code: '+385 ## ### ###' },
    { code: '+386 ## ### ###' },
    { code: '+389 ## ### ###' },
    { code: '+39 6 698 #####' },
    { code: '+40 ## ### ####' },
    { code: '+41 ## ### ####' },
    { code: '+45 ## ## ## ##' },
    { code: '+46 ## ### ####' },
    { code: '+48 ### ### ###' },
    { code: '+49 ### ## ####' },
    { code: '+502 # ### ####' },
    { code: '+503 ## ## ####' },
    { code: '+509 ## ## ####' },
    { code: '+51 ### ### ###' },
    { code: '+56 # #### ####' },
    { code: '+591 # ### ####' },
    { code: '+593 # ### ####' },
    { code: '+594 ##### ####' },
    { code: '+60 ## ### ####' },
    { code: '+60 ### ### ###' },
    { code: '+61 # #### ####' },
    { code: '+62 ## ### ####' },
    { code: '+62 8## ### ###' },
    { code: '+64 ### ### ###' },
    { code: '+66 ## ### ####' },
    { code: '+675 ### ## ###' },
    { code: '+81 ### ### ###' },
    { code: '+82 ## ### ####' },
    { code: '+84 ## #### ###' },
    { code: '+850 ## ### ###' },
    { code: '+855 ## ### ###' },
    { code: '+856 ## ### ###' },
    { code: '+880 ## ### ###' },
    { code: '+93 ## ### ####' },
    { code: '+94 ## ### ####' },
    { code: '+961 ## ### ###' },
    { code: '+966 # ### ####' },
    { code: '+967 ## ### ###' },
    { code: '+968 ## ### ###' },
    { code: '+971 # ### ####' },
    { code: '+972 # ### ####' },
    { code: '+975 17 ### ###' },
    { code: '+976 ## ## ####' },
    { code: '+977 ## ### ###' },
    { code: '+993 # ### ####' },
    { code: '+20 ### ### ####' },
    { code: '+211 ## ### ####' },
    { code: '+212 ## #### ###' },
    { code: '+213 ## ### ####' },
    { code: '+218 21 ### ####' },
    { code: '+221 ## ### ####' },
    { code: '+233 ### ### ###' },
    { code: '+235 ## ## ## ##' },
    { code: '+240 ## ### ####' },
    { code: '+242 ## ### ####' },
    { code: '+243 ### ### ###' },
    { code: '+244 ### ### ###' },
    { code: '+249 ## ### ####' },
    { code: '+250 ### ### ###' },
    { code: '+251 ## ### ####' },
    { code: '+253 ## ## ## ##' },
    { code: '+255 ## ### ####' },
    { code: '+256 ### ### ###' },
    { code: '+260 ## ### ####' },
    { code: '+261 ## ## #####' },
    { code: '+264 ## ### ####' },
    { code: '+265 # #### ####' },
    { code: '+30 ### ### ####' },
    { code: '+351 ## ### ####' },
    { code: '+352 ### ### ###' },
    { code: '+353 ### ### ###' },
    { code: '+355 ### ### ###' },
    { code: '+359 ### ### ###' },
    { code: '+377 ### ### ###' },
    { code: '+378 #### ######' },
    { code: '+381 ## ### ####' },
    { code: '+39 ### #### ###' },
    { code: '+420 ### ### ###' },
    { code: '+421 ### ### ###' },
    { code: '+43 ### ### ####' },
    { code: '+44 ## #### ####' },
    { code: '+49 ### ### ####' },
    { code: '+52 ### ### ####' },
    { code: '+54 ### ### ####' },
    { code: '+55 ## #### ####' },
    { code: '+55 ## 7### ####' },
    { code: '+57 ### ### ####' },
    { code: '+58 ### ### ####' },
    { code: '+590 ### ### ###' },
    { code: '+593 ## ### ####' },
    { code: '+595 ### ### ###' },
    { code: '+598 # ### ## ##' },
    { code: '+62 8## ### ####' },
    { code: '+63 ### ### ####' },
    { code: '+64 ### ### ####' },
    { code: '+7 ### ### ## ##' },
    { code: '+7 6## ### ## ##' },
    { code: '+7 7## ### ## ##' },
    { code: '+81 ## #### ####' },
    { code: '+84 ### #### ###' },
    { code: '+86 ### #### ###' },
    { code: '+886 # #### ####' },
    { code: '+90 ### ### ####' },
    { code: '+91 #### ### ###' },
    { code: '+92 ### ### ####' },
    { code: '+962 # #### ####' },
    { code: '+963 ## #### ###' },
    { code: '+966 5 #### ####' },
    { code: '+967 ### ### ###' },
    { code: '+970 ## ### ####' },
    { code: '+971 5# ### ####' },
    { code: '+972 5# ### ####' },
    { code: '+98 ### ### ####' },
    { code: '+992 ## ### ####' },
    { code: '+995 ### ### ###' },
    { code: '+996 ### ### ###' },
    { code: '+998 ## ### ####' },
    { code: '+234 ### ### ####' },
    { code: '+234 ### ### ####' },
    { code: '+375 ## ### ## ##' },
    { code: '+380 ## ### ## ##' },
    { code: '+423 ### ### ####' },
    { code: '+49 #### ### ####' },
    { code: '+55 ## 9#### ####' },
    { code: '+596 ### ## ## ##' },
    { code: '+850 ### #### ###' },
    { code: '+850 191 ### ####' },
    { code: '+856 20## ### ###' },
    { code: '+86 ### #### ####' },
    { code: '+964 ### ### ####' },
    { code: '+994 ## ### ## ##' },
    { code: '+358 ### ### ## ##' },
    { code: '+62 8## ### ## ###' },
    { code: '+86 ## ##### #####' },
    { code: '+850 #### #############' }
];
const PHONE_MASK = {
    mask: ['+', /\d/, '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
};
function dateMask(config) {
    return {
        mask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/],
        pipe: createAutoCorrectedDatePipe('dd.mm.yyyy', config),
        keepCharPositions: true
    };
}
const EMAIL_MASK = emailMask;
const TIME_MASK = {
    mask: [/\d/, /\d/, ':', /\d/, /\d/]
};

class PhonePipe {
    transform(value, ...args) {
        let matrix = '+###############';
        PHONE_MASK_LIST.forEach(item => {
            const code = item.code.replace(/[\s+]/g, '');
            const phone = value.replace(/[\s#-)(]/g, '');
            if (code.length === phone.length) {
                let isSuccess = false;
                const startCode = code.replace(/[\s#]/g, '');
                const checkVal = phone.substr(0, startCode.length);
                if (startCode === checkVal) {
                    isSuccess = true;
                }
                if (isSuccess) {
                    matrix = item.code;
                }
            }
        });
        let i = 0;
        const val = value.replace(/\D/g, '');
        // tslint:disable-next-line:only-arrow-functions
        value = matrix.replace(/(?!\+)./g, function (a) {
            return /[#\d]/.test(a) && i < val.length ? val.charAt(i++) : i >= val.length ? '' : a;
        });
        return value;
        /*value = value.replace(/\D+/gi, '');
        if (value.length === 10) {
          value = `7${value}`;
        }
        return `+${value.substr(0, 1)} (${value.substr(1, 3)}) ${value.substr(4, 3)}-${value.substr(7, 2)}-${value.substr(9, 2)}`;*/
    }
}
PhonePipe.ɵfac = function PhonePipe_Factory(t) { return new (t || PhonePipe)(); };
PhonePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "phone", type: PhonePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PhonePipe, [{
        type: Pipe,
        args: [{
                name: 'phone'
            }]
    }], null, null); })();

class PluralizePipe {
    transform(value, variants) {
        if (isNaN(+value)) {
            return value;
        }
        let numberValue = +value % 100;
        if (numberValue > 9 && numberValue < 15) {
            return `${value} ${variants[2]}`;
        }
        numberValue = numberValue % 10;
        if (numberValue === 1) {
            return `${value} ${variants[0]}`;
        }
        else if (numberValue > 0 && numberValue < 5) {
            return `${value} ${variants[1]}`;
        }
        else {
            return `${value} ${variants[2]}`;
        }
    }
}
PluralizePipe.ɵfac = function PluralizePipe_Factory(t) { return new (t || PluralizePipe)(); };
PluralizePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "pluralize", type: PluralizePipe, pure: false });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PluralizePipe, [{
        type: Pipe,
        args: [{
                name: 'pluralize',
                pure: false
            }]
    }], null, null); })();

class SafePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, type) {
        switch (type) {
            case 'html': return this.sanitizer.bypassSecurityTrustHtml(value);
            case 'style': return this.sanitizer.bypassSecurityTrustStyle(value);
            case 'script': return this.sanitizer.bypassSecurityTrustScript(value);
            case 'url': return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl': return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default: throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
SafePipe.ɵfac = function SafePipe_Factory(t) { return new (t || SafePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer, 16)); };
SafePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "safe", type: SafePipe, pure: true });
SafePipe.ctorParameters = () => [
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SafePipe, [{
        type: Pipe,
        args: [{ name: 'safe' }]
    }], function () { return [{ type: ɵngcc4.DomSanitizer }]; }, null); })();

const localization = {
    [Locales.ru]: {
        today: 'Сегодня',
        yesterday: 'Вчера',
        tomorrow: 'Завтра',
    },
    [Locales.en]: {
        today: 'Today',
        yesterday: 'Yesterday',
        tomorrow: 'Tomorrow',
    }
};
class DatePipe {
    constructor(localizationService) {
        this.localizationService = localizationService;
    }
    transform(value) {
        const today = new Date();
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);
        const date = new Date(value.getTime());
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
        const diff = today.getTime() - date.getTime();
        const days = Math.floor(Math.abs(diff / 86400000));
        if (days === 0) {
            return localization[this.localizationService.getLocale()].today;
        }
        else if (days === 1) {
            return diff < 0
                ? localization[this.localizationService.getLocale()].tomorrow
                : localization[this.localizationService.getLocale()].yesterday;
        }
        return formatDate(value, 'dd MMM', this.localizationService.getLocale());
    }
}
DatePipe.ɵfac = function DatePipe_Factory(t) { return new (t || DatePipe)(ɵngcc0.ɵɵdirectiveInject(LocalizationService, 16)); };
DatePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "mtgDate", type: DatePipe, pure: true });
DatePipe.ctorParameters = () => [
    { type: LocalizationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatePipe, [{
        type: Pipe,
        args: [{
                name: 'mtgDate'
            }]
    }], function () { return [{ type: LocalizationService }]; }, null); })();

class DialogRef {
    constructor(overlayRef) {
        this.overlayRef = overlayRef;
        this.closeEventEmitter = new Subject$1();
        this.beforeCloseObservables = [of(null)];
    }
    close(data) {
        this.overlayRef.dispose();
        this.closeEventEmitter.next(data);
        this.closeEventEmitter.complete();
    }
    addBeforeClose(checkObservable) {
        this.beforeCloseObservables.push(checkObservable);
    }
    beforeClose() {
        return forkJoin(this.beforeCloseObservables);
    }
    afterClosed() {
        return this.closeEventEmitter;
    }
    setInstance(instance) {
        this.instance = instance;
    }
    getOverlayRef() {
        return this.overlayRef;
    }
    setOverlayRef(overlayRef) {
        this.overlayRef = overlayRef;
    }
    getDialogContainerElement() {
        return this.instance.containerElementRef;
    }
    attachView(viewRef) {
        this.instance.attachView(viewRef);
    }
}

class DialogConfig {
    constructor(data) {
        this.closeLink = '';
        this.isBackButtonVisible = false;
        this.isCloseButtonVisible = false;
        this.ignoreBackdropClick = false;
        this.closeOnEsc = true;
        this.hasBackdrop = true;
        this.backdropClass = 'mtg-overlay-backdrop';
        this.fullScreen = false;
        for (const key of Object.keys(data)) {
            this[key] = data[key];
        }
    }
}

class DialogComponent {
    constructor(router, dialogRef, dialogConfig) {
        this.router = router;
        this.dialogRef = dialogRef;
        this.dialogConfig = dialogConfig;
    }
    ngOnInit() {
        if (this.dialogConfig.closeOnEsc) {
            this.dialogRef.getOverlayRef().keydownEvents().subscribe(event => {
                if (event.code === 'Escape') {
                    this.close();
                }
            });
        }
    }
    attachView(view) {
        this.viewContainerRef.detach();
        return this.viewContainerRef
            .insert(view);
    }
    get isCloseButtonVisible() {
        return this.dialogConfig.isCloseButtonVisible;
    }
    get isFullScreen() {
        return this.dialogConfig.fullScreen;
    }
    backdropClicked($event) {
        if (!this.dialogConfig.ignoreBackdropClick) {
            this.close();
        }
    }
    close() {
        this.dialogRef.beforeClose().subscribe(res => {
            if (!res) {
                return;
            }
            if (this.dialogConfig.closeLink) {
                this.router.navigateByUrl(this.dialogConfig.closeLink);
            }
            else {
                this.dialogRef.close();
            }
        }, error => { });
    }
}
DialogComponent.ɵfac = function DialogComponent_Factory(t) { return new (t || DialogComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router), ɵngcc0.ɵɵdirectiveInject(DialogRef), ɵngcc0.ɵɵdirectiveInject(DialogConfig)); };
DialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DialogComponent, selectors: [["mtg-dialog"]], viewQuery: function DialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, 7, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c6, 5);
        ɵngcc0.ɵɵviewQuery(_c4, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.viewContainerRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.containerElementRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentElementRef = _t.first);
    } }, decls: 9, vars: 4, consts: [[1, "dialog"], ["cdk-scrollable", "", 1, "dialog-container", 3, "ngClass"], ["container", ""], ["variant", "circle", "class", "close-btn", 3, "click", 4, "ngIf"], [1, "backdrop", 3, "click"], [1, "dialog-content"], ["content", ""], ["host", ""], ["variant", "circle", 1, "close-btn", 3, "click"], ["icon", "icons-close"]], template: function DialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1, 2);
        ɵngcc0.ɵɵtemplate(3, DialogComponent_mtg_button_3_Template, 2, 0, "mtg-button", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵlistener("click", function DialogComponent_Template_div_click_4_listener($event) { return ctx.backdropClicked($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5, 6);
        ɵngcc0.ɵɵelementContainer(7, null, 7);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c7, ctx.isFullScreen));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isCloseButtonVisible);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc6.CdkScrollable, ButtonComponent, SvgIconComponent], encapsulation: 2, changeDetection: 0 });
DialogComponent.ctorParameters = () => [
    { type: Router },
    { type: DialogRef },
    { type: DialogConfig }
];
DialogComponent.propDecorators = {
    viewContainerRef: [{ type: ViewChild, args: ['host', { read: ViewContainerRef, static: true },] }],
    containerElementRef: [{ type: ViewChild, args: ['container',] }],
    contentElementRef: [{ type: ViewChild, args: ['content',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-dialog',
                template: "<div class=\"dialog\">\n  <div class=\"dialog-container\" #container cdk-scrollable [ngClass]=\"{fullscreen: isFullScreen}\">\n    <mtg-button variant=\"circle\" class=\"close-btn\"  (click)=\"close()\" *ngIf=\"isCloseButtonVisible\">\n      <mtg-svg-icon icon=\"icons-close\"></mtg-svg-icon>\n    </mtg-button>\n    <div class=\"backdrop\" (click)=\"backdropClicked($event)\"></div>\n    <div class=\"dialog-content\" #content>\n      <ng-container #host></ng-container>\n    </div>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc5.Router }, { type: DialogRef }, { type: DialogConfig }]; }, { viewContainerRef: [{
            type: ViewChild,
            args: ['host', { read: ViewContainerRef, static: true }]
        }], containerElementRef: [{
            type: ViewChild,
            args: ['container']
        }], contentElementRef: [{
            type: ViewChild,
            args: ['content']
        }] }); })();

class DialogService {
    constructor(platformId, router, overlay, injector, componentFactoryResolver) {
        this.platformId = platformId;
        this.router = router;
        this.overlay = overlay;
        this.injector = injector;
        this.componentFactoryResolver = componentFactoryResolver;
        this.dialogs = [];
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    get isOpened() {
        return this.dialogs.length > 0;
    }
    open(componentType, config = {}, dialogRef, injector) {
        const dialogConfig = new DialogConfig(config);
        const positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();
        const overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: dialogConfig.hasBackdrop,
            backdropClass: dialogConfig.backdropClass
        });
        if (!dialogRef) {
            dialogRef = new DialogRef(overlayRef);
            this.dialogs.push(dialogRef);
        }
        else {
            dialogRef.getOverlayRef().dispose();
            dialogRef.setOverlayRef(overlayRef);
            this.dialogs.push(dialogRef);
        }
        const portalInjector = this.getInjector(dialogConfig, dialogRef, injector);
        const dialogPortal = new ComponentPortal(DialogComponent, null, portalInjector);
        const dialogComponentRef = overlayRef.attach(dialogPortal);
        const componentRef = this.componentFactoryResolver.resolveComponentFactory(componentType)
            .create(portalInjector);
        dialogComponentRef.instance.attachView(componentRef.hostView);
        dialogRef.setInstance(dialogComponentRef.instance);
        this.bodyBlock();
        overlayRef.detachments().subscribe(ref => {
            this.dialogs.splice(this.dialogs.indexOf(dialogRef), 1);
            if (this.dialogs.length === 0) {
                this.bodyUnBlock();
            }
        });
        return dialogRef;
    }
    bodyBlock() {
        if (!this.isBrowser) {
            return;
        }
        document.body.classList.add('dialog-opened');
        document.body.addEventListener('ontouchmove', this.preventDefault);
    }
    bodyUnBlock() {
        if (!this.isBrowser) {
            return;
        }
        document.body.classList.remove('dialog-opened');
        document.body.removeEventListener('ontouchmove', this.preventDefault);
    }
    preventDefault(event) {
        event.preventDefault();
        return false;
    }
    closeAll() {
        for (const dialog of this.dialogs) {
            dialog.close();
        }
    }
    getInjector(config, dialogRef, injector) {
        const tokens = new WeakMap();
        tokens.set(DialogConfig, config);
        tokens.set(DialogRef, dialogRef);
        return new PortalInjector(injector || this.injector, tokens);
    }
}
DialogService.ɵfac = function DialogService_Factory(t) { return new (t || DialogService)(ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(ɵngcc5.Router), ɵngcc0.ɵɵinject(ɵngcc2.Overlay), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver)); };
DialogService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DialogService, factory: DialogService.ɵfac });
DialogService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: Router },
    { type: Overlay },
    { type: Injector },
    { type: ComponentFactoryResolver }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc5.Router }, { type: ɵngcc2.Overlay }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ComponentFactoryResolver }]; }, null); })();

class DialogPageComponent {
    constructor(platformId, route, dialogService, injector) {
        this.platformId = platformId;
        this.route = route;
        this.dialogService = dialogService;
        this.injector = injector;
        this.destroyed$ = new Subject$1();
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.defaultClass = true;
    }
    ngOnInit() {
        if (!this.isBrowser) {
            return;
        }
        const routeParams = this.getRouteParams(this.route.snapshot);
        const data = this.route.snapshot.data;
        const config = Object.assign({}, data.config);
        delete data.config;
        config.data = Object.assign(Object.assign(Object.assign({}, data), routeParams), (config.data || {}));
        for (const key of Object.keys(routeParams)) {
            if (config.closeLink) {
                config.closeLink = config.closeLink.replace(`:${key}`, routeParams[key]);
            }
        }
        if (data.component) {
            this.dialogRef = this.dialogService.open(data.component, config, null, this.injector);
        }
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }
    getRouteParams(route) {
        if (!route.parent) {
            return {};
        }
        return Object.assign(Object.assign({}, route.params), this.getRouteParams(route.parent));
    }
}
DialogPageComponent.ɵfac = function DialogPageComponent_Factory(t) { return new (t || DialogPageComponent)(ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(DialogService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
DialogPageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DialogPageComponent, selectors: [["mtg-dialog-page"]], hostVars: 2, hostBindings: function DialogPageComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dialog-page", ctx.defaultClass);
    } }, decls: 1, vars: 1, consts: [["class", "overlay", 4, "ngIf"], [1, "overlay"]], template: function DialogPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DialogPageComponent_div_0_Template, 2, 0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isBrowser);
    } }, dependencies: [ɵngcc1.NgIf, SpinnerComponent], encapsulation: 2, changeDetection: 0 });
DialogPageComponent.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: ActivatedRoute },
    { type: DialogService },
    { type: Injector }
];
DialogPageComponent.propDecorators = {
    defaultClass: [{ type: HostBinding, args: ['class.dialog-page',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogPageComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-dialog-page',
                template: "<div class=\"overlay\" *ngIf=\"!isBrowser\">\n  <mtg-spinner></mtg-spinner>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc5.ActivatedRoute }, { type: DialogService }, { type: ɵngcc0.Injector }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.dialog-page']
        }] }); })();

var confirmDialogLocalization = {
    [Locales.ru]: {
        yes: 'Да',
        no: 'Нет',
    },
    [Locales.en]: {
        yes: 'Yes',
        no: 'No',
    }
};

class ConfirmDialogComponent {
    constructor(dialogRef, dialogConfig) {
        this.dialogRef = dialogRef;
        this.dialogConfig = dialogConfig;
        this.message = this.dialogConfig.data.message;
        this.localization = confirmDialogLocalization;
    }
    close(value) {
        this.dialogRef.close(value);
    }
}
ConfirmDialogComponent.ɵfac = function ConfirmDialogComponent_Factory(t) { return new (t || ConfirmDialogComponent)(ɵngcc0.ɵɵdirectiveInject(DialogRef), ɵngcc0.ɵɵdirectiveInject(DialogConfig)); };
ConfirmDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ConfirmDialogComponent, selectors: [["mtg-confirm-dialog"]], decls: 10, vars: 9, consts: [[1, "confirm-dialog"], [1, "title"], [1, "actions"], ["variant", "link", 3, "click"], ["variant", "link", "color", "secondary", 3, "click"]], template: function ConfirmDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2)(4, "mtg-button", 3);
        ɵngcc0.ɵɵlistener("click", function ConfirmDialogComponent_Template_mtg_button_click_4_listener() { return ctx.close(true); });
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "mtgTranslate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "mtg-button", 4);
        ɵngcc0.ɵɵlistener("click", function ConfirmDialogComponent_Template_mtg_button_click_7_listener() { return ctx.close(false); });
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "mtgTranslate");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(6, 3, ctx.localization, "yes"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(9, 6, ctx.localization, "no"), " ");
    } }, dependencies: function () { return [ButtonComponent, TranslatePipe]; }, encapsulation: 2, changeDetection: 0 });
ConfirmDialogComponent.ctorParameters = () => [
    { type: DialogRef },
    { type: DialogConfig }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfirmDialogComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-confirm-dialog',
                template: "<div class=\"confirm-dialog\">\n  <div class=\"title\">{{ message }}</div>\n  <div class=\"actions\">\n    <mtg-button variant=\"link\" (click)=\"close(true)\">\n      {{ localization | mtgTranslate: 'yes' }}\n    </mtg-button>\n    <mtg-button variant=\"link\" color=\"secondary\" (click)=\"close(false)\">\n      {{ localization | mtgTranslate: 'no' }}\n    </mtg-button>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: DialogRef }, { type: DialogConfig }]; }, null); })();

class FireEventDirective {
    constructor(metrika) {
        this.metrika = metrika;
    }
    onClick() {
        if (this.event) {
            this.metrika.fireEvent(this.event);
        }
    }
}
FireEventDirective.ɵfac = function FireEventDirective_Factory(t) { return new (t || FireEventDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc7.Metrika)); };
FireEventDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FireEventDirective, selectors: [["", "mtgFireEvent", ""]], hostBindings: function FireEventDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function FireEventDirective_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { event: ["mtgFireEvent", "event"] } });
FireEventDirective.ctorParameters = () => [
    { type: Metrika }
];
FireEventDirective.propDecorators = {
    event: [{ type: Input, args: ['mtgFireEvent',] }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FireEventDirective, [{
        type: Directive,
        args: [{
                selector: '[mtgFireEvent]'
            }]
    }], function () { return [{ type: ɵngcc7.Metrika }]; }, { onClick: [{
            type: HostListener,
            args: ['click']
        }], event: [{
            type: Input,
            args: ['mtgFireEvent']
        }] }); })();

class AgreementComponent {
    constructor(localizationService) {
        this.localizationService = localizationService;
        this.locale = this.localizationService.getLocale();
        this.locales = Locales;
    }
}
AgreementComponent.ɵfac = function AgreementComponent_Factory(t) { return new (t || AgreementComponent)(ɵngcc0.ɵɵdirectiveInject(LocalizationService)); };
AgreementComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AgreementComponent, selectors: [["mtg-agreement"]], decls: 2, vars: 2, consts: [["class", "agreement-box", 4, "ngIf"], [1, "agreement-box"]], template: function AgreementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AgreementComponent_div_0_Template, 36, 0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, AgreementComponent_div_1_Template, 2, 0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.locale === ctx.locales.ru);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.locale === ctx.locales.en);
    } }, dependencies: [ɵngcc1.NgIf], encapsulation: 2, changeDetection: 0 });
AgreementComponent.ctorParameters = () => [
    { type: LocalizationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AgreementComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-agreement',
                template: "<div\n  *ngIf=\"locale === locales.ru\"\n  class=\"agreement-box\"\n>\n  <p>\n    \u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044F \u0441\u0432\u043E\u0438 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0434\u0430\u0451\u0442 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443, \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u0432\u043E\u0438\u0445 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0424\u0417 \u2116 152-\u0424\u0417 \u00AB\u041E \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445\u00BB \u043E\u0442 27.07.2006 \u0433. \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0446\u0435\u043B\u044F\u0445:\n  </p>\n  <ul>\n    <li>\u041E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0439 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438</li>\n    <li>\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u043C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u044B\u0445 \u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0445</li>\n    <li>\u041F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0430\u0443\u0434\u0438\u0442\u0430 \u0438 \u043F\u0440\u043E\u0447\u0438\u0445 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0439 \u0441 \u0446\u0435\u043B\u044C\u044E \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u0438\u044F \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u0443\u0441\u043B\u0443\u0433.</li>\n  </ul>\n\n  <p>\u041F\u043E\u0434 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\u0434\u0440\u0430\u0437\u0443\u043C\u0435\u0432\u0430\u0435\u0442\u0441\u044F \u043B\u044E\u0431\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0430, \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0449\u0430\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043B\u0438\u0447\u043D\u043E\u0441\u0442\u044C\n    \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F/\u041F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F \u0442\u0430\u043A\u0430\u044F \u043A\u0430\u043A:</p>\n\n  <ul>\n    <li>\u0424\u0430\u043C\u0438\u043B\u0438\u044F, \u0418\u043C\u044F, \u041E\u0442\u0447\u0435\u0441\u0442\u0432\u043E;</li>\n    <li>\u0414\u0430\u0442\u0430 \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F;</li>\n    <li>\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D;</li>\n    <li>\u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B;</li>\n    <li>\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0430\u0434\u0440\u0435\u0441;</li>\n    <li>\u0411\u0438\u043E\u043C\u0435\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0435.</li>\n  </ul>\n\n  <p>\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0445\u0440\u0430\u043D\u044F\u0442\u0441\u044F \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0445 \u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F\u0445 \u0438 \u043E\u0431\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0441\n    \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0441\u0438\u0441\u0442\u0435\u043C, \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0441\u043B\u0443\u0447\u0430\u0435\u0432, \u043A\u043E\u0433\u0434\u0430 \u043D\u0435\u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\n    \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435\u043C \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u0439 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430.</p>\n\n  <p>\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u043E\u0431\u044F\u0437\u0443\u0435\u0442\u0441\u044F \u043D\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435 \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C, \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0441\u043B\u0443\u0447\u0430\u0435\u0432:</p>\n\n  <ul>\n    <li>\u041F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0430\u043C \u0443\u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0435\u043D\u043D\u044B\u0445 \u043E\u0440\u0433\u0430\u043D\u043E\u0432 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u0432\u043B\u0430\u0441\u0442\u0438 \u0420\u0424 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F\u043C \u0438 \u0432 \u043F\u043E\u0440\u044F\u0434\u043A\u0435, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0420\u0424;</li>\n    <li>\u0421\u0442\u0440\u0430\u0442\u0435\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u0430\u043C, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0442 \u0441 \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0435\u0439 \u0434\u043B\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 \u0438 \u0443\u0441\u043B\u0443\u0433, \u0438\u043B\u0438 \u0442\u0435\u043C \u0438\u0437 \u043D\u0438\u0445, \u043A\u043E\u0442\u043E\u0440\u044B\u0435\n      \u043F\u043E\u043C\u043E\u0433\u0430\u044E\u0442 \u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u044B\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u044B \u0438 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u044F\u043C. \u041C\u044B \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C \u0442\u0440\u0435\u0442\u044C\u0438\u043C \u043B\u0438\u0446\u0430\u043C \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u0431\u044A\u0435\u043C\n      \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0439 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F \u0442\u0440\u0435\u0431\u0443\u0435\u043C\u043E\u0439 \u0443\u0441\u043B\u0443\u0433\u0438 \u0438\u043B\u0438 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0439 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438.</li>\n  </ul>\n\n  <p>\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u0430\u0432\u043E \u0432\u043D\u043E\u0441\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u043E\u0434\u043D\u043E\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430, \u043F\u0440\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0438,\n    \u0447\u0442\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043D\u0435 \u043F\u0440\u043E\u0442\u0438\u0432\u043E\u0440\u0435\u0447\u0430\u0442 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0420\u0424. \u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0445 \u043F\u0440\u0430\u0432\u0438\u043B \u0432\u0441\u0442\u0443\u043F\u0430\u044E\u0442\n    \u0432 \u0441\u0438\u043B\u0443 \u043F\u043E\u0441\u043B\u0435 \u0438\u0445 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043D\u0430 \u0421\u0430\u0439\u0442\u0435 https://mtgame.ru.</p>\n</div>\n\n<div\n  *ngIf=\"locale === locales.en\"\n  class=\"agreement-box\"\n>\n  TODO\n</div>\n\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: LocalizationService }]; }, null); })();

class FitToParentDirective {
    constructor(elementRef, platformId) {
        this.elementRef = elementRef;
        this.platformId = platformId;
    }
    onWindowResize() {
        this.transform();
    }
    ngAfterViewChecked() {
        this.transform();
    }
    transform() {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.elementRef.nativeElement.style.transform = null;
        const parentPosition = this.elementRef.nativeElement.parentNode.getBoundingClientRect();
        const parentStyles = window.getComputedStyle(this.elementRef.nativeElement.parentNode);
        parentPosition.width -= parseFloat(parentStyles.paddingLeft) + parseFloat(parentStyles.paddingRight);
        parentPosition.height -= parseFloat(parentStyles.paddingTop) + parseFloat(parentStyles.paddingBottom);
        const elementPosition = this.elementRef.nativeElement.getBoundingClientRect();
        if (elementPosition.width > parentPosition.width || elementPosition.height > parentPosition.height) {
            const scale = Math.min(parentPosition.width / elementPosition.width, parentPosition.height / elementPosition.height);
            this.elementRef.nativeElement.style.transform = `scale(${scale})`;
        }
    }
}
FitToParentDirective.ɵfac = function FitToParentDirective_Factory(t) { return new (t || FitToParentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
FitToParentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FitToParentDirective, selectors: [["", "mtgFitToParent", ""]], hostBindings: function FitToParentDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function FitToParentDirective_resize_HostBindingHandler() { return ctx.onWindowResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } } });
FitToParentDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
FitToParentDirective.propDecorators = {
    onWindowResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FitToParentDirective, [{
        type: Directive,
        args: [{
                selector: '[mtgFitToParent]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { onWindowResize: [{
            type: HostListener,
            args: ['window:resize']
        }] }); })();

class ScrollShadowComponent {
    constructor(renderer, elementRef, cdr) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.cdr = cdr;
        this.scrollPosition = 'outside';
        this.size = 's';
        this.color = 'background';
        this.direction = 'vertical';
        this.subscriptions = [];
    }
    get defaultClass() {
        return true;
    }
    get verticalDirectionClass() {
        return this.direction === 'vertical';
    }
    get horizontalDirectionClass() {
        return this.direction === 'horizontal';
    }
    get scrollOutsideClass() {
        return this.scrollPosition === 'outside';
    }
    get scrollInsideClass() {
        return this.scrollPosition === 'inside';
    }
    get colorBackground() {
        return this.color === 'background';
    }
    get colorPanel() {
        return this.color === 'panel';
    }
    get sizeXs() {
        return this.size === 'xs';
    }
    get sizeS() {
        return this.size === 's';
    }
    get sizeXl() {
        return this.size === 'xl';
    }
    ngAfterViewInit() {
        setTimeout(() => this.checkScroll());
        this.subscriptions.push(this.renderer.listen(this.scrollContainer.nativeElement, 'scroll', () => this.checkScroll()));
    }
    ngOnDestroy() {
        for (const unsubscribe of this.subscriptions) {
            unsubscribe();
        }
    }
    scrollTo(data) {
        this.scrollContainer.nativeElement.scrollTo(data);
    }
    checkScroll() {
        if (this.direction === 'vertical') {
            this.checkVerticalScroll();
        }
        else if (this.direction === 'horizontal') {
            this.checkHorizontalScroll();
        }
    }
    checkVerticalScroll() {
        const scrollContainer = this.scrollContainer.nativeElement;
        const scrollHeight = scrollContainer.scrollHeight - scrollContainer.clientHeight;
        const canScrollTop = scrollContainer.scrollTop > 0;
        const canScrollBottom = scrollContainer.scrollTop < scrollHeight;
        if (canScrollTop) {
            if (!this.topShadowVisible) {
                this.topShadowVisible = true;
                this.cdr.markForCheck();
            }
        }
        else {
            if (this.topShadowVisible) {
                this.topShadowVisible = false;
                this.cdr.markForCheck();
            }
        }
        if (canScrollBottom) {
            if (!this.bottomShadowVisible) {
                this.bottomShadowVisible = true;
                this.cdr.markForCheck();
            }
        }
        else {
            if (this.bottomShadowVisible) {
                this.bottomShadowVisible = false;
                this.cdr.markForCheck();
            }
        }
    }
    checkHorizontalScroll() {
        const scrollContainer = this.scrollContainer.nativeElement;
        const scrollWidth = scrollContainer.scrollWidth - scrollContainer.clientWidth;
        const canScrollLeft = scrollContainer.scrollLeft > 0;
        const canScrollRight = scrollContainer.scrollLeft < scrollWidth;
        if (canScrollLeft) {
            if (!this.leftShadowVisible) {
                this.leftShadowVisible = true;
                this.cdr.markForCheck();
            }
        }
        else {
            if (this.leftShadowVisible) {
                this.leftShadowVisible = false;
                this.cdr.markForCheck();
            }
        }
        if (canScrollRight) {
            if (!this.rightShadowVisible) {
                this.rightShadowVisible = true;
                this.cdr.markForCheck();
            }
        }
        else {
            if (this.rightShadowVisible) {
                this.rightShadowVisible = false;
                this.cdr.markForCheck();
            }
        }
    }
}
ScrollShadowComponent.ɵfac = function ScrollShadowComponent_Factory(t) { return new (t || ScrollShadowComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ScrollShadowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ScrollShadowComponent, selectors: [["mtg-scroll-shadow"]], viewQuery: function ScrollShadowComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c8, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollContainer = _t.first);
    } }, hostVars: 28, hostBindings: function ScrollShadowComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("scroll-shadow", ctx.defaultClass)("direction--vertical", ctx.verticalDirectionClass)("direction--horizontal", ctx.horizontalDirectionClass)("scroll--outside", ctx.scrollOutsideClass)("scroll-inside", ctx.scrollInsideClass)("color--background", ctx.colorBackground)("color--panel", ctx.colorPanel)("size--xs", ctx.sizeXs)("size--s", ctx.sizeS)("size--xl", ctx.sizeXl)("shadow-top", ctx.topShadowVisible)("shadow-bottom", ctx.bottomShadowVisible)("shadow-left", ctx.leftShadowVisible)("shadow-right", ctx.rightShadowVisible);
    } }, inputs: { scrollPosition: "scrollPosition", size: "size", color: "color", direction: "direction" }, ngContentSelectors: _c2, decls: 3, vars: 0, consts: [["cdk-scrollable", "", 1, "scroll-container"], ["scrollContainer", ""]], template: function ScrollShadowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
ScrollShadowComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
ScrollShadowComponent.propDecorators = {
    scrollPosition: [{ type: Input }],
    size: [{ type: Input }],
    color: [{ type: Input }],
    direction: [{ type: Input }],
    scrollContainer: [{ type: ViewChild, args: ['scrollContainer', { read: ElementRef },] }],
    topShadowVisible: [{ type: HostBinding, args: ['class.shadow-top',] }],
    bottomShadowVisible: [{ type: HostBinding, args: ['class.shadow-bottom',] }],
    leftShadowVisible: [{ type: HostBinding, args: ['class.shadow-left',] }],
    rightShadowVisible: [{ type: HostBinding, args: ['class.shadow-right',] }],
    defaultClass: [{ type: HostBinding, args: ['class.scroll-shadow',] }],
    verticalDirectionClass: [{ type: HostBinding, args: ['class.direction--vertical',] }],
    horizontalDirectionClass: [{ type: HostBinding, args: ['class.direction--horizontal',] }],
    scrollOutsideClass: [{ type: HostBinding, args: ['class.scroll--outside',] }],
    scrollInsideClass: [{ type: HostBinding, args: ['class.scroll-inside',] }],
    colorBackground: [{ type: HostBinding, args: ['class.color--background',] }],
    colorPanel: [{ type: HostBinding, args: ['class.color--panel',] }],
    sizeXs: [{ type: HostBinding, args: ['class.size--xs',] }],
    sizeS: [{ type: HostBinding, args: ['class.size--s',] }],
    sizeXl: [{ type: HostBinding, args: ['class.size--xl',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollShadowComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-scroll-shadow',
                template: "<div class=\"scroll-container\" #scrollContainer cdk-scrollable>\n  <ng-content></ng-content>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { scrollPosition: [{
            type: Input
        }], size: [{
            type: Input
        }], color: [{
            type: Input
        }], direction: [{
            type: Input
        }], defaultClass: [{
            type: HostBinding,
            args: ['class.scroll-shadow']
        }], verticalDirectionClass: [{
            type: HostBinding,
            args: ['class.direction--vertical']
        }], horizontalDirectionClass: [{
            type: HostBinding,
            args: ['class.direction--horizontal']
        }], scrollOutsideClass: [{
            type: HostBinding,
            args: ['class.scroll--outside']
        }], scrollInsideClass: [{
            type: HostBinding,
            args: ['class.scroll-inside']
        }], colorBackground: [{
            type: HostBinding,
            args: ['class.color--background']
        }], colorPanel: [{
            type: HostBinding,
            args: ['class.color--panel']
        }], sizeXs: [{
            type: HostBinding,
            args: ['class.size--xs']
        }], sizeS: [{
            type: HostBinding,
            args: ['class.size--s']
        }], sizeXl: [{
            type: HostBinding,
            args: ['class.size--xl']
        }], topShadowVisible: [{
            type: HostBinding,
            args: ['class.shadow-top']
        }], bottomShadowVisible: [{
            type: HostBinding,
            args: ['class.shadow-bottom']
        }], leftShadowVisible: [{
            type: HostBinding,
            args: ['class.shadow-left']
        }], rightShadowVisible: [{
            type: HostBinding,
            args: ['class.shadow-right']
        }], scrollContainer: [{
            type: ViewChild,
            args: ['scrollContainer', { read: ElementRef }]
        }] }); })();

function download(url) {
    return __awaiter(this, void 0, void 0, function* () {
        const a = document.createElement('a');
        a.href = yield toDataURL(url);
        a.download = '';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    });
}
function toDataURL(url) {
    return fetch(url + '?cors=1').then((response) => {
        return response.blob();
    }).then(blob => {
        const urlCreator = window.URL || window.webkitURL;
        return urlCreator.createObjectURL(blob);
    });
}

class LoaderService {
    constructor(overlay) {
        this.overlay = overlay;
    }
    show() {
        if (this.visible) {
            return;
        }
        if (this.overlayRef) {
            this.visible = true;
            return;
        }
        this.visible = true;
        const positionStrategy = this.overlay.position().global().top().left();
        this.overlayRef = this.overlay.create({
            positionStrategy,
            hasBackdrop: true,
            backdropClass: 'loader-backdrop',
            width: '100%'
        });
        const componentPortal = new ComponentPortal(LinearProgressComponent);
        this.overlayRef.attach(componentPortal);
    }
    hide() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.visible = false;
        this.timeout = setTimeout(() => {
            if (this.visible || !this.overlayRef) {
                return;
            }
            this.overlayRef.dispose();
            delete this.overlayRef;
        }, 300);
    }
}
LoaderService.ɵfac = function LoaderService_Factory(t) { return new (t || LoaderService)(ɵngcc0.ɵɵinject(ɵngcc2.Overlay)); };
LoaderService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LoaderService_Factory() { return new LoaderService(i0.ɵɵinject(i1.Overlay)); }, token: LoaderService, providedIn: "root" });
LoaderService.ctorParameters = () => [
    { type: Overlay }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoaderService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc2.Overlay }]; }, null); })();

class DownloadDirective {
    constructor(renderer, elementRef, loaderService, buttonComponent) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.loaderService = loaderService;
        this.buttonComponent = buttonComponent;
    }
    ngAfterViewInit() {
        if (this.buttonComponent) {
            this.renderer.listen(this.buttonComponent.linkElement.nativeElement, 'click', this.onClick.bind(this));
        }
        else {
            this.renderer.listen(this.elementRef.nativeElement, 'click', this.onClick.bind(this));
        }
    }
    onClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const href = this.buttonComponent
                ? this.buttonComponent.href
                : this.elementRef.nativeElement.getAttribute('href');
            this.loaderService.show();
            try {
                yield download(href);
            }
            finally {
                this.loaderService.hide();
            }
        });
    }
}
DownloadDirective.ɵfac = function DownloadDirective_Factory(t) { return new (t || DownloadDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(LoaderService), ɵngcc0.ɵɵdirectiveInject(ButtonComponent, 8)); };
DownloadDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DownloadDirective, selectors: [["a", "mtgDownload", ""], ["mtg-button", "mtgDownload", ""]] });
DownloadDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: LoaderService },
    { type: ButtonComponent, decorators: [{ type: Optional }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DownloadDirective, [{
        type: Directive,
        args: [{
                selector: 'a[mtgDownload],mtg-button[mtgDownload]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: LoaderService }, { type: ButtonComponent, decorators: [{
                type: Optional
            }] }]; }, null); })();

class SuggestHighlightPipe {
    transform(value, positions) {
        const pre = '<span class="text-color">';
        const post = '</span>';
        let index = 0;
        for (const numbers of positions) {
            numbers[0] += index * (pre + post).length;
            numbers[1] += index * (pre + post).length;
            value = [
                value.slice(0, numbers[0]),
                pre,
                value.slice(numbers[0], numbers[1]),
                post,
                value.slice(numbers[1])
            ].join('');
            index++;
        }
        return value;
    }
}
SuggestHighlightPipe.ɵfac = function SuggestHighlightPipe_Factory(t) { return new (t || SuggestHighlightPipe)(); };
SuggestHighlightPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "suggestHighlight", type: SuggestHighlightPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuggestHighlightPipe, [{
        type: Pipe,
        args: [{
                name: 'suggestHighlight'
            }]
    }], null, null); })();

class LocalizationCustomPipe {
    constructor(localizationService, cdr) {
        this.localizationService = localizationService;
        this.cdr = cdr;
    }
    ngOnDestroy() {
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
    }
    transform(value, ...args) {
        if (this.lastKey === value) {
            return this.value;
        }
        if (!this.langChangeSubscription) {
            this.langChangeSubscription = this.localizationService.locale$.subscribe(() => {
                if (this.lastKey) {
                    this.value = this.localizationService.localize(value);
                    this.cdr.markForCheck();
                }
            });
        }
        this.value = this.localizationService.localize(value);
        this.lastKey = value;
        return this.value;
    }
}
LocalizationCustomPipe.ɵfac = function LocalizationCustomPipe_Factory(t) { return new (t || LocalizationCustomPipe)(ɵngcc0.ɵɵdirectiveInject(LocalizationService, 16), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef, 16)); };
LocalizationCustomPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "mtgLocalizeCustom", type: LocalizationCustomPipe, pure: false });
LocalizationCustomPipe.ctorParameters = () => [
    { type: LocalizationService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizationCustomPipe, [{
        type: Pipe,
        args: [{ name: 'mtgLocalizeCustom', pure: false }]
    }], function () { return [{ type: LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

class DateFormatPipe {
    constructor(localizationService, cdr) {
        this.localizationService = localizationService;
        this.cdr = cdr;
    }
    transform(value, format) {
        const cacheKey = `${value}_${format}`;
        if (this.lastKey === cacheKey) {
            return this.value;
        }
        if (!this.langSubscription) {
            this.langSubscription = this.localizationService.locale$.subscribe(() => {
                if (this.lastKey) {
                    this.value = formatDate(value, format, this.localizationService.getLocale());
                    this.cdr.markForCheck();
                }
            });
        }
        this.lastKey = cacheKey;
        this.value = formatDate(value, format, this.localizationService.getLocale());
        return this.value;
    }
    ngOnDestroy() {
        if (this.langSubscription) {
            this.langSubscription.unsubscribe();
        }
    }
}
DateFormatPipe.ɵfac = function DateFormatPipe_Factory(t) { return new (t || DateFormatPipe)(ɵngcc0.ɵɵdirectiveInject(LocalizationService, 16), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef, 16)); };
DateFormatPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "mtgDateFormat", type: DateFormatPipe, pure: false });
DateFormatPipe.ctorParameters = () => [
    { type: LocalizationService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateFormatPipe, [{
        type: Pipe,
        args: [{
                name: 'mtgDateFormat',
                pure: false
            }]
    }], function () { return [{ type: LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

class TranslatePipe {
    constructor(localizationService, cdr) {
        this.localizationService = localizationService;
        this.cdr = cdr;
    }
    transform(value, key) {
        if (this.lastKey === key) {
            return this.value;
        }
        if (!this.langSubscription) {
            this.langSubscription = this.localizationService.locale$.subscribe(localeId => {
                if (this.lastKey && localeId) {
                    // @ts-ignore
                    this.value = value[localeId][key];
                    this.cdr.markForCheck();
                }
            });
        }
        this.lastKey = key;
        // @ts-ignore
        this.value = value[this.localizationService.getLocale() || 'ru-RU'][key];
        return this.value;
    }
}
TranslatePipe.ɵfac = function TranslatePipe_Factory(t) { return new (t || TranslatePipe)(ɵngcc0.ɵɵdirectiveInject(LocalizationService, 16), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef, 16)); };
TranslatePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "mtgTranslate", type: TranslatePipe, pure: false });
TranslatePipe.ctorParameters = () => [
    { type: LocalizationService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TranslatePipe, [{
        type: Pipe,
        args: [{
                name: 'mtgTranslate',
                pure: false
            }]
    }], function () { return [{ type: LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

class FormErrorLocalizationPipe {
    constructor(localizationService, cdr) {
        this.localizationService = localizationService;
        this.cdr = cdr;
    }
    ngOnDestroy() {
        if (this.langChangeSubscription) {
            this.langChangeSubscription.unsubscribe();
        }
    }
    transform(value, ...args) {
        if (this.lastKey === value) {
            return this.value;
        }
        if (!this.langChangeSubscription) {
            this.langChangeSubscription = this.localizationService.locale$.subscribe(() => {
                if (this.lastKey) {
                    this.value = this.localizationService.formErrorLocalize(value);
                    this.cdr.markForCheck();
                }
            });
        }
        this.value = this.localizationService.formErrorLocalize(value);
        this.lastKey = value;
        return this.value;
    }
}
FormErrorLocalizationPipe.ɵfac = function FormErrorLocalizationPipe_Factory(t) { return new (t || FormErrorLocalizationPipe)(ɵngcc0.ɵɵdirectiveInject(LocalizationService, 16), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef, 16)); };
FormErrorLocalizationPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "mtgFormErrorLocalization", type: FormErrorLocalizationPipe, pure: false });
FormErrorLocalizationPipe.ctorParameters = () => [
    { type: LocalizationService },
    { type: ChangeDetectorRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormErrorLocalizationPipe, [{
        type: Pipe,
        args: [{ name: 'mtgFormErrorLocalization', pure: false }]
    }], function () { return [{ type: LocalizationService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

const FORMS_LOCALIZATION = {
    [Locales.ru]: {
        required: 'Поле обязательно для заполнения',
        email: 'Email введен неверно',
        emailTaken: 'Email уже зарегистрирован в системе',
        minlength: 'Должно быть больше {requiredLength} символов',
        min: 'Должно быть больше {min}',
        mismatch: 'Неверное подтверждение',
        time: 'Время введено неверно',
        emailExists: 'Email занят',
        invalidDate: 'Дата введена неверно',
        invalidPhone: 'Телефон введен неверно',
        pattern: 'Введены запрещенные символы',
        invalidUrl: 'Ссылка введена неверно',
        groupExist: 'Группа с таким названием уже есть'
    },
    [Locales.en]: {
        required: 'Field is required',
        email: 'Email is not valid',
        emailTaken: 'Email is already registered in the system',
        minlength: 'Must be greater than {requiredLength} characters',
        min: 'Must be more than {min}',
        mismatch: 'Incorrect confirmation',
        time: 'The time entered is incorrect.',
        emailExists: 'Email is already registered in the system',
        invalidDate: 'The date was entered incorrectly.',
        invalidPhone: 'The phone number entered is incorrect',
        pattern: 'Prohibited characters entered',
        invalidUrl: 'The link is entered incorrectly',
        groupExist: 'There is already a group with this name'
    },
};

class CityNamePipe {
    constructor(localizationService) {
        this.localizationService = localizationService;
    }
    transform(value) {
        if (this.localizationService.getLocale() === Locales.en) {
            return value.nameEn;
        }
        return value.name;
    }
}
CityNamePipe.ɵfac = function CityNamePipe_Factory(t) { return new (t || CityNamePipe)(ɵngcc0.ɵɵdirectiveInject(LocalizationService, 16)); };
CityNamePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "mtgCityName", type: CityNamePipe, pure: true });
CityNamePipe.ctorParameters = () => [
    { type: LocalizationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CityNamePipe, [{
        type: Pipe,
        args: [{
                name: 'mtgCityName'
            }]
    }], function () { return [{ type: LocalizationService }]; }, null); })();

const ɵ0 = FORMS_LOCALIZATION, ɵ1 = {};
class LocalizationModule {
}
LocalizationModule.ɵfac = function LocalizationModule_Factory(t) { return new (t || LocalizationModule)(); };
LocalizationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LocalizationModule });
LocalizationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        LocalizationService,
        {
            provide: FORM_ERROR_LIST,
            useFactory: formErrorLocalizationFactory,
            deps: [
                FORM_ERROR_LOCALIZATION,
                [new SkipSelf(), new Optional(), new Inject(FORM_ERROR_LIST)],
            ]
        },
        {
            provide: LOCALIZATION_DATA_LIST,
            useFactory: localizationDataFactory,
            deps: [
                LOCALIZATION_DATA,
                [new SkipSelf(), new Optional(), new Inject(LOCALIZATION_DATA_LIST)],
            ]
        },
        {
            provide: FORM_ERROR_LOCALIZATION,
            useValue: ɵ0,
            multi: true
        },
        {
            provide: LOCALIZATION_DATA,
            useValue: ɵ1,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useFactory: initializeLang,
            deps: [LocalizationService, DOCUMENT]
        }
    ], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    TranslatePipe,
                    LocalizationCustomPipe,
                    FormErrorLocalizationPipe,
                    DateFormatPipe,
                    CityNamePipe,
                ],
                exports: [
                    TranslatePipe,
                    LocalizationCustomPipe,
                    FormErrorLocalizationPipe,
                    DateFormatPipe,
                    CityNamePipe,
                ],
                providers: [
                    LocalizationService,
                    {
                        provide: FORM_ERROR_LIST,
                        useFactory: formErrorLocalizationFactory,
                        deps: [
                            FORM_ERROR_LOCALIZATION,
                            [new SkipSelf(), new Optional(), new Inject(FORM_ERROR_LIST)],
                        ]
                    },
                    {
                        provide: LOCALIZATION_DATA_LIST,
                        useFactory: localizationDataFactory,
                        deps: [
                            LOCALIZATION_DATA,
                            [new SkipSelf(), new Optional(), new Inject(LOCALIZATION_DATA_LIST)],
                        ]
                    },
                    {
                        provide: FORM_ERROR_LOCALIZATION,
                        useValue: ɵ0,
                        multi: true
                    },
                    {
                        provide: LOCALIZATION_DATA,
                        useValue: ɵ1,
                        multi: true
                    },
                    {
                        provide: LOCALE_ID,
                        useFactory: initializeLang,
                        deps: [LocalizationService, DOCUMENT]
                    }
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LocalizationModule, { declarations: function () { return [TranslatePipe, LocalizationCustomPipe, FormErrorLocalizationPipe, DateFormatPipe, CityNamePipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TranslatePipe, LocalizationCustomPipe, FormErrorLocalizationPipe, DateFormatPipe, CityNamePipe]; } }); })();
function localizationDataFactory(newData, parent) {
    const data = Object.assign({}, parent);
    for (const localeId of Object.values(Locales)) {
        for (const row of newData) {
            data[localeId] = Object.assign(Object.assign({}, (data[localeId] || {})), row[localeId]);
        }
    }
    return data;
}
function formErrorLocalizationFactory(newData, parent) {
    const data = Object.assign({}, parent);
    for (const localeId of Object.values(Locales)) {
        for (const row of newData) {
            data[localeId] = Object.assign(Object.assign({}, (data[localeId] || {})), row[localeId]);
        }
    }
    return data;
}
function initializeLang(localizationService, document) {
    if (document.location.hostname.endsWith('.mtgame-sports.com')) {
        localizationService.setLocale(Locales.en);
    }
    else {
        localizationService.setLocale(Locales.ru);
    }
    return localizationService.getLocale();
}

class UtilsModule {
}
UtilsModule.ɵfac = function UtilsModule_Factory(t) { return new (t || UtilsModule)(); };
UtilsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UtilsModule });
UtilsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        ProgressModule,
        ButtonModule,
        LocalizationModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UtilsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ProgressModule,
                    ButtonModule,
                    LocalizationModule,
                ],
                declarations: [
                    AgreementComponent,
                    DialogPageComponent,
                    ConfirmDialogComponent,
                    ScrollShadowComponent,
                    PaginationScrollDirective,
                    StickyDirective,
                    StopPropagationDirective,
                    FireEventDirective,
                    FitToParentDirective,
                    DownloadDirective,
                    FilterPipe,
                    LocalizationPipe,
                    PhonePipe,
                    PluralizePipe,
                    SafePipe,
                    DatePipe,
                    SuggestHighlightPipe,
                ],
                exports: [
                    AgreementComponent,
                    DialogPageComponent,
                    ConfirmDialogComponent,
                    ScrollShadowComponent,
                    PaginationScrollDirective,
                    StickyDirective,
                    StopPropagationDirective,
                    FireEventDirective,
                    FitToParentDirective,
                    DownloadDirective,
                    FilterPipe,
                    LocalizationPipe,
                    PhonePipe,
                    PluralizePipe,
                    SafePipe,
                    DatePipe,
                    SuggestHighlightPipe,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UtilsModule, { declarations: function () { return [AgreementComponent, DialogPageComponent, ConfirmDialogComponent, ScrollShadowComponent, PaginationScrollDirective, StickyDirective, StopPropagationDirective, FireEventDirective, FitToParentDirective, DownloadDirective, FilterPipe, LocalizationPipe, PhonePipe, PluralizePipe, SafePipe, DatePipe, SuggestHighlightPipe]; }, imports: function () { return [CommonModule, ProgressModule, ButtonModule, LocalizationModule]; }, exports: function () { return [AgreementComponent, DialogPageComponent, ConfirmDialogComponent, ScrollShadowComponent, PaginationScrollDirective, StickyDirective, StopPropagationDirective, FireEventDirective, FitToParentDirective, DownloadDirective, FilterPipe, LocalizationPipe, PhonePipe, PluralizePipe, SafePipe, DatePipe, SuggestHighlightPipe]; } }); })();

class DropdownModule {
}
DropdownModule.ɵfac = function DropdownModule_Factory(t) { return new (t || DropdownModule)(); };
DropdownModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DropdownModule });
DropdownModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        LayoutModule,
        SvgIconModule,
        ButtonModule,
        UtilsModule,
        LocalizationModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    LayoutModule,
                    SvgIconModule,
                    ButtonModule,
                    UtilsModule,
                    LocalizationModule,
                ],
                declarations: [
                    DropdownComponent,
                    DropdownMenuComponent,
                    DropdownGroupComponent,
                    DropdownItemComponent,
                    DropdownTriggerDirective,
                ],
                exports: [
                    DropdownComponent,
                    DropdownMenuComponent,
                    DropdownGroupComponent,
                    DropdownItemComponent,
                    DropdownTriggerDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DropdownModule, { declarations: function () { return [DropdownComponent, DropdownMenuComponent, DropdownGroupComponent, DropdownItemComponent, DropdownTriggerDirective]; }, imports: function () { return [CommonModule,
        LayoutModule, SvgIconModule, ButtonModule, UtilsModule, LocalizationModule]; }, exports: function () { return [DropdownComponent, DropdownMenuComponent, DropdownGroupComponent, DropdownItemComponent, DropdownTriggerDirective]; } }); })();

class RadioGroupComponent {
    constructor(parentFormGroup) {
        this.parentFormGroup = parentFormGroup;
        this.value$ = new Subject();
        this.defaultClass = true;
    }
    ngOnInit() {
        if (this.parentFormGroup) {
            this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
        }
        else {
            this.control = this.formControl;
        }
    }
    ngOnDestroy() {
        this.value$.complete();
    }
    writeValue(obj) {
        this.value = obj;
        this.value$.next(obj);
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    onItemClick(value) {
        this.value = value;
        this.value$.next(value);
        if (this.onTouch) {
            this.onTouch();
        }
        if (this.onChange) {
            this.onChange(this.value);
        }
    }
}
RadioGroupComponent.ɵfac = function RadioGroupComponent_Factory(t) { return new (t || RadioGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 8)); };
RadioGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioGroupComponent, selectors: [["mtg-radio-group"]], hostVars: 2, hostBindings: function RadioGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("radio-group", ctx.defaultClass);
    } }, inputs: { formControl: "formControl", formControlName: "formControlName", reverse: "reverse" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RadioGroupComponent),
                multi: true
            }
        ])], ngContentSelectors: _c2, decls: 1, vars: 0, template: function RadioGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
RadioGroupComponent.ctorParameters = () => [
    { type: FormGroupDirective, decorators: [{ type: Optional }] }
];
RadioGroupComponent.propDecorators = {
    formControl: [{ type: Input }],
    formControlName: [{ type: Input }],
    reverse: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.radio-group',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioGroupComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-radio-group',
                template: "<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RadioGroupComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Optional
            }] }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.radio-group']
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], reverse: [{
            type: Input
        }] }); })();

class RadioComponent {
    constructor(parentFormGroup, radioGroupComponent, cdr) {
        this.parentFormGroup = parentFormGroup;
        this.radioGroupComponent = radioGroupComponent;
        this.cdr = cdr;
        this.defaultClass = true;
    }
    get isReverse() {
        return (this.radioGroupComponent && this.radioGroupComponent.reverse) || this.reverse;
    }
    ngOnInit() {
        if (this.parentFormGroup) {
            this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
        }
        else {
            this.control = this.formControl;
        }
        if (this.radioGroupComponent) {
            this.radioGroupComponent.value$.subscribe(value => {
                this.checked = this.value === value;
                this.cdr.markForCheck();
            });
        }
    }
    writeValue(obj) {
        this.checked = obj === this.value;
        this.cdr.markForCheck();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    changeValue() {
        this.checked = true;
        if (this.onTouch) {
            this.onTouch();
        }
        if (this.onChange) {
            this.onChange(this.value);
        }
        if (this.radioGroupComponent) {
            this.radioGroupComponent.onItemClick(this.value);
        }
    }
}
RadioComponent.ɵfac = function RadioComponent_Factory(t) { return new (t || RadioComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 8), ɵngcc0.ɵɵdirectiveInject(RadioGroupComponent, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
RadioComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioComponent, selectors: [["mtg-radio"]], hostVars: 2, hostBindings: function RadioComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("radio-container", ctx.defaultClass);
    } }, inputs: { value: "value", formControl: "formControl", formControlName: "formControlName", reverse: "reverse" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RadioComponent),
                multi: true
            }
        ])], ngContentSelectors: _c2, decls: 6, vars: 4, consts: [[3, "ngClass"], [1, "radio"], ["type", "radio", 3, "checked", "change"], [1, "radio-appearance"], [1, "label"]], template: function RadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "label", 0)(1, "div", 1)(2, "input", 2);
        ɵngcc0.ɵɵlistener("change", function RadioComponent_Template_input_change_2_listener() { return ctx.changeValue(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c3, ctx.isReverse));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("checked", ctx.checked);
    } }, dependencies: [ɵngcc1.NgClass], encapsulation: 2, changeDetection: 0 });
RadioComponent.ctorParameters = () => [
    { type: FormGroupDirective, decorators: [{ type: Optional }] },
    { type: RadioGroupComponent, decorators: [{ type: Optional }] },
    { type: ChangeDetectorRef }
];
RadioComponent.propDecorators = {
    value: [{ type: Input }],
    formControl: [{ type: Input }],
    formControlName: [{ type: Input }],
    reverse: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.radio-container',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-radio',
                template: "<label [ngClass]=\"{reverse: isReverse}\">\n  <div class=\"radio\">\n    <input type=\"radio\" (change)=\"changeValue()\" [checked]=\"checked\"/>\n    <div class=\"radio-appearance\"></div>\n  </div>\n  <div class=\"label\"><ng-content></ng-content></div>\n</label>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RadioComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Optional
            }] }, { type: RadioGroupComponent, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.radio-container']
        }], value: [{
            type: Input
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], reverse: [{
            type: Input
        }] }); })();

class RadioModule {
}
RadioModule.ɵfac = function RadioModule_Factory(t) { return new (t || RadioModule)(); };
RadioModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RadioModule });
RadioModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    RadioComponent,
                    RadioGroupComponent,
                ],
                exports: [
                    RadioComponent,
                    RadioGroupComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RadioModule, { declarations: function () { return [RadioComponent, RadioGroupComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [RadioComponent, RadioGroupComponent]; } }); })();

class SwitcherGroupComponent {
    constructor(parentFormGroup) {
        this.parentFormGroup = parentFormGroup;
        this.value = [];
        this.defaultClass = true;
    }
    ngOnInit() {
        if (this.parentFormGroup) {
            this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
        }
        else {
            this.control = this.formControl;
        }
    }
    writeValue(obj) {
        this.value = obj || [];
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    onItemChanged(value, checked) {
        if (checked) {
            if (this.value.indexOf(value) < 0) {
                this.value.push(value);
            }
        }
        else {
            this.value.splice(this.value.indexOf(value), 1);
        }
        if (this.onTouch) {
            this.onTouch();
        }
        if (this.onChange) {
            this.onChange(this.value);
        }
    }
}
SwitcherGroupComponent.ɵfac = function SwitcherGroupComponent_Factory(t) { return new (t || SwitcherGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 8)); };
SwitcherGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SwitcherGroupComponent, selectors: [["mtg-switcher-group"]], hostVars: 2, hostBindings: function SwitcherGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("switcher-group", ctx.defaultClass);
    } }, inputs: { formControl: "formControl", formControlName: "formControlName", reverse: "reverse" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SwitcherGroupComponent),
                multi: true
            }
        ])], ngContentSelectors: _c2, decls: 1, vars: 0, template: function SwitcherGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
SwitcherGroupComponent.ctorParameters = () => [
    { type: FormGroupDirective, decorators: [{ type: Optional }] }
];
SwitcherGroupComponent.propDecorators = {
    formControl: [{ type: Input }],
    formControlName: [{ type: Input }],
    reverse: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.switcher-group',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwitcherGroupComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-switcher-group',
                template: "<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SwitcherGroupComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Optional
            }] }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.switcher-group']
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], reverse: [{
            type: Input
        }] }); })();

class SwitcherComponent {
    constructor(parentFormGroup, switcherGroupComponent, cdr) {
        this.parentFormGroup = parentFormGroup;
        this.switcherGroupComponent = switcherGroupComponent;
        this.cdr = cdr;
        this.defaultClass = true;
    }
    get isReverse() {
        var _a;
        return this.reverse || ((_a = this.switcherGroupComponent) === null || _a === void 0 ? void 0 : _a.reverse);
    }
    ngOnInit() {
        if (this.parentFormGroup) {
            this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
        }
        else {
            this.control = this.formControl;
        }
        if (this.switcherGroupComponent) {
            this.checked = (this.switcherGroupComponent.value || []).indexOf(this.value) > -1;
        }
    }
    writeValue(obj) {
        this.checked = obj === this.value;
        this.cdr.markForCheck();
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    changeValue(checked) {
        this.checked = checked;
        if (this.onChange) {
            const value = this.value !== undefined ? this.value : true;
            this.onChange(this.checked ? value : null);
        }
        if (this.onTouch) {
            this.onTouch();
        }
        if (this.switcherGroupComponent) {
            this.switcherGroupComponent.onItemChanged(this.value, checked);
        }
    }
}
SwitcherComponent.ɵfac = function SwitcherComponent_Factory(t) { return new (t || SwitcherComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 8), ɵngcc0.ɵɵdirectiveInject(SwitcherGroupComponent, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SwitcherComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SwitcherComponent, selectors: [["mtg-switcher"]], hostVars: 2, hostBindings: function SwitcherComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("switcher-container", ctx.defaultClass);
    } }, inputs: { value: "value", formControl: "formControl", formControlName: "formControlName", reverse: "reverse" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => SwitcherComponent),
                multi: true
            }
        ])], ngContentSelectors: _c2, decls: 7, vars: 4, consts: [[3, "ngClass"], [1, "switcher"], ["type", "checkbox", 3, "checked", "change"], [1, "switcher-appearance"], ["icon", "icons-switcher"], [1, "label"]], template: function SwitcherComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "label", 0)(1, "div", 1)(2, "input", 2);
        ɵngcc0.ɵɵlistener("change", function SwitcherComponent_Template_input_change_2_listener($event) { return ctx.changeValue($event.target.checked); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelement(4, "mtg-svg-icon", 4);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c3, ctx.isReverse));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("checked", ctx.checked);
    } }, dependencies: [ɵngcc1.NgClass, SvgIconComponent], encapsulation: 2, changeDetection: 0 });
SwitcherComponent.ctorParameters = () => [
    { type: FormGroupDirective, decorators: [{ type: Optional }] },
    { type: SwitcherGroupComponent, decorators: [{ type: Optional }] },
    { type: ChangeDetectorRef }
];
SwitcherComponent.propDecorators = {
    value: [{ type: Input }],
    formControl: [{ type: Input }],
    formControlName: [{ type: Input }],
    reverse: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.switcher-container',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwitcherComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-switcher',
                template: "<label [ngClass]=\"{reverse: isReverse}\">\n  <div class=\"switcher\">\n    <input type=\"checkbox\" (change)=\"changeValue($event.target.checked)\" [checked]=\"checked\" />\n    <div class=\"switcher-appearance\">\n      <mtg-svg-icon icon=\"icons-switcher\"></mtg-svg-icon>\n    </div>\n  </div>\n  <div class=\"label\"><ng-content></ng-content></div>\n</label>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => SwitcherComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Optional
            }] }, { type: SwitcherGroupComponent, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.switcher-container']
        }], value: [{
            type: Input
        }], formControl: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], reverse: [{
            type: Input
        }] }); })();

class SwitcherModule {
}
SwitcherModule.ɵfac = function SwitcherModule_Factory(t) { return new (t || SwitcherModule)(); };
SwitcherModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SwitcherModule });
SwitcherModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        SvgIconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SwitcherModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SvgIconModule,
                ],
                declarations: [
                    SwitcherComponent,
                    SwitcherGroupComponent,
                ],
                exports: [
                    SwitcherComponent,
                    SwitcherGroupComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SwitcherModule, { declarations: function () { return [SwitcherComponent, SwitcherGroupComponent]; }, imports: function () { return [CommonModule, SvgIconModule]; }, exports: function () { return [SwitcherComponent, SwitcherGroupComponent]; } }); })();

function isTouchDevice() {
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    const mq = (q) => {
        return window.matchMedia(q).matches;
    };
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch) {
        return true;
    }
    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}

class TextMaskConfig$1 {
}
class TextFieldComponent {
    constructor(parentFormGroup, localizationService) {
        this.parentFormGroup = parentFormGroup;
        this.localizationService = localizationService;
        this.errorVisible = true;
        this.size = 'md';
        this.change = new EventEmitter();
        this.focus = new EventEmitter();
        this.blur = new EventEmitter();
        this.valueChange = new EventEmitter();
        this.keyDownEvent = new EventEmitter();
    }
    get className() {
        const value = this.inputElement && this.inputElement.value || this.value || '';
        const classList = ['text-field'];
        const control = this.control || this.formControl;
        if (!this.isFocused || this.hasErrorsOnFocus) {
            if (control && control.touched && !control.valid && control.enabled) {
                classList.push('error');
            }
        }
        if (value.toString().length > 0) {
            classList.push('filled');
        }
        if (this.trailingIcon || this.withClearButton) {
            classList.push('with-trailing-icon');
        }
        if (this.leadingIcon) {
            classList.push('with-leading-icon');
        }
        if (this.placeholder) {
            classList.push('with-placeholder');
        }
        if (this.prefix) {
            classList.push('with-prefix');
        }
        if (!this.label) {
            classList.push('without-label');
        }
        if (this.isFocused) {
            classList.push('focused');
        }
        if (this.size === 'sm') {
            classList.push('text-field--size-sm');
        }
        else if (this.size === 'xs') {
            classList.push('text-field--size-xs');
        }
        else {
            classList.push('text-field--size-md');
        }
        return classList.join(' ');
    }
    ngOnInit() {
        if (this.parentFormGroup) {
            this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
        }
    }
    ngAfterViewInit() {
        if (this.input) {
            this.inputElement = this.input.nativeElement;
        }
        else if (this.textarea) {
            this.inputElement = this.textarea.nativeElement;
        }
        if (this.inputElement && this.value) {
            this.inputElement.value = this.value;
        }
        if (this.textMask) {
            this.setupMask();
        }
    }
    clear() {
        this.changeValue('');
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update('');
        }
        else if (this.inputElement) {
            this.inputElement.value = '';
        }
    }
    writeValue(value) {
        this.value = value;
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(value);
        }
        else if (this.inputElement) {
            this.inputElement.value = value;
        }
    }
    registerOnChange(fn) {
        this.onChangeFunc = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedFunc = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    changeValue(value, updateViewValue = false) {
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(value);
            value = this.inputElement.value;
        }
        else if (updateViewValue) {
            this.inputElement.value = value;
        }
        if (this.type === 'number' && value.length > 0) {
            value = +value;
        }
        if (this.type !== 'number' && this.trim) {
            if (value.trim().length !== value.length) {
                value = value.trim();
                this.inputElement.value = value;
            }
        }
        this.change.emit(value);
        this.valueChange.emit(value);
        if (this.onChangeFunc) {
            this.onChangeFunc(value);
        }
        this.value = value;
    }
    onFocus($event) {
        this.isFocused = true;
        this.hasErrorsOnFocus = this.getErrors().length > 0;
        this.focus.emit($event);
        if (isTouchDevice()) {
            document.body.classList.add('input-focused');
        }
    }
    onBlur($event) {
        this.isFocused = false;
        if (this.onTouchedFunc) {
            this.onTouchedFunc();
        }
        if (isTouchDevice()) {
            document.body.classList.remove('input-focused');
        }
        this.blur.emit($event);
    }
    onKeyDown($event) {
        this.keyDownEvent.emit($event);
    }
    getErrors() {
        const control = (this.control || this.formControl);
        let errors = {};
        if (control && control.touched && control.errors) {
            errors = control.errors;
        }
        return Object.keys(errors)
            .filter(k => errors[k])
            .reduce((acc, value) => {
            let error = this.localizationService.formErrorLocalize(value);
            if (!error) {
                return acc;
            }
            if (typeof errors[value] === 'object') {
                for (const errorKey of Object.keys(errors[value])) {
                    error = error.replace(`{${errorKey}}`, errors[value][errorKey]);
                }
            }
            acc.push(error);
            return acc;
        }, []);
    }
    setupMask() {
        if (this.inputElement) {
            this.textMaskInputElement = createTextMaskInputElement(Object.assign({ inputElement: this.inputElement }, this.textMaskConfig));
        }
    }
    get textMaskConfig() {
        const defaultConfig = {
            mask: [],
            guide: true,
            placeholderChar: '_',
            pipe: undefined,
            keepCharPositions: false,
        };
        return Object.assign(defaultConfig, this.textMask);
    }
}
TextFieldComponent.ɵfac = function TextFieldComponent_Factory(t) { return new (t || TextFieldComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormGroupDirective, 8), ɵngcc0.ɵɵdirectiveInject(LocalizationService)); };
TextFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextFieldComponent, selectors: [["mtg-text-field"]], viewQuery: function TextFieldComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c10, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textarea = _t.first);
    } }, hostVars: 2, hostBindings: function TextFieldComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.className);
    } }, inputs: { errorVisible: "errorVisible", size: "size", value: "value", disabled: "disabled", type: "type", placeholder: "placeholder", label: "label", required: "required", trailingIcon: "trailingIcon", leadingIcon: "leadingIcon", min: "min", pattern: "pattern", formControlName: "formControlName", formControl: "formControl", textMask: "textMask", prefix: "prefix", trim: "trim", withClearButton: "withClearButton" }, outputs: { change: "change", focus: "focus", blur: "blur", valueChange: "valueChange", keyDownEvent: "keyDownEvent" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => TextFieldComponent),
                multi: true
            }
        ])], decls: 13, vars: 10, consts: [[1, "input", 3, "ngClass"], ["class", "icon leading-icon", 4, "ngIf"], [3, "type", "min", "pattern", "placeholder", "disabled", "focus", "blur", "input", "keydown", 4, "ngIf"], [3, "placeholder", "disabled", "focus", "blur", "input", "keydown", 4, "ngIf"], [1, "outline"], [1, "start"], [1, "center"], [1, "label"], [1, "end"], ["class", "icon trailing-icon", 4, "ngIf"], ["class", "icon trailing-icon btn", 3, "click", 4, "ngIf"], ["class", "error-text", 4, "ngIf"], [1, "icon", "leading-icon"], [3, "icon"], [3, "type", "min", "pattern", "placeholder", "disabled", "focus", "blur", "input", "keydown"], ["input", ""], [3, "placeholder", "disabled", "focus", "blur", "input", "keydown"], ["textarea", ""], [1, "icon", "trailing-icon"], [1, "icon", "trailing-icon", "btn", 3, "click"], ["icon", "icons-close"], [1, "error-text"], [4, "ngIf"]], template: function TextFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TextFieldComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, TextFieldComponent_input_2_Template, 2, 5, "input", 2);
        ɵngcc0.ɵɵtemplate(3, TextFieldComponent_textarea_3_Template, 2, 2, "textarea", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelement(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "div", 6)(7, "label", 7);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(9, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, TextFieldComponent_div_10_Template, 2, 1, "div", 9);
        ɵngcc0.ɵɵtemplate(11, TextFieldComponent_div_11_Template, 2, 0, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, TextFieldComponent_div_12_Template, 2, 1, "div", 11);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c11, ctx.type === "textarea"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.leadingIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type !== "textarea");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.type === "textarea");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.trailingIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.trailingIcon && ctx.withClearButton && ctx.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorVisible);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, SvgIconComponent], encapsulation: 2, changeDetection: 0 });
TextFieldComponent.ctorParameters = () => [
    { type: FormGroupDirective, decorators: [{ type: Optional }] },
    { type: LocalizationService }
];
TextFieldComponent.propDecorators = {
    input: [{ type: ViewChild, args: ['input', { read: ElementRef },] }],
    textarea: [{ type: ViewChild, args: ['textarea', { read: ElementRef },] }],
    type: [{ type: Input }],
    placeholder: [{ type: Input }],
    label: [{ type: Input }],
    disabled: [{ type: Input }],
    required: [{ type: Input }],
    trailingIcon: [{ type: Input }],
    leadingIcon: [{ type: Input }],
    min: [{ type: Input }],
    pattern: [{ type: Input }],
    formControlName: [{ type: Input }],
    formControl: [{ type: Input }],
    value: [{ type: Input }],
    textMask: [{ type: Input }],
    prefix: [{ type: Input }],
    trim: [{ type: Input }],
    errorVisible: [{ type: Input }],
    size: [{ type: Input }],
    withClearButton: [{ type: Input }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }],
    valueChange: [{ type: Output }],
    keyDownEvent: [{ type: Output }],
    className: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextFieldComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-text-field',
                template: "<div class=\"input\" [ngClass]=\"{textarea: type === 'textarea'}\">\n  <div class=\"icon leading-icon\" *ngIf=\"leadingIcon\">\n    <mtg-svg-icon [icon]=\"leadingIcon\"></mtg-svg-icon>\n  </div>\n  <input\n    *ngIf=\"type !== 'textarea'\"\n    [type]=\"type === 'password' && showPassword ? 'text' : type\"\n    [min]=\"min\"\n    [pattern]=\"pattern || ''\"\n    [placeholder]=\"placeholder || ''\"\n    [disabled]=\"disabled\"\n    (focus)=\"onFocus($event)\"\n    (blur)=\"onBlur($event)\"\n    (input)=\"changeValue($event.target.value)\"\n    (keydown)=\"onKeyDown($event)\"\n    #input\n  />\n  <textarea\n    *ngIf=\"type === 'textarea'\"\n    [placeholder]=\"placeholder || ''\"\n    [disabled]=\"disabled\"\n    (focus)=\"onFocus($event)\"\n    (blur)=\"onBlur($event)\"\n    (input)=\"changeValue($event.target.value)\"\n    (keydown)=\"onKeyDown($event)\"\n    #textarea\n  ></textarea>\n  <div class=\"outline\">\n    <div class=\"start\"></div>\n    <div class=\"center\">\n      <label class=\"label\">{{ label }}</label>\n    </div>\n    <div class=\"end\"></div>\n  </div>\n  <div class=\"icon trailing-icon\" *ngIf=\"trailingIcon\">\n    <mtg-svg-icon [icon]=\"trailingIcon\"></mtg-svg-icon>\n  </div>\n  <div\n    *ngIf=\"!trailingIcon && withClearButton && value\"\n    class=\"icon trailing-icon btn\"\n    (click)=\"clear()\"\n  >\n    <mtg-svg-icon icon=\"icons-close\"></mtg-svg-icon>\n  </div>\n</div>\n<div class=\"error-text\" *ngIf=\"errorVisible\">\n  <ng-container *ngIf=\"getErrors().length && (!isFocused || hasErrorsOnFocus)\">\n    {{ getErrors().join(', ') }}\n  </ng-container>\n</div>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => TextFieldComponent),
                        multi: true
                    }
                ],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc3.FormGroupDirective, decorators: [{
                type: Optional
            }] }, { type: LocalizationService }]; }, { errorVisible: [{
            type: Input
        }], size: [{
            type: Input
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], valueChange: [{
            type: Output
        }], keyDownEvent: [{
            type: Output
        }], className: [{
            type: HostBinding,
            args: ['class']
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], input: [{
            type: ViewChild,
            args: ['input', { read: ElementRef }]
        }], textarea: [{
            type: ViewChild,
            args: ['textarea', { read: ElementRef }]
        }], type: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], label: [{
            type: Input
        }], required: [{
            type: Input
        }], trailingIcon: [{
            type: Input
        }], leadingIcon: [{
            type: Input
        }], min: [{
            type: Input
        }], pattern: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], formControl: [{
            type: Input
        }], textMask: [{
            type: Input
        }], prefix: [{
            type: Input
        }], trim: [{
            type: Input
        }], withClearButton: [{
            type: Input
        }] }); })();

class TextMaskConfig {
}
const MASKEDINPUT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextMaskDirective),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 */
function _isAndroid() {
    const userAgent = ɵgetDOM() ? ɵgetDOM().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
class TextMaskDirective {
    constructor(_renderer, _elementRef, _compositionMode) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.textMaskConfig = {
            mask: [],
            guide: true,
            placeholderChar: '_',
            pipe: undefined,
            keepCharPositions: false,
        };
        this.valueChange = new EventEmitter();
        /** Whether the user is creating a composition string (IME events). */
        this._composing = false;
        this.onChange = (_) => {
        };
        this.onTouched = () => {
        };
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    ngOnChanges(changes) {
        this._setupMask(true);
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(this.inputElement.value);
        }
    }
    writeValue(value) {
        this._setupMask();
        // set the initial value for cases where the mask is disabled
        const normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this.inputElement, 'value', normalizedValue);
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(value);
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    }
    _handleInput(value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this._setupMask();
            if (this.textMaskInputElement !== undefined) {
                this.textMaskInputElement.update(value);
                // get the updated value
                value = this.inputElement.value;
                this.onChange(value);
                this.valueChange.emit(value);
            }
        }
    }
    _setupMask(create = false) {
        if (!this.inputElement) {
            if (this._elementRef.nativeElement.tagName.toUpperCase() === 'INPUT') {
                // `textMask` directive is used directly on an input element
                this.inputElement = this._elementRef.nativeElement;
            }
            else {
                // `textMask` directive is used on an abstracted input element, `md-input-container`, etc
                this.inputElement = this._elementRef.nativeElement.getElementsByTagName('INPUT')[0];
            }
        }
        if (this.inputElement && create) {
            this.textMaskInputElement = createTextMaskInputElement(Object.assign({ inputElement: this.inputElement }, this.textMaskConfig));
        }
    }
    _compositionStart() {
        this._composing = true;
    }
    _compositionEnd(value) {
        this._composing = false;
        this._compositionMode && this._handleInput(value);
    }
}
TextMaskDirective.ɵfac = function TextMaskDirective_Factory(t) { return new (t || TextMaskDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(COMPOSITION_BUFFER_MODE, 8)); };
TextMaskDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TextMaskDirective, selectors: [["", "mtgTextMask", ""]], hostBindings: function TextMaskDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function TextMaskDirective_input_HostBindingHandler($event) { return ctx._handleInput($event.target.value); })("blur", function TextMaskDirective_blur_HostBindingHandler() { return ctx.onTouched(); })("compositionstart", function TextMaskDirective_compositionstart_HostBindingHandler() { return ctx._compositionStart(); })("compositionend", function TextMaskDirective_compositionend_HostBindingHandler($event) { return ctx._compositionEnd($event.target.value); });
    } }, inputs: { textMaskConfig: ["mtgTextMask", "textMaskConfig"] }, outputs: { valueChange: "valueChange" }, exportAs: ["textMask"], features: [ɵngcc0.ɵɵProvidersFeature([MASKEDINPUT_VALUE_ACCESSOR]), ɵngcc0.ɵɵNgOnChangesFeature] });
TextMaskDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: Boolean, decorators: [{ type: Optional }, { type: Inject, args: [COMPOSITION_BUFFER_MODE,] }] }
];
TextMaskDirective.propDecorators = {
    textMaskConfig: [{ type: Input, args: ['mtgTextMask',] }],
    valueChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextMaskDirective, [{
        type: Directive,
        args: [{
                host: {
                    '(input)': '_handleInput($event.target.value)',
                    '(blur)': 'onTouched()',
                    '(compositionstart)': '_compositionStart()',
                    '(compositionend)': '_compositionEnd($event.target.value)'
                },
                selector: '[mtgTextMask]',
                exportAs: 'textMask',
                providers: [MASKEDINPUT_VALUE_ACCESSOR]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: Boolean, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [COMPOSITION_BUFFER_MODE]
            }] }]; }, { textMaskConfig: [{
            type: Input,
            args: ['mtgTextMask']
        }], valueChange: [{
            type: Output
        }] }); })();

class TextFieldModule {
}
TextFieldModule.ɵfac = function TextFieldModule_Factory(t) { return new (t || TextFieldModule)(); };
TextFieldModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TextFieldModule });
TextFieldModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule, SvgIconModule, LocalizationModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextFieldModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, SvgIconModule, LocalizationModule],
                declarations: [TextFieldComponent, TextMaskDirective],
                exports: [TextFieldComponent, TextMaskDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TextFieldModule, { declarations: function () { return [TextFieldComponent, TextMaskDirective]; }, imports: function () { return [CommonModule, SvgIconModule, LocalizationModule]; }, exports: function () { return [TextFieldComponent, TextMaskDirective]; } }); })();

class DialogModule {
}
DialogModule.ɵfac = function DialogModule_Factory(t) { return new (t || DialogModule)(); };
DialogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DialogModule });
DialogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        DialogService,
    ], imports: [CommonModule,
        OverlayModule,
        ButtonModule,
        SvgIconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DialogModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    OverlayModule,
                    ButtonModule,
                    SvgIconModule
                ],
                declarations: [
                    DialogComponent,
                ],
                providers: [
                    DialogService,
                ],
                entryComponents: [
                    DialogComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DialogModule, { declarations: function () { return [DialogComponent]; }, imports: function () { return [CommonModule,
        OverlayModule, ButtonModule, SvgIconModule]; } }); })();

class ToastData {
}

class ToastRef {
    constructor(overlay) {
        this.overlay = overlay;
    }
    close() {
        this.overlay.detach();
        setTimeout(() => {
            this.overlay.dispose();
        }, 300);
    }
    isVisible() {
        return this.overlay && this.overlay.overlayElement;
    }
    getPosition() {
        return this.overlay.overlayElement.getBoundingClientRect();
    }
    updatePosition(strategy) {
        this.overlay.updatePositionStrategy(strategy);
    }
}

class ToastComponent {
    constructor(data, ref, cdr) {
        this.data = data;
        this.ref = ref;
        this.cdr = cdr;
    }
    ngOnInit() {
        this.cdr.markForCheck();
        setTimeout(() => {
            this.close();
        }, this.data.duration || 5000);
    }
    close() {
        this.ref.close();
        this.cdr.markForCheck();
    }
}
ToastComponent.ɵfac = function ToastComponent_Factory(t) { return new (t || ToastComponent)(ɵngcc0.ɵɵdirectiveInject(ToastData), ɵngcc0.ɵɵdirectiveInject(ToastRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ToastComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToastComponent, selectors: [["mtg-toast"]], hostVars: 1, hostBindings: function ToastComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@openClose", ctx.true);
    } }, decls: 5, vars: 5, consts: [[4, "ngIf"], ["href", "javascript:;", 1, "close", 3, "click"], ["icon", "icons-close", 1, "icon-close"]], template: function ToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵtemplate(2, ToastComponent_ng_container_2_Template, 2, 0, "ng-container", 0);
        ɵngcc0.ɵɵelementStart(3, "a", 1);
        ɵngcc0.ɵɵlistener("click", function ToastComponent_Template_a_click_3_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelement(4, "mtg-svg-icon", 2);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("toast ", ctx.data.type, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.data.text, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.type === "success");
    } }, dependencies: [ɵngcc1.NgIf, SvgIconComponent], encapsulation: 2, data: { animation: [
            trigger('openClose', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('0.3s ease-in', style({ opacity: 1 }))
                ]),
                transition(':leave', [
                    style({ opacity: 1 }),
                    animate('0.3s ease-out', style({ opacity: 0 }))
                ])
            ])
        ] }, changeDetection: 0 });
ToastComponent.ctorParameters = () => [
    { type: ToastData },
    { type: ToastRef },
    { type: ChangeDetectorRef }
];
ToastComponent.propDecorators = {
    true: [{ type: HostBinding, args: ['@openClose',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-toast',
                template: "<div class=\"toast {{ data.type }}\">\n  {{ data.text }}<ng-container *ngIf=\"data.type === 'success'\"> \uD83D\uDC4D</ng-container>\n  <a href=\"javascript:;\" class=\"close\" (click)=\"close()\"><mtg-svg-icon icon=\"icons-close\" class=\"icon-close\"></mtg-svg-icon></a>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                animations: [
                    trigger('openClose', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            animate('0.3s ease-in', style({ opacity: 1 }))
                        ]),
                        transition(':leave', [
                            style({ opacity: 1 }),
                            animate('0.3s ease-out', style({ opacity: 0 }))
                        ])
                    ])
                ]
            }]
    }], function () { return [{ type: ToastData }, { type: ToastRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { true: [{
            type: HostBinding,
            args: ['@openClose']
        }] }); })();

class ToastService {
    constructor(overlay, parentInjector) {
        this.overlay = overlay;
        this.parentInjector = parentInjector;
        this.toasts = [];
    }
    success(text) {
        return this.show({ type: 'success', text });
    }
    danger(text) {
        return this.show({ type: 'danger', text });
    }
    info(text) {
        return this.show({ type: 'info', text });
    }
    show(data) {
        const positionStrategy = this.getPositionStrategy(this.lastToast);
        const overlayRef = this.overlay.create({ positionStrategy });
        const toastRef = new ToastRef(overlayRef);
        this.toasts.push(toastRef);
        const injector = this.getInjector(data, toastRef, this.parentInjector);
        const toastPortal = new ComponentPortal(ToastComponent, null, injector);
        overlayRef.attach(toastPortal);
        overlayRef.detachments().subscribe(() => {
            setTimeout(() => {
                this.toasts.splice(this.toasts.indexOf(toastRef), 1);
                if (this.toasts.length === 0) {
                    return;
                }
                let previousToast = null;
                for (const toast of this.toasts) {
                    toast.updatePosition(this.getPositionStrategy(previousToast));
                    previousToast = toast;
                }
            }, 100);
        });
        if (this.toasts.length > 3) {
            for (const toast of this.toasts.slice(0, -3)) {
                toast.close();
            }
        }
        return toastRef;
    }
    getPositionStrategy(lastToast) {
        if (lastToast && lastToast.isVisible()) {
            if (lastToast.getPosition().top <= 0)
                return;
            return this.overlay.position()
                .global()
                .top(this.getPosition(lastToast))
                .centerHorizontally();
        }
        else {
            return this.overlay.position()
                .global()
                .bottom('40px')
                .centerHorizontally();
        }
    }
    getPosition(lastToast) {
        const lastToastIsVisible = lastToast && lastToast.isVisible();
        const position = lastToastIsVisible
            ? lastToast.getPosition().top - lastToast.getPosition().height
            : '0';
        return position + 'px';
    }
    get lastToast() {
        return this.toasts.length && this.toasts[this.toasts.length - 1];
    }
    getInjector(data, toastRef, parentInjector) {
        const tokens = new WeakMap();
        tokens.set(ToastData, data);
        tokens.set(ToastRef, toastRef);
        return new PortalInjector(parentInjector, tokens);
    }
}
ToastService.ɵfac = function ToastService_Factory(t) { return new (t || ToastService)(ɵngcc0.ɵɵinject(ɵngcc2.Overlay), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
ToastService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(i0.ɵɵinject(i1.Overlay), i0.ɵɵinject(i0.INJECTOR)); }, token: ToastService, providedIn: "root" });
ToastService.ctorParameters = () => [
    { type: Overlay },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.Overlay }, { type: ɵngcc0.Injector }]; }, null); })();

class ToastModule {
}
ToastModule.ɵfac = function ToastModule_Factory(t) { return new (t || ToastModule)(); };
ToastModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ToastModule });
ToastModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        ToastService
    ], imports: [CommonModule,
        SvgIconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SvgIconModule
                ],
                declarations: [
                    ToastComponent
                ],
                providers: [
                    ToastService
                ],
                entryComponents: [
                    ToastComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ToastModule, { declarations: function () { return [ToastComponent]; }, imports: function () { return [CommonModule, SvgIconModule]; } }); })();

class DataSliderItemComponent {
    constructor() {
        this.defaultClass = true;
    }
}
DataSliderItemComponent.ɵfac = function DataSliderItemComponent_Factory(t) { return new (t || DataSliderItemComponent)(); };
DataSliderItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DataSliderItemComponent, selectors: [["mtg-data-slider-item"]], hostVars: 2, hostBindings: function DataSliderItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("data-slider-item", ctx.defaultClass);
    } }, ngContentSelectors: _c2, decls: 1, vars: 0, template: function DataSliderItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
DataSliderItemComponent.propDecorators = {
    defaultClass: [{ type: HostBinding, args: ['class.data-slider-item',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataSliderItemComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-data-slider-item',
                template: '<ng-content></ng-content>',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.data-slider-item']
        }] }); })();

class DataSliderComponent {
    constructor(renderer, cdr, platformId) {
        this.renderer = renderer;
        this.cdr = cdr;
        this.platformId = platformId;
        this.arrowVisible = true;
        this.subscriptions = [];
        this.scrolledToEnd = new EventEmitter();
        this.scrolledToStart = new EventEmitter();
    }
    get defaultClass() {
        return true;
    }
    get rightShadow() {
        return this.canScrollRight || this.loading;
    }
    get leftShadow() {
        return this.canScrollLeft || this.loading;
    }
    get isTouch() {
        if (isPlatformBrowser(this.platformId)) {
            return isTouchDevice();
        }
        return false;
    }
    get isScrollLocked() {
        return this.loading;
    }
    ngAfterViewInit() {
        this.initializeSlider();
    }
    ngOnDestroy() {
        for (const unsubscribe of this.subscriptions) {
            unsubscribe();
        }
    }
    initializeSlider() {
        setTimeout(() => {
            this.checkSliderWidth();
            this.checkScroll(false);
        });
        this.slides.changes.subscribe(slides => {
            setTimeout(() => {
                this.checkSliderWidth();
                this.checkScroll(false);
            });
        });
        this.subscriptions.push(this.renderer.listen('window', 'resize', () => {
            this.checkSliderWidth();
            this.checkScroll(false);
        }));
        this.subscriptions.push(this.renderer.listen(this.content.nativeElement, 'scroll', () => {
            this.checkScroll();
        }));
    }
    checkSliderWidth() {
        this.showArrows = this.content.nativeElement.scrollWidth > this.slider.nativeElement.clientWidth;
        if (!this.showArrows) {
            this.scrolledToEnd.emit();
        }
        this.cdr.markForCheck();
    }
    slideLeft() {
        if (!this.canScrollLeft || this.loading) {
            return;
        }
        let scrollWidth = this.content.nativeElement.scrollLeft - this.slider.nativeElement.clientWidth / 2;
        if (scrollWidth < 0) {
            scrollWidth = 0;
        }
        this.content.nativeElement.scroll({ left: scrollWidth, top: 0, behavior: 'smooth' });
    }
    slideRight() {
        if (!this.canScrollRight || this.loading) {
            return;
        }
        let scrollWidth = this.content.nativeElement.scrollLeft + this.slider.nativeElement.clientWidth / 2;
        if (scrollWidth > this.content.nativeElement.scrollWidth) {
            scrollWidth = this.content.nativeElement.scrollWidth;
        }
        this.content.nativeElement.scroll({ left: scrollWidth, top: 0, behavior: 'smooth' });
    }
    correctScroll(slidesCount, repeat) {
        const slide = this.slides.toArray()[slidesCount];
        if (!slide) {
            return;
        }
        const scrollWidth = this.content.nativeElement.scrollLeft + slide.nativeElement.offsetLeft;
        this.content.nativeElement.scroll({ left: scrollWidth });
    }
    scrollToSlide(slideIndex) {
        const slide = this.slides.toArray()[slideIndex];
        if (!slide) {
            return;
        }
        this.content.nativeElement.scrollLeft = slide.nativeElement.offsetLeft;
    }
    checkScroll(emitEvent = true) {
        const scrollWidth = this.content.nativeElement.scrollWidth - this.content.nativeElement.scrollLeft;
        this.canScrollRight = scrollWidth > this.content.nativeElement.clientWidth;
        this.canScrollLeft = this.content.nativeElement.scrollLeft > 0;
        const scrollCheck = 10;
        if (emitEvent && (scrollWidth - scrollCheck) <= this.content.nativeElement.clientWidth && this.canScrollLeft) {
            this.scrolledToEnd.emit();
        }
        if (emitEvent && this.content.nativeElement.scrollLeft < scrollCheck) {
            this.scrolledToStart.emit();
        }
        this.cdr.markForCheck();
    }
}
DataSliderComponent.ɵfac = function DataSliderComponent_Factory(t) { return new (t || DataSliderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
DataSliderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DataSliderComponent, selectors: [["mtg-data-slider"]], contentQueries: function DataSliderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DataSliderItemComponent, 4, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.slides = _t);
    } }, viewQuery: function DataSliderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c4, 5);
        ɵngcc0.ɵɵviewQuery(_c12, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.slider = _t.first);
    } }, hostVars: 10, hostBindings: function DataSliderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("data-slider", ctx.defaultClass)("right-shadow", ctx.rightShadow)("left-shadow", ctx.leftShadow)("touch", ctx.isTouch)("lock-scroll", ctx.isScrollLocked);
    } }, inputs: { arrowVisible: "arrowVisible", loading: "loading", arrowInside: "arrowInside" }, outputs: { scrolledToEnd: "scrolledToEnd", scrolledToStart: "scrolledToStart" }, ngContentSelectors: _c2, decls: 8, vars: 1, consts: [["class", "navigation", 3, "ngClass", 4, "ngIf"], [1, "wrapper"], ["slider", ""], [1, "content"], ["content", ""], [1, "mobile-spacing"], [1, "navigation", 3, "ngClass"], ["variant", "circle", "color", "secondary", "class", "left", 3, "click", 4, "ngIf"], ["variant", "circle", "color", "secondary", "class", "right", 3, "click", 4, "ngIf"], ["variant", "circle", "color", "secondary", 1, "left", 3, "click"], ["icon", "icons-corner-left"], ["variant", "circle", "color", "secondary", 1, "right", 3, "click"], ["icon", "icons-corner-right"]], template: function DataSliderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DataSliderComponent_div_0_Template, 3, 5, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2)(3, "div", 3, 4);
        ɵngcc0.ɵɵelement(5, "div", 5);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelement(7, "div", 5);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showArrows && ctx.arrowVisible);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, SvgIconComponent, ButtonComponent], encapsulation: 2, changeDetection: 0 });
DataSliderComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
DataSliderComponent.propDecorators = {
    loading: [{ type: Input }],
    arrowVisible: [{ type: Input }],
    arrowInside: [{ type: Input }],
    content: [{ type: ViewChild, args: ['content',] }],
    slider: [{ type: ViewChild, args: ['slider',] }],
    slides: [{ type: ContentChildren, args: [DataSliderItemComponent, { read: ElementRef },] }],
    defaultClass: [{ type: HostBinding, args: ['class.data-slider',] }],
    rightShadow: [{ type: HostBinding, args: ['class.right-shadow',] }],
    leftShadow: [{ type: HostBinding, args: ['class.left-shadow',] }],
    isTouch: [{ type: HostBinding, args: ['class.touch',] }],
    isScrollLocked: [{ type: HostBinding, args: ['class.lock-scroll',] }],
    scrolledToEnd: [{ type: Output }],
    scrolledToStart: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataSliderComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-data-slider',
                template: "<div class=\"navigation\" *ngIf=\"showArrows && arrowVisible\" [ngClass]=\"{inside: arrowInside}\">\n  <mtg-button variant=\"circle\" color=\"secondary\" class=\"left\" *ngIf=\"canScrollLeft\" (click)=\"slideLeft()\">\n    <mtg-svg-icon icon=\"icons-corner-left\"></mtg-svg-icon>\n  </mtg-button>\n  <mtg-button variant=\"circle\" color=\"secondary\" class=\"right\" *ngIf=\"canScrollRight\" (click)=\"slideRight()\">\n    <mtg-svg-icon icon=\"icons-corner-right\"></mtg-svg-icon>\n  </mtg-button>\n</div>\n<div class=\"wrapper\" #slider>\n  <div class=\"content\" #content>\n    <div class=\"mobile-spacing\"></div>\n    <ng-content></ng-content>\n    <div class=\"mobile-spacing\"></div>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { arrowVisible: [{
            type: Input
        }], scrolledToEnd: [{
            type: Output
        }], scrolledToStart: [{
            type: Output
        }], defaultClass: [{
            type: HostBinding,
            args: ['class.data-slider']
        }], rightShadow: [{
            type: HostBinding,
            args: ['class.right-shadow']
        }], leftShadow: [{
            type: HostBinding,
            args: ['class.left-shadow']
        }], isTouch: [{
            type: HostBinding,
            args: ['class.touch']
        }], isScrollLocked: [{
            type: HostBinding,
            args: ['class.lock-scroll']
        }], loading: [{
            type: Input
        }], arrowInside: [{
            type: Input
        }], content: [{
            type: ViewChild,
            args: ['content']
        }], slider: [{
            type: ViewChild,
            args: ['slider']
        }], slides: [{
            type: ContentChildren,
            args: [DataSliderItemComponent, { read: ElementRef }]
        }] }); })();

class DataSliderModule {
}
DataSliderModule.ɵfac = function DataSliderModule_Factory(t) { return new (t || DataSliderModule)(); };
DataSliderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DataSliderModule });
DataSliderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        SvgIconModule,
        ButtonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DataSliderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SvgIconModule,
                    ButtonModule
                ],
                declarations: [
                    DataSliderComponent,
                    DataSliderItemComponent,
                ],
                exports: [
                    DataSliderComponent,
                    DataSliderItemComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DataSliderModule, { declarations: function () { return [DataSliderComponent, DataSliderItemComponent]; }, imports: function () { return [CommonModule, SvgIconModule, ButtonModule]; }, exports: function () { return [DataSliderComponent, DataSliderItemComponent]; } }); })();

class TableComponent {
    constructor(cdr, renderer2, platformId) {
        this.cdr = cdr;
        this.renderer2 = renderer2;
        this.platformId = platformId;
        this.defaultClass = true;
        this.small = false;
        this.bordered = true;
        this.withScroll = true;
        this.stickyTop = 0;
        this.subscriptions = [];
    }
    get smallClass() {
        return this.small;
    }
    get borderedClass() {
        return this.bordered;
    }
    get withScrollClass() {
        return this.withScroll;
    }
    get hasIdentityColClass() {
        return Boolean(this.hasIdentityCol);
    }
    ngAfterViewInit() {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.subscriptions.push(this.renderer2.listen(this.scroll.nativeElement, 'scroll', () => this.checkScroll()));
        this.subscriptions.push(this.renderer2.listen('window', 'resize', () => this.checkScroll()));
        setTimeout(() => {
            this.checkScroll();
        }, 100);
    }
    ngOnDestroy() {
        for (const unsubscribe of this.subscriptions) {
            unsubscribe();
        }
    }
    scrollLeft() {
        if (!this.canScrollLeft) {
            return;
        }
        let scrollWidth = this.scroll.nativeElement.scrollLeft - this.scroll.nativeElement.clientWidth / 2;
        if (scrollWidth < 10) {
            scrollWidth = 0;
        }
        this.scroll.nativeElement.scroll({ left: scrollWidth, top: 0, behavior: 'smooth' });
    }
    scrollRight() {
        if (!this.canScrollRight) {
            return;
        }
        let scrollWidth = this.scroll.nativeElement.scrollLeft + this.scroll.nativeElement.clientWidth / 2;
        if (scrollWidth > this.scroll.nativeElement.scrollWidth) {
            scrollWidth = this.scroll.nativeElement.scrollWidth;
        }
        this.scroll.nativeElement.scroll({ left: scrollWidth, top: 0, behavior: 'smooth' });
    }
    checkScroll() {
        const scrollWidth = this.scroll.nativeElement.scrollWidth - this.scroll.nativeElement.scrollLeft;
        this.canScrollRight = scrollWidth > this.scroll.nativeElement.clientWidth;
        this.canScrollLeft = this.scroll.nativeElement.scrollLeft > 0;
        this.cdr.markForCheck();
    }
}
TableComponent.ɵfac = function TableComponent_Factory(t) { return new (t || TableComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
TableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableComponent, selectors: [["mtg-table"]], viewQuery: function TableComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c14, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scroll = _t.first);
    } }, hostVars: 12, hostBindings: function TableComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("statistic-table", ctx.defaultClass)("statistic-table--small", ctx.smallClass)("statistic-table--bordered", ctx.borderedClass)("with-scroll", ctx.withScrollClass)("has-identity-col", ctx.hasIdentityColClass)("with-groups", ctx.withGroups);
    } }, inputs: { small: "small", bordered: "bordered", withScroll: "withScroll", stickyTop: "stickyTop", showScrollArrows: "showScrollArrows" }, ngContentSelectors: _c2, decls: 6, vars: 2, consts: [["cdk-scrollable", "", 1, "scroll-wrapper"], ["scroll", ""], [1, "content"], ["variant", "circle", "class", "scroll-left", "color", "secondary", "mtgSticky", "top", 3, "top", "click", 4, "ngIf"], ["variant", "circle", "class", "scroll-right", "color", "secondary", "mtgSticky", "top", 3, "top", "click", 4, "ngIf"], ["variant", "circle", "color", "secondary", "mtgSticky", "top", 1, "scroll-left", 3, "top", "click"], ["icon", "icons-corner-left"], ["variant", "circle", "color", "secondary", "mtgSticky", "top", 1, "scroll-right", 3, "top", "click"], ["icon", "icons-corner-right"]], template: function TableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵtemplate(4, TableComponent_mtg_button_4_Template, 2, 1, "mtg-button", 3);
        ɵngcc0.ɵɵtemplate(5, TableComponent_mtg_button_5_Template, 2, 1, "mtg-button", 4);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canScrollLeft && ctx.showScrollArrows);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.canScrollRight && ctx.showScrollArrows);
    } }, dependencies: [ɵngcc1.NgIf, StickyDirective, ButtonComponent, SvgIconComponent, ɵngcc6.CdkScrollable], encapsulation: 2, changeDetection: 0 });
TableComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: Renderer2 },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
TableComponent.propDecorators = {
    defaultClass: [{ type: HostBinding, args: ['class.statistic-table',] }],
    withGroups: [{ type: HostBinding, args: ['class.with-groups',] }],
    small: [{ type: Input }],
    bordered: [{ type: Input }],
    withScroll: [{ type: Input }],
    stickyTop: [{ type: Input }],
    showScrollArrows: [{ type: Input }],
    scroll: [{ type: ViewChild, args: ['scroll', { read: ElementRef },] }],
    smallClass: [{ type: HostBinding, args: ['class.statistic-table--small',] }],
    borderedClass: [{ type: HostBinding, args: ['class.statistic-table--bordered',] }],
    withScrollClass: [{ type: HostBinding, args: ['class.with-scroll',] }],
    hasIdentityColClass: [{ type: HostBinding, args: ['class.has-identity-col',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-table',
                template: "<div class=\"scroll-wrapper\" #scroll cdk-scrollable>\n  <div class=\"content\">\n    <ng-content></ng-content>\n    <mtg-button\n      *ngIf=\"canScrollLeft && showScrollArrows\"\n      variant=\"circle\"\n      class=\"scroll-left\"\n      color=\"secondary\"\n      (click)=\"scrollLeft()\"\n      mtgSticky=\"top\"\n      [top]=\"stickyTop\"\n    ><mtg-svg-icon icon=\"icons-corner-left\"></mtg-svg-icon></mtg-button>\n    <mtg-button\n      *ngIf=\"canScrollRight && showScrollArrows\"\n      variant=\"circle\"\n      class=\"scroll-right\"\n      color=\"secondary\"\n      (click)=\"scrollRight()\"\n      mtgSticky=\"top\"\n      [top]=\"stickyTop\"\n    ><mtg-svg-icon icon=\"icons-corner-right\"></mtg-svg-icon></mtg-button>\n  </div>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Renderer2 }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.statistic-table']
        }], small: [{
            type: Input
        }], bordered: [{
            type: Input
        }], withScroll: [{
            type: Input
        }], stickyTop: [{
            type: Input
        }], smallClass: [{
            type: HostBinding,
            args: ['class.statistic-table--small']
        }], borderedClass: [{
            type: HostBinding,
            args: ['class.statistic-table--bordered']
        }], withScrollClass: [{
            type: HostBinding,
            args: ['class.with-scroll']
        }], hasIdentityColClass: [{
            type: HostBinding,
            args: ['class.has-identity-col']
        }], withGroups: [{
            type: HostBinding,
            args: ['class.with-groups']
        }], showScrollArrows: [{
            type: Input
        }], scroll: [{
            type: ViewChild,
            args: ['scroll', { read: ElementRef }]
        }] }); })();

class TableRowComponent {
    constructor() {
        this.defaultClass = true;
    }
}
TableRowComponent.ɵfac = function TableRowComponent_Factory(t) { return new (t || TableRowComponent)(); };
TableRowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableRowComponent, selectors: [["mtg-table-row"]], hostVars: 2, hostBindings: function TableRowComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("table-row", ctx.defaultClass);
    } }, ngContentSelectors: _c2, decls: 1, vars: 0, template: function TableRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
TableRowComponent.propDecorators = {
    defaultClass: [{ type: HostBinding, args: ['class.table-row',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableRowComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-table-row',
                template: '<ng-content></ng-content>',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.table-row']
        }] }); })();

class TableHeaderRowComponent extends TableRowComponent {
    constructor() {
        super(...arguments);
        this.headerClass = true;
    }
}
TableHeaderRowComponent.ɵfac = /*@__PURE__*/ function () { let ɵTableHeaderRowComponent_BaseFactory; return function TableHeaderRowComponent_Factory(t) { return (ɵTableHeaderRowComponent_BaseFactory || (ɵTableHeaderRowComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TableHeaderRowComponent)))(t || TableHeaderRowComponent); }; }();
TableHeaderRowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableHeaderRowComponent, selectors: [["mtg-table-header-row"]], hostVars: 2, hostBindings: function TableHeaderRowComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("header", ctx.headerClass);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c2, decls: 1, vars: 0, template: function TableHeaderRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
TableHeaderRowComponent.propDecorators = {
    headerClass: [{ type: HostBinding, args: ['class.header',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableHeaderRowComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-table-header-row',
                template: '<ng-content></ng-content>',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], null, { headerClass: [{
            type: HostBinding,
            args: ['class.header']
        }] }); })();

class TableColComponent {
    constructor() {
        this.defaultClass = true;
    }
    get highlightClass() {
        return this.highlight;
    }
    get sortableClass() {
        return this.sortable;
    }
}
TableColComponent.ɵfac = function TableColComponent_Factory(t) { return new (t || TableColComponent)(); };
TableColComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableColComponent, selectors: [["mtg-table-col"]], hostVars: 6, hostBindings: function TableColComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("table-cell", ctx.defaultClass)("highlight", ctx.highlightClass)("sortable", ctx.sortableClass);
    } }, inputs: { highlight: "highlight", sortable: "sortable" }, ngContentSelectors: _c2, decls: 1, vars: 0, template: function TableColComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
TableColComponent.propDecorators = {
    defaultClass: [{ type: HostBinding, args: ['class.table-cell',] }],
    highlightClass: [{ type: HostBinding, args: ['class.highlight',] }],
    sortableClass: [{ type: HostBinding, args: ['class.sortable',] }],
    highlight: [{ type: Input }],
    sortable: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableColComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-table-col',
                template: '<ng-content></ng-content>',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.table-cell']
        }], highlightClass: [{
            type: HostBinding,
            args: ['class.highlight']
        }], sortableClass: [{
            type: HostBinding,
            args: ['class.sortable']
        }], highlight: [{
            type: Input
        }], sortable: [{
            type: Input
        }] }); })();

class TableIdentityColComponent extends TableColComponent {
    constructor(tableComponent) {
        super();
        this.tableComponent = tableComponent;
        this.identityClass = true;
        this.tableComponent.hasIdentityCol = true;
    }
}
TableIdentityColComponent.ɵfac = function TableIdentityColComponent_Factory(t) { return new (t || TableIdentityColComponent)(ɵngcc0.ɵɵdirectiveInject(TableComponent)); };
TableIdentityColComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableIdentityColComponent, selectors: [["mtg-table-identity-col"]], hostVars: 2, hostBindings: function TableIdentityColComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("identity", ctx.identityClass);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c2, decls: 1, vars: 0, template: function TableIdentityColComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
TableIdentityColComponent.ctorParameters = () => [
    { type: TableComponent }
];
TableIdentityColComponent.propDecorators = {
    identityClass: [{ type: HostBinding, args: ['class.identity',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableIdentityColComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-table-identity-col',
                template: '<ng-content></ng-content>',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: TableComponent }]; }, { identityClass: [{
            type: HostBinding,
            args: ['class.identity']
        }] }); })();

class TableSubtitleComponent {
    constructor() {
        this.defaultClass = true;
    }
}
TableSubtitleComponent.ɵfac = function TableSubtitleComponent_Factory(t) { return new (t || TableSubtitleComponent)(); };
TableSubtitleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableSubtitleComponent, selectors: [["mtg-table-subtitle"]], hostVars: 2, hostBindings: function TableSubtitleComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("subtitle", ctx.defaultClass);
    } }, ngContentSelectors: _c2, decls: 2, vars: 0, consts: [[1, "text"]], template: function TableSubtitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2, changeDetection: 0 });
TableSubtitleComponent.propDecorators = {
    defaultClass: [{ type: HostBinding, args: ['class.subtitle',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableSubtitleComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-table-subtitle',
                template: '<div class="text"><ng-content></ng-content></div>',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.subtitle']
        }] }); })();

class TableColGroupComponent {
    constructor(header, table) {
        this.header = header;
        this.table = table;
        table.withGroups = true;
    }
    get isHeader() {
        return this.header;
    }
    get isContent() {
        return !this.header;
    }
}
TableColGroupComponent.ɵfac = function TableColGroupComponent_Factory(t) { return new (t || TableColGroupComponent)(ɵngcc0.ɵɵdirectiveInject(TableHeaderRowComponent, 8), ɵngcc0.ɵɵdirectiveInject(TableComponent)); };
TableColGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TableColGroupComponent, selectors: [["mtg-table-col-group"]], hostVars: 4, hostBindings: function TableColGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("table-cell-group-header", ctx.isHeader)("table-cell-group", ctx.isContent);
    } }, inputs: { title: "title" }, ngContentSelectors: _c2, decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["content", ""], [1, "title"], [1, "table-cell-group"], [3, "ngTemplateOutlet"]], template: function TableColGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TableColGroupComponent_ng_container_0_Template, 5, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, TableColGroupComponent_ng_template_1_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.header)("ngIfElse", _r1);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2, changeDetection: 0 });
TableColGroupComponent.ctorParameters = () => [
    { type: TableHeaderRowComponent, decorators: [{ type: Optional }] },
    { type: TableComponent }
];
TableColGroupComponent.propDecorators = {
    title: [{ type: Input }],
    isHeader: [{ type: HostBinding, args: ['class.table-cell-group-header',] }],
    isContent: [{ type: HostBinding, args: ['class.table-cell-group',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableColGroupComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-table-col-group',
                template: "<ng-container *ngIf=\"header else content\">\n  <div class=\"title\">{{ title }}</div>\n  <div class=\"table-cell-group\">\n    <ng-container [ngTemplateOutlet]=\"content\"></ng-container>\n  </div>\n</ng-container>\n<ng-template #content>\n  <ng-content></ng-content>\n</ng-template>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: TableHeaderRowComponent, decorators: [{
                type: Optional
            }] }, { type: TableComponent }]; }, { isHeader: [{
            type: HostBinding,
            args: ['class.table-cell-group-header']
        }], isContent: [{
            type: HostBinding,
            args: ['class.table-cell-group']
        }], title: [{
            type: Input
        }] }); })();

class TableModule {
}
TableModule.ɵfac = function TableModule_Factory(t) { return new (t || TableModule)(); };
TableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TableModule });
TableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        UtilsModule,
        ButtonModule,
        SvgIconModule,
        CdkScrollableModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TableModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    UtilsModule,
                    ButtonModule,
                    SvgIconModule,
                    CdkScrollableModule,
                ],
                declarations: [
                    TableComponent,
                    TableRowComponent,
                    TableHeaderRowComponent,
                    TableColComponent,
                    TableIdentityColComponent,
                    TableSubtitleComponent,
                    TableColGroupComponent,
                ],
                exports: [
                    TableComponent,
                    TableRowComponent,
                    TableHeaderRowComponent,
                    TableColComponent,
                    TableIdentityColComponent,
                    TableSubtitleComponent,
                    TableColGroupComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TableModule, { declarations: function () { return [TableComponent, TableRowComponent, TableHeaderRowComponent, TableColComponent, TableIdentityColComponent, TableSubtitleComponent, TableColGroupComponent]; }, imports: function () { return [CommonModule, UtilsModule, ButtonModule, SvgIconModule, CdkScrollableModule]; }, exports: function () { return [TableComponent, TableRowComponent, TableHeaderRowComponent, TableColComponent, TableIdentityColComponent, TableSubtitleComponent, TableColGroupComponent]; } }); })();

class TooltipConfig {
}

class TooltipComponent {
    constructor(tooltipConfig) {
        this.tooltipConfig = tooltipConfig;
        this.defaultClass = true;
    }
    get sizeSm() {
        return this.tooltipConfig.size === 'sm';
    }
    get sizeMd() {
        return this.tooltipConfig.size === 'md' || !this.tooltipConfig.size;
    }
    get positionTop() {
        return this.tooltipConfig.position === 'top';
    }
    get positionBottom() {
        return this.tooltipConfig.position === 'bottom';
    }
    get positionStart() {
        return this.tooltipConfig.horizontalPosition === 'start';
    }
    get positionCenter() {
        return this.tooltipConfig.horizontalPosition === 'center';
    }
    get positionEnd() {
        return this.tooltipConfig.horizontalPosition === 'end';
    }
    get content() {
        if (typeof this.tooltipConfig.content === 'string') {
            return null;
        }
        return this.tooltipConfig.content;
    }
    get text() {
        if (typeof this.tooltipConfig.content !== 'string') {
            return null;
        }
        return this.tooltipConfig.content;
    }
}
TooltipComponent.ɵfac = function TooltipComponent_Factory(t) { return new (t || TooltipComponent)(ɵngcc0.ɵɵdirectiveInject(TooltipConfig)); };
TooltipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TooltipComponent, selectors: [["mtg-tooltip"]], hostVars: 16, hostBindings: function TooltipComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("tooltip", ctx.defaultClass)("tooltip--size-sm", ctx.sizeSm)("tooltip--size-md", ctx.sizeMd)("tooltip--position-top", ctx.positionTop)("tooltip--position-bottom", ctx.positionBottom)("tooltip--position-start", ctx.positionStart)("tooltip--position-center", ctx.positionCenter)("tooltip--position-end", ctx.positionEnd);
    } }, ngContentSelectors: _c2, decls: 2, vars: 2, consts: [[4, "ngIf"], [4, "ngTemplateOutlet"]], template: function TooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TooltipComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, TooltipComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.content);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.text);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2, changeDetection: 0 });
TooltipComponent.ctorParameters = () => [
    { type: TooltipConfig }
];
TooltipComponent.propDecorators = {
    defaultClass: [{ type: HostBinding, args: ['class.tooltip',] }],
    sizeSm: [{ type: HostBinding, args: ['class.tooltip--size-sm',] }],
    sizeMd: [{ type: HostBinding, args: ['class.tooltip--size-md',] }],
    positionTop: [{ type: HostBinding, args: ['class.tooltip--position-top',] }],
    positionBottom: [{ type: HostBinding, args: ['class.tooltip--position-bottom',] }],
    positionStart: [{ type: HostBinding, args: ['class.tooltip--position-start',] }],
    positionCenter: [{ type: HostBinding, args: ['class.tooltip--position-center',] }],
    positionEnd: [{ type: HostBinding, args: ['class.tooltip--position-end',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-tooltip',
                template: "<ng-container *ngIf=\"content\">\n  <ng-content *ngTemplateOutlet=\"content\"></ng-content>\n</ng-container>\n<ng-container *ngIf=\"text\">{{ text }}</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: TooltipConfig }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.tooltip']
        }], sizeSm: [{
            type: HostBinding,
            args: ['class.tooltip--size-sm']
        }], sizeMd: [{
            type: HostBinding,
            args: ['class.tooltip--size-md']
        }], positionTop: [{
            type: HostBinding,
            args: ['class.tooltip--position-top']
        }], positionBottom: [{
            type: HostBinding,
            args: ['class.tooltip--position-bottom']
        }], positionStart: [{
            type: HostBinding,
            args: ['class.tooltip--position-start']
        }], positionCenter: [{
            type: HostBinding,
            args: ['class.tooltip--position-center']
        }], positionEnd: [{
            type: HostBinding,
            args: ['class.tooltip--position-end']
        }] }); })();

class TooltipDirective {
    constructor(overlay, renderer, elementRef, injector) {
        this.overlay = overlay;
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.injector = injector;
        this.subscriptions = [];
        this.trigger = 'hover';
        this.position = 'top';
        // tslint:disable-next-line:no-input-rename
        this.horizontalPosition = 'center';
    }
    set isVisible(visible) {
        if (visible) {
            this.showTooltip();
        }
        else {
            this.hideTooltip();
        }
    }
    ngAfterViewInit() {
        if (this.trigger === 'click') {
            this.subscriptions.push(this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
                if (this.overlayRef) {
                    this.hideTooltip();
                }
                else {
                    this.showTooltip();
                }
            }));
        }
        if (this.trigger === 'hover') {
            this.subscriptions.push(this.renderer.listen(this.elementRef.nativeElement, 'mouseover', (event) => {
                this.showTooltip();
            }));
            this.subscriptions.push(this.renderer.listen(this.elementRef.nativeElement, 'mouseout', (event) => {
                this.hideTooltip();
            }));
        }
    }
    ngOnDestroy() {
        for (const unsubscribe of this.subscriptions) {
            unsubscribe();
        }
        this.hideTooltip();
    }
    showTooltip() {
        if (this.overlayRef || this.disabled) {
            return;
        }
        this.overlayRef = this.overlay.create({
            positionStrategy: this.getPositionStrategy(),
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            panelClass: 'cdk-overlay-tooltip'
        });
        const weekmap = new WeakMap();
        const config = new TooltipConfig();
        config.content = this.content;
        config.position = this.position;
        config.horizontalPosition = this.horizontalPosition;
        config.size = this.size;
        weekmap.set(TooltipConfig, config);
        const injector = new PortalInjector(this.injector, weekmap);
        const componentPortal = new ComponentPortal(TooltipComponent, null, injector);
        this.overlayRef.attach(componentPortal);
    }
    hideTooltip() {
        if (!this.overlayRef) {
            return;
        }
        this.overlayRef.dispose();
        this.overlayRef = null;
    }
    getPositionStrategy() {
        const positions = [];
        if (this.position === 'top') {
            positions.push({
                originX: this.horizontalPosition,
                originY: 'top',
                overlayX: this.horizontalPosition,
                overlayY: 'bottom'
            });
            positions.push({
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom'
            });
            positions.push({
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'bottom'
            });
        }
        if (this.position === 'bottom') {
            positions.push({
                originX: this.horizontalPosition,
                originY: 'bottom',
                overlayX: this.horizontalPosition,
                overlayY: 'top'
            });
        }
        return this.overlay.position()
            .flexibleConnectedTo(this.elementRef.nativeElement)
            .withFlexibleDimensions(false)
            .withPush(false)
            .withPositions(positions);
    }
}
TooltipDirective.ɵfac = function TooltipDirective_Factory(t) { return new (t || TooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
TooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TooltipDirective, selectors: [["", "mtgTooltip", ""]], inputs: { trigger: ["mtgTooltipTrigger", "trigger"], position: ["mtgTooltipPosition", "position"], horizontalPosition: ["mtgTooltipHorizontalPosition", "horizontalPosition"], isVisible: ["mtgTooltipVisible", "isVisible"], content: ["mtgTooltip", "content"], size: ["mtgTooltipSize", "size"], disabled: ["mtgTooltipDisabled", "disabled"] } });
TooltipDirective.ctorParameters = () => [
    { type: Overlay },
    { type: Renderer2 },
    { type: ElementRef },
    { type: Injector }
];
TooltipDirective.propDecorators = {
    content: [{ type: Input, args: ['mtgTooltip',] }],
    trigger: [{ type: Input, args: ['mtgTooltipTrigger',] }],
    position: [{ type: Input, args: ['mtgTooltipPosition',] }],
    horizontalPosition: [{ type: Input, args: ['mtgTooltipHorizontalPosition',] }],
    size: [{ type: Input, args: ['mtgTooltipSize',] }],
    isVisible: [{ type: Input, args: ['mtgTooltipVisible',] }],
    disabled: [{ type: Input, args: ['mtgTooltipDisabled',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[mtgTooltip]'
            }]
    }], function () { return [{ type: ɵngcc2.Overlay }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Injector }]; }, { trigger: [{
            type: Input,
            args: ['mtgTooltipTrigger']
        }], position: [{
            type: Input,
            args: ['mtgTooltipPosition']
        }], horizontalPosition: [{
            type: Input,
            args: ['mtgTooltipHorizontalPosition']
        }], isVisible: [{
            type: Input,
            args: ['mtgTooltipVisible']
        }], content: [{
            type: Input,
            args: ['mtgTooltip']
        }], size: [{
            type: Input,
            args: ['mtgTooltipSize']
        }], disabled: [{
            type: Input,
            args: ['mtgTooltipDisabled']
        }] }); })();

class TooltipModule {
}
TooltipModule.ɵfac = function TooltipModule_Factory(t) { return new (t || TooltipModule)(); };
TooltipModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TooltipModule });
TooltipModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        OverlayModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    OverlayModule
                ],
                declarations: [
                    TooltipComponent,
                    TooltipDirective
                ],
                exports: [
                    TooltipComponent,
                    TooltipDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TooltipModule, { declarations: function () { return [TooltipComponent, TooltipDirective]; }, imports: function () { return [CommonModule,
        OverlayModule]; }, exports: function () { return [TooltipComponent, TooltipDirective]; } }); })();

const resourcesRegistry = new Map();
function loadScript(url) {
    return new Promise((resolve, reject) => {
        if (!url) {
            reject();
        }
        if (resourcesRegistry.has(url)) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = url;
        script.type = 'text/javascript';
        script.async = true;
        script.onerror = reject;
        script.onload = () => {
            resourcesRegistry.set(url, script);
            resolve();
        };
        document.head.appendChild(script);
    });
}

class RecaptchaService {
    constructor(localizationService) {
        this.localizationService = localizationService;
    }
    load() {
        if (!this.loadedSubject) {
            this.loadedSubject = new ReplaySubject(1);
            window.recaptchaLoaded = () => {
                this.loadedSubject.next(true);
            };
            const lang = this.localizationService.getLocale() === Locales.en ? 'en' : 'ru';
            loadScript(`https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit&hl=${lang}`);
        }
        return this.loadedSubject;
    }
}
RecaptchaService.ɵfac = function RecaptchaService_Factory(t) { return new (t || RecaptchaService)(ɵngcc0.ɵɵinject(LocalizationService)); };
RecaptchaService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: RecaptchaService, factory: RecaptchaService.ɵfac });
RecaptchaService.ctorParameters = () => [
    { type: LocalizationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RecaptchaService, [{
        type: Injectable
    }], function () { return [{ type: LocalizationService }]; }, null); })();

const RECAPTCHA_KEY = 'mtg-recaptcha-key';
class RecaptchaComponent {
    constructor(recaptchaService, elementRef, recaptchaKey, platformId) {
        this.recaptchaService = recaptchaService;
        this.elementRef = elementRef;
        this.recaptchaKey = recaptchaKey;
        this.platformId = platformId;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    ngOnInit() {
        if (!this.isBrowser) {
            return;
        }
        this.recaptchaService.load().subscribe(() => {
            window.grecaptcha.render(this.elementRef.nativeElement, {
                sitekey: this.recaptchaKey,
                callback: this.callback.bind(this),
                size: window.innerWidth < 700 ? 'compact' : 'normal',
                theme: 'dark',
            });
        });
    }
    callback(value) {
        this.value = value;
        if (this._onTouchFunc) {
            this._onTouchFunc();
        }
        if (this._onChangeFunc) {
            this._onChangeFunc(value);
        }
    }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnTouched(fn) {
        this._onTouchFunc = fn;
    }
    registerOnChange(fn) {
        this._onChangeFunc = fn;
    }
}
RecaptchaComponent.ɵfac = function RecaptchaComponent_Factory(t) { return new (t || RecaptchaComponent)(ɵngcc0.ɵɵdirectiveInject(RecaptchaService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(RECAPTCHA_KEY, 8), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
RecaptchaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RecaptchaComponent, selectors: [["mtg-recaptcha"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => RecaptchaComponent),
                multi: true
            }
        ])], decls: 0, vars: 0, template: function RecaptchaComponent_Template(rf, ctx) { }, encapsulation: 2 });
RecaptchaComponent.ctorParameters = () => [
    { type: RecaptchaService },
    { type: ElementRef },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [RECAPTCHA_KEY,] }] },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RecaptchaComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-recaptcha',
                template: '',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => RecaptchaComponent),
                        multi: true
                    }
                ]
            }]
    }], function () { return [{ type: RecaptchaService }, { type: ɵngcc0.ElementRef }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RECAPTCHA_KEY]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

class RecaptchaModule {
}
RecaptchaModule.ɵfac = function RecaptchaModule_Factory(t) { return new (t || RecaptchaModule)(); };
RecaptchaModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RecaptchaModule });
RecaptchaModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        RecaptchaService,
    ], imports: [CommonModule,
        UtilsModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RecaptchaModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    UtilsModule,
                ],
                declarations: [
                    RecaptchaComponent,
                ],
                providers: [
                    RecaptchaService,
                ],
                exports: [
                    RecaptchaComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RecaptchaModule, { declarations: function () { return [RecaptchaComponent]; }, imports: function () { return [CommonModule, UtilsModule]; }, exports: function () { return [RecaptchaComponent]; } }); })();

function shareVK(url) {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    window.open(`https://vk.com/share.php?url=${url}`, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
}
function shareFB(url) {
    const width = 600;
    const height = 400;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    window.open(`https://www.facebook.com/dialog/share?app_id=164936710911531&display=popup&href=${url}`, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
}
const copyToClipboard = str => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};

var shareLocalization = {
    [Locales.ru]: {
        vk: 'ВКонтакте',
        link: 'Ссылка',
        linkCopied: 'Ссылка скопирована',
    },
    [Locales.en]: {
        vk: 'VKontakte',
        link: 'Link',
        linkCopied: 'Link copied',
    }
};

class ShareComponent {
    constructor(toastService, localizationService) {
        this.toastService = toastService;
        this.localizationService = localizationService;
        this.variant = 'icon';
        this.localization = shareLocalization[this.localizationService.getLocale()];
    }
    shareVk() {
        shareVK(this.url);
    }
    shareFb() {
        shareFB(this.url);
    }
    copyLink() {
        copyToClipboard(this.url);
        this.toastService.success(this.localization.linkCopied);
    }
}
ShareComponent.ɵfac = function ShareComponent_Factory(t) { return new (t || ShareComponent)(ɵngcc0.ɵɵdirectiveInject(ToastService), ɵngcc0.ɵɵdirectiveInject(LocalizationService)); };
ShareComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ShareComponent, selectors: [["mtg-share"]], inputs: { variant: "variant", url: "url" }, decls: 10, vars: 4, consts: [["color", "secondary", "variant", "circle", 3, "mtgDropdownTriggerFor", 4, "ngIf"], ["class", "share-icon-trigger", "icon", "icons-share", 3, "mtgDropdownTriggerFor", 4, "ngIf"], ["share", ""], [1, "share-popup__menu-item", 3, "click"], ["icon", "icons-vkontakte"], ["icon", "icons-link"], ["color", "secondary", "variant", "circle", 3, "mtgDropdownTriggerFor"], ["icon", "icons-share"], ["icon", "icons-share", 1, "share-icon-trigger", 3, "mtgDropdownTriggerFor"]], template: function ShareComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ShareComponent_mtg_button_0_Template, 2, 1, "mtg-button", 0);
        ɵngcc0.ɵɵtemplate(1, ShareComponent_mtg_svg_icon_1_Template, 1, 1, "mtg-svg-icon", 1);
        ɵngcc0.ɵɵelementStart(2, "mtg-dropdown-menu", null, 2)(4, "mtg-dropdown-item", 3);
        ɵngcc0.ɵɵlistener("click", function ShareComponent_Template_mtg_dropdown_item_click_4_listener() { return ctx.shareVk(); });
        ɵngcc0.ɵɵelement(5, "mtg-svg-icon", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "mtg-dropdown-item", 3);
        ɵngcc0.ɵɵlistener("click", function ShareComponent_Template_mtg_dropdown_item_click_7_listener() { return ctx.copyLink(); });
        ɵngcc0.ɵɵelement(8, "mtg-svg-icon", 5);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.variant === "button");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.variant === "icon");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.localization.vk, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.localization.link, " ");
    } }, dependencies: [ɵngcc1.NgIf, SvgIconComponent, DropdownMenuComponent, DropdownItemComponent, DropdownTriggerDirective, ButtonComponent], encapsulation: 2, changeDetection: 0 });
ShareComponent.ctorParameters = () => [
    { type: ToastService },
    { type: LocalizationService }
];
ShareComponent.propDecorators = {
    url: [{ type: Input }],
    variant: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShareComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-share',
                template: "<mtg-button color=\"secondary\" variant=\"circle\" [mtgDropdownTriggerFor]=\"share\" *ngIf=\"variant === 'button'\">\n  <mtg-svg-icon icon=\"icons-share\"></mtg-svg-icon>\n</mtg-button>\n<mtg-svg-icon\n  *ngIf=\"variant === 'icon'\"\n  class=\"share-icon-trigger\"\n  icon=\"icons-share\"\n  [mtgDropdownTriggerFor]=\"share\"\n></mtg-svg-icon>\n<mtg-dropdown-menu #share>\n  <mtg-dropdown-item class=\"share-popup__menu-item\" (click)=\"shareVk()\">\n    <mtg-svg-icon icon=\"icons-vkontakte\"></mtg-svg-icon>\n    {{ localization.vk }}\n  </mtg-dropdown-item>\n  <!--<mtg-dropdown-item class=\"share-popup__menu-item\" (click)=\"shareFb()\">\n    <mtg-svg-icon icon=\"icons-facebook\"></mtg-svg-icon>\n    Facebook\n  </mtg-dropdown-item>-->\n  <mtg-dropdown-item class=\"share-popup__menu-item\" (click)=\"copyLink()\">\n    <mtg-svg-icon icon=\"icons-link\"></mtg-svg-icon>\n    {{ localization.link }}\n  </mtg-dropdown-item>\n</mtg-dropdown-menu>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ToastService }, { type: LocalizationService }]; }, { variant: [{
            type: Input
        }], url: [{
            type: Input
        }] }); })();

class ShareModule {
}
ShareModule.ɵfac = function ShareModule_Factory(t) { return new (t || ShareModule)(); };
ShareModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ShareModule });
ShareModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        SvgIconModule,
        DropdownModule,
        ButtonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ShareModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    SvgIconModule,
                    DropdownModule,
                    ButtonModule,
                ],
                declarations: [
                    ShareComponent,
                ],
                exports: [
                    ShareComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ShareModule, { declarations: function () { return [ShareComponent]; }, imports: function () { return [CommonModule, SvgIconModule, DropdownModule, ButtonModule]; }, exports: function () { return [ShareComponent]; } }); })();

class TypeaheadComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    selectedItem(value) {
        this.change.emit(value);
    }
}
TypeaheadComponent.ɵfac = function TypeaheadComponent_Factory(t) { return new (t || TypeaheadComponent)(); };
TypeaheadComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TypeaheadComponent, selectors: [["mtg-typeahead"]], viewQuery: function TypeaheadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, outputs: { change: "change" }, exportAs: ["mtgTypeahead"], ngContentSelectors: _c2, decls: 1, vars: 0, consts: [[1, "typeahead"]], template: function TypeaheadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, TypeaheadComponent_ng_template_0_Template, 2, 0, "ng-template");
    } }, encapsulation: 2, changeDetection: 0 });
TypeaheadComponent.propDecorators = {
    template: [{ type: ViewChild, args: [TemplateRef,] }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypeaheadComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-typeahead',
                template: "<ng-template>\n  <div class=\"typeahead\">\n    <ng-content></ng-content>\n  </div>\n</ng-template>\n",
                exportAs: 'mtgTypeahead',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { change: [{
            type: Output
        }], template: [{
            type: ViewChild,
            args: [TemplateRef]
        }] }); })();

class TypeaheadOptionComponent {
    constructor(typeahead) {
        this.typeahead = typeahead;
        this.defaultClass = true;
    }
    onClick() {
        this.typeahead.selectedItem(this.value);
    }
}
TypeaheadOptionComponent.ɵfac = function TypeaheadOptionComponent_Factory(t) { return new (t || TypeaheadOptionComponent)(ɵngcc0.ɵɵdirectiveInject(TypeaheadComponent)); };
TypeaheadOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TypeaheadOptionComponent, selectors: [["mtg-typeahead-option"]], hostVars: 2, hostBindings: function TypeaheadOptionComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function TypeaheadOptionComponent_click_HostBindingHandler() { return ctx.onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("typeahead-option", ctx.defaultClass);
    } }, inputs: { value: "value" }, ngContentSelectors: _c2, decls: 1, vars: 0, template: function TypeaheadOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2, changeDetection: 0 });
TypeaheadOptionComponent.ctorParameters = () => [
    { type: TypeaheadComponent }
];
TypeaheadOptionComponent.propDecorators = {
    value: [{ type: Input }],
    defaultClass: [{ type: HostBinding, args: ['class.typeahead-option',] }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypeaheadOptionComponent, [{
        type: Component,
        args: [{
                selector: 'mtg-typeahead-option',
                template: "<ng-content></ng-content>\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: TypeaheadComponent }]; }, { defaultClass: [{
            type: HostBinding,
            args: ['class.typeahead-option']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], value: [{
            type: Input
        }] }); })();

class TypeaheadDirective {
    constructor(viewContainerRef, overlay, elementRef, renderer, cdr) {
        this.viewContainerRef = viewContainerRef;
        this.overlay = overlay;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.cdr = cdr;
        this.subscriptions = [];
    }
    onFocus() {
        this.attachOverlay();
    }
    ngOnInit() {
        this.subscriptions.push(this.renderer.listen('window', 'click', $event => {
            if (!this.overlayRef) {
                return;
            }
            const target = $event.composedPath() && $event.composedPath()[0] || $event.target;
            if (!this.elementRef.nativeElement.contains(target)) {
                this.overlayRef.dispose();
                if (this.typeahead) {
                    this.typeahead.isVisible = false;
                }
                this.cdr.markForCheck();
            }
        }));
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
        for (const unsubscribe of this.subscriptions) {
            unsubscribe();
        }
        if (this.typeahead) {
            this.typeahead.isVisible = false;
        }
    }
    attachOverlay() {
        const templatePortal = new TemplatePortal(this.typeahead.template, this.viewContainerRef);
        this.overlayRef = this.overlay.create(this._getOverlayConfig());
        this.overlayRef.attach(templatePortal);
        this.typeahead.isVisible = true;
    }
    _getOverlayConfig() {
        return new OverlayConfig({
            positionStrategy: this.getPositionStrategy(),
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            width: this._getHostWidth(),
        });
    }
    getPositionStrategy() {
        return this.overlay.position()
            .flexibleConnectedTo(this.elementRef.nativeElement)
            .withFlexibleDimensions(false)
            .withPush(false)
            .withPositions([
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top'
            },
            {
                originX: 'center',
                originY: 'top',
                overlayX: 'center',
                overlayY: 'bottom',
            }
        ]);
    }
    /** Returns the width of the input element, so the panel width can match it. */
    _getHostWidth() {
        return this.elementRef.nativeElement.getBoundingClientRect().width;
    }
}
TypeaheadDirective.ɵfac = function TypeaheadDirective_Factory(t) { return new (t || TypeaheadDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
TypeaheadDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TypeaheadDirective, selectors: [["mtg-text-field", "mtgTypeahead", ""]], hostBindings: function TypeaheadDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function TypeaheadDirective_focus_HostBindingHandler() { return ctx.onFocus(); });
    } }, inputs: { typeahead: ["mtgTypeahead", "typeahead"] } });
TypeaheadDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: Overlay },
    { type: ElementRef },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
TypeaheadDirective.propDecorators = {
    typeahead: [{ type: Input, args: ['mtgTypeahead',] }],
    onFocus: [{ type: HostListener, args: ['focus',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypeaheadDirective, [{
        type: Directive,
        args: [{
                selector: 'mtg-text-field[mtgTypeahead]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc2.Overlay }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { onFocus: [{
            type: HostListener,
            args: ['focus']
        }], typeahead: [{
            type: Input,
            args: ['mtgTypeahead']
        }] }); })();

class TypeaheadModule {
}
TypeaheadModule.ɵfac = function TypeaheadModule_Factory(t) { return new (t || TypeaheadModule)(); };
TypeaheadModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TypeaheadModule });
TypeaheadModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TypeaheadModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    TypeaheadComponent,
                    TypeaheadOptionComponent,
                    TypeaheadDirective,
                ],
                exports: [
                    TypeaheadComponent,
                    TypeaheadOptionComponent,
                    TypeaheadDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TypeaheadModule, { declarations: function () { return [TypeaheadComponent, TypeaheadOptionComponent, TypeaheadDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [TypeaheadComponent, TypeaheadOptionComponent, TypeaheadDirective]; } }); })();

class LocalizationHttpInterceptor {
    constructor(localizationService) {
        this.localizationService = localizationService;
    }
    intercept(req, next) {
        req = req.clone({
            headers: req.headers.set('x-locale', this.localizationService.getLocale())
        });
        return next.handle(req);
    }
}
LocalizationHttpInterceptor.ɵfac = function LocalizationHttpInterceptor_Factory(t) { return new (t || LocalizationHttpInterceptor)(ɵngcc0.ɵɵinject(LocalizationService)); };
LocalizationHttpInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LocalizationHttpInterceptor, factory: LocalizationHttpInterceptor.ɵfac });
LocalizationHttpInterceptor.ctorParameters = () => [
    { type: LocalizationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LocalizationHttpInterceptor, [{
        type: Injectable
    }], function () { return [{ type: LocalizationService }]; }, null); })();

function replaceParams(localeStr, params) {
    for (const key of Object.keys(params)) {
        localeStr = localeStr.replace(new RegExp(`%${key}%`, 'gi'), params[key]);
    }
    localeStr = localeStr.replace(new RegExp('%.*%', 'gi'), '');
    return localeStr;
}
function getTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Generated bundle index. Do not edit.
 */

export { AgreementComponent, AudioComponent, AudioModule, ButtonComponent, ButtonModule, CheckboxComponent, CheckboxGroupComponent, CheckboxModule, ChipsComponent, ChipsModule, CityNamePipe, ConfirmDialogComponent, DataSliderComponent, DataSliderItemComponent, DataSliderModule, DateFormatPipe, DatePipe, DialogComponent, DialogConfig, DialogModule, DialogPageComponent, DialogRef, DialogService, DropdownComponent, DropdownGroupComponent, DropdownItemComponent, DropdownMenuComponent, DropdownModule, DropdownTriggerDirective, EMAIL_MASK, FORM_ERROR_LOCALIZATION, FilterPipe, FireEventDirective, FitToParentDirective, FormErrorLocalizationPipe, LOCALIZATION_DATA, LinearProgressComponent, LoaderService, Locales, LocalizationCustomPipe, LocalizationHttpInterceptor, LocalizationModule, LocalizationPipe, LocalizationService, PHONE_MASK, PHONE_MASK_LIST, PaginationScrollDirective, PhonePipe, PluralizePipe, ProgressModule, RECAPTCHA_KEY, RadioComponent, RadioGroupComponent, RadioModule, RecaptchaComponent, RecaptchaModule, RecaptchaService, SafePipe, ScrollShadowComponent, ShareComponent, ShareModule, SpinnerComponent, StickyDirective, StopPropagationDirective, SuggestHighlightPipe, SvgIconComponent, SvgIconDefinitionsComponent, SvgIconModule, SwitcherComponent, SwitcherGroupComponent, SwitcherModule, TIME_MASK, TableColComponent, TableColGroupComponent, TableComponent, TableHeaderRowComponent, TableIdentityColComponent, TableModule, TableRowComponent, TableSubtitleComponent, TextFieldComponent, TextFieldModule, TextMaskDirective, ToastComponent, ToastData, ToastModule, ToastRef, ToastService, TooltipComponent, TooltipConfig, TooltipDirective, TooltipModule, TranslatePipe, TypeaheadComponent, TypeaheadDirective, TypeaheadModule, TypeaheadOptionComponent, UtilsModule, copyToClipboard, dateMask, getTimezone, isTouchDevice, replaceParams, shareFB, shareVK, MASKEDINPUT_VALUE_ACCESSOR as ɵa, localizationDataFactory as ɵb, formErrorLocalizationFactory as ɵc, initializeLang as ɵd, FORM_ERROR_LIST as ɵe, LOCALIZATION_DATA_LIST as ɵf, FORMS_LOCALIZATION as ɵg, DownloadDirective as ɵh };

